export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  Strapi_CertificationComponentsDynamicZoneInput: any;
  Strapi_CityComponentsDynamicZoneInput: any;
  Strapi_CourseComponentsDynamicZoneInput: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Strapi_Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Strapi_DateTime: any;
  Strapi_EnglishTestComponentsDynamicZoneInput: any;
  Strapi_HomepageComponentsDynamicZoneInput: any;
  /** A string used to identify an i18n locale */
  Strapi_I18NLocaleCode: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Strapi_JSON: any;
  Strapi_PageComponentsDynamicZoneInput: any;
  Strapi_SchoolComponentsDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Strapi_Upload: any;
};










export type BooleanQueryOperatorInput = {
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};


export type DateQueryOperatorInput = {
  eq?: Maybe<Scalars['Date']>;
  ne?: Maybe<Scalars['Date']>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
  in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Date']>>>;
};

export type Directory = Node & {
  __typename?: 'Directory';
  sourceInstanceName: Scalars['String'];
  absolutePath: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['Int'];
  prettySize: Scalars['String'];
  modifiedTime: Scalars['Date'];
  accessTime: Scalars['Date'];
  changeTime: Scalars['Date'];
  birthTime: Scalars['Date'];
  root: Scalars['String'];
  dir: Scalars['String'];
  base: Scalars['String'];
  ext: Scalars['String'];
  name: Scalars['String'];
  relativeDirectory: Scalars['String'];
  dev: Scalars['Int'];
  mode: Scalars['Int'];
  nlink: Scalars['Int'];
  uid: Scalars['Int'];
  gid: Scalars['Int'];
  rdev: Scalars['Int'];
  ino: Scalars['Float'];
  atimeMs: Scalars['Float'];
  mtimeMs: Scalars['Float'];
  ctimeMs: Scalars['Float'];
  atime: Scalars['Date'];
  mtime: Scalars['Date'];
  ctime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type DirectoryModifiedTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryAccessTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryChangeTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryBirthTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryAtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryMtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type DirectoryCtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type DirectoryConnection = {
  __typename?: 'DirectoryConnection';
  totalCount: Scalars['Int'];
  edges: Array<DirectoryEdge>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<DirectoryGroupConnection>;
};


export type DirectoryConnectionDistinctArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: DirectoryFieldsEnum;
};

export type DirectoryEdge = {
  __typename?: 'DirectoryEdge';
  next?: Maybe<Directory>;
  node: Directory;
  previous?: Maybe<Directory>;
};

export enum DirectoryFieldsEnum {
  sourceInstanceName = 'sourceInstanceName',
  absolutePath = 'absolutePath',
  relativePath = 'relativePath',
  extension = 'extension',
  size = 'size',
  prettySize = 'prettySize',
  modifiedTime = 'modifiedTime',
  accessTime = 'accessTime',
  changeTime = 'changeTime',
  birthTime = 'birthTime',
  root = 'root',
  dir = 'dir',
  base = 'base',
  ext = 'ext',
  name = 'name',
  relativeDirectory = 'relativeDirectory',
  dev = 'dev',
  mode = 'mode',
  nlink = 'nlink',
  uid = 'uid',
  gid = 'gid',
  rdev = 'rdev',
  ino = 'ino',
  atimeMs = 'atimeMs',
  mtimeMs = 'mtimeMs',
  ctimeMs = 'ctimeMs',
  atime = 'atime',
  mtime = 'mtime',
  ctime = 'ctime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type DirectoryFilterInput = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type DirectoryGroupConnection = {
  __typename?: 'DirectoryGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<DirectoryEdge>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type DirectorySortInput = {
  fields?: Maybe<Array<Maybe<DirectoryFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type File = Node & {
  __typename?: 'File';
  sourceInstanceName: Scalars['String'];
  absolutePath: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['Int'];
  prettySize: Scalars['String'];
  modifiedTime: Scalars['Date'];
  accessTime: Scalars['Date'];
  changeTime: Scalars['Date'];
  birthTime: Scalars['Date'];
  root: Scalars['String'];
  dir: Scalars['String'];
  base: Scalars['String'];
  ext: Scalars['String'];
  name: Scalars['String'];
  relativeDirectory: Scalars['String'];
  dev: Scalars['Int'];
  mode: Scalars['Int'];
  nlink: Scalars['Int'];
  uid: Scalars['Int'];
  gid: Scalars['Int'];
  rdev: Scalars['Int'];
  ino: Scalars['Float'];
  atimeMs: Scalars['Float'];
  mtimeMs: Scalars['Float'];
  ctimeMs: Scalars['Float'];
  atime: Scalars['Date'];
  mtime: Scalars['Date'];
  ctime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type FileModifiedTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileAccessTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileChangeTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileBirthTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileAtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileMtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};


export type FileCtimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type FileConnection = {
  __typename?: 'FileConnection';
  totalCount: Scalars['Int'];
  edges: Array<FileEdge>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<FileGroupConnection>;
};


export type FileConnectionDistinctArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: FileFieldsEnum;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  next?: Maybe<File>;
  node: File;
  previous?: Maybe<File>;
};

export enum FileFieldsEnum {
  sourceInstanceName = 'sourceInstanceName',
  absolutePath = 'absolutePath',
  relativePath = 'relativePath',
  extension = 'extension',
  size = 'size',
  prettySize = 'prettySize',
  modifiedTime = 'modifiedTime',
  accessTime = 'accessTime',
  changeTime = 'changeTime',
  birthTime = 'birthTime',
  root = 'root',
  dir = 'dir',
  base = 'base',
  ext = 'ext',
  name = 'name',
  relativeDirectory = 'relativeDirectory',
  dev = 'dev',
  mode = 'mode',
  nlink = 'nlink',
  uid = 'uid',
  gid = 'gid',
  rdev = 'rdev',
  ino = 'ino',
  atimeMs = 'atimeMs',
  mtimeMs = 'mtimeMs',
  ctimeMs = 'ctimeMs',
  atime = 'atime',
  mtime = 'mtime',
  ctime = 'ctime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type FileFilterInput = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type FileGroupConnection = {
  __typename?: 'FileGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<FileEdge>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type FileSortInput = {
  fields?: Maybe<Array<Maybe<FileFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type FloatQueryOperatorInput = {
  eq?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type GraphQlSource = Node & {
  __typename?: 'GraphQLSource';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  typeName?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
};

export type GraphQlSourceConnection = {
  __typename?: 'GraphQLSourceConnection';
  totalCount: Scalars['Int'];
  edges: Array<GraphQlSourceEdge>;
  nodes: Array<GraphQlSource>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<GraphQlSourceGroupConnection>;
};


export type GraphQlSourceConnectionDistinctArgs = {
  field: GraphQlSourceFieldsEnum;
};


export type GraphQlSourceConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: GraphQlSourceFieldsEnum;
};

export type GraphQlSourceEdge = {
  __typename?: 'GraphQLSourceEdge';
  next?: Maybe<GraphQlSource>;
  node: GraphQlSource;
  previous?: Maybe<GraphQlSource>;
};

export enum GraphQlSourceFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  typeName = 'typeName',
  fieldName = 'fieldName'
}

export type GraphQlSourceFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  typeName?: Maybe<StringQueryOperatorInput>;
  fieldName?: Maybe<StringQueryOperatorInput>;
};

export type GraphQlSourceGroupConnection = {
  __typename?: 'GraphQLSourceGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<GraphQlSourceEdge>;
  nodes: Array<GraphQlSource>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type GraphQlSourceSortInput = {
  fields?: Maybe<Array<Maybe<GraphQlSourceFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type IntQueryOperatorInput = {
  eq?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type Internal = {
  __typename?: 'Internal';
  content?: Maybe<Scalars['String']>;
  contentDigest: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fieldOwners?: Maybe<Array<Maybe<Scalars['String']>>>;
  ignoreType?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  type: Scalars['String'];
};

export type InternalFilterInput = {
  content?: Maybe<StringQueryOperatorInput>;
  contentDigest?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  fieldOwners?: Maybe<StringQueryOperatorInput>;
  ignoreType?: Maybe<BooleanQueryOperatorInput>;
  mediaType?: Maybe<StringQueryOperatorInput>;
  owner?: Maybe<StringQueryOperatorInput>;
  type?: Maybe<StringQueryOperatorInput>;
};

/** Node Interface */
export type Node = {
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type NodeFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: Maybe<NodeFilterInput>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int'];
  hasPreviousPage: Scalars['Boolean'];
  hasNextPage: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  file?: Maybe<File>;
  allFile: FileConnection;
  directory?: Maybe<Directory>;
  allDirectory: DirectoryConnection;
  site?: Maybe<Site>;
  allSite: SiteConnection;
  sitePage?: Maybe<SitePage>;
  allSitePage: SitePageConnection;
  graphQlSource?: Maybe<GraphQlSource>;
  allGraphQlSource: GraphQlSourceConnection;
  siteBuildMetadata?: Maybe<SiteBuildMetadata>;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  sitePlugin?: Maybe<SitePlugin>;
  allSitePlugin: SitePluginConnection;
  strapi: Strapi;
};


export type QueryFileArgs = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllFileArgs = {
  filter?: Maybe<FileFilterInput>;
  sort?: Maybe<FileSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryDirectoryArgs = {
  sourceInstanceName?: Maybe<StringQueryOperatorInput>;
  absolutePath?: Maybe<StringQueryOperatorInput>;
  relativePath?: Maybe<StringQueryOperatorInput>;
  extension?: Maybe<StringQueryOperatorInput>;
  size?: Maybe<IntQueryOperatorInput>;
  prettySize?: Maybe<StringQueryOperatorInput>;
  modifiedTime?: Maybe<DateQueryOperatorInput>;
  accessTime?: Maybe<DateQueryOperatorInput>;
  changeTime?: Maybe<DateQueryOperatorInput>;
  birthTime?: Maybe<DateQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  dir?: Maybe<StringQueryOperatorInput>;
  base?: Maybe<StringQueryOperatorInput>;
  ext?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  relativeDirectory?: Maybe<StringQueryOperatorInput>;
  dev?: Maybe<IntQueryOperatorInput>;
  mode?: Maybe<IntQueryOperatorInput>;
  nlink?: Maybe<IntQueryOperatorInput>;
  uid?: Maybe<IntQueryOperatorInput>;
  gid?: Maybe<IntQueryOperatorInput>;
  rdev?: Maybe<IntQueryOperatorInput>;
  ino?: Maybe<FloatQueryOperatorInput>;
  atimeMs?: Maybe<FloatQueryOperatorInput>;
  mtimeMs?: Maybe<FloatQueryOperatorInput>;
  ctimeMs?: Maybe<FloatQueryOperatorInput>;
  atime?: Maybe<DateQueryOperatorInput>;
  mtime?: Maybe<DateQueryOperatorInput>;
  ctime?: Maybe<DateQueryOperatorInput>;
  birthtime?: Maybe<DateQueryOperatorInput>;
  birthtimeMs?: Maybe<FloatQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllDirectoryArgs = {
  filter?: Maybe<DirectoryFilterInput>;
  sort?: Maybe<DirectorySortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySiteArgs = {
  buildTime?: Maybe<DateQueryOperatorInput>;
  siteMetadata?: Maybe<SiteSiteMetadataFilterInput>;
  port?: Maybe<IntQueryOperatorInput>;
  host?: Maybe<StringQueryOperatorInput>;
  flags?: Maybe<SiteFlagsFilterInput>;
  polyfill?: Maybe<BooleanQueryOperatorInput>;
  pathPrefix?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSiteArgs = {
  filter?: Maybe<SiteFilterInput>;
  sort?: Maybe<SiteSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySitePageArgs = {
  path?: Maybe<StringQueryOperatorInput>;
  component?: Maybe<StringQueryOperatorInput>;
  internalComponentName?: Maybe<StringQueryOperatorInput>;
  componentChunkName?: Maybe<StringQueryOperatorInput>;
  matchPath?: Maybe<StringQueryOperatorInput>;
  isCreatedByStatefulCreatePages?: Maybe<BooleanQueryOperatorInput>;
  context?: Maybe<SitePageContextFilterInput>;
  pluginCreator?: Maybe<SitePluginFilterInput>;
  pluginCreatorId?: Maybe<StringQueryOperatorInput>;
  componentPath?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};


export type QueryAllSitePageArgs = {
  filter?: Maybe<SitePageFilterInput>;
  sort?: Maybe<SitePageSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGraphQlSourceArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  typeName?: Maybe<StringQueryOperatorInput>;
  fieldName?: Maybe<StringQueryOperatorInput>;
};


export type QueryAllGraphQlSourceArgs = {
  filter?: Maybe<GraphQlSourceFilterInput>;
  sort?: Maybe<GraphQlSourceSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySiteBuildMetadataArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  buildTime?: Maybe<DateQueryOperatorInput>;
};


export type QueryAllSiteBuildMetadataArgs = {
  filter?: Maybe<SiteBuildMetadataFilterInput>;
  sort?: Maybe<SiteBuildMetadataSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySitePluginArgs = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  resolve?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
  pluginOptions?: Maybe<SitePluginPluginOptionsFilterInput>;
  nodeAPIs?: Maybe<StringQueryOperatorInput>;
  browserAPIs?: Maybe<StringQueryOperatorInput>;
  ssrAPIs?: Maybe<StringQueryOperatorInput>;
  pluginFilepath?: Maybe<StringQueryOperatorInput>;
  packageJson?: Maybe<SitePluginPackageJsonFilterInput>;
};


export type QueryAllSitePluginArgs = {
  filter?: Maybe<SitePluginFilterInput>;
  sort?: Maybe<SitePluginSortInput>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type Site = Node & {
  __typename?: 'Site';
  buildTime?: Maybe<Scalars['Date']>;
  siteMetadata?: Maybe<SiteSiteMetadata>;
  port?: Maybe<Scalars['Int']>;
  host?: Maybe<Scalars['String']>;
  flags?: Maybe<SiteFlags>;
  polyfill?: Maybe<Scalars['Boolean']>;
  pathPrefix?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type SiteBuildTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SiteBuildMetadata = Node & {
  __typename?: 'SiteBuildMetadata';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  buildTime?: Maybe<Scalars['Date']>;
};


export type SiteBuildMetadataBuildTimeArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SiteBuildMetadataConnection = {
  __typename?: 'SiteBuildMetadataConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteBuildMetadataEdge>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<SiteBuildMetadataGroupConnection>;
};


export type SiteBuildMetadataConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SiteBuildMetadataFieldsEnum;
};

export type SiteBuildMetadataEdge = {
  __typename?: 'SiteBuildMetadataEdge';
  next?: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous?: Maybe<SiteBuildMetadata>;
};

export enum SiteBuildMetadataFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  buildTime = 'buildTime'
}

export type SiteBuildMetadataFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  buildTime?: Maybe<DateQueryOperatorInput>;
};

export type SiteBuildMetadataGroupConnection = {
  __typename?: 'SiteBuildMetadataGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteBuildMetadataEdge>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SiteBuildMetadataSortInput = {
  fields?: Maybe<Array<Maybe<SiteBuildMetadataFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteEdge>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<SiteGroupConnection>;
};


export type SiteConnectionDistinctArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SiteFieldsEnum;
};

export type SiteEdge = {
  __typename?: 'SiteEdge';
  next?: Maybe<Site>;
  node: Site;
  previous?: Maybe<Site>;
};

export enum SiteFieldsEnum {
  buildTime = 'buildTime',
  siteMetadata___title = 'siteMetadata___title',
  siteMetadata___description = 'siteMetadata___description',
  siteMetadata___author = 'siteMetadata___author',
  siteMetadata___studentLogin = 'siteMetadata___studentLogin',
  port = 'port',
  host = 'host',
  flags___DEV_SSR = 'flags___DEV_SSR',
  polyfill = 'polyfill',
  pathPrefix = 'pathPrefix',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SiteFilterInput = {
  buildTime?: Maybe<DateQueryOperatorInput>;
  siteMetadata?: Maybe<SiteSiteMetadataFilterInput>;
  port?: Maybe<IntQueryOperatorInput>;
  host?: Maybe<StringQueryOperatorInput>;
  flags?: Maybe<SiteFlagsFilterInput>;
  polyfill?: Maybe<BooleanQueryOperatorInput>;
  pathPrefix?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SiteFlags = {
  __typename?: 'SiteFlags';
  DEV_SSR?: Maybe<Scalars['Boolean']>;
};

export type SiteFlagsFilterInput = {
  DEV_SSR?: Maybe<BooleanQueryOperatorInput>;
};

export type SiteGroupConnection = {
  __typename?: 'SiteGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SiteEdge>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePage = Node & {
  __typename?: 'SitePage';
  path: Scalars['String'];
  component: Scalars['String'];
  internalComponentName: Scalars['String'];
  componentChunkName: Scalars['String'];
  matchPath?: Maybe<Scalars['String']>;
  isCreatedByStatefulCreatePages?: Maybe<Scalars['Boolean']>;
  context?: Maybe<SitePageContext>;
  pluginCreator?: Maybe<SitePlugin>;
  pluginCreatorId?: Maybe<Scalars['String']>;
  componentPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SitePageConnection = {
  __typename?: 'SitePageConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePageEdge>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<SitePageGroupConnection>;
};


export type SitePageConnectionDistinctArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SitePageFieldsEnum;
};

export type SitePageContext = {
  __typename?: 'SitePageContext';
  breadcrumb?: Maybe<SitePageContextBreadcrumb>;
  globalScripts?: Maybe<Array<Maybe<SitePageContextGlobalScripts>>>;
  website?: Maybe<SitePageContextWebsite>;
  websiteId?: Maybe<Scalars['String']>;
  websiteLocale?: Maybe<SitePageContextWebsiteLocale>;
  websiteLocaleId?: Maybe<Scalars['String']>;
  currentDate?: Maybe<Scalars['Date']>;
  pathPrefixes?: Maybe<SitePageContextPathPrefixes>;
  originalPathPrefixes?: Maybe<SitePageContextOriginalPathPrefixes>;
  id?: Maybe<Scalars['String']>;
  avoidIndexing?: Maybe<Scalars['Boolean']>;
  allCareerPosts?: Maybe<Array<Maybe<SitePageContextAllCareerPosts>>>;
  careersCtaId?: Maybe<Scalars['String']>;
  hasCareersCta?: Maybe<Scalars['Boolean']>;
  relatedIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageNumber?: Maybe<Scalars['Int']>;
  humanPageNumber?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  numberOfPages?: Maybe<Scalars['Int']>;
  previousPagePath?: Maybe<Scalars['String']>;
  nextPagePath?: Maybe<Scalars['String']>;
  schools?: Maybe<Array<Maybe<SitePageContextSchools>>>;
  exercises?: Maybe<Array<Maybe<SitePageContextExercises>>>;
  certificationCtaId?: Maybe<Scalars['Int']>;
  certificationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasDefaultCertificationCta?: Maybe<Scalars['Boolean']>;
  cityId?: Maybe<Scalars['String']>;
};


export type SitePageContextCurrentDateArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextAllCareerPosts = {
  __typename?: 'SitePageContextAllCareerPosts';
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  pageSettings?: Maybe<SitePageContextAllCareerPostsPageSettings>;
};

export type SitePageContextAllCareerPostsFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  pageSettings?: Maybe<SitePageContextAllCareerPostsPageSettingsFilterInput>;
};

export type SitePageContextAllCareerPostsFilterListInput = {
  elemMatch?: Maybe<SitePageContextAllCareerPostsFilterInput>;
};

export type SitePageContextAllCareerPostsPageSettings = {
  __typename?: 'SitePageContextAllCareerPostsPageSettings';
  avoid_indexing?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextAllCareerPostsPageSettingsFilterInput = {
  avoid_indexing?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextBreadcrumb = {
  __typename?: 'SitePageContextBreadcrumb';
  location?: Maybe<Scalars['String']>;
  crumbs?: Maybe<Array<Maybe<SitePageContextBreadcrumbCrumbs>>>;
};

export type SitePageContextBreadcrumbCrumbs = {
  __typename?: 'SitePageContextBreadcrumbCrumbs';
  pathname?: Maybe<Scalars['String']>;
  crumbLabel?: Maybe<Scalars['String']>;
};

export type SitePageContextBreadcrumbCrumbsFilterInput = {
  pathname?: Maybe<StringQueryOperatorInput>;
  crumbLabel?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextBreadcrumbCrumbsFilterListInput = {
  elemMatch?: Maybe<SitePageContextBreadcrumbCrumbsFilterInput>;
};

export type SitePageContextBreadcrumbFilterInput = {
  location?: Maybe<StringQueryOperatorInput>;
  crumbs?: Maybe<SitePageContextBreadcrumbCrumbsFilterListInput>;
};

export type SitePageContextExercises = {
  __typename?: 'SitePageContextExercises';
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Date']>;
  excerpt?: Maybe<Scalars['String']>;
  image?: Maybe<SitePageContextExercisesImage>;
  pageSettings?: Maybe<SitePageContextExercisesPageSettings>;
};


export type SitePageContextExercisesPublishedAtArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextExercisesFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  publishedAt?: Maybe<DateQueryOperatorInput>;
  excerpt?: Maybe<StringQueryOperatorInput>;
  image?: Maybe<SitePageContextExercisesImageFilterInput>;
  pageSettings?: Maybe<SitePageContextExercisesPageSettingsFilterInput>;
};

export type SitePageContextExercisesFilterListInput = {
  elemMatch?: Maybe<SitePageContextExercisesFilterInput>;
};

export type SitePageContextExercisesImage = {
  __typename?: 'SitePageContextExercisesImage';
  url?: Maybe<Scalars['String']>;
};

export type SitePageContextExercisesImageFilterInput = {
  url?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextExercisesPageSettings = {
  __typename?: 'SitePageContextExercisesPageSettings';
  avoid_indexing?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextExercisesPageSettingsFilterInput = {
  avoid_indexing?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextFilterInput = {
  breadcrumb?: Maybe<SitePageContextBreadcrumbFilterInput>;
  globalScripts?: Maybe<SitePageContextGlobalScriptsFilterListInput>;
  website?: Maybe<SitePageContextWebsiteFilterInput>;
  websiteId?: Maybe<StringQueryOperatorInput>;
  websiteLocale?: Maybe<SitePageContextWebsiteLocaleFilterInput>;
  websiteLocaleId?: Maybe<StringQueryOperatorInput>;
  currentDate?: Maybe<DateQueryOperatorInput>;
  pathPrefixes?: Maybe<SitePageContextPathPrefixesFilterInput>;
  originalPathPrefixes?: Maybe<SitePageContextOriginalPathPrefixesFilterInput>;
  id?: Maybe<StringQueryOperatorInput>;
  avoidIndexing?: Maybe<BooleanQueryOperatorInput>;
  allCareerPosts?: Maybe<SitePageContextAllCareerPostsFilterListInput>;
  careersCtaId?: Maybe<StringQueryOperatorInput>;
  hasCareersCta?: Maybe<BooleanQueryOperatorInput>;
  relatedIds?: Maybe<StringQueryOperatorInput>;
  pageNumber?: Maybe<IntQueryOperatorInput>;
  humanPageNumber?: Maybe<IntQueryOperatorInput>;
  skip?: Maybe<IntQueryOperatorInput>;
  limit?: Maybe<IntQueryOperatorInput>;
  numberOfPages?: Maybe<IntQueryOperatorInput>;
  previousPagePath?: Maybe<StringQueryOperatorInput>;
  nextPagePath?: Maybe<StringQueryOperatorInput>;
  schools?: Maybe<SitePageContextSchoolsFilterListInput>;
  exercises?: Maybe<SitePageContextExercisesFilterListInput>;
  certificationCtaId?: Maybe<IntQueryOperatorInput>;
  certificationIds?: Maybe<StringQueryOperatorInput>;
  hasDefaultCertificationCta?: Maybe<BooleanQueryOperatorInput>;
  cityId?: Maybe<StringQueryOperatorInput>;
};

export type Strapi_JsonFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Strapi_JSON']>>>;
  or?: Maybe<Array<Maybe<Scalars['Strapi_JSON']>>>;
  not?: Maybe<Strapi_JsonFilterInput>;
  eq?: Maybe<Scalars['Strapi_JSON']>;
  eqi?: Maybe<Scalars['Strapi_JSON']>;
  ne?: Maybe<Scalars['Strapi_JSON']>;
  startsWith?: Maybe<Scalars['Strapi_JSON']>;
  endsWith?: Maybe<Scalars['Strapi_JSON']>;
  contains?: Maybe<Scalars['Strapi_JSON']>;
  notContains?: Maybe<Scalars['Strapi_JSON']>;
  containsi?: Maybe<Scalars['Strapi_JSON']>;
  notContainsi?: Maybe<Scalars['Strapi_JSON']>;
  gt?: Maybe<Scalars['Strapi_JSON']>;
  gte?: Maybe<Scalars['Strapi_JSON']>;
  lt?: Maybe<Scalars['Strapi_JSON']>;
  lte?: Maybe<Scalars['Strapi_JSON']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Strapi_JSON']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Strapi_JSON']>>>;
  between?: Maybe<Array<Maybe<Scalars['Strapi_JSON']>>>;
};


export type SitePageContextGlobalScripts = {
  __typename?: 'SitePageContextGlobalScripts';
  name?: Maybe<Scalars['String']>;
  loadInHead?: Maybe<Scalars['Boolean']>;
  scripts?: Maybe<Array<Maybe<SitePageContextGlobalScriptsScripts>>>;
  noscripts?: Maybe<Array<Maybe<Scalars['String']>>>;
  load_defer?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextGlobalScriptsFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  loadInHead?: Maybe<BooleanQueryOperatorInput>;
  scripts?: Maybe<SitePageContextGlobalScriptsScriptsFilterListInput>;
  noscripts?: Maybe<StringQueryOperatorInput>;
  load_defer?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextGlobalScriptsFilterListInput = {
  elemMatch?: Maybe<SitePageContextGlobalScriptsFilterInput>;
};

export type SitePageContextGlobalScriptsScripts = {
  __typename?: 'SitePageContextGlobalScriptsScripts';
  attributes?: Maybe<SitePageContextGlobalScriptsScriptsAttributes>;
  innerHTML?: Maybe<Scalars['String']>;
};

export type SitePageContextGlobalScriptsScriptsAttributes = {
  __typename?: 'SitePageContextGlobalScriptsScriptsAttributes';
  src?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  defer?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextGlobalScriptsScriptsAttributesFilterInput = {
  src?: Maybe<StringQueryOperatorInput>;
  type?: Maybe<StringQueryOperatorInput>;
  defer?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextGlobalScriptsScriptsFilterInput = {
  attributes?: Maybe<SitePageContextGlobalScriptsScriptsAttributesFilterInput>;
  innerHTML?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextGlobalScriptsScriptsFilterListInput = {
  elemMatch?: Maybe<SitePageContextGlobalScriptsScriptsFilterInput>;
};

export type SitePageContextOriginalPathPrefixes = {
  __typename?: 'SitePageContextOriginalPathPrefixes';
  root?: Maybe<Scalars['String']>;
  blog?: Maybe<Scalars['String']>;
  careers?: Maybe<Scalars['String']>;
  certifications?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['String']>;
  courses?: Maybe<Scalars['String']>;
  english_tests?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  exercises?: Maybe<Scalars['String']>;
  promotions?: Maybe<Scalars['String']>;
  schools?: Maybe<Scalars['String']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
};

export type SitePageContextOriginalPathPrefixesFilterInput = {
  root?: Maybe<StringQueryOperatorInput>;
  blog?: Maybe<StringQueryOperatorInput>;
  careers?: Maybe<StringQueryOperatorInput>;
  certifications?: Maybe<StringQueryOperatorInput>;
  cities?: Maybe<StringQueryOperatorInput>;
  courses?: Maybe<StringQueryOperatorInput>;
  english_tests?: Maybe<StringQueryOperatorInput>;
  events?: Maybe<StringQueryOperatorInput>;
  exercises?: Maybe<StringQueryOperatorInput>;
  promotions?: Maybe<StringQueryOperatorInput>;
  schools?: Maybe<StringQueryOperatorInput>;
  terms_and_conditions?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextPathPrefixes = {
  __typename?: 'SitePageContextPathPrefixes';
  root?: Maybe<Scalars['String']>;
  blog?: Maybe<Scalars['String']>;
  careers?: Maybe<Scalars['String']>;
  certifications?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['String']>;
  courses?: Maybe<Scalars['String']>;
  english_tests?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  exercises?: Maybe<Scalars['String']>;
  promotions?: Maybe<Scalars['String']>;
  schools?: Maybe<Scalars['String']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
};

export type SitePageContextPathPrefixesFilterInput = {
  root?: Maybe<StringQueryOperatorInput>;
  blog?: Maybe<StringQueryOperatorInput>;
  careers?: Maybe<StringQueryOperatorInput>;
  certifications?: Maybe<StringQueryOperatorInput>;
  cities?: Maybe<StringQueryOperatorInput>;
  courses?: Maybe<StringQueryOperatorInput>;
  english_tests?: Maybe<StringQueryOperatorInput>;
  events?: Maybe<StringQueryOperatorInput>;
  exercises?: Maybe<StringQueryOperatorInput>;
  promotions?: Maybe<StringQueryOperatorInput>;
  schools?: Maybe<StringQueryOperatorInput>;
  terms_and_conditions?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextSchools = {
  __typename?: 'SitePageContextSchools';
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  pageSettings?: Maybe<SitePageContextSchoolsPageSettings>;
};

export type SitePageContextSchoolsFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  slug?: Maybe<StringQueryOperatorInput>;
  pageSettings?: Maybe<SitePageContextSchoolsPageSettingsFilterInput>;
};

export type SitePageContextSchoolsFilterListInput = {
  elemMatch?: Maybe<SitePageContextSchoolsFilterInput>;
};

export type SitePageContextSchoolsPageSettings = {
  __typename?: 'SitePageContextSchoolsPageSettings';
  avoid_indexing?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextSchoolsPageSettingsFilterInput = {
  avoid_indexing?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsite = {
  __typename?: 'SitePageContextWebsite';
  id?: Maybe<Scalars['String']>;
  domainName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  globalScripts?: Maybe<Array<Maybe<SitePageContextWebsiteGlobalScripts>>>;
  settings?: Maybe<SitePageContextWebsiteSettings>;
  websiteLocales?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocales>>>;
  defaultWebsiteLocale?: Maybe<SitePageContextWebsiteDefaultWebsiteLocale>;
};

export type SitePageContextWebsiteDefaultWebsiteLocale = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocale';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  navigation?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigation>>>;
  topBarCta?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleTopBarCta>;
  footerLeftLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinks>>>;
  footerRightLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinks>>>;
  legalLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleLegalLinks>>>;
  socialLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleSocialLinks>>>;
  footerCta?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterCta>;
  hasExternalBlog?: Maybe<Scalars['Boolean']>;
  externalBlogText?: Maybe<Scalars['String']>;
  externalBlogUrl?: Maybe<Scalars['String']>;
  translations?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleTranslations>;
  pathPrefixes?: Maybe<SitePageContextWebsiteDefaultWebsiteLocalePathPrefixes>;
  footerMetaInfo?: Maybe<Scalars['String']>;
  hasRightToLeftLanguage?: Maybe<Scalars['Boolean']>;
  careersCta?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleCareersCta>;
  telephone?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleCareersCta = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleCareersCta';
  id?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleCareersCtaFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  languageCode?: Maybe<StringQueryOperatorInput>;
  navigation?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationFilterListInput>;
  topBarCta?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleTopBarCtaFilterInput>;
  footerLeftLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksFilterListInput>;
  footerRightLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksFilterListInput>;
  legalLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleLegalLinksFilterListInput>;
  socialLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleSocialLinksFilterListInput>;
  footerCta?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterCtaFilterInput>;
  hasExternalBlog?: Maybe<BooleanQueryOperatorInput>;
  externalBlogText?: Maybe<StringQueryOperatorInput>;
  externalBlogUrl?: Maybe<StringQueryOperatorInput>;
  translations?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleTranslationsFilterInput>;
  pathPrefixes?: Maybe<SitePageContextWebsiteDefaultWebsiteLocalePathPrefixesFilterInput>;
  footerMetaInfo?: Maybe<StringQueryOperatorInput>;
  hasRightToLeftLanguage?: Maybe<BooleanQueryOperatorInput>;
  careersCta?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleCareersCtaFilterInput>;
  telephone?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterCta = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterCta';
  title?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  element_id?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterCtaFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  script?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  element_id?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinks';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinks>>>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksPage = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksChildLinksFilterListInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLink = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLink';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkPage = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterLeftLinksLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinks';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinks>>>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksPage = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksChildLinksFilterListInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLink = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLink';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkPage = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleFooterRightLinksLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleLegalLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleLegalLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleLegalLinksFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleLegalLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleLegalLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigation = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleNavigation';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinks>>>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksPage = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationChildLinksFilterListInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationLink = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleNavigationLink';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkPage = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleNavigationLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocalePathPrefixes = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocalePathPrefixes';
  blog?: Maybe<Scalars['String']>;
  root?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  careers?: Maybe<Scalars['String']>;
  courses?: Maybe<Scalars['String']>;
  schools?: Maybe<Scalars['String']>;
  exercises?: Maybe<Scalars['String']>;
  promotions?: Maybe<Scalars['String']>;
  english_tests?: Maybe<Scalars['String']>;
  certifications?: Maybe<Scalars['String']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocalePathPrefixesFilterInput = {
  blog?: Maybe<StringQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  cities?: Maybe<StringQueryOperatorInput>;
  events?: Maybe<StringQueryOperatorInput>;
  careers?: Maybe<StringQueryOperatorInput>;
  courses?: Maybe<StringQueryOperatorInput>;
  schools?: Maybe<StringQueryOperatorInput>;
  exercises?: Maybe<StringQueryOperatorInput>;
  promotions?: Maybe<StringQueryOperatorInput>;
  english_tests?: Maybe<StringQueryOperatorInput>;
  certifications?: Maybe<StringQueryOperatorInput>;
  terms_and_conditions?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleSocialLinks = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleSocialLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleSocialLinksFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleSocialLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleSocialLinksFilterInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleTopBarCta = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleTopBarCta';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteDefaultWebsiteLocaleTopBarCtaIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleTopBarCtaFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleTranslations = {
  __typename?: 'SitePageContextWebsiteDefaultWebsiteLocaleTranslations';
  loadMore?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  schoolsIn?: Maybe<Scalars['String']>;
  schoolsOf?: Maybe<Scalars['String']>;
  updatedText?: Maybe<Scalars['String']>;
  blogCardText?: Maybe<Scalars['String']>;
  searchButton?: Maybe<Scalars['String']>;
  careersAtText?: Maybe<Scalars['String']>;
  flagOfCountry?: Maybe<Scalars['String']>;
  categoriesText?: Maybe<Scalars['String']>;
  eventsCardText?: Maybe<Scalars['String']>;
  schoolCardText?: Maybe<Scalars['String']>;
  seo_blog_title?: Maybe<Scalars['String']>;
  blogDividerText?: Maybe<Scalars['String']>;
  careersCardText?: Maybe<Scalars['String']>;
  coursesCardText?: Maybe<Scalars['String']>;
  promotionsAtText?: Maybe<Scalars['String']>;
  seo_events_title?: Maybe<Scalars['String']>;
  courseHeadingText?: Maybe<Scalars['String']>;
  eventsDividerText?: Maybe<Scalars['String']>;
  exercisesCardText?: Maybe<Scalars['String']>;
  searchPlaceholder?: Maybe<Scalars['String']>;
  seo_careers_title?: Maybe<Scalars['String']>;
  seo_courses_title?: Maybe<Scalars['String']>;
  seo_schools_title?: Maybe<Scalars['String']>;
  eventsIndexHeading?: Maybe<Scalars['String']>;
  placeholderJobType?: Maybe<Scalars['String']>;
  promotionsCardText?: Maybe<Scalars['String']>;
  totalSchoolsInCity?: Maybe<Scalars['String']>;
  careersIndexHeading?: Maybe<Scalars['String']>;
  certificationInCity?: Maybe<Scalars['String']>;
  countSchoolsOfTotal?: Maybe<Scalars['String']>;
  coursesIndexHeading?: Maybe<Scalars['String']>;
  englishTestCardText?: Maybe<Scalars['String']>;
  notFoundTextHeading?: Maybe<Scalars['String']>;
  placeholderLocation?: Maybe<Scalars['String']>;
  seo_exercises_title?: Maybe<Scalars['String']>;
  exercisesDividerText?: Maybe<Scalars['String']>;
  noEventsIndexHeading?: Maybe<Scalars['String']>;
  placeholderEventType?: Maybe<Scalars['String']>;
  seo_blog_description?: Maybe<Scalars['String']>;
  seo_promotions_title?: Maybe<Scalars['String']>;
  exercisesIndexHeading?: Maybe<Scalars['String']>;
  noCareersIndexHeading?: Maybe<Scalars['String']>;
  placeholderSchoolType?: Maybe<Scalars['String']>;
  certificationsCardText?: Maybe<Scalars['String']>;
  defaultSchoolsMapTitle?: Maybe<Scalars['String']>;
  promotionsIndexHeading?: Maybe<Scalars['String']>;
  seo_englishTests_title?: Maybe<Scalars['String']>;
  seo_events_description?: Maybe<Scalars['String']>;
  coursesIndexDescription?: Maybe<Scalars['String']>;
  noExercisesIndexHeading?: Maybe<Scalars['String']>;
  notFoundTextDescription?: Maybe<Scalars['String']>;
  seo_careers_description?: Maybe<Scalars['String']>;
  seo_courses_description?: Maybe<Scalars['String']>;
  seo_schools_description?: Maybe<Scalars['String']>;
  termsAndConditionsTitle?: Maybe<Scalars['String']>;
  englishTestsIndexHeading?: Maybe<Scalars['String']>;
  noEventsIndexDescription?: Maybe<Scalars['String']>;
  noPromotionsIndexHeading?: Maybe<Scalars['String']>;
  notFoundReturnButtonText?: Maybe<Scalars['String']>;
  seo_certifications_title?: Maybe<Scalars['String']>;
  certificationIndexHeading?: Maybe<Scalars['String']>;
  seo_exercises_description?: Maybe<Scalars['String']>;
  noEnglishTestsIndexHeading?: Maybe<Scalars['String']>;
  promotionsIndexDescription?: Maybe<Scalars['String']>;
  seo_promotions_description?: Maybe<Scalars['String']>;
  termsAndConditionsLinkText?: Maybe<Scalars['String']>;
  noCertificationsIndexHeading?: Maybe<Scalars['String']>;
  noPromotionsIndexDescription?: Maybe<Scalars['String']>;
  seo_englishTests_description?: Maybe<Scalars['String']>;
  certificationIndexDescription?: Maybe<Scalars['String']>;
  noEnglishTestsIndexDescription?: Maybe<Scalars['String']>;
  seo_certifications_description?: Maybe<Scalars['String']>;
  noCertificationsIndexDescription?: Maybe<Scalars['String']>;
  seo_certification_city_description?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteDefaultWebsiteLocaleTranslationsFilterInput = {
  loadMore?: Maybe<StringQueryOperatorInput>;
  copyright?: Maybe<StringQueryOperatorInput>;
  schoolsIn?: Maybe<StringQueryOperatorInput>;
  schoolsOf?: Maybe<StringQueryOperatorInput>;
  updatedText?: Maybe<StringQueryOperatorInput>;
  blogCardText?: Maybe<StringQueryOperatorInput>;
  searchButton?: Maybe<StringQueryOperatorInput>;
  careersAtText?: Maybe<StringQueryOperatorInput>;
  flagOfCountry?: Maybe<StringQueryOperatorInput>;
  categoriesText?: Maybe<StringQueryOperatorInput>;
  eventsCardText?: Maybe<StringQueryOperatorInput>;
  schoolCardText?: Maybe<StringQueryOperatorInput>;
  seo_blog_title?: Maybe<StringQueryOperatorInput>;
  blogDividerText?: Maybe<StringQueryOperatorInput>;
  careersCardText?: Maybe<StringQueryOperatorInput>;
  coursesCardText?: Maybe<StringQueryOperatorInput>;
  promotionsAtText?: Maybe<StringQueryOperatorInput>;
  seo_events_title?: Maybe<StringQueryOperatorInput>;
  courseHeadingText?: Maybe<StringQueryOperatorInput>;
  eventsDividerText?: Maybe<StringQueryOperatorInput>;
  exercisesCardText?: Maybe<StringQueryOperatorInput>;
  searchPlaceholder?: Maybe<StringQueryOperatorInput>;
  seo_careers_title?: Maybe<StringQueryOperatorInput>;
  seo_courses_title?: Maybe<StringQueryOperatorInput>;
  seo_schools_title?: Maybe<StringQueryOperatorInput>;
  eventsIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderJobType?: Maybe<StringQueryOperatorInput>;
  promotionsCardText?: Maybe<StringQueryOperatorInput>;
  totalSchoolsInCity?: Maybe<StringQueryOperatorInput>;
  careersIndexHeading?: Maybe<StringQueryOperatorInput>;
  certificationInCity?: Maybe<StringQueryOperatorInput>;
  countSchoolsOfTotal?: Maybe<StringQueryOperatorInput>;
  coursesIndexHeading?: Maybe<StringQueryOperatorInput>;
  englishTestCardText?: Maybe<StringQueryOperatorInput>;
  notFoundTextHeading?: Maybe<StringQueryOperatorInput>;
  placeholderLocation?: Maybe<StringQueryOperatorInput>;
  seo_exercises_title?: Maybe<StringQueryOperatorInput>;
  exercisesDividerText?: Maybe<StringQueryOperatorInput>;
  noEventsIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderEventType?: Maybe<StringQueryOperatorInput>;
  seo_blog_description?: Maybe<StringQueryOperatorInput>;
  seo_promotions_title?: Maybe<StringQueryOperatorInput>;
  exercisesIndexHeading?: Maybe<StringQueryOperatorInput>;
  noCareersIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderSchoolType?: Maybe<StringQueryOperatorInput>;
  certificationsCardText?: Maybe<StringQueryOperatorInput>;
  defaultSchoolsMapTitle?: Maybe<StringQueryOperatorInput>;
  promotionsIndexHeading?: Maybe<StringQueryOperatorInput>;
  seo_englishTests_title?: Maybe<StringQueryOperatorInput>;
  seo_events_description?: Maybe<StringQueryOperatorInput>;
  coursesIndexDescription?: Maybe<StringQueryOperatorInput>;
  noExercisesIndexHeading?: Maybe<StringQueryOperatorInput>;
  notFoundTextDescription?: Maybe<StringQueryOperatorInput>;
  seo_careers_description?: Maybe<StringQueryOperatorInput>;
  seo_courses_description?: Maybe<StringQueryOperatorInput>;
  seo_schools_description?: Maybe<StringQueryOperatorInput>;
  termsAndConditionsTitle?: Maybe<StringQueryOperatorInput>;
  englishTestsIndexHeading?: Maybe<StringQueryOperatorInput>;
  noEventsIndexDescription?: Maybe<StringQueryOperatorInput>;
  noPromotionsIndexHeading?: Maybe<StringQueryOperatorInput>;
  notFoundReturnButtonText?: Maybe<StringQueryOperatorInput>;
  seo_certifications_title?: Maybe<StringQueryOperatorInput>;
  certificationIndexHeading?: Maybe<StringQueryOperatorInput>;
  seo_exercises_description?: Maybe<StringQueryOperatorInput>;
  noEnglishTestsIndexHeading?: Maybe<StringQueryOperatorInput>;
  promotionsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_promotions_description?: Maybe<StringQueryOperatorInput>;
  termsAndConditionsLinkText?: Maybe<StringQueryOperatorInput>;
  noCertificationsIndexHeading?: Maybe<StringQueryOperatorInput>;
  noPromotionsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_englishTests_description?: Maybe<StringQueryOperatorInput>;
  certificationIndexDescription?: Maybe<StringQueryOperatorInput>;
  noEnglishTestsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_certifications_description?: Maybe<StringQueryOperatorInput>;
  noCertificationsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_certification_city_description?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  domainName?: Maybe<StringQueryOperatorInput>;
  countryCode?: Maybe<StringQueryOperatorInput>;
  globalScripts?: Maybe<SitePageContextWebsiteGlobalScriptsFilterListInput>;
  settings?: Maybe<SitePageContextWebsiteSettingsFilterInput>;
  websiteLocales?: Maybe<SitePageContextWebsiteWebsiteLocalesFilterListInput>;
  defaultWebsiteLocale?: Maybe<SitePageContextWebsiteDefaultWebsiteLocaleFilterInput>;
};

export type SitePageContextWebsiteGlobalScripts = {
  __typename?: 'SitePageContextWebsiteGlobalScripts';
  name?: Maybe<Scalars['String']>;
  loadInHead?: Maybe<Scalars['Boolean']>;
  html?: Maybe<Scalars['String']>;
  load_defer?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteGlobalScriptsFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  loadInHead?: Maybe<BooleanQueryOperatorInput>;
  html?: Maybe<StringQueryOperatorInput>;
  load_defer?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteGlobalScriptsFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteGlobalScriptsFilterInput>;
};

export type SitePageContextWebsiteLocale = {
  __typename?: 'SitePageContextWebsiteLocale';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  navigation?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleNavigation>>>;
  topBarCta?: Maybe<SitePageContextWebsiteLocaleTopBarCta>;
  footerLeftLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleFooterLeftLinks>>>;
  footerRightLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleFooterRightLinks>>>;
  legalLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleLegalLinks>>>;
  socialLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleSocialLinks>>>;
  footerCta?: Maybe<SitePageContextWebsiteLocaleFooterCta>;
  hasExternalBlog?: Maybe<Scalars['Boolean']>;
  externalBlogText?: Maybe<Scalars['String']>;
  externalBlogUrl?: Maybe<Scalars['String']>;
  translations?: Maybe<SitePageContextWebsiteLocaleTranslations>;
  pathPrefixes?: Maybe<SitePageContextWebsiteLocalePathPrefixes>;
  footerMetaInfo?: Maybe<Scalars['String']>;
  hasRightToLeftLanguage?: Maybe<Scalars['Boolean']>;
  careersCta?: Maybe<SitePageContextWebsiteLocaleCareersCta>;
  telephone?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleCareersCta = {
  __typename?: 'SitePageContextWebsiteLocaleCareersCta';
  id?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleCareersCtaFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  languageCode?: Maybe<StringQueryOperatorInput>;
  navigation?: Maybe<SitePageContextWebsiteLocaleNavigationFilterListInput>;
  topBarCta?: Maybe<SitePageContextWebsiteLocaleTopBarCtaFilterInput>;
  footerLeftLinks?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksFilterListInput>;
  footerRightLinks?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksFilterListInput>;
  legalLinks?: Maybe<SitePageContextWebsiteLocaleLegalLinksFilterListInput>;
  socialLinks?: Maybe<SitePageContextWebsiteLocaleSocialLinksFilterListInput>;
  footerCta?: Maybe<SitePageContextWebsiteLocaleFooterCtaFilterInput>;
  hasExternalBlog?: Maybe<BooleanQueryOperatorInput>;
  externalBlogText?: Maybe<StringQueryOperatorInput>;
  externalBlogUrl?: Maybe<StringQueryOperatorInput>;
  translations?: Maybe<SitePageContextWebsiteLocaleTranslationsFilterInput>;
  pathPrefixes?: Maybe<SitePageContextWebsiteLocalePathPrefixesFilterInput>;
  footerMetaInfo?: Maybe<StringQueryOperatorInput>;
  hasRightToLeftLanguage?: Maybe<BooleanQueryOperatorInput>;
  careersCta?: Maybe<SitePageContextWebsiteLocaleCareersCtaFilterInput>;
  telephone?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterCta = {
  __typename?: 'SitePageContextWebsiteLocaleFooterCta';
  title?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  element_id?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterCtaFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  script?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  element_id?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinks = {
  __typename?: 'SitePageContextWebsiteLocaleFooterLeftLinks';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleFooterLeftLinksChildLinks>>>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksChildLinks = {
  __typename?: 'SitePageContextWebsiteLocaleFooterLeftLinksChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteLocaleFooterLeftLinksChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksChildLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksChildLinksPage = {
  __typename?: 'SitePageContextWebsiteLocaleFooterLeftLinksChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksChildLinksFilterListInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksLink = {
  __typename?: 'SitePageContextWebsiteLocaleFooterLeftLinksLink';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteLocaleFooterLeftLinksLinkIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksLinkFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterLeftLinksLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksLinkPage = {
  __typename?: 'SitePageContextWebsiteLocaleFooterLeftLinksLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterLeftLinksLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinks = {
  __typename?: 'SitePageContextWebsiteLocaleFooterRightLinks';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleFooterRightLinksChildLinks>>>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksChildLinks = {
  __typename?: 'SitePageContextWebsiteLocaleFooterRightLinksChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteLocaleFooterRightLinksChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksChildLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksChildLinksPage = {
  __typename?: 'SitePageContextWebsiteLocaleFooterRightLinksChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksChildLinksFilterListInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksLink = {
  __typename?: 'SitePageContextWebsiteLocaleFooterRightLinksLink';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteLocaleFooterRightLinksLinkIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksLinkFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteLocaleFooterRightLinksLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksLinkPage = {
  __typename?: 'SitePageContextWebsiteLocaleFooterRightLinksLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleFooterRightLinksLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleLegalLinks = {
  __typename?: 'SitePageContextWebsiteLocaleLegalLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteLocaleLegalLinksFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleLegalLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleLegalLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleNavigation = {
  __typename?: 'SitePageContextWebsiteLocaleNavigation';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteLocaleNavigationLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteLocaleNavigationChildLinks>>>;
};

export type SitePageContextWebsiteLocaleNavigationChildLinks = {
  __typename?: 'SitePageContextWebsiteLocaleNavigationChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteLocaleNavigationChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteLocaleNavigationChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleNavigationChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteLocaleNavigationChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleNavigationChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleNavigationChildLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleNavigationChildLinksPage = {
  __typename?: 'SitePageContextWebsiteLocaleNavigationChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleNavigationChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleNavigationFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteLocaleNavigationLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteLocaleNavigationChildLinksFilterListInput>;
};

export type SitePageContextWebsiteLocaleNavigationFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleNavigationFilterInput>;
};

export type SitePageContextWebsiteLocaleNavigationLink = {
  __typename?: 'SitePageContextWebsiteLocaleNavigationLink';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteLocaleNavigationLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteLocaleNavigationLinkFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteLocaleNavigationLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleNavigationLinkPage = {
  __typename?: 'SitePageContextWebsiteLocaleNavigationLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleNavigationLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocalePathPrefixes = {
  __typename?: 'SitePageContextWebsiteLocalePathPrefixes';
  blog?: Maybe<Scalars['String']>;
  root?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  careers?: Maybe<Scalars['String']>;
  courses?: Maybe<Scalars['String']>;
  schools?: Maybe<Scalars['String']>;
  exercises?: Maybe<Scalars['String']>;
  promotions?: Maybe<Scalars['String']>;
  english_tests?: Maybe<Scalars['String']>;
  certifications?: Maybe<Scalars['String']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocalePathPrefixesFilterInput = {
  blog?: Maybe<StringQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  cities?: Maybe<StringQueryOperatorInput>;
  events?: Maybe<StringQueryOperatorInput>;
  careers?: Maybe<StringQueryOperatorInput>;
  courses?: Maybe<StringQueryOperatorInput>;
  schools?: Maybe<StringQueryOperatorInput>;
  exercises?: Maybe<StringQueryOperatorInput>;
  promotions?: Maybe<StringQueryOperatorInput>;
  english_tests?: Maybe<StringQueryOperatorInput>;
  certifications?: Maybe<StringQueryOperatorInput>;
  terms_and_conditions?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleSocialLinks = {
  __typename?: 'SitePageContextWebsiteLocaleSocialLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteLocaleSocialLinksFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleSocialLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteLocaleSocialLinksFilterInput>;
};

export type SitePageContextWebsiteLocaleTopBarCta = {
  __typename?: 'SitePageContextWebsiteLocaleTopBarCta';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteLocaleTopBarCtaIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleTopBarCtaFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteLocaleTranslations = {
  __typename?: 'SitePageContextWebsiteLocaleTranslations';
  loadMore?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  schoolsIn?: Maybe<Scalars['String']>;
  schoolsOf?: Maybe<Scalars['String']>;
  updatedText?: Maybe<Scalars['String']>;
  blogCardText?: Maybe<Scalars['String']>;
  searchButton?: Maybe<Scalars['String']>;
  careersAtText?: Maybe<Scalars['String']>;
  flagOfCountry?: Maybe<Scalars['String']>;
  categoriesText?: Maybe<Scalars['String']>;
  eventsCardText?: Maybe<Scalars['String']>;
  schoolCardText?: Maybe<Scalars['String']>;
  seo_blog_title?: Maybe<Scalars['String']>;
  blogDividerText?: Maybe<Scalars['String']>;
  careersCardText?: Maybe<Scalars['String']>;
  coursesCardText?: Maybe<Scalars['String']>;
  promotionsAtText?: Maybe<Scalars['String']>;
  seo_events_title?: Maybe<Scalars['String']>;
  courseHeadingText?: Maybe<Scalars['String']>;
  eventsDividerText?: Maybe<Scalars['String']>;
  exercisesCardText?: Maybe<Scalars['String']>;
  searchPlaceholder?: Maybe<Scalars['String']>;
  seo_careers_title?: Maybe<Scalars['String']>;
  seo_courses_title?: Maybe<Scalars['String']>;
  seo_schools_title?: Maybe<Scalars['String']>;
  eventsIndexHeading?: Maybe<Scalars['String']>;
  placeholderJobType?: Maybe<Scalars['String']>;
  promotionsCardText?: Maybe<Scalars['String']>;
  totalSchoolsInCity?: Maybe<Scalars['String']>;
  careersIndexHeading?: Maybe<Scalars['String']>;
  certificationInCity?: Maybe<Scalars['String']>;
  countSchoolsOfTotal?: Maybe<Scalars['String']>;
  coursesIndexHeading?: Maybe<Scalars['String']>;
  englishTestCardText?: Maybe<Scalars['String']>;
  notFoundTextHeading?: Maybe<Scalars['String']>;
  placeholderLocation?: Maybe<Scalars['String']>;
  seo_exercises_title?: Maybe<Scalars['String']>;
  exercisesDividerText?: Maybe<Scalars['String']>;
  noEventsIndexHeading?: Maybe<Scalars['String']>;
  placeholderEventType?: Maybe<Scalars['String']>;
  seo_blog_description?: Maybe<Scalars['String']>;
  seo_promotions_title?: Maybe<Scalars['String']>;
  exercisesIndexHeading?: Maybe<Scalars['String']>;
  noCareersIndexHeading?: Maybe<Scalars['String']>;
  placeholderSchoolType?: Maybe<Scalars['String']>;
  certificationsCardText?: Maybe<Scalars['String']>;
  defaultSchoolsMapTitle?: Maybe<Scalars['String']>;
  promotionsIndexHeading?: Maybe<Scalars['String']>;
  seo_englishTests_title?: Maybe<Scalars['String']>;
  seo_events_description?: Maybe<Scalars['String']>;
  coursesIndexDescription?: Maybe<Scalars['String']>;
  noExercisesIndexHeading?: Maybe<Scalars['String']>;
  notFoundTextDescription?: Maybe<Scalars['String']>;
  seo_careers_description?: Maybe<Scalars['String']>;
  seo_courses_description?: Maybe<Scalars['String']>;
  seo_schools_description?: Maybe<Scalars['String']>;
  termsAndConditionsTitle?: Maybe<Scalars['String']>;
  englishTestsIndexHeading?: Maybe<Scalars['String']>;
  noEventsIndexDescription?: Maybe<Scalars['String']>;
  noPromotionsIndexHeading?: Maybe<Scalars['String']>;
  notFoundReturnButtonText?: Maybe<Scalars['String']>;
  seo_certifications_title?: Maybe<Scalars['String']>;
  certificationIndexHeading?: Maybe<Scalars['String']>;
  seo_exercises_description?: Maybe<Scalars['String']>;
  noEnglishTestsIndexHeading?: Maybe<Scalars['String']>;
  promotionsIndexDescription?: Maybe<Scalars['String']>;
  seo_promotions_description?: Maybe<Scalars['String']>;
  termsAndConditionsLinkText?: Maybe<Scalars['String']>;
  noCertificationsIndexHeading?: Maybe<Scalars['String']>;
  noPromotionsIndexDescription?: Maybe<Scalars['String']>;
  seo_englishTests_description?: Maybe<Scalars['String']>;
  certificationIndexDescription?: Maybe<Scalars['String']>;
  noEnglishTestsIndexDescription?: Maybe<Scalars['String']>;
  seo_certifications_description?: Maybe<Scalars['String']>;
  noCertificationsIndexDescription?: Maybe<Scalars['String']>;
  seo_certification_city_description?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteLocaleTranslationsFilterInput = {
  loadMore?: Maybe<StringQueryOperatorInput>;
  copyright?: Maybe<StringQueryOperatorInput>;
  schoolsIn?: Maybe<StringQueryOperatorInput>;
  schoolsOf?: Maybe<StringQueryOperatorInput>;
  updatedText?: Maybe<StringQueryOperatorInput>;
  blogCardText?: Maybe<StringQueryOperatorInput>;
  searchButton?: Maybe<StringQueryOperatorInput>;
  careersAtText?: Maybe<StringQueryOperatorInput>;
  flagOfCountry?: Maybe<StringQueryOperatorInput>;
  categoriesText?: Maybe<StringQueryOperatorInput>;
  eventsCardText?: Maybe<StringQueryOperatorInput>;
  schoolCardText?: Maybe<StringQueryOperatorInput>;
  seo_blog_title?: Maybe<StringQueryOperatorInput>;
  blogDividerText?: Maybe<StringQueryOperatorInput>;
  careersCardText?: Maybe<StringQueryOperatorInput>;
  coursesCardText?: Maybe<StringQueryOperatorInput>;
  promotionsAtText?: Maybe<StringQueryOperatorInput>;
  seo_events_title?: Maybe<StringQueryOperatorInput>;
  courseHeadingText?: Maybe<StringQueryOperatorInput>;
  eventsDividerText?: Maybe<StringQueryOperatorInput>;
  exercisesCardText?: Maybe<StringQueryOperatorInput>;
  searchPlaceholder?: Maybe<StringQueryOperatorInput>;
  seo_careers_title?: Maybe<StringQueryOperatorInput>;
  seo_courses_title?: Maybe<StringQueryOperatorInput>;
  seo_schools_title?: Maybe<StringQueryOperatorInput>;
  eventsIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderJobType?: Maybe<StringQueryOperatorInput>;
  promotionsCardText?: Maybe<StringQueryOperatorInput>;
  totalSchoolsInCity?: Maybe<StringQueryOperatorInput>;
  careersIndexHeading?: Maybe<StringQueryOperatorInput>;
  certificationInCity?: Maybe<StringQueryOperatorInput>;
  countSchoolsOfTotal?: Maybe<StringQueryOperatorInput>;
  coursesIndexHeading?: Maybe<StringQueryOperatorInput>;
  englishTestCardText?: Maybe<StringQueryOperatorInput>;
  notFoundTextHeading?: Maybe<StringQueryOperatorInput>;
  placeholderLocation?: Maybe<StringQueryOperatorInput>;
  seo_exercises_title?: Maybe<StringQueryOperatorInput>;
  exercisesDividerText?: Maybe<StringQueryOperatorInput>;
  noEventsIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderEventType?: Maybe<StringQueryOperatorInput>;
  seo_blog_description?: Maybe<StringQueryOperatorInput>;
  seo_promotions_title?: Maybe<StringQueryOperatorInput>;
  exercisesIndexHeading?: Maybe<StringQueryOperatorInput>;
  noCareersIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderSchoolType?: Maybe<StringQueryOperatorInput>;
  certificationsCardText?: Maybe<StringQueryOperatorInput>;
  defaultSchoolsMapTitle?: Maybe<StringQueryOperatorInput>;
  promotionsIndexHeading?: Maybe<StringQueryOperatorInput>;
  seo_englishTests_title?: Maybe<StringQueryOperatorInput>;
  seo_events_description?: Maybe<StringQueryOperatorInput>;
  coursesIndexDescription?: Maybe<StringQueryOperatorInput>;
  noExercisesIndexHeading?: Maybe<StringQueryOperatorInput>;
  notFoundTextDescription?: Maybe<StringQueryOperatorInput>;
  seo_careers_description?: Maybe<StringQueryOperatorInput>;
  seo_courses_description?: Maybe<StringQueryOperatorInput>;
  seo_schools_description?: Maybe<StringQueryOperatorInput>;
  termsAndConditionsTitle?: Maybe<StringQueryOperatorInput>;
  englishTestsIndexHeading?: Maybe<StringQueryOperatorInput>;
  noEventsIndexDescription?: Maybe<StringQueryOperatorInput>;
  noPromotionsIndexHeading?: Maybe<StringQueryOperatorInput>;
  notFoundReturnButtonText?: Maybe<StringQueryOperatorInput>;
  seo_certifications_title?: Maybe<StringQueryOperatorInput>;
  certificationIndexHeading?: Maybe<StringQueryOperatorInput>;
  seo_exercises_description?: Maybe<StringQueryOperatorInput>;
  noEnglishTestsIndexHeading?: Maybe<StringQueryOperatorInput>;
  promotionsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_promotions_description?: Maybe<StringQueryOperatorInput>;
  termsAndConditionsLinkText?: Maybe<StringQueryOperatorInput>;
  noCertificationsIndexHeading?: Maybe<StringQueryOperatorInput>;
  noPromotionsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_englishTests_description?: Maybe<StringQueryOperatorInput>;
  certificationIndexDescription?: Maybe<StringQueryOperatorInput>;
  noEnglishTestsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_certifications_description?: Maybe<StringQueryOperatorInput>;
  noCertificationsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_certification_city_description?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteSettings = {
  __typename?: 'SitePageContextWebsiteSettings';
  isInternationalSite?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteSettingsFilterInput = {
  isInternationalSite?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocales = {
  __typename?: 'SitePageContextWebsiteWebsiteLocales';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  navigation?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesNavigation>>>;
  topBarCta?: Maybe<SitePageContextWebsiteWebsiteLocalesTopBarCta>;
  footerLeftLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinks>>>;
  footerRightLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinks>>>;
  legalLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesLegalLinks>>>;
  socialLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesSocialLinks>>>;
  footerCta?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterCta>;
  hasExternalBlog?: Maybe<Scalars['Boolean']>;
  externalBlogText?: Maybe<Scalars['String']>;
  externalBlogUrl?: Maybe<Scalars['String']>;
  translations?: Maybe<SitePageContextWebsiteWebsiteLocalesTranslations>;
  pathPrefixes?: Maybe<SitePageContextWebsiteWebsiteLocalesPathPrefixes>;
  footerMetaInfo?: Maybe<Scalars['String']>;
  hasRightToLeftLanguage?: Maybe<Scalars['Boolean']>;
  careersCta?: Maybe<SitePageContextWebsiteWebsiteLocalesCareersCta>;
  telephone?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesCareersCta = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesCareersCta';
  id?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesCareersCtaFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  languageCode?: Maybe<StringQueryOperatorInput>;
  navigation?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationFilterListInput>;
  topBarCta?: Maybe<SitePageContextWebsiteWebsiteLocalesTopBarCtaFilterInput>;
  footerLeftLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksFilterListInput>;
  footerRightLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksFilterListInput>;
  legalLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesLegalLinksFilterListInput>;
  socialLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesSocialLinksFilterListInput>;
  footerCta?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterCtaFilterInput>;
  hasExternalBlog?: Maybe<BooleanQueryOperatorInput>;
  externalBlogText?: Maybe<StringQueryOperatorInput>;
  externalBlogUrl?: Maybe<StringQueryOperatorInput>;
  translations?: Maybe<SitePageContextWebsiteWebsiteLocalesTranslationsFilterInput>;
  pathPrefixes?: Maybe<SitePageContextWebsiteWebsiteLocalesPathPrefixesFilterInput>;
  footerMetaInfo?: Maybe<StringQueryOperatorInput>;
  hasRightToLeftLanguage?: Maybe<BooleanQueryOperatorInput>;
  careersCta?: Maybe<SitePageContextWebsiteWebsiteLocalesCareersCtaFilterInput>;
  telephone?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterCta = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterCta';
  title?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  element_id?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterCtaFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  script?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  element_id?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterLeftLinks';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinks>>>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksPage = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksChildLinksFilterListInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLink = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLink';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkPage = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterLeftLinksLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterRightLinks';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinks>>>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksPage = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksChildLinksFilterListInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksLink = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterRightLinksLink';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkPage = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesFooterRightLinksLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesLegalLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesLegalLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteWebsiteLocalesLegalLinksFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesLegalLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesLegalLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigation = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesNavigation';
  title?: Maybe<Scalars['String']>;
  link?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationLink>;
  childLinks?: Maybe<Array<Maybe<SitePageContextWebsiteWebsiteLocalesNavigationChildLinks>>>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationChildLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesNavigationChildLinks';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationChildLinksPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteWebsiteLocalesNavigationChildLinksIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationChildLinksFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationChildLinksPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationChildLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationChildLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationChildLinksPage = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesNavigationChildLinksPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationChildLinksPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  link?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationLinkFilterInput>;
  childLinks?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationChildLinksFilterListInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationLink = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesNavigationLink';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationLinkPage>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationLinkFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  page?: Maybe<SitePageContextWebsiteWebsiteLocalesNavigationLinkPageFilterInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationLinkPage = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesNavigationLinkPage';
  slug?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesNavigationLinkPageFilterInput = {
  slug?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesPathPrefixes = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesPathPrefixes';
  blog?: Maybe<Scalars['String']>;
  root?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  careers?: Maybe<Scalars['String']>;
  courses?: Maybe<Scalars['String']>;
  schools?: Maybe<Scalars['String']>;
  exercises?: Maybe<Scalars['String']>;
  promotions?: Maybe<Scalars['String']>;
  english_tests?: Maybe<Scalars['String']>;
  certifications?: Maybe<Scalars['String']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesPathPrefixesFilterInput = {
  blog?: Maybe<StringQueryOperatorInput>;
  root?: Maybe<StringQueryOperatorInput>;
  cities?: Maybe<StringQueryOperatorInput>;
  events?: Maybe<StringQueryOperatorInput>;
  careers?: Maybe<StringQueryOperatorInput>;
  courses?: Maybe<StringQueryOperatorInput>;
  schools?: Maybe<StringQueryOperatorInput>;
  exercises?: Maybe<StringQueryOperatorInput>;
  promotions?: Maybe<StringQueryOperatorInput>;
  english_tests?: Maybe<StringQueryOperatorInput>;
  certifications?: Maybe<StringQueryOperatorInput>;
  terms_and_conditions?: Maybe<StringQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesSocialLinks = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesSocialLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type SitePageContextWebsiteWebsiteLocalesSocialLinksFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesSocialLinksFilterListInput = {
  elemMatch?: Maybe<SitePageContextWebsiteWebsiteLocalesSocialLinksFilterInput>;
};

export type SitePageContextWebsiteWebsiteLocalesTopBarCta = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesTopBarCta';
  id?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};


export type SitePageContextWebsiteWebsiteLocalesTopBarCtaIdArgs = {
  formatString?: Maybe<Scalars['String']>;
  fromNow?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesTopBarCtaFilterInput = {
  id?: Maybe<DateQueryOperatorInput>;
  title?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  openInNewWindow?: Maybe<BooleanQueryOperatorInput>;
  nofollow?: Maybe<BooleanQueryOperatorInput>;
};

export type SitePageContextWebsiteWebsiteLocalesTranslations = {
  __typename?: 'SitePageContextWebsiteWebsiteLocalesTranslations';
  loadMore?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  schoolsIn?: Maybe<Scalars['String']>;
  schoolsOf?: Maybe<Scalars['String']>;
  updatedText?: Maybe<Scalars['String']>;
  blogCardText?: Maybe<Scalars['String']>;
  searchButton?: Maybe<Scalars['String']>;
  careersAtText?: Maybe<Scalars['String']>;
  flagOfCountry?: Maybe<Scalars['String']>;
  categoriesText?: Maybe<Scalars['String']>;
  eventsCardText?: Maybe<Scalars['String']>;
  schoolCardText?: Maybe<Scalars['String']>;
  seo_blog_title?: Maybe<Scalars['String']>;
  blogDividerText?: Maybe<Scalars['String']>;
  careersCardText?: Maybe<Scalars['String']>;
  coursesCardText?: Maybe<Scalars['String']>;
  promotionsAtText?: Maybe<Scalars['String']>;
  seo_events_title?: Maybe<Scalars['String']>;
  courseHeadingText?: Maybe<Scalars['String']>;
  eventsDividerText?: Maybe<Scalars['String']>;
  exercisesCardText?: Maybe<Scalars['String']>;
  searchPlaceholder?: Maybe<Scalars['String']>;
  seo_careers_title?: Maybe<Scalars['String']>;
  seo_courses_title?: Maybe<Scalars['String']>;
  seo_schools_title?: Maybe<Scalars['String']>;
  eventsIndexHeading?: Maybe<Scalars['String']>;
  placeholderJobType?: Maybe<Scalars['String']>;
  promotionsCardText?: Maybe<Scalars['String']>;
  totalSchoolsInCity?: Maybe<Scalars['String']>;
  careersIndexHeading?: Maybe<Scalars['String']>;
  certificationInCity?: Maybe<Scalars['String']>;
  countSchoolsOfTotal?: Maybe<Scalars['String']>;
  coursesIndexHeading?: Maybe<Scalars['String']>;
  englishTestCardText?: Maybe<Scalars['String']>;
  notFoundTextHeading?: Maybe<Scalars['String']>;
  placeholderLocation?: Maybe<Scalars['String']>;
  seo_exercises_title?: Maybe<Scalars['String']>;
  exercisesDividerText?: Maybe<Scalars['String']>;
  noEventsIndexHeading?: Maybe<Scalars['String']>;
  placeholderEventType?: Maybe<Scalars['String']>;
  seo_blog_description?: Maybe<Scalars['String']>;
  seo_promotions_title?: Maybe<Scalars['String']>;
  exercisesIndexHeading?: Maybe<Scalars['String']>;
  noCareersIndexHeading?: Maybe<Scalars['String']>;
  placeholderSchoolType?: Maybe<Scalars['String']>;
  certificationsCardText?: Maybe<Scalars['String']>;
  defaultSchoolsMapTitle?: Maybe<Scalars['String']>;
  promotionsIndexHeading?: Maybe<Scalars['String']>;
  seo_englishTests_title?: Maybe<Scalars['String']>;
  seo_events_description?: Maybe<Scalars['String']>;
  coursesIndexDescription?: Maybe<Scalars['String']>;
  noExercisesIndexHeading?: Maybe<Scalars['String']>;
  notFoundTextDescription?: Maybe<Scalars['String']>;
  seo_careers_description?: Maybe<Scalars['String']>;
  seo_courses_description?: Maybe<Scalars['String']>;
  seo_schools_description?: Maybe<Scalars['String']>;
  termsAndConditionsTitle?: Maybe<Scalars['String']>;
  englishTestsIndexHeading?: Maybe<Scalars['String']>;
  noEventsIndexDescription?: Maybe<Scalars['String']>;
  noPromotionsIndexHeading?: Maybe<Scalars['String']>;
  notFoundReturnButtonText?: Maybe<Scalars['String']>;
  seo_certifications_title?: Maybe<Scalars['String']>;
  certificationIndexHeading?: Maybe<Scalars['String']>;
  seo_exercises_description?: Maybe<Scalars['String']>;
  noEnglishTestsIndexHeading?: Maybe<Scalars['String']>;
  promotionsIndexDescription?: Maybe<Scalars['String']>;
  seo_promotions_description?: Maybe<Scalars['String']>;
  termsAndConditionsLinkText?: Maybe<Scalars['String']>;
  noCertificationsIndexHeading?: Maybe<Scalars['String']>;
  noPromotionsIndexDescription?: Maybe<Scalars['String']>;
  seo_englishTests_description?: Maybe<Scalars['String']>;
  certificationIndexDescription?: Maybe<Scalars['String']>;
  noEnglishTestsIndexDescription?: Maybe<Scalars['String']>;
  seo_certifications_description?: Maybe<Scalars['String']>;
  noCertificationsIndexDescription?: Maybe<Scalars['String']>;
  seo_certification_city_description?: Maybe<Scalars['String']>;
};

export type SitePageContextWebsiteWebsiteLocalesTranslationsFilterInput = {
  loadMore?: Maybe<StringQueryOperatorInput>;
  copyright?: Maybe<StringQueryOperatorInput>;
  schoolsIn?: Maybe<StringQueryOperatorInput>;
  schoolsOf?: Maybe<StringQueryOperatorInput>;
  updatedText?: Maybe<StringQueryOperatorInput>;
  blogCardText?: Maybe<StringQueryOperatorInput>;
  searchButton?: Maybe<StringQueryOperatorInput>;
  careersAtText?: Maybe<StringQueryOperatorInput>;
  flagOfCountry?: Maybe<StringQueryOperatorInput>;
  categoriesText?: Maybe<StringQueryOperatorInput>;
  eventsCardText?: Maybe<StringQueryOperatorInput>;
  schoolCardText?: Maybe<StringQueryOperatorInput>;
  seo_blog_title?: Maybe<StringQueryOperatorInput>;
  blogDividerText?: Maybe<StringQueryOperatorInput>;
  careersCardText?: Maybe<StringQueryOperatorInput>;
  coursesCardText?: Maybe<StringQueryOperatorInput>;
  promotionsAtText?: Maybe<StringQueryOperatorInput>;
  seo_events_title?: Maybe<StringQueryOperatorInput>;
  courseHeadingText?: Maybe<StringQueryOperatorInput>;
  eventsDividerText?: Maybe<StringQueryOperatorInput>;
  exercisesCardText?: Maybe<StringQueryOperatorInput>;
  searchPlaceholder?: Maybe<StringQueryOperatorInput>;
  seo_careers_title?: Maybe<StringQueryOperatorInput>;
  seo_courses_title?: Maybe<StringQueryOperatorInput>;
  seo_schools_title?: Maybe<StringQueryOperatorInput>;
  eventsIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderJobType?: Maybe<StringQueryOperatorInput>;
  promotionsCardText?: Maybe<StringQueryOperatorInput>;
  totalSchoolsInCity?: Maybe<StringQueryOperatorInput>;
  careersIndexHeading?: Maybe<StringQueryOperatorInput>;
  certificationInCity?: Maybe<StringQueryOperatorInput>;
  countSchoolsOfTotal?: Maybe<StringQueryOperatorInput>;
  coursesIndexHeading?: Maybe<StringQueryOperatorInput>;
  englishTestCardText?: Maybe<StringQueryOperatorInput>;
  notFoundTextHeading?: Maybe<StringQueryOperatorInput>;
  placeholderLocation?: Maybe<StringQueryOperatorInput>;
  seo_exercises_title?: Maybe<StringQueryOperatorInput>;
  exercisesDividerText?: Maybe<StringQueryOperatorInput>;
  noEventsIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderEventType?: Maybe<StringQueryOperatorInput>;
  seo_blog_description?: Maybe<StringQueryOperatorInput>;
  seo_promotions_title?: Maybe<StringQueryOperatorInput>;
  exercisesIndexHeading?: Maybe<StringQueryOperatorInput>;
  noCareersIndexHeading?: Maybe<StringQueryOperatorInput>;
  placeholderSchoolType?: Maybe<StringQueryOperatorInput>;
  certificationsCardText?: Maybe<StringQueryOperatorInput>;
  defaultSchoolsMapTitle?: Maybe<StringQueryOperatorInput>;
  promotionsIndexHeading?: Maybe<StringQueryOperatorInput>;
  seo_englishTests_title?: Maybe<StringQueryOperatorInput>;
  seo_events_description?: Maybe<StringQueryOperatorInput>;
  coursesIndexDescription?: Maybe<StringQueryOperatorInput>;
  noExercisesIndexHeading?: Maybe<StringQueryOperatorInput>;
  notFoundTextDescription?: Maybe<StringQueryOperatorInput>;
  seo_careers_description?: Maybe<StringQueryOperatorInput>;
  seo_courses_description?: Maybe<StringQueryOperatorInput>;
  seo_schools_description?: Maybe<StringQueryOperatorInput>;
  termsAndConditionsTitle?: Maybe<StringQueryOperatorInput>;
  englishTestsIndexHeading?: Maybe<StringQueryOperatorInput>;
  noEventsIndexDescription?: Maybe<StringQueryOperatorInput>;
  noPromotionsIndexHeading?: Maybe<StringQueryOperatorInput>;
  notFoundReturnButtonText?: Maybe<StringQueryOperatorInput>;
  seo_certifications_title?: Maybe<StringQueryOperatorInput>;
  certificationIndexHeading?: Maybe<StringQueryOperatorInput>;
  seo_exercises_description?: Maybe<StringQueryOperatorInput>;
  noEnglishTestsIndexHeading?: Maybe<StringQueryOperatorInput>;
  promotionsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_promotions_description?: Maybe<StringQueryOperatorInput>;
  termsAndConditionsLinkText?: Maybe<StringQueryOperatorInput>;
  noCertificationsIndexHeading?: Maybe<StringQueryOperatorInput>;
  noPromotionsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_englishTests_description?: Maybe<StringQueryOperatorInput>;
  certificationIndexDescription?: Maybe<StringQueryOperatorInput>;
  noEnglishTestsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_certifications_description?: Maybe<StringQueryOperatorInput>;
  noCertificationsIndexDescription?: Maybe<StringQueryOperatorInput>;
  seo_certification_city_description?: Maybe<StringQueryOperatorInput>;
};

export type SitePageEdge = {
  __typename?: 'SitePageEdge';
  next?: Maybe<SitePage>;
  node: SitePage;
  previous?: Maybe<SitePage>;
};

export enum SitePageFieldsEnum {
  path = 'path',
  component = 'component',
  internalComponentName = 'internalComponentName',
  componentChunkName = 'componentChunkName',
  matchPath = 'matchPath',
  isCreatedByStatefulCreatePages = 'isCreatedByStatefulCreatePages',
  context___breadcrumb___location = 'context___breadcrumb___location',
  context___breadcrumb___crumbs = 'context___breadcrumb___crumbs',
  context___breadcrumb___crumbs___pathname = 'context___breadcrumb___crumbs___pathname',
  context___breadcrumb___crumbs___crumbLabel = 'context___breadcrumb___crumbs___crumbLabel',
  context___globalScripts = 'context___globalScripts',
  context___globalScripts___name = 'context___globalScripts___name',
  context___globalScripts___loadInHead = 'context___globalScripts___loadInHead',
  context___globalScripts___scripts = 'context___globalScripts___scripts',
  context___globalScripts___scripts___innerHTML = 'context___globalScripts___scripts___innerHTML',
  context___globalScripts___noscripts = 'context___globalScripts___noscripts',
  context___website___id = 'context___website___id',
  context___website___domainName = 'context___website___domainName',
  context___website___countryCode = 'context___website___countryCode',
  context___website___globalScripts = 'context___website___globalScripts',
  context___website___globalScripts___name = 'context___website___globalScripts___name',
  context___website___globalScripts___loadInHead = 'context___website___globalScripts___loadInHead',
  context___website___globalScripts___html = 'context___website___globalScripts___html',
  context___website___settings___isInternationalSite = 'context___website___settings___isInternationalSite',
  context___website___websiteLocales = 'context___website___websiteLocales',
  context___website___websiteLocales___id = 'context___website___websiteLocales___id',
  context___website___websiteLocales___name = 'context___website___websiteLocales___name',
  context___website___websiteLocales___languageCode = 'context___website___websiteLocales___languageCode',
  context___website___websiteLocales___navigation = 'context___website___websiteLocales___navigation',
  context___website___websiteLocales___footerLeftLinks = 'context___website___websiteLocales___footerLeftLinks',
  context___website___websiteLocales___footerRightLinks = 'context___website___websiteLocales___footerRightLinks',
  context___website___websiteLocales___legalLinks = 'context___website___websiteLocales___legalLinks',
  context___website___websiteLocales___socialLinks = 'context___website___websiteLocales___socialLinks',
  context___website___websiteLocales___hasExternalBlog = 'context___website___websiteLocales___hasExternalBlog',
  context___website___websiteLocales___externalBlogText = 'context___website___websiteLocales___externalBlogText',
  context___website___websiteLocales___externalBlogUrl = 'context___website___websiteLocales___externalBlogUrl',
  context___website___websiteLocales___footerMetaInfo = 'context___website___websiteLocales___footerMetaInfo',
  context___website___websiteLocales___hasRightToLeftLanguage = 'context___website___websiteLocales___hasRightToLeftLanguage',
  context___website___websiteLocales___telephone = 'context___website___websiteLocales___telephone',
  context___website___defaultWebsiteLocale___id = 'context___website___defaultWebsiteLocale___id',
  context___website___defaultWebsiteLocale___name = 'context___website___defaultWebsiteLocale___name',
  context___website___defaultWebsiteLocale___languageCode = 'context___website___defaultWebsiteLocale___languageCode',
  context___website___defaultWebsiteLocale___navigation = 'context___website___defaultWebsiteLocale___navigation',
  context___website___defaultWebsiteLocale___footerLeftLinks = 'context___website___defaultWebsiteLocale___footerLeftLinks',
  context___website___defaultWebsiteLocale___footerRightLinks = 'context___website___defaultWebsiteLocale___footerRightLinks',
  context___website___defaultWebsiteLocale___legalLinks = 'context___website___defaultWebsiteLocale___legalLinks',
  context___website___defaultWebsiteLocale___socialLinks = 'context___website___defaultWebsiteLocale___socialLinks',
  context___website___defaultWebsiteLocale___hasExternalBlog = 'context___website___defaultWebsiteLocale___hasExternalBlog',
  context___website___defaultWebsiteLocale___externalBlogText = 'context___website___defaultWebsiteLocale___externalBlogText',
  context___website___defaultWebsiteLocale___externalBlogUrl = 'context___website___defaultWebsiteLocale___externalBlogUrl',
  context___website___defaultWebsiteLocale___footerMetaInfo = 'context___website___defaultWebsiteLocale___footerMetaInfo',
  context___website___defaultWebsiteLocale___hasRightToLeftLanguage = 'context___website___defaultWebsiteLocale___hasRightToLeftLanguage',
  context___website___defaultWebsiteLocale___telephone = 'context___website___defaultWebsiteLocale___telephone',
  context___websiteId = 'context___websiteId',
  context___websiteLocale___id = 'context___websiteLocale___id',
  context___websiteLocale___name = 'context___websiteLocale___name',
  context___websiteLocale___languageCode = 'context___websiteLocale___languageCode',
  context___websiteLocale___navigation = 'context___websiteLocale___navigation',
  context___websiteLocale___navigation___title = 'context___websiteLocale___navigation___title',
  context___websiteLocale___navigation___childLinks = 'context___websiteLocale___navigation___childLinks',
  context___websiteLocale___topBarCta___id = 'context___websiteLocale___topBarCta___id',
  context___websiteLocale___topBarCta___title = 'context___websiteLocale___topBarCta___title',
  context___websiteLocale___topBarCta___url = 'context___websiteLocale___topBarCta___url',
  context___websiteLocale___topBarCta___openInNewWindow = 'context___websiteLocale___topBarCta___openInNewWindow',
  context___websiteLocale___topBarCta___nofollow = 'context___websiteLocale___topBarCta___nofollow',
  context___websiteLocale___footerLeftLinks = 'context___websiteLocale___footerLeftLinks',
  context___websiteLocale___footerLeftLinks___title = 'context___websiteLocale___footerLeftLinks___title',
  context___websiteLocale___footerLeftLinks___childLinks = 'context___websiteLocale___footerLeftLinks___childLinks',
  context___websiteLocale___footerRightLinks = 'context___websiteLocale___footerRightLinks',
  context___websiteLocale___footerRightLinks___title = 'context___websiteLocale___footerRightLinks___title',
  context___websiteLocale___footerRightLinks___childLinks = 'context___websiteLocale___footerRightLinks___childLinks',
  context___websiteLocale___legalLinks = 'context___websiteLocale___legalLinks',
  context___websiteLocale___legalLinks___id = 'context___websiteLocale___legalLinks___id',
  context___websiteLocale___legalLinks___title = 'context___websiteLocale___legalLinks___title',
  context___websiteLocale___legalLinks___url = 'context___websiteLocale___legalLinks___url',
  context___websiteLocale___legalLinks___openInNewWindow = 'context___websiteLocale___legalLinks___openInNewWindow',
  context___websiteLocale___legalLinks___nofollow = 'context___websiteLocale___legalLinks___nofollow',
  context___websiteLocale___socialLinks = 'context___websiteLocale___socialLinks',
  context___websiteLocale___socialLinks___id = 'context___websiteLocale___socialLinks___id',
  context___websiteLocale___socialLinks___title = 'context___websiteLocale___socialLinks___title',
  context___websiteLocale___socialLinks___url = 'context___websiteLocale___socialLinks___url',
  context___websiteLocale___socialLinks___openInNewWindow = 'context___websiteLocale___socialLinks___openInNewWindow',
  context___websiteLocale___socialLinks___nofollow = 'context___websiteLocale___socialLinks___nofollow',
  context___websiteLocale___footerCta___title = 'context___websiteLocale___footerCta___title',
  context___websiteLocale___footerCta___script = 'context___websiteLocale___footerCta___script',
  context___websiteLocale___footerCta___description = 'context___websiteLocale___footerCta___description',
  context___websiteLocale___footerCta___id = 'context___websiteLocale___footerCta___id',
  context___websiteLocale___footerCta___element_id = 'context___websiteLocale___footerCta___element_id',
  context___websiteLocale___hasExternalBlog = 'context___websiteLocale___hasExternalBlog',
  context___websiteLocale___externalBlogText = 'context___websiteLocale___externalBlogText',
  context___websiteLocale___externalBlogUrl = 'context___websiteLocale___externalBlogUrl',
  context___websiteLocale___translations___loadMore = 'context___websiteLocale___translations___loadMore',
  context___websiteLocale___translations___copyright = 'context___websiteLocale___translations___copyright',
  context___websiteLocale___translations___schoolsIn = 'context___websiteLocale___translations___schoolsIn',
  context___websiteLocale___translations___schoolsOf = 'context___websiteLocale___translations___schoolsOf',
  context___websiteLocale___translations___updatedText = 'context___websiteLocale___translations___updatedText',
  context___websiteLocale___translations___blogCardText = 'context___websiteLocale___translations___blogCardText',
  context___websiteLocale___translations___searchButton = 'context___websiteLocale___translations___searchButton',
  context___websiteLocale___translations___careersAtText = 'context___websiteLocale___translations___careersAtText',
  context___websiteLocale___translations___flagOfCountry = 'context___websiteLocale___translations___flagOfCountry',
  context___websiteLocale___translations___categoriesText = 'context___websiteLocale___translations___categoriesText',
  context___websiteLocale___translations___eventsCardText = 'context___websiteLocale___translations___eventsCardText',
  context___websiteLocale___translations___schoolCardText = 'context___websiteLocale___translations___schoolCardText',
  context___websiteLocale___translations___seo_blog_title = 'context___websiteLocale___translations___seo_blog_title',
  context___websiteLocale___translations___blogDividerText = 'context___websiteLocale___translations___blogDividerText',
  context___websiteLocale___translations___careersCardText = 'context___websiteLocale___translations___careersCardText',
  context___websiteLocale___translations___coursesCardText = 'context___websiteLocale___translations___coursesCardText',
  context___websiteLocale___translations___promotionsAtText = 'context___websiteLocale___translations___promotionsAtText',
  context___websiteLocale___translations___seo_events_title = 'context___websiteLocale___translations___seo_events_title',
  context___websiteLocale___translations___courseHeadingText = 'context___websiteLocale___translations___courseHeadingText',
  context___websiteLocale___translations___eventsDividerText = 'context___websiteLocale___translations___eventsDividerText',
  context___websiteLocale___translations___exercisesCardText = 'context___websiteLocale___translations___exercisesCardText',
  context___websiteLocale___translations___searchPlaceholder = 'context___websiteLocale___translations___searchPlaceholder',
  context___websiteLocale___translations___seo_careers_title = 'context___websiteLocale___translations___seo_careers_title',
  context___websiteLocale___translations___seo_courses_title = 'context___websiteLocale___translations___seo_courses_title',
  context___websiteLocale___translations___seo_schools_title = 'context___websiteLocale___translations___seo_schools_title',
  context___websiteLocale___translations___eventsIndexHeading = 'context___websiteLocale___translations___eventsIndexHeading',
  context___websiteLocale___translations___placeholderJobType = 'context___websiteLocale___translations___placeholderJobType',
  context___websiteLocale___translations___promotionsCardText = 'context___websiteLocale___translations___promotionsCardText',
  context___websiteLocale___translations___totalSchoolsInCity = 'context___websiteLocale___translations___totalSchoolsInCity',
  context___websiteLocale___translations___careersIndexHeading = 'context___websiteLocale___translations___careersIndexHeading',
  context___websiteLocale___translations___certificationInCity = 'context___websiteLocale___translations___certificationInCity',
  context___websiteLocale___translations___countSchoolsOfTotal = 'context___websiteLocale___translations___countSchoolsOfTotal',
  context___websiteLocale___translations___coursesIndexHeading = 'context___websiteLocale___translations___coursesIndexHeading',
  context___websiteLocale___translations___englishTestCardText = 'context___websiteLocale___translations___englishTestCardText',
  context___websiteLocale___translations___notFoundTextHeading = 'context___websiteLocale___translations___notFoundTextHeading',
  context___websiteLocale___translations___placeholderLocation = 'context___websiteLocale___translations___placeholderLocation',
  context___websiteLocale___translations___seo_exercises_title = 'context___websiteLocale___translations___seo_exercises_title',
  context___websiteLocale___translations___exercisesDividerText = 'context___websiteLocale___translations___exercisesDividerText',
  context___websiteLocale___translations___noEventsIndexHeading = 'context___websiteLocale___translations___noEventsIndexHeading',
  context___websiteLocale___translations___placeholderEventType = 'context___websiteLocale___translations___placeholderEventType',
  context___websiteLocale___translations___seo_blog_description = 'context___websiteLocale___translations___seo_blog_description',
  context___websiteLocale___translations___seo_promotions_title = 'context___websiteLocale___translations___seo_promotions_title',
  context___websiteLocale___translations___exercisesIndexHeading = 'context___websiteLocale___translations___exercisesIndexHeading',
  context___websiteLocale___translations___noCareersIndexHeading = 'context___websiteLocale___translations___noCareersIndexHeading',
  context___websiteLocale___translations___placeholderSchoolType = 'context___websiteLocale___translations___placeholderSchoolType',
  context___websiteLocale___translations___certificationsCardText = 'context___websiteLocale___translations___certificationsCardText',
  context___websiteLocale___translations___defaultSchoolsMapTitle = 'context___websiteLocale___translations___defaultSchoolsMapTitle',
  context___websiteLocale___translations___promotionsIndexHeading = 'context___websiteLocale___translations___promotionsIndexHeading',
  context___websiteLocale___translations___seo_englishTests_title = 'context___websiteLocale___translations___seo_englishTests_title',
  context___websiteLocale___translations___seo_events_description = 'context___websiteLocale___translations___seo_events_description',
  context___websiteLocale___translations___coursesIndexDescription = 'context___websiteLocale___translations___coursesIndexDescription',
  context___websiteLocale___translations___noExercisesIndexHeading = 'context___websiteLocale___translations___noExercisesIndexHeading',
  context___websiteLocale___translations___notFoundTextDescription = 'context___websiteLocale___translations___notFoundTextDescription',
  context___websiteLocale___translations___seo_careers_description = 'context___websiteLocale___translations___seo_careers_description',
  context___websiteLocale___translations___seo_courses_description = 'context___websiteLocale___translations___seo_courses_description',
  context___websiteLocale___translations___seo_schools_description = 'context___websiteLocale___translations___seo_schools_description',
  context___websiteLocale___translations___termsAndConditionsTitle = 'context___websiteLocale___translations___termsAndConditionsTitle',
  context___websiteLocale___translations___englishTestsIndexHeading = 'context___websiteLocale___translations___englishTestsIndexHeading',
  context___websiteLocale___translations___noEventsIndexDescription = 'context___websiteLocale___translations___noEventsIndexDescription',
  context___websiteLocale___translations___noPromotionsIndexHeading = 'context___websiteLocale___translations___noPromotionsIndexHeading',
  context___websiteLocale___translations___notFoundReturnButtonText = 'context___websiteLocale___translations___notFoundReturnButtonText',
  context___websiteLocale___translations___seo_certifications_title = 'context___websiteLocale___translations___seo_certifications_title',
  context___websiteLocale___translations___certificationIndexHeading = 'context___websiteLocale___translations___certificationIndexHeading',
  context___websiteLocale___translations___seo_exercises_description = 'context___websiteLocale___translations___seo_exercises_description',
  context___websiteLocale___translations___noEnglishTestsIndexHeading = 'context___websiteLocale___translations___noEnglishTestsIndexHeading',
  context___websiteLocale___translations___promotionsIndexDescription = 'context___websiteLocale___translations___promotionsIndexDescription',
  context___websiteLocale___translations___seo_promotions_description = 'context___websiteLocale___translations___seo_promotions_description',
  context___websiteLocale___translations___termsAndConditionsLinkText = 'context___websiteLocale___translations___termsAndConditionsLinkText',
  context___websiteLocale___translations___noCertificationsIndexHeading = 'context___websiteLocale___translations___noCertificationsIndexHeading',
  context___websiteLocale___translations___noPromotionsIndexDescription = 'context___websiteLocale___translations___noPromotionsIndexDescription',
  context___websiteLocale___translations___seo_englishTests_description = 'context___websiteLocale___translations___seo_englishTests_description',
  context___websiteLocale___translations___certificationIndexDescription = 'context___websiteLocale___translations___certificationIndexDescription',
  context___websiteLocale___translations___noEnglishTestsIndexDescription = 'context___websiteLocale___translations___noEnglishTestsIndexDescription',
  context___websiteLocale___translations___seo_certifications_description = 'context___websiteLocale___translations___seo_certifications_description',
  context___websiteLocale___translations___noCertificationsIndexDescription = 'context___websiteLocale___translations___noCertificationsIndexDescription',
  context___websiteLocale___translations___seo_certification_city_description = 'context___websiteLocale___translations___seo_certification_city_description',
  context___websiteLocale___pathPrefixes___blog = 'context___websiteLocale___pathPrefixes___blog',
  context___websiteLocale___pathPrefixes___root = 'context___websiteLocale___pathPrefixes___root',
  context___websiteLocale___pathPrefixes___cities = 'context___websiteLocale___pathPrefixes___cities',
  context___websiteLocale___pathPrefixes___events = 'context___websiteLocale___pathPrefixes___events',
  context___websiteLocale___pathPrefixes___careers = 'context___websiteLocale___pathPrefixes___careers',
  context___websiteLocale___pathPrefixes___courses = 'context___websiteLocale___pathPrefixes___courses',
  context___websiteLocale___pathPrefixes___schools = 'context___websiteLocale___pathPrefixes___schools',
  context___websiteLocale___pathPrefixes___exercises = 'context___websiteLocale___pathPrefixes___exercises',
  context___websiteLocale___pathPrefixes___promotions = 'context___websiteLocale___pathPrefixes___promotions',
  context___websiteLocale___pathPrefixes___english_tests = 'context___websiteLocale___pathPrefixes___english_tests',
  context___websiteLocale___pathPrefixes___certifications = 'context___websiteLocale___pathPrefixes___certifications',
  context___websiteLocale___pathPrefixes___terms_and_conditions = 'context___websiteLocale___pathPrefixes___terms_and_conditions',
  context___websiteLocale___footerMetaInfo = 'context___websiteLocale___footerMetaInfo',
  context___websiteLocale___hasRightToLeftLanguage = 'context___websiteLocale___hasRightToLeftLanguage',
  context___websiteLocale___careersCta___id = 'context___websiteLocale___careersCta___id',
  context___websiteLocale___telephone = 'context___websiteLocale___telephone',
  context___websiteLocaleId = 'context___websiteLocaleId',
  context___currentDate = 'context___currentDate',
  context___pathPrefixes___root = 'context___pathPrefixes___root',
  context___pathPrefixes___blog = 'context___pathPrefixes___blog',
  context___pathPrefixes___careers = 'context___pathPrefixes___careers',
  context___pathPrefixes___certifications = 'context___pathPrefixes___certifications',
  context___pathPrefixes___cities = 'context___pathPrefixes___cities',
  context___pathPrefixes___courses = 'context___pathPrefixes___courses',
  context___pathPrefixes___english_tests = 'context___pathPrefixes___english_tests',
  context___pathPrefixes___events = 'context___pathPrefixes___events',
  context___pathPrefixes___exercises = 'context___pathPrefixes___exercises',
  context___pathPrefixes___promotions = 'context___pathPrefixes___promotions',
  context___pathPrefixes___schools = 'context___pathPrefixes___schools',
  context___pathPrefixes___terms_and_conditions = 'context___pathPrefixes___terms_and_conditions',
  context___originalPathPrefixes___root = 'context___originalPathPrefixes___root',
  context___originalPathPrefixes___blog = 'context___originalPathPrefixes___blog',
  context___originalPathPrefixes___careers = 'context___originalPathPrefixes___careers',
  context___originalPathPrefixes___certifications = 'context___originalPathPrefixes___certifications',
  context___originalPathPrefixes___cities = 'context___originalPathPrefixes___cities',
  context___originalPathPrefixes___courses = 'context___originalPathPrefixes___courses',
  context___originalPathPrefixes___english_tests = 'context___originalPathPrefixes___english_tests',
  context___originalPathPrefixes___events = 'context___originalPathPrefixes___events',
  context___originalPathPrefixes___exercises = 'context___originalPathPrefixes___exercises',
  context___originalPathPrefixes___promotions = 'context___originalPathPrefixes___promotions',
  context___originalPathPrefixes___schools = 'context___originalPathPrefixes___schools',
  context___originalPathPrefixes___terms_and_conditions = 'context___originalPathPrefixes___terms_and_conditions',
  context___id = 'context___id',
  context___avoidIndexing = 'context___avoidIndexing',
  context___allCareerPosts = 'context___allCareerPosts',
  context___allCareerPosts___id = 'context___allCareerPosts___id',
  context___allCareerPosts___slug = 'context___allCareerPosts___slug',
  context___allCareerPosts___pageSettings___avoid_indexing = 'context___allCareerPosts___pageSettings___avoid_indexing',
  context___careersCtaId = 'context___careersCtaId',
  context___hasCareersCta = 'context___hasCareersCta',
  context___relatedIds = 'context___relatedIds',
  context___pageNumber = 'context___pageNumber',
  context___humanPageNumber = 'context___humanPageNumber',
  context___skip = 'context___skip',
  context___limit = 'context___limit',
  context___numberOfPages = 'context___numberOfPages',
  context___previousPagePath = 'context___previousPagePath',
  context___nextPagePath = 'context___nextPagePath',
  context___schools = 'context___schools',
  context___schools___id = 'context___schools___id',
  context___schools___slug = 'context___schools___slug',
  context___schools___pageSettings___avoid_indexing = 'context___schools___pageSettings___avoid_indexing',
  context___exercises = 'context___exercises',
  context___exercises___id = 'context___exercises___id',
  context___exercises___slug = 'context___exercises___slug',
  context___exercises___title = 'context___exercises___title',
  context___exercises___publishedAt = 'context___exercises___publishedAt',
  context___exercises___excerpt = 'context___exercises___excerpt',
  context___exercises___image___url = 'context___exercises___image___url',
  context___exercises___pageSettings___avoid_indexing = 'context___exercises___pageSettings___avoid_indexing',
  context___certificationCtaId = 'context___certificationCtaId',
  context___certificationIds = 'context___certificationIds',
  context___hasDefaultCertificationCta = 'context___hasDefaultCertificationCta',
  context___cityId = 'context___cityId',
  pluginCreator___id = 'pluginCreator___id',
  pluginCreator___parent___id = 'pluginCreator___parent___id',
  pluginCreator___parent___parent___id = 'pluginCreator___parent___parent___id',
  pluginCreator___parent___parent___children = 'pluginCreator___parent___parent___children',
  pluginCreator___parent___children = 'pluginCreator___parent___children',
  pluginCreator___parent___children___id = 'pluginCreator___parent___children___id',
  pluginCreator___parent___children___children = 'pluginCreator___parent___children___children',
  pluginCreator___parent___internal___content = 'pluginCreator___parent___internal___content',
  pluginCreator___parent___internal___contentDigest = 'pluginCreator___parent___internal___contentDigest',
  pluginCreator___parent___internal___description = 'pluginCreator___parent___internal___description',
  pluginCreator___parent___internal___fieldOwners = 'pluginCreator___parent___internal___fieldOwners',
  pluginCreator___parent___internal___ignoreType = 'pluginCreator___parent___internal___ignoreType',
  pluginCreator___parent___internal___mediaType = 'pluginCreator___parent___internal___mediaType',
  pluginCreator___parent___internal___owner = 'pluginCreator___parent___internal___owner',
  pluginCreator___parent___internal___type = 'pluginCreator___parent___internal___type',
  pluginCreator___children = 'pluginCreator___children',
  pluginCreator___children___id = 'pluginCreator___children___id',
  pluginCreator___children___parent___id = 'pluginCreator___children___parent___id',
  pluginCreator___children___parent___children = 'pluginCreator___children___parent___children',
  pluginCreator___children___children = 'pluginCreator___children___children',
  pluginCreator___children___children___id = 'pluginCreator___children___children___id',
  pluginCreator___children___children___children = 'pluginCreator___children___children___children',
  pluginCreator___children___internal___content = 'pluginCreator___children___internal___content',
  pluginCreator___children___internal___contentDigest = 'pluginCreator___children___internal___contentDigest',
  pluginCreator___children___internal___description = 'pluginCreator___children___internal___description',
  pluginCreator___children___internal___fieldOwners = 'pluginCreator___children___internal___fieldOwners',
  pluginCreator___children___internal___ignoreType = 'pluginCreator___children___internal___ignoreType',
  pluginCreator___children___internal___mediaType = 'pluginCreator___children___internal___mediaType',
  pluginCreator___children___internal___owner = 'pluginCreator___children___internal___owner',
  pluginCreator___children___internal___type = 'pluginCreator___children___internal___type',
  pluginCreator___internal___content = 'pluginCreator___internal___content',
  pluginCreator___internal___contentDigest = 'pluginCreator___internal___contentDigest',
  pluginCreator___internal___description = 'pluginCreator___internal___description',
  pluginCreator___internal___fieldOwners = 'pluginCreator___internal___fieldOwners',
  pluginCreator___internal___ignoreType = 'pluginCreator___internal___ignoreType',
  pluginCreator___internal___mediaType = 'pluginCreator___internal___mediaType',
  pluginCreator___internal___owner = 'pluginCreator___internal___owner',
  pluginCreator___internal___type = 'pluginCreator___internal___type',
  pluginCreator___resolve = 'pluginCreator___resolve',
  pluginCreator___name = 'pluginCreator___name',
  pluginCreator___version = 'pluginCreator___version',
  pluginCreator___pluginOptions___typeName = 'pluginCreator___pluginOptions___typeName',
  pluginCreator___pluginOptions___fieldName = 'pluginCreator___pluginOptions___fieldName',
  pluginCreator___pluginOptions___url = 'pluginCreator___pluginOptions___url',
  pluginCreator___pluginOptions___refetchInterval = 'pluginCreator___pluginOptions___refetchInterval',
  pluginCreator___pluginOptions___output = 'pluginCreator___pluginOptions___output',
  pluginCreator___pluginOptions___query = 'pluginCreator___pluginOptions___query',
  pluginCreator___pluginOptions___createLinkInHead = 'pluginCreator___pluginOptions___createLinkInHead',
  pluginCreator___pluginOptions___entryLimit = 'pluginCreator___pluginOptions___entryLimit',
  pluginCreator___pluginOptions___exclude = 'pluginCreator___pluginOptions___exclude',
  pluginCreator___pluginOptions___useAutoGen = 'pluginCreator___pluginOptions___useAutoGen',
  pluginCreator___pluginOptions___sitemap = 'pluginCreator___pluginOptions___sitemap',
  pluginCreator___pluginOptions___name = 'pluginCreator___pluginOptions___name',
  pluginCreator___pluginOptions___short_name = 'pluginCreator___pluginOptions___short_name',
  pluginCreator___pluginOptions___start_url = 'pluginCreator___pluginOptions___start_url',
  pluginCreator___pluginOptions___background_color = 'pluginCreator___pluginOptions___background_color',
  pluginCreator___pluginOptions___theme_color = 'pluginCreator___pluginOptions___theme_color',
  pluginCreator___pluginOptions___display = 'pluginCreator___pluginOptions___display',
  pluginCreator___pluginOptions___icon = 'pluginCreator___pluginOptions___icon',
  pluginCreator___pluginOptions___legacy = 'pluginCreator___pluginOptions___legacy',
  pluginCreator___pluginOptions___theme_color_in_head = 'pluginCreator___pluginOptions___theme_color_in_head',
  pluginCreator___pluginOptions___cache_busting_mode = 'pluginCreator___pluginOptions___cache_busting_mode',
  pluginCreator___pluginOptions___crossOrigin = 'pluginCreator___pluginOptions___crossOrigin',
  pluginCreator___pluginOptions___include_favicon = 'pluginCreator___pluginOptions___include_favicon',
  pluginCreator___pluginOptions___cacheDigest = 'pluginCreator___pluginOptions___cacheDigest',
  pluginCreator___pluginOptions___path = 'pluginCreator___pluginOptions___path',
  pluginCreator___pluginOptions___pathCheck = 'pluginCreator___pluginOptions___pathCheck',
  pluginCreator___pluginOptions___allExtensions = 'pluginCreator___pluginOptions___allExtensions',
  pluginCreator___pluginOptions___isTSX = 'pluginCreator___pluginOptions___isTSX',
  pluginCreator___pluginOptions___jsxPragma = 'pluginCreator___pluginOptions___jsxPragma',
  pluginCreator___nodeAPIs = 'pluginCreator___nodeAPIs',
  pluginCreator___browserAPIs = 'pluginCreator___browserAPIs',
  pluginCreator___ssrAPIs = 'pluginCreator___ssrAPIs',
  pluginCreator___pluginFilepath = 'pluginCreator___pluginFilepath',
  pluginCreator___packageJson___name = 'pluginCreator___packageJson___name',
  pluginCreator___packageJson___description = 'pluginCreator___packageJson___description',
  pluginCreator___packageJson___version = 'pluginCreator___packageJson___version',
  pluginCreator___packageJson___main = 'pluginCreator___packageJson___main',
  pluginCreator___packageJson___author = 'pluginCreator___packageJson___author',
  pluginCreator___packageJson___license = 'pluginCreator___packageJson___license',
  pluginCreator___packageJson___dependencies = 'pluginCreator___packageJson___dependencies',
  pluginCreator___packageJson___dependencies___name = 'pluginCreator___packageJson___dependencies___name',
  pluginCreator___packageJson___dependencies___version = 'pluginCreator___packageJson___dependencies___version',
  pluginCreator___packageJson___devDependencies = 'pluginCreator___packageJson___devDependencies',
  pluginCreator___packageJson___devDependencies___name = 'pluginCreator___packageJson___devDependencies___name',
  pluginCreator___packageJson___devDependencies___version = 'pluginCreator___packageJson___devDependencies___version',
  pluginCreator___packageJson___peerDependencies = 'pluginCreator___packageJson___peerDependencies',
  pluginCreator___packageJson___peerDependencies___name = 'pluginCreator___packageJson___peerDependencies___name',
  pluginCreator___packageJson___peerDependencies___version = 'pluginCreator___packageJson___peerDependencies___version',
  pluginCreator___packageJson___keywords = 'pluginCreator___packageJson___keywords',
  pluginCreatorId = 'pluginCreatorId',
  componentPath = 'componentPath',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SitePageFilterInput = {
  path?: Maybe<StringQueryOperatorInput>;
  component?: Maybe<StringQueryOperatorInput>;
  internalComponentName?: Maybe<StringQueryOperatorInput>;
  componentChunkName?: Maybe<StringQueryOperatorInput>;
  matchPath?: Maybe<StringQueryOperatorInput>;
  isCreatedByStatefulCreatePages?: Maybe<BooleanQueryOperatorInput>;
  context?: Maybe<SitePageContextFilterInput>;
  pluginCreator?: Maybe<SitePluginFilterInput>;
  pluginCreatorId?: Maybe<StringQueryOperatorInput>;
  componentPath?: Maybe<StringQueryOperatorInput>;
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
};

export type SitePageGroupConnection = {
  __typename?: 'SitePageGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePageEdge>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePageSortInput = {
  fields?: Maybe<Array<Maybe<SitePageFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SitePlugin = Node & {
  __typename?: 'SitePlugin';
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
  resolve?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  pluginOptions?: Maybe<SitePluginPluginOptions>;
  nodeAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  browserAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  ssrAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  pluginFilepath?: Maybe<Scalars['String']>;
  packageJson?: Maybe<SitePluginPackageJson>;
};

export type SitePluginConnection = {
  __typename?: 'SitePluginConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePluginEdge>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  group: Array<SitePluginGroupConnection>;
};


export type SitePluginConnectionDistinctArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionGroupArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  field: SitePluginFieldsEnum;
};

export type SitePluginEdge = {
  __typename?: 'SitePluginEdge';
  next?: Maybe<SitePlugin>;
  node: SitePlugin;
  previous?: Maybe<SitePlugin>;
};

export enum SitePluginFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  resolve = 'resolve',
  name = 'name',
  version = 'version',
  pluginOptions___typeName = 'pluginOptions___typeName',
  pluginOptions___fieldName = 'pluginOptions___fieldName',
  pluginOptions___url = 'pluginOptions___url',
  pluginOptions___refetchInterval = 'pluginOptions___refetchInterval',
  pluginOptions___output = 'pluginOptions___output',
  pluginOptions___query = 'pluginOptions___query',
  pluginOptions___createLinkInHead = 'pluginOptions___createLinkInHead',
  pluginOptions___entryLimit = 'pluginOptions___entryLimit',
  pluginOptions___exclude = 'pluginOptions___exclude',
  pluginOptions___useAutoGen = 'pluginOptions___useAutoGen',
  pluginOptions___sitemap = 'pluginOptions___sitemap',
  pluginOptions___name = 'pluginOptions___name',
  pluginOptions___short_name = 'pluginOptions___short_name',
  pluginOptions___start_url = 'pluginOptions___start_url',
  pluginOptions___background_color = 'pluginOptions___background_color',
  pluginOptions___theme_color = 'pluginOptions___theme_color',
  pluginOptions___display = 'pluginOptions___display',
  pluginOptions___icon = 'pluginOptions___icon',
  pluginOptions___legacy = 'pluginOptions___legacy',
  pluginOptions___theme_color_in_head = 'pluginOptions___theme_color_in_head',
  pluginOptions___cache_busting_mode = 'pluginOptions___cache_busting_mode',
  pluginOptions___crossOrigin = 'pluginOptions___crossOrigin',
  pluginOptions___include_favicon = 'pluginOptions___include_favicon',
  pluginOptions___cacheDigest = 'pluginOptions___cacheDigest',
  pluginOptions___path = 'pluginOptions___path',
  pluginOptions___pathCheck = 'pluginOptions___pathCheck',
  pluginOptions___allExtensions = 'pluginOptions___allExtensions',
  pluginOptions___isTSX = 'pluginOptions___isTSX',
  pluginOptions___jsxPragma = 'pluginOptions___jsxPragma',
  nodeAPIs = 'nodeAPIs',
  browserAPIs = 'browserAPIs',
  ssrAPIs = 'ssrAPIs',
  pluginFilepath = 'pluginFilepath',
  packageJson___name = 'packageJson___name',
  packageJson___description = 'packageJson___description',
  packageJson___version = 'packageJson___version',
  packageJson___main = 'packageJson___main',
  packageJson___author = 'packageJson___author',
  packageJson___license = 'packageJson___license',
  packageJson___dependencies = 'packageJson___dependencies',
  packageJson___dependencies___name = 'packageJson___dependencies___name',
  packageJson___dependencies___version = 'packageJson___dependencies___version',
  packageJson___devDependencies = 'packageJson___devDependencies',
  packageJson___devDependencies___name = 'packageJson___devDependencies___name',
  packageJson___devDependencies___version = 'packageJson___devDependencies___version',
  packageJson___peerDependencies = 'packageJson___peerDependencies',
  packageJson___peerDependencies___name = 'packageJson___peerDependencies___name',
  packageJson___peerDependencies___version = 'packageJson___peerDependencies___version',
  packageJson___keywords = 'packageJson___keywords'
}

export type SitePluginFilterInput = {
  id?: Maybe<StringQueryOperatorInput>;
  parent?: Maybe<NodeFilterInput>;
  children?: Maybe<NodeFilterListInput>;
  internal?: Maybe<InternalFilterInput>;
  resolve?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
  pluginOptions?: Maybe<SitePluginPluginOptionsFilterInput>;
  nodeAPIs?: Maybe<StringQueryOperatorInput>;
  browserAPIs?: Maybe<StringQueryOperatorInput>;
  ssrAPIs?: Maybe<StringQueryOperatorInput>;
  pluginFilepath?: Maybe<StringQueryOperatorInput>;
  packageJson?: Maybe<SitePluginPackageJsonFilterInput>;
};

export type SitePluginGroupConnection = {
  __typename?: 'SitePluginGroupConnection';
  totalCount: Scalars['Int'];
  edges: Array<SitePluginEdge>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJson = {
  __typename?: 'SitePluginPackageJson';
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  license?: Maybe<Scalars['String']>;
  dependencies?: Maybe<Array<Maybe<SitePluginPackageJsonDependencies>>>;
  devDependencies?: Maybe<Array<Maybe<SitePluginPackageJsonDevDependencies>>>;
  peerDependencies?: Maybe<Array<Maybe<SitePluginPackageJsonPeerDependencies>>>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SitePluginPackageJsonDependencies = {
  __typename?: 'SitePluginPackageJsonDependencies';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJsonDependenciesFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonDependenciesFilterListInput = {
  elemMatch?: Maybe<SitePluginPackageJsonDependenciesFilterInput>;
};

export type SitePluginPackageJsonDevDependencies = {
  __typename?: 'SitePluginPackageJsonDevDependencies';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJsonDevDependenciesFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonDevDependenciesFilterListInput = {
  elemMatch?: Maybe<SitePluginPackageJsonDevDependenciesFilterInput>;
};

export type SitePluginPackageJsonFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
  main?: Maybe<StringQueryOperatorInput>;
  author?: Maybe<StringQueryOperatorInput>;
  license?: Maybe<StringQueryOperatorInput>;
  dependencies?: Maybe<SitePluginPackageJsonDependenciesFilterListInput>;
  devDependencies?: Maybe<SitePluginPackageJsonDevDependenciesFilterListInput>;
  peerDependencies?: Maybe<SitePluginPackageJsonPeerDependenciesFilterListInput>;
  keywords?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonPeerDependencies = {
  __typename?: 'SitePluginPackageJsonPeerDependencies';
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginPackageJsonPeerDependenciesFilterInput = {
  name?: Maybe<StringQueryOperatorInput>;
  version?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginPackageJsonPeerDependenciesFilterListInput = {
  elemMatch?: Maybe<SitePluginPackageJsonPeerDependenciesFilterInput>;
};

export type SitePluginPluginOptions = {
  __typename?: 'SitePluginPluginOptions';
  typeName?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  refetchInterval?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  createLinkInHead?: Maybe<Scalars['Boolean']>;
  entryLimit?: Maybe<Scalars['Int']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
  useAutoGen?: Maybe<Scalars['Boolean']>;
  sitemap?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  start_url?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['String']>;
  theme_color?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  legacy?: Maybe<Scalars['Boolean']>;
  theme_color_in_head?: Maybe<Scalars['Boolean']>;
  cache_busting_mode?: Maybe<Scalars['String']>;
  crossOrigin?: Maybe<Scalars['String']>;
  include_favicon?: Maybe<Scalars['Boolean']>;
  cacheDigest?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  pathCheck?: Maybe<Scalars['Boolean']>;
  allExtensions?: Maybe<Scalars['Boolean']>;
  isTSX?: Maybe<Scalars['Boolean']>;
  jsxPragma?: Maybe<Scalars['String']>;
};

export type SitePluginPluginOptionsFilterInput = {
  typeName?: Maybe<StringQueryOperatorInput>;
  fieldName?: Maybe<StringQueryOperatorInput>;
  url?: Maybe<StringQueryOperatorInput>;
  refetchInterval?: Maybe<StringQueryOperatorInput>;
  output?: Maybe<StringQueryOperatorInput>;
  query?: Maybe<StringQueryOperatorInput>;
  createLinkInHead?: Maybe<BooleanQueryOperatorInput>;
  entryLimit?: Maybe<IntQueryOperatorInput>;
  exclude?: Maybe<StringQueryOperatorInput>;
  useAutoGen?: Maybe<BooleanQueryOperatorInput>;
  sitemap?: Maybe<StringQueryOperatorInput>;
  name?: Maybe<StringQueryOperatorInput>;
  short_name?: Maybe<StringQueryOperatorInput>;
  start_url?: Maybe<StringQueryOperatorInput>;
  background_color?: Maybe<StringQueryOperatorInput>;
  theme_color?: Maybe<StringQueryOperatorInput>;
  display?: Maybe<StringQueryOperatorInput>;
  icon?: Maybe<StringQueryOperatorInput>;
  legacy?: Maybe<BooleanQueryOperatorInput>;
  theme_color_in_head?: Maybe<BooleanQueryOperatorInput>;
  cache_busting_mode?: Maybe<StringQueryOperatorInput>;
  crossOrigin?: Maybe<StringQueryOperatorInput>;
  include_favicon?: Maybe<BooleanQueryOperatorInput>;
  cacheDigest?: Maybe<StringQueryOperatorInput>;
  path?: Maybe<StringQueryOperatorInput>;
  pathCheck?: Maybe<BooleanQueryOperatorInput>;
  allExtensions?: Maybe<BooleanQueryOperatorInput>;
  isTSX?: Maybe<BooleanQueryOperatorInput>;
  jsxPragma?: Maybe<StringQueryOperatorInput>;
};

export type SitePluginSortInput = {
  fields?: Maybe<Array<Maybe<SitePluginFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export type SiteSiteMetadata = {
  __typename?: 'SiteSiteMetadata';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  studentLogin?: Maybe<Scalars['String']>;
};

export type SiteSiteMetadataFilterInput = {
  title?: Maybe<StringQueryOperatorInput>;
  description?: Maybe<StringQueryOperatorInput>;
  author?: Maybe<StringQueryOperatorInput>;
  studentLogin?: Maybe<StringQueryOperatorInput>;
};

export type SiteSortInput = {
  fields?: Maybe<Array<Maybe<SiteFieldsEnum>>>;
  order?: Maybe<Array<Maybe<SortOrderEnum>>>;
};

export enum SortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type Strapi = {
  __typename?: 'Strapi';
  blogPost?: Maybe<Strapi_BlogPost>;
  blogPosts?: Maybe<Array<Maybe<Strapi_BlogPost>>>;
  blogPostsConnection?: Maybe<Strapi_BlogPostConnection>;
  careerPost?: Maybe<Strapi_CareerPost>;
  careerPosts?: Maybe<Array<Maybe<Strapi_CareerPost>>>;
  careerPostsConnection?: Maybe<Strapi_CareerPostConnection>;
  careersCta?: Maybe<Strapi_CareersCta>;
  careersCtas?: Maybe<Array<Maybe<Strapi_CareersCta>>>;
  careersCtasConnection?: Maybe<Strapi_CareersCtaConnection>;
  category?: Maybe<Strapi_Category>;
  categories?: Maybe<Array<Maybe<Strapi_Category>>>;
  categoriesConnection?: Maybe<Strapi_CategoryConnection>;
  certificationCta?: Maybe<Strapi_CertificationCta>;
  certificationCtas?: Maybe<Array<Maybe<Strapi_CertificationCta>>>;
  certificationCtasConnection?: Maybe<Strapi_CertificationCtaConnection>;
  certification?: Maybe<Strapi_Certification>;
  certifications?: Maybe<Array<Maybe<Strapi_Certification>>>;
  certificationsConnection?: Maybe<Strapi_CertificationConnection>;
  city?: Maybe<Strapi_City>;
  cities?: Maybe<Array<Maybe<Strapi_City>>>;
  citiesConnection?: Maybe<Strapi_CityConnection>;
  course?: Maybe<Strapi_Course>;
  courses?: Maybe<Array<Maybe<Strapi_Course>>>;
  coursesConnection?: Maybe<Strapi_CourseConnection>;
  deliveryMethod?: Maybe<Strapi_DeliveryMethod>;
  deliveryMethods?: Maybe<Array<Maybe<Strapi_DeliveryMethod>>>;
  deliveryMethodsConnection?: Maybe<Strapi_DeliveryMethodConnection>;
  englishLevelGroup?: Maybe<Strapi_EnglishLevelGroup>;
  englishLevelGroups?: Maybe<Array<Maybe<Strapi_EnglishLevelGroup>>>;
  englishLevelGroupsConnection?: Maybe<Strapi_EnglishLevelGroupConnection>;
  englishTest?: Maybe<Strapi_EnglishTest>;
  englishTests?: Maybe<Array<Maybe<Strapi_EnglishTest>>>;
  englishTestsConnection?: Maybe<Strapi_EnglishTestConnection>;
  event?: Maybe<Strapi_Event>;
  events?: Maybe<Array<Maybe<Strapi_Event>>>;
  eventsConnection?: Maybe<Strapi_EventConnection>;
  exercise?: Maybe<Strapi_Exercise>;
  exercises?: Maybe<Array<Maybe<Strapi_Exercise>>>;
  exercisesConnection?: Maybe<Strapi_ExerciseConnection>;
  footerCta?: Maybe<Strapi_FooterCta>;
  footerCtas?: Maybe<Array<Maybe<Strapi_FooterCta>>>;
  footerCtasConnection?: Maybe<Strapi_FooterCtaConnection>;
  homepage?: Maybe<Strapi_Homepage>;
  homepages?: Maybe<Array<Maybe<Strapi_Homepage>>>;
  homepagesConnection?: Maybe<Strapi_HomepageConnection>;
  jobType?: Maybe<Strapi_JobType>;
  jobTypes?: Maybe<Array<Maybe<Strapi_JobType>>>;
  jobTypesConnection?: Maybe<Strapi_JobTypeConnection>;
  modal?: Maybe<Strapi_Modal>;
  modals?: Maybe<Array<Maybe<Strapi_Modal>>>;
  modalsConnection?: Maybe<Strapi_ModalConnection>;
  page?: Maybe<Strapi_Page>;
  pages?: Maybe<Array<Maybe<Strapi_Page>>>;
  pagesConnection?: Maybe<Strapi_PageConnection>;
  promotion?: Maybe<Strapi_Promotion>;
  promotions?: Maybe<Array<Maybe<Strapi_Promotion>>>;
  promotionsConnection?: Maybe<Strapi_PromotionConnection>;
  school?: Maybe<Strapi_School>;
  schools?: Maybe<Array<Maybe<Strapi_School>>>;
  schoolsConnection?: Maybe<Strapi_SchoolConnection>;
  websiteLocale?: Maybe<Strapi_WebsiteLocale>;
  websiteLocales?: Maybe<Array<Maybe<Strapi_WebsiteLocale>>>;
  websiteLocalesConnection?: Maybe<Strapi_WebsiteLocaleConnection>;
  website?: Maybe<Strapi_Website>;
  websites?: Maybe<Array<Maybe<Strapi_Website>>>;
  websitesConnection?: Maybe<Strapi_WebsiteConnection>;
  files?: Maybe<Array<Maybe<Strapi_UploadFile>>>;
  filesConnection?: Maybe<Strapi_UploadFileConnection>;
  role?: Maybe<Strapi_UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<Strapi_UsersPermissionsRole>>>;
  rolesConnection?: Maybe<Strapi_UsersPermissionsRoleConnection>;
  user?: Maybe<Strapi_UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<Strapi_UsersPermissionsUser>>>;
  usersConnection?: Maybe<Strapi_UsersPermissionsUserConnection>;
  me?: Maybe<Strapi_UsersPermissionsMe>;
};


export type StrapiBlogPostArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiBlogPostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiBlogPostsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCareerPostArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCareerPostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCareerPostsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCareersCtaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCareersCtasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCareersCtasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCategoryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCategoriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCertificationCtaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCertificationCtasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCertificationCtasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCertificationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCertificationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCertificationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCityArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCitiesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCitiesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiCourseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCoursesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiCoursesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiDeliveryMethodArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiDeliveryMethodsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiDeliveryMethodsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiEnglishLevelGroupArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiEnglishLevelGroupsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiEnglishLevelGroupsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiEnglishTestArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiEnglishTestsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiEnglishTestsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiEventArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiEventsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiEventsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiExerciseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiExercisesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiExercisesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiFooterCtaArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiFooterCtasArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiFooterCtasConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiHomepageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiHomepagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiHomepagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiJobTypeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiJobTypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiJobTypesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiModalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiModalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiModalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiPageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiPagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiPagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiPromotionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiPromotionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiPromotionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiSchoolArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiSchoolsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiSchoolsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiWebsiteLocaleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiWebsiteLocalesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiWebsiteLocalesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiWebsiteArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiWebsitesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiWebsitesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type StrapiUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
  publicationState?: Maybe<Strapi_PublicationState>;
};


export type StrapiUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_AdminUser = {
  __typename?: 'Strapi_AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type Strapi_BlogPost = {
  __typename?: 'Strapi_BlogPost';
  documentId: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  title: Scalars['String'];
  body: Scalars['String'];
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  slug?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFile>;
  excerpt?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  html_code?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  related_posts?: Maybe<Array<Maybe<Strapi_BlogPost>>>;
  categories?: Maybe<Array<Maybe<Strapi_Category>>>;
};


export type Strapi_BlogPostRelated_PostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_BlogPostCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_BlogPostAggregator = {
  __typename?: 'Strapi_BlogPostAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_BlogPostConnection = {
  __typename?: 'Strapi_BlogPostConnection';
  values?: Maybe<Array<Maybe<Strapi_BlogPost>>>;
  groupBy?: Maybe<Strapi_BlogPostGroupBy>;
  aggregate?: Maybe<Strapi_BlogPostAggregator>;
};

export type Strapi_BlogPostConnectionBody = {
  __typename?: 'Strapi_BlogPostConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionCreated_At = {
  __typename?: 'Strapi_BlogPostConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionExcerpt = {
  __typename?: 'Strapi_BlogPostConnectionExcerpt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionHtml_Code = {
  __typename?: 'Strapi_BlogPostConnectionHtml_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionId = {
  __typename?: 'Strapi_BlogPostConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionImage = {
  __typename?: 'Strapi_BlogPostConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionInternal_Name = {
  __typename?: 'Strapi_BlogPostConnectionInternal_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionOriginal_Date = {
  __typename?: 'Strapi_BlogPostConnectionOriginal_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionPage_Settings = {
  __typename?: 'Strapi_BlogPostConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionPublished_At = {
  __typename?: 'Strapi_BlogPostConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionSlug = {
  __typename?: 'Strapi_BlogPostConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionTitle = {
  __typename?: 'Strapi_BlogPostConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionUpdated_At = {
  __typename?: 'Strapi_BlogPostConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostConnectionWebsite_Locale = {
  __typename?: 'Strapi_BlogPostConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_BlogPostConnection>;
};

export type Strapi_BlogPostGroupBy = {
  __typename?: 'Strapi_BlogPostGroupBy';
  id?: Maybe<Array<Maybe<Strapi_BlogPostConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_BlogPostConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_BlogPostConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_BlogPostConnectionTitle>>>;
  body?: Maybe<Array<Maybe<Strapi_BlogPostConnectionBody>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_BlogPostConnectionWebsite_Locale>>>;
  slug?: Maybe<Array<Maybe<Strapi_BlogPostConnectionSlug>>>;
  image?: Maybe<Array<Maybe<Strapi_BlogPostConnectionImage>>>;
  excerpt?: Maybe<Array<Maybe<Strapi_BlogPostConnectionExcerpt>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_BlogPostConnectionPage_Settings>>>;
  original_date?: Maybe<Array<Maybe<Strapi_BlogPostConnectionOriginal_Date>>>;
  html_code?: Maybe<Array<Maybe<Strapi_BlogPostConnectionHtml_Code>>>;
  internal_name?: Maybe<Array<Maybe<Strapi_BlogPostConnectionInternal_Name>>>;
  published_at?: Maybe<Array<Maybe<Strapi_BlogPostConnectionPublished_At>>>;
};

export type Strapi_BlogPostInput = {
  title: Scalars['String'];
  body: Scalars['String'];
  related_posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  slug?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  excerpt?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  html_code?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_CareerPost = {
  __typename?: 'Strapi_CareerPost';
  documentId:Maybe<Scalars['ID']>;
  title: Scalars['String'];
  content: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  embed_code?: Maybe<Scalars['String']>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  short: Scalars['String'];
  call_to_action?: Maybe<Strapi_ComponentPageCallToAction>;
  city?: Maybe<Strapi_CityEntityResponse>;
  job_type?: Maybe<Strapi_JobTypeEntityResponse>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_CareerPostRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};

export type Strapi_CareerPostEntity = {
  __typename?: 'Strapi_CareerPostEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_CareerPost>;
};

export type Strapi_CareerPostEntityResponse = {
  __typename?: 'Strapi_CareerPostEntityResponse';
  data?: Maybe<Strapi_CareerPostEntity>;
};

export type Strapi_CareerPostEntityResponseCollection = {
  __typename?: 'Strapi_CareerPostEntityResponseCollection';
  data: Array<Strapi_CareerPostEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_CareerPostRelationResponseCollection = {
  __typename?: 'Strapi_CareerPostRelationResponseCollection';
  data: Array<Strapi_CareerPostEntity>;
};

export type Strapi_CareerPostAggregator = {
  __typename?: 'Strapi_CareerPostAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_CareerPostConnection = {
  __typename?: 'Strapi_CareerPostConnection';
  values?: Maybe<Array<Maybe<Strapi_CareerPost>>>;
  groupBy?: Maybe<Strapi_CareerPostGroupBy>;
  aggregate?: Maybe<Strapi_CareerPostAggregator>;
};

export type Strapi_CareerPostConnectionCall_To_Action = {
  __typename?: 'Strapi_CareerPostConnectionCall_to_action';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionCity = {
  __typename?: 'Strapi_CareerPostConnectionCity';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionContent = {
  __typename?: 'Strapi_CareerPostConnectionContent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionCreated_At = {
  __typename?: 'Strapi_CareerPostConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionEmbed_Code = {
  __typename?: 'Strapi_CareerPostConnectionEmbed_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionId = {
  __typename?: 'Strapi_CareerPostConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionJob_Type = {
  __typename?: 'Strapi_CareerPostConnectionJob_type';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionLink = {
  __typename?: 'Strapi_CareerPostConnectionLink';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionPage_Settings = {
  __typename?: 'Strapi_CareerPostConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionPublished_At = {
  __typename?: 'Strapi_CareerPostConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionShort = {
  __typename?: 'Strapi_CareerPostConnectionShort';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionSlug = {
  __typename?: 'Strapi_CareerPostConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionTitle = {
  __typename?: 'Strapi_CareerPostConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionUpdated_At = {
  __typename?: 'Strapi_CareerPostConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostConnectionWebsite_Locale = {
  __typename?: 'Strapi_CareerPostConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareerPostConnection>;
};

export type Strapi_CareerPostGroupBy = {
  __typename?: 'Strapi_CareerPostGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CareerPostConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CareerPostConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CareerPostConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_CareerPostConnectionTitle>>>;
  content?: Maybe<Array<Maybe<Strapi_CareerPostConnectionContent>>>;
  slug?: Maybe<Array<Maybe<Strapi_CareerPostConnectionSlug>>>;
  link?: Maybe<Array<Maybe<Strapi_CareerPostConnectionLink>>>;
  embed_code?: Maybe<Array<Maybe<Strapi_CareerPostConnectionEmbed_Code>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CareerPostConnectionWebsite_Locale>>>;
  short?: Maybe<Array<Maybe<Strapi_CareerPostConnectionShort>>>;
  call_to_action?: Maybe<Array<Maybe<Strapi_CareerPostConnectionCall_To_Action>>>;
  city?: Maybe<Array<Maybe<Strapi_CareerPostConnectionCity>>>;
  job_type?: Maybe<Array<Maybe<Strapi_CareerPostConnectionJob_Type>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_CareerPostConnectionPage_Settings>>>;
  published_at?: Maybe<Array<Maybe<Strapi_CareerPostConnectionPublished_At>>>;
};

export type Strapi_CareerPostInput = {
  title: Scalars['String'];
  content: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  embed_code?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  short: Scalars['String'];
  call_to_action?: Maybe<Strapi_ComponentPageCallToActionInput>;
  city?: Maybe<Scalars['ID']>;
  job_type?: Maybe<Scalars['ID']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_CareersCta = {
  __typename?: 'Strapi_CareersCta';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  cta_panel?: Maybe<Strapi_ComponentPageImageAndText>;
  cta_name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_CareersCtaEntity = {
  __typename?: 'Strapi_CareersCtaEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_CareersCta>;
};

export type Strapi_CareersCtaEntityResponse = {
  __typename?: 'Strapi_CareersCtaEntityResponse';
  data?: Maybe<Strapi_CareersCtaEntity>;
};

export type Strapi_CareersCtaEntityResponseCollection = {
  __typename?: 'Strapi_CareersCtaEntityResponseCollection';
  data: Array<Strapi_CareersCtaEntity>;
  meta: Strapi_ResponseCollectionMeta;
};


export type Strapi_CareersCtaAggregator = {
  __typename?: 'Strapi_CareersCtaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_CareersCtaConnection = {
  __typename?: 'Strapi_CareersCtaConnection';
  values?: Maybe<Array<Maybe<Strapi_CareersCta>>>;
  groupBy?: Maybe<Strapi_CareersCtaGroupBy>;
  aggregate?: Maybe<Strapi_CareersCtaAggregator>;
};

export type Strapi_CareersCtaConnectionCreated_At = {
  __typename?: 'Strapi_CareersCtaConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaConnectionCta_Name = {
  __typename?: 'Strapi_CareersCtaConnectionCta_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaConnectionCta_Panel = {
  __typename?: 'Strapi_CareersCtaConnectionCta_panel';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaConnectionId = {
  __typename?: 'Strapi_CareersCtaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaConnectionPublished_At = {
  __typename?: 'Strapi_CareersCtaConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaConnectionUpdated_At = {
  __typename?: 'Strapi_CareersCtaConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaConnectionWebsite_Locale = {
  __typename?: 'Strapi_CareersCtaConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CareersCtaConnection>;
};

export type Strapi_CareersCtaGroupBy = {
  __typename?: 'Strapi_CareersCtaGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionUpdated_At>>>;
  cta_panel?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionCta_Panel>>>;
  cta_name?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionCta_Name>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_CareersCtaConnectionPublished_At>>>;
};

export type Strapi_CareersCtaInput = {
  cta_panel?: Maybe<Strapi_ComponentPageImageAndTextInput>;
  cta_name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Category = {
  __typename?: 'Strapi_Category';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  name: Scalars['String'];
  website_locale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_CategoryEntity = {
  __typename?: 'Strapi_CategoryEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Category>;
};

export type Strapi_CategoryEntityResponse = {
  __typename?: 'Strapi_CategoryEntityResponse';
  data?: Maybe<Strapi_CategoryEntity>;
};

export type Strapi_CategoryEntityResponseCollection = {
  __typename?: 'Strapi_CategoryEntityResponseCollection';
  data: Array<Strapi_CategoryEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_CategoryRelationResponseCollection = {
  __typename?: 'Strapi_CategoryRelationResponseCollection';
  data: Array<Strapi_CategoryEntity>;
};

export type Strapi_CategoryAggregator = {
  __typename?: 'Strapi_CategoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_CategoryConnection = {
  __typename?: 'Strapi_CategoryConnection';
  values?: Maybe<Array<Maybe<Strapi_Category>>>;
  groupBy?: Maybe<Strapi_CategoryGroupBy>;
  aggregate?: Maybe<Strapi_CategoryAggregator>;
};

export type Strapi_CategoryConnectionCreated_At = {
  __typename?: 'Strapi_CategoryConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CategoryConnection>;
};

export type Strapi_CategoryConnectionId = {
  __typename?: 'Strapi_CategoryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CategoryConnection>;
};

export type Strapi_CategoryConnectionName = {
  __typename?: 'Strapi_CategoryConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CategoryConnection>;
};

export type Strapi_CategoryConnectionUpdated_At = {
  __typename?: 'Strapi_CategoryConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CategoryConnection>;
};

export type Strapi_CategoryConnectionWebsite_Locale = {
  __typename?: 'Strapi_CategoryConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CategoryConnection>;
};

export type Strapi_CategoryGroupBy = {
  __typename?: 'Strapi_CategoryGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CategoryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CategoryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CategoryConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_CategoryConnectionName>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CategoryConnectionWebsite_Locale>>>;
};

export type Strapi_CategoryInput = {
  name: Scalars['String'];
  website_locale?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Certification = {
  __typename?: 'Strapi_Certification';
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  certification_cta?: Maybe<Strapi_CertificationCtaEntityResponse>;
  image?: Maybe<Strapi_UploadFileEntityResponse>;
  hero_body?: Maybe<Scalars['String']>;
  hero_link?: Maybe<Strapi_ComponentAtomLink>;
  schools?: Maybe<Strapi_SchoolRelationResponseCollection>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  footer_cta?: Maybe<Strapi_ComponentPageCallToAction>;
  certification_english_levels?: Maybe<Strapi_ComponentPageEnglishLevels>;
  cities?: Maybe<Strapi_CityRelationResponseCollection>;
  city_heading_text?: Maybe<Scalars['String']>;
  exam_schools?: Maybe<Strapi_SchoolRelationResponseCollection>;
  exam_schools_heading?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Maybe<Strapi_CertificationComponentsDynamicZone>>>;
  reviews_widget?: Maybe<Strapi_ComponentPageReviewsIoWidget>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_CertificationRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};


export type Strapi_CertificationEntity = {
  __typename?: 'Strapi_CertificationEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Certification>;
};

export type Strapi_CertificationCtaRelationResponseCollection = {
  __typename?: 'Strapi_CertificationCtaRelationResponseCollection';
  data: Array<Strapi_CertificationCtaEntity>;
};

export type Strapi_CertificationEntityResponse = {
  __typename?: 'Strapi_CertificationEntityResponse';
  data?: Maybe<Strapi_CertificationEntity>;
};

export type Strapi_CertificationEntityResponseCollection = {
  __typename?: 'Strapi_CertificationEntityResponseCollection';
  data: Array<Strapi_CertificationEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_CertificationRelationResponseCollection = {
  __typename?: 'Strapi_CertificationRelationResponseCollection';
  data: Array<Strapi_CertificationEntity>;
};


export type Strapi_CertificationSchoolsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_CertificationCitiesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_CertificationExam_SchoolsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_CertificationAggregator = {
  __typename?: 'Strapi_CertificationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_CertificationComponentsDynamicZone = Strapi_ComponentPageCallToAction | Strapi_ComponentPageCareersGallery | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnglishLevelsAccordion | Strapi_ComponentPageEnglishLevelsTable | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHeroMap | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageInlineHubspotForm | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText;


export type Strapi_CertificationConnection = {
  __typename?: 'Strapi_CertificationConnection';
  values?: Maybe<Array<Maybe<Strapi_Certification>>>;
  groupBy?: Maybe<Strapi_CertificationGroupBy>;
  aggregate?: Maybe<Strapi_CertificationAggregator>;
};

export type Strapi_CertificationConnectionCertification_Cta = {
  __typename?: 'Strapi_CertificationConnectionCertification_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionCertification_English_Levels = {
  __typename?: 'Strapi_CertificationConnectionCertification_english_levels';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionCity_Heading_Text = {
  __typename?: 'Strapi_CertificationConnectionCity_heading_text';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionCreated_At = {
  __typename?: 'Strapi_CertificationConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionExam_Schools_Heading = {
  __typename?: 'Strapi_CertificationConnectionExam_schools_heading';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionExcerpt = {
  __typename?: 'Strapi_CertificationConnectionExcerpt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionFooter_Cta = {
  __typename?: 'Strapi_CertificationConnectionFooter_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionHero_Body = {
  __typename?: 'Strapi_CertificationConnectionHero_body';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionHero_Link = {
  __typename?: 'Strapi_CertificationConnectionHero_link';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionId = {
  __typename?: 'Strapi_CertificationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionImage = {
  __typename?: 'Strapi_CertificationConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionName = {
  __typename?: 'Strapi_CertificationConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionPage_Settings = {
  __typename?: 'Strapi_CertificationConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionPublished_At = {
  __typename?: 'Strapi_CertificationConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionReviews_Widget = {
  __typename?: 'Strapi_CertificationConnectionReviews_widget';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionSlug = {
  __typename?: 'Strapi_CertificationConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionUpdated_At = {
  __typename?: 'Strapi_CertificationConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationConnectionWebsite_Locale = {
  __typename?: 'Strapi_CertificationConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationConnection>;
};

export type Strapi_CertificationCta = {
  __typename?: 'Strapi_CertificationCta';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  column_one_heading?: Maybe<Scalars['String']>;
  column_one_body?: Maybe<Scalars['String']>;
  column_one_link?: Maybe<Strapi_ComponentAtomLink>;
  column_two_heading?: Maybe<Scalars['String']>;
  column_two_body?: Maybe<Scalars['String']>;
  column_two_link?: Maybe<Strapi_ComponentAtomLink>;
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_CertificationCtaEntity = {
  __typename?: 'Strapi_CertificationCtaEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_CertificationCta>;
};

export type Strapi_CertificationCtaEntityResponse = {
  __typename?: 'Strapi_CertificationCtaEntityResponse';
  data?: Maybe<Strapi_CertificationCtaEntity>;
};

export type Strapi_CertificationCtaAggregator = {
  __typename?: 'Strapi_CertificationCtaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_CertificationCtaConnection = {
  __typename?: 'Strapi_CertificationCtaConnection';
  values?: Maybe<Array<Maybe<Strapi_CertificationCta>>>;
  groupBy?: Maybe<Strapi_CertificationCtaGroupBy>;
  aggregate?: Maybe<Strapi_CertificationCtaAggregator>;
};

export type Strapi_CertificationCtaConnectionColumn_One_Body = {
  __typename?: 'Strapi_CertificationCtaConnectionColumn_one_body';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionColumn_One_Heading = {
  __typename?: 'Strapi_CertificationCtaConnectionColumn_one_heading';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionColumn_One_Link = {
  __typename?: 'Strapi_CertificationCtaConnectionColumn_one_link';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionColumn_Two_Body = {
  __typename?: 'Strapi_CertificationCtaConnectionColumn_two_body';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionColumn_Two_Heading = {
  __typename?: 'Strapi_CertificationCtaConnectionColumn_two_heading';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionColumn_Two_Link = {
  __typename?: 'Strapi_CertificationCtaConnectionColumn_two_link';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionCreated_At = {
  __typename?: 'Strapi_CertificationCtaConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionId = {
  __typename?: 'Strapi_CertificationCtaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionName = {
  __typename?: 'Strapi_CertificationCtaConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionPublished_At = {
  __typename?: 'Strapi_CertificationCtaConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionUpdated_At = {
  __typename?: 'Strapi_CertificationCtaConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaConnectionWebsite_Locale = {
  __typename?: 'Strapi_CertificationCtaConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CertificationCtaConnection>;
};

export type Strapi_CertificationCtaGroupBy = {
  __typename?: 'Strapi_CertificationCtaGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionUpdated_At>>>;
  column_one_heading?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionColumn_One_Heading>>>;
  column_one_body?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionColumn_One_Body>>>;
  column_one_link?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionColumn_One_Link>>>;
  column_two_heading?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionColumn_Two_Heading>>>;
  column_two_body?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionColumn_Two_Body>>>;
  column_two_link?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionColumn_Two_Link>>>;
  name?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionName>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_CertificationCtaConnectionPublished_At>>>;
};

export type Strapi_CertificationCtaInput = {
  column_one_heading?: Maybe<Scalars['String']>;
  column_one_body?: Maybe<Scalars['String']>;
  column_one_link?: Maybe<Strapi_ComponentAtomLinkInput>;
  column_two_heading?: Maybe<Scalars['String']>;
  column_two_body?: Maybe<Scalars['String']>;
  column_two_link?: Maybe<Strapi_ComponentAtomLinkInput>;
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_CertificationGroupBy = {
  __typename?: 'Strapi_CertificationGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CertificationConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CertificationConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CertificationConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_CertificationConnectionName>>>;
  slug?: Maybe<Array<Maybe<Strapi_CertificationConnectionSlug>>>;
  excerpt?: Maybe<Array<Maybe<Strapi_CertificationConnectionExcerpt>>>;
  certification_cta?: Maybe<Array<Maybe<Strapi_CertificationConnectionCertification_Cta>>>;
  image?: Maybe<Array<Maybe<Strapi_CertificationConnectionImage>>>;
  hero_body?: Maybe<Array<Maybe<Strapi_CertificationConnectionHero_Body>>>;
  hero_link?: Maybe<Array<Maybe<Strapi_CertificationConnectionHero_Link>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CertificationConnectionWebsite_Locale>>>;
  footer_cta?: Maybe<Array<Maybe<Strapi_CertificationConnectionFooter_Cta>>>;
  certification_english_levels?: Maybe<Array<Maybe<Strapi_CertificationConnectionCertification_English_Levels>>>;
  city_heading_text?: Maybe<Array<Maybe<Strapi_CertificationConnectionCity_Heading_Text>>>;
  exam_schools_heading?: Maybe<Array<Maybe<Strapi_CertificationConnectionExam_Schools_Heading>>>;
  reviews_widget?: Maybe<Array<Maybe<Strapi_CertificationConnectionReviews_Widget>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_CertificationConnectionPage_Settings>>>;
  published_at?: Maybe<Array<Maybe<Strapi_CertificationConnectionPublished_At>>>;
};

export type Strapi_CertificationInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  certification_cta?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  hero_body?: Maybe<Scalars['String']>;
  hero_link?: Maybe<Strapi_ComponentAtomLinkInput>;
  schools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  footer_cta?: Maybe<Strapi_ComponentPageCallToActionInput>;
  certification_english_levels?: Maybe<Strapi_ComponentPageEnglishLevelInput>;
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  city_heading_text?: Maybe<Scalars['String']>;
  exam_schools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  exam_schools_heading?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Scalars['Strapi_CertificationComponentsDynamicZoneInput']>>;
  reviews_widget?: Maybe<Strapi_ComponentPageReviewsIoWidgetInput>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_City = {
  __typename?: 'Strapi_City';
  name: Scalars['String'];
  schools?: Maybe<Strapi_SchoolRelationResponseCollection>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  description?: Maybe<Scalars['String']>;
  hero_link?: Maybe<Strapi_ComponentAtomLink>;
  image?: Maybe<Strapi_UploadFileEntityResponse>;
  components?: Maybe<Array<Maybe<Strapi_CityComponentsDynamicZone>>>;
  image_and_text?: Maybe<Strapi_ComponentPageImageAndText>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  slug?: Maybe<Scalars['String']>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_CityRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};




export type Strapi_CitySchoolsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_CityAggregator = {
  __typename?: 'Strapi_CityAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};
export type Strapi_CityComponentsDynamicZone = Strapi_ComponentPageCallToAction | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnLvlsAcd | Strapi_ComponentPageEnLvlsTbl | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHeroMap | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText | Strapi_ComponentDataRelatedSchools | Strapi_Error;

export type Strapi_CityEntity = {
  __typename?: 'Strapi_CityEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_City>;
};

export type Strapi_CityEntityResponse = {
  __typename?: 'Strapi_CityEntityResponse';
  data?: Maybe<Strapi_CityEntity>;
};

export type Strapi_CityRelationResponseCollection = {
  __typename?: 'Strapi_CityRelationResponseCollection';
  data: Array<Strapi_CityEntity>;
};

export type Strapi_CityConnection = {
  __typename?: 'Strapi_CityConnection';
  values?: Maybe<Array<Maybe<Strapi_City>>>;
  groupBy?: Maybe<Strapi_CityGroupBy>;
  aggregate?: Maybe<Strapi_CityAggregator>;
};

export type Strapi_CityConnectionCreated_At = {
  __typename?: 'Strapi_CityConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionDescription = {
  __typename?: 'Strapi_CityConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionHero_Link = {
  __typename?: 'Strapi_CityConnectionHero_link';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionId = {
  __typename?: 'Strapi_CityConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionImage = {
  __typename?: 'Strapi_CityConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionImage_And_Text = {
  __typename?: 'Strapi_CityConnectionImage_and_text';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionName = {
  __typename?: 'Strapi_CityConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionPage_Settings = {
  __typename?: 'Strapi_CityConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionPublished_At = {
  __typename?: 'Strapi_CityConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionSlug = {
  __typename?: 'Strapi_CityConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionUpdated_At = {
  __typename?: 'Strapi_CityConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityConnectionWebsite_Locale = {
  __typename?: 'Strapi_CityConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CityConnection>;
};

export type Strapi_CityGroupBy = {
  __typename?: 'Strapi_CityGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CityConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CityConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CityConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_CityConnectionName>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CityConnectionWebsite_Locale>>>;
  description?: Maybe<Array<Maybe<Strapi_CityConnectionDescription>>>;
  hero_link?: Maybe<Array<Maybe<Strapi_CityConnectionHero_Link>>>;
  image?: Maybe<Array<Maybe<Strapi_CityConnectionImage>>>;
  image_and_text?: Maybe<Array<Maybe<Strapi_CityConnectionImage_And_Text>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_CityConnectionPage_Settings>>>;
  slug?: Maybe<Array<Maybe<Strapi_CityConnectionSlug>>>;
  published_at?: Maybe<Array<Maybe<Strapi_CityConnectionPublished_At>>>;
};

export type Strapi_CityInput = {
  name?: Maybe<Scalars['String']>;
  schools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  hero_link?: Maybe<Strapi_ComponentAtomLinkInput>;
  image?: Maybe<Scalars['ID']>;
  components?: Maybe<Array<Scalars['Strapi_CityComponentsDynamicZoneInput']>>;
  image_and_text?: Maybe<Strapi_ComponentPageImageAndTextInput>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingsInput>;
  slug?: Maybe<Scalars['String']>;
  seo?: Maybe<Strapi_ComponentSharedSeoInput>;
  title?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_ComponentAtomArrowList = {
  __typename?: 'Strapi_ComponentAtomArrowList';
  id: Scalars['ID'];
  list_item?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomArrowListInput = {
  list_item?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomColumn = {
  __typename?: 'Strapi_ComponentAtomColumn';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  content: Scalars['String'];
};

export type Strapi_ComponentAtomColumnInput = {
  title?: Maybe<Scalars['String']>;
  content: Scalars['String'];
};

export type Strapi_ComponentAtomCourseFeatureInput = {
  feature?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomCourseTextInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomCourseFeatures = {
  __typename?: 'Strapi_ComponentAtomCourseFeatures';
  id: Scalars['ID'];
  feature?: Maybe<Scalars['String']>;
};
export type Strapi_ComponentAtomCourseText = {
  __typename?: 'Strapi_ComponentAtomCourseText';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomDeliveryMethodCard = {
  __typename?: 'Strapi_ComponentAtomDeliveryMethodCard';
  id: Scalars['ID'];
  delivery_method?: Maybe<Strapi_DeliveryMethod>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  show_features: Scalars['Boolean'];
  show_price: Scalars['Boolean'];
};

export type Strapi_ComponentAtomDeliveryMethodCardInput = {
  name: Scalars['String'];
  delivery_method?: Maybe<Scalars['ID']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  show_features?: Maybe<Scalars['Boolean']>;
  show_price?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentAtomEnglishLevel = {
  __typename?: 'Strapi_ComponentAtomEnglishLevel';
  id: Scalars['ID'];
  level?: Maybe<Scalars['String']>;
  level_description?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomEnglishLevelInput = {
  level?: Maybe<Scalars['String']>;
  level_description?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomExternalLinkInput = {
  link_name?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  open_in_new_window?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentAtomExternalLinks = {
  __typename?: 'Strapi_ComponentAtomExternalLinks';
  id: Scalars['ID'];
  link_name?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  open_in_new_window?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentAtomHeaderHeroSection = {
  __typename?: 'Strapi_ComponentAtomHeaderHeroSection';
  id: Scalars['ID'];
  hero_title?: Maybe<Scalars['String']>;
  hero_full_image?: Maybe<Strapi_UploadFileEntityResponse>;
  hero_body_features?: Maybe<Array<Maybe<Strapi_ComponentAtomCourseFeatures>>>;
  hero_cta?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  show_hero_section?: Maybe<Scalars['Boolean']>;
  promotion?: Maybe<Array<Maybe<Strapi_Promotion>>>;
};

export type Strapi_ComponentAtomLink = {
  __typename?: 'Strapi_ComponentAtomLink';
  id: Scalars['ID'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  page?: Maybe<Strapi_Page>;
  open_in_new_window?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
  modal?: Maybe<Strapi_Modal>;
};

export type Strapi_ComponentAtomLinkInput = {
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['ID']>;
  open_in_new_window?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
  modal?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentAtomListItem = {
  __typename?: 'Strapi_ComponentAtomListItem';
  id: Scalars['ID'];
  content: Scalars['String'];
  is_faded: Scalars['Boolean'];
};

export type Strapi_ComponentAtomListItemInput = {
  content: Scalars['String'];
  is_faded?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentAtomLogoInput = {
  name?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentAtomLogos = {
  __typename?: 'Strapi_ComponentAtomLogos';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentAtomMapMarker = {
  __typename?: 'Strapi_ComponentAtomMapMarker';
  id: Scalars['ID'];
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;
};
export type Strapi_ComponentAtomMapMarkerInput = {
  id?: Maybe<Scalars['ID']>;
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentAtomMapLocationInput = {
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentAtomPeopleCard = {
  __typename?: 'Strapi_ComponentAtomPeopleCard';
  id: Scalars['ID'];
  person_name?: Maybe<Scalars['String']>;
  person_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentAtomPeopleCardInput = {
  person_name?: Maybe<Scalars['String']>;
  person_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentAtomPricingPlan = {
  __typename?: 'Strapi_ComponentAtomPricingPlan';
  id: Scalars['ID'];
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  hubspot_form?: Maybe<Scalars['String']>;
  banner_text?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomPricingPlanInput = {
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  hubspot_form?: Maybe<Scalars['String']>;
  banner_text?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomScrollingStatement = {
  __typename?: 'Strapi_ComponentAtomScrollingStatement';
  id: Scalars['ID'];
  statement?: Maybe<Scalars['String']>;
  sub_heading?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomScrollingStatementInput = {
  statement?: Maybe<Scalars['String']>;
  sub_heading?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomSocialLink = {
  __typename?: 'Strapi_ComponentAtomSocialLink';
  id: Scalars['ID'];
  link_name?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomSocialLinkInput = {
  link_name?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentAtomTeacher = {
  __typename?: 'Strapi_ComponentAtomTeacher';
  id: Scalars['ID'];
  teacher_name?: Maybe<Scalars['String']>;
  teacher_position?: Maybe<Scalars['String']>;
  teacher_image?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentAtomTeacherInput = {
  teacher_name?: Maybe<Scalars['String']>;
  teacher_position?: Maybe<Scalars['String']>;
  teacher_image?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentAtomLearningProductList = {
  __typename?: 'Strapi_ComponentAtomLearningProductList';
  id: Scalars['ID'];
  product_name?: Maybe<Scalars['String']>;
  product_link_url?: Maybe<Scalars['String']>;
  product_image?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentAtomLearningProductListInput = {
  product_name?: Maybe<Scalars['String']>;
  product_link_url?: Maybe<Scalars['String']>;
  product_image?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentAtomWseSiteLink = {
  __typename?: 'Strapi_ComponentAtomWseSiteLink';
  id: Scalars['ID'];
  territory?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  flag_image?: Maybe<Strapi_UploadFile>;
  region?: Maybe<Strapi_Enum_Componentatomwsesitelink_Region>;
};

export type Strapi_ComponentAtomWseSiteLinkInput = {
  territory?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  flag_image?: Maybe<Scalars['ID']>;
  region?: Maybe<Strapi_Enum_Componentatomwsesitelink_Region>;
};

export type Strapi_ComponentDataEnglishLevel = {
  __typename?: 'Strapi_ComponentDataEnglishLevel';
  id: Scalars['ID'];
  name: Scalars['String'];
  level: Scalars['Int'];
  description: Scalars['String'];
  certifications?: Maybe<Array<Maybe<Strapi_ComponentDataEnglishLevelComparison>>>;
  information_blocks?: Maybe<Array<Maybe<Strapi_ComponentAtomColumn>>>;
  examples?: Maybe<Strapi_ComponentAtomColumn>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_ComponentDataEnglishLevelComparison = {
  __typename?: 'Strapi_ComponentDataEnglishLevelComparison';
  id: Scalars['ID'];
  certification: Scalars['String'];
  corresponding_level: Scalars['String'];
};

export type Strapi_ComponentDataEnglishLevelComparisonInput = {
  certification: Scalars['String'];
  corresponding_level: Scalars['String'];
};

export type Strapi_ComponentDataEnglishLevelInput = {
  name: Scalars['String'];
  level: Scalars['Int'];
  description: Scalars['String'];
  certifications?: Maybe<Array<Maybe<Strapi_ComponentDataEnglishLevelComparisonInput>>>;
  information_blocks?: Maybe<Array<Strapi_ComponentAtomColumnInput>>;
  examples: Strapi_ComponentAtomColumnInput;
  website_locale?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentDataCourseName = {
  __typename?: 'Strapi_ComponentDataCourseName';
  id: Scalars['ID'];
  name: Scalars['String'];
  courses_available?: Maybe<Array<Maybe<Strapi_ComponentDataCourseAvailability>>>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_ComponentDataCourseAvailability = {
  __typename?: 'Strapi_ComponentDataCourseAvailability';
  id: Scalars['ID'];
  courseName: Scalars['String'];
  availability: Scalars['Boolean'];
};

export type Strapi_ComponentDataCourseAvailabilityInput = {
  courseName: Scalars['String'];
  availability: Scalars['Boolean'];
};

export type Strapi_ComponentDataCourseNameInput = {
  name: Scalars['String'];
  couses_available?: Maybe<Array<Maybe<Strapi_ComponentDataCourseAvailabilityInput>>>;
  website_locale?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentDataPageSettingInput = {
  show_footer_cta?: Maybe<Scalars['Boolean']>;
  custom_footer_cta?: Maybe<Scalars['ID']>;
  meta_description?: Maybe<Scalars['String']>;
  avoid_indexing?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentDataPageSettings = {
  __typename?: 'Strapi_ComponentDataPageSettings';
  id: Scalars['ID'];
  show_footer_cta: Scalars['Boolean'];
  custom_footer_cta?: Maybe<Strapi_FooterCta>;
  meta_description?: Maybe<Scalars['String']>;
  avoid_indexing?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentDataPriceDescription = {
  __typename?: 'Strapi_ComponentDataPriceDescription';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  price: Scalars['String'];
  frequency?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentDataPriceDescriptionInput = {
  label?: Maybe<Scalars['String']>;
  price: Scalars['String'];
  frequency?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentDataPageSettingsInput = {
  id?: Maybe<Scalars['ID']>;
  show_footer_cta?: Maybe<Scalars['Boolean']>;
  custom_footer_cta?: Maybe<Scalars['ID']>;
  meta_description?: Maybe<Scalars['String']>;
  avoid_indexing?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentDataRelatedSchools = {
  __typename?: 'Strapi_ComponentDataRelatedSchools';
  id: Scalars['ID'];
  related_schools?: Maybe<Strapi_SchoolRelationResponseCollection>;
};

export type Strapi_ComponentNavigationNavigationItem = {
  __typename?: 'Strapi_ComponentNavigationNavigationItem';
  id: Scalars['ID'];
  title: Scalars['String'];
  link?: Maybe<Strapi_ComponentAtomLink>;
  child_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
};

export type Strapi_ComponentNavigationNavigationItemInput = {
  title: Scalars['String'];
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  child_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
};

export type Strapi_ComponentPageCallToAction = {
  __typename?: 'Strapi_ComponentPageCallToAction';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  style?: Maybe<Strapi_Enum_Componentpagecalltoaction_Style>;
};

export type Strapi_ComponentPageCallToActionInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  link: Strapi_ComponentAtomLinkInput;
  style?: Maybe<Strapi_Enum_Componentpagecalltoaction_Style>;
};

export type Strapi_ComponentPageCareersGallery = {
  __typename?: 'Strapi_ComponentPageCareersGallery';
  id: Scalars['ID'];
  career_posts?: Maybe<Array<Maybe<Strapi_CareerPost>>>;
};


export type Strapi_ComponentPageCareersGalleryCareer_PostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentPageCareersGalleryInput = {
  career_posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Strapi_ComponentPageColumnInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Strapi_ComponentAtomColumnInput>>;
  show_column_index?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
};

export type Strapi_ComponentPageColumns = {
  __typename?: 'Strapi_ComponentPageColumns';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Maybe<Strapi_ComponentAtomColumn>>>;
  show_column_index?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
};

export type Strapi_ComponentPageCourseCmprsns = {
  __typename?: 'Strapi_ComponentPageCourseCmprsns';
  id: Scalars['ID'];
  course_comparison_table?: Maybe<Strapi_CourseComparisonTableEntityResponse>;
};

export type Strapi_ComponentPageCourseCtaPanel = {
  __typename?: 'Strapi_ComponentPageCourseCtaPanel';
  id: Scalars['ID'];
  image?: Maybe<Strapi_UploadFile>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  Speech_bubble_text?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageCourseCtaPanelInput = {
  image?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  Speech_bubble_text?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageDetailedPricingPlan = {
  __typename?: 'Strapi_ComponentPageDetailedPricingPlan';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  delivery_method?: Maybe<Strapi_DeliveryMethod>;
};

export type Strapi_ComponentPageDetailedPricingPlanInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  delivery_method?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageEmbedCode = {
  __typename?: 'Strapi_ComponentPageEmbedCode';
  id: Scalars['ID'];
  content: Scalars['String'];
};

export type Strapi_ComponentPageEmbedCodeInput = {
  content: Scalars['String'];
};

export type Strapi_ComponentPageEnLvlsAcd = {
  __typename?: 'Strapi_ComponentPageEnLvlsAcd';
  id: Scalars['ID'];
  english_level_group?: Maybe<Strapi_EnglishLevelGroupEntityResponse>;
};

export type Strapi_ComponentPageEnLvlsTbl = {
  __typename?: 'Strapi_ComponentPageEnLvlsTbl';
  id: Scalars['ID'];
  english_level_group?: Maybe<Strapi_EnglishLevelGroupEntityResponse>;
  highlighted_columns?: Maybe<Scalars['String']>;
};


export type Strapi_ComponentPageEnglishLevelInput = {
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  footer_header?: Maybe<Scalars['String']>;
  footer_description?: Maybe<Scalars['String']>;
  footer_link_url?: Maybe<Scalars['String']>;
  footer_link_url_text?: Maybe<Scalars['String']>;
  English_Level?: Maybe<Array<Maybe<Strapi_ComponentAtomEnglishLevelInput>>>;
};

export type Strapi_ComponentPageEnglishLevels = {
  __typename?: 'Strapi_ComponentPageEnglishLevels';
  id: Scalars['ID'];
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  footer_header?: Maybe<Scalars['String']>;
  footer_description?: Maybe<Scalars['String']>;
  footer_link_url?: Maybe<Scalars['String']>;
  footer_link_url_text?: Maybe<Scalars['String']>;
  English_Level?: Maybe<Array<Maybe<Strapi_ComponentAtomEnglishLevel>>>;
};

export type Strapi_ComponentPageEnglishLevelsAccordion = {
  __typename?: 'Strapi_ComponentPageEnglishLevelsAccordion';
  id: Scalars['ID'];
  english_level_group?: Maybe<Strapi_EnglishLevelGroup>;
};

export type Strapi_ComponentPageEnglishLevelsAccordionInput = {
  english_level_group?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageEnglishLevelsTable = {
  __typename?: 'Strapi_ComponentPageEnglishLevelsTable';
  id: Scalars['ID'];
  english_level_group?: Maybe<Strapi_EnglishLevelGroup>;
  highlighted_columns?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageEnglishLevelsTableInput = {
  english_level_group?: Maybe<Scalars['ID']>;
  highlighted_columns?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageCourseComparison = {
  __typename?: 'Strapi_ComponentPageCourseComparison';
  id: Scalars['ID'];
  course_comparison_table?: Maybe<Strapi_CourseComparison>;
};

export type Strapi_ComponentPageCourseComparisonInput = {
  course_comparison_table?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageEventsCtaPanel = {
  __typename?: 'Strapi_ComponentPageEventsCtaPanel';
  id: Scalars['ID'];
  panel_title?: Maybe<Scalars['String']>;
  event_link_text?: Maybe<Scalars['String']>;
  event_link_url?: Maybe<Scalars['String']>;
  event_calendar_text?: Maybe<Scalars['String']>;
  event_calendar_url?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageEventsCtaPanelInput = {
  panel_title?: Maybe<Scalars['String']>;
  event_link_text?: Maybe<Scalars['String']>;
  event_link_url?: Maybe<Scalars['String']>;
  event_calendar_text?: Maybe<Scalars['String']>;
  event_calendar_url?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageHero = {
  __typename?: 'Strapi_ComponentPageHero';
  id: Scalars['ID'];
  image?: Maybe<Strapi_UploadFile>;
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  button?: Maybe<Strapi_ComponentAtomLink>;
};

export type Strapi_ComponentPageHeroCourse = {
  __typename?: 'Strapi_ComponentPageHeroCourse';
  id: Scalars['ID'];
  main_heading?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFile>;
  logo_one?: Maybe<Strapi_UploadFile>;
  logo_two?: Maybe<Strapi_UploadFile>;
  logo_one_url_link?: Maybe<Scalars['String']>;
  logo_two_url_link?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageHeroCourseInput = {
  main_heading?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  logo_one?: Maybe<Scalars['ID']>;
  logo_two?: Maybe<Scalars['ID']>;
  logo_one_url_link?: Maybe<Scalars['String']>;
  logo_two_url_link?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageHeroInput = {
  image?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  button?: Maybe<Strapi_ComponentAtomLinkInput>;
};

export type Strapi_ComponentPageHeroMap = {
  __typename?: 'Strapi_ComponentPageHeroMap';
  id: Scalars['ID'];
  map_title?: Maybe<Scalars['String']>;
  map_default_zoom?: Maybe<Scalars['Int']>;
  markers?: Maybe<Array<Maybe<Strapi_ComponentAtomMapMarker>>>;
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentPageHeroMapInput = {
  map_title?: Maybe<Scalars['String']>;
  map_default_zoom?: Maybe<Scalars['Int']>;
  markers?: Maybe<Array<Maybe<Strapi_ComponentAtomMapMarkerInput>>>;
};

export type Strapi_ComponentPageHtml = {
  __typename?: 'Strapi_ComponentPageHtml';
  id: Scalars['ID'];
  name: Scalars['String'];
  html_code: Scalars['String'];
};

export type Strapi_ComponentPageHtmlInput = {
  name: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  html_code: Scalars['String'];
};

export type Strapi_ComponentPageImageAndText = {
  __typename?: 'Strapi_ComponentPageImageAndText';
  id: Scalars['ID'];
  title: Scalars['String'];
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  button?: Maybe<Strapi_ComponentAtomLink>;
  image_position?: Maybe<Strapi_Enum_Componentpageimageandtext_Image_Position>;
  image?: Maybe<Strapi_UploadFile>;
  intro?: Maybe<Scalars['String']>;
  shaded_background?: Maybe<Scalars['Boolean']>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_ComponentPageImageAndTextInput = {
  title: Scalars['String'];
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  button?: Maybe<Strapi_ComponentAtomLinkInput>;
  image_position?: Maybe<Strapi_Enum_Componentpageimageandtext_Image_Position>;
  image?: Maybe<Scalars['ID']>;
  intro?: Maybe<Scalars['String']>;
  shaded_background?: Maybe<Scalars['Boolean']>;
  website_locale?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageInlineHubspotForm = {
  __typename?: 'Strapi_ComponentPageInlineHubspotForm';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  html: Scalars['String'];
};

export type Strapi_ComponentPageInlineHubspotFormFiltersInput = {
  title?: Maybe<Strapi_StringFilterInput>;
  description?: Maybe<Strapi_StringFilterInput>;
  html?: Maybe<Strapi_StringFilterInput>;
  and?: Maybe<Array<Maybe<Strapi_ComponentPageInlineHubspotFormFiltersInput>>>;
  or?: Maybe<Array<Maybe<Strapi_ComponentPageInlineHubspotFormFiltersInput>>>;
  not?: Maybe<Strapi_ComponentPageInlineHubspotFormFiltersInput>;
};

export type Strapi_ComponentPageInlineHubspotFormInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageLocationPanel = {
  __typename?: 'Strapi_ComponentPageLocationPanel';
  id: Scalars['ID'];
  title: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  map?: Maybe<Strapi_ComponentPageMap>;
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentPageLocationPanelInput = {
  title: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  map?: Maybe<Strapi_ComponentPageMapInput>;
};

export type Strapi_ComponentPageLogoGallery = {
  __typename?: 'Strapi_ComponentPageLogoGallery';
  id: Scalars['ID'];
  logos?: Maybe<Array<Maybe<Strapi_ComponentAtomLogos>>>;
  logo_title?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageLogoGalleryInput = {
  logos?: Maybe<Array<Maybe<Strapi_ComponentAtomLogoInput>>>;
  logo_title?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageMap = {
  __typename?: 'Strapi_ComponentPageMap';
  id: Scalars['ID'];
  width: Scalars['String'];
  height: Scalars['String'];
  default_zoom: Scalars['Int'];
  markers?: Maybe<Array<Maybe<Strapi_ComponentAtomMapMarker>>>;
  default_center?: Maybe<Strapi_ComponentAtomMapMarker>;
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentPageMapInput = {
  width?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  default_zoom?: Maybe<Scalars['Int']>;
  markers?: Maybe<Array<Maybe<Strapi_ComponentAtomMapMarkerInput>>>;
  default_center?: Maybe<Strapi_ComponentAtomMapMarkerInput>;
};

export type Strapi_ComponentPageMeetTheTeamGallery = {
  __typename?: 'Strapi_ComponentPageMeetTheTeamGallery';
  id: Scalars['ID'];
  people?: Maybe<Array<Maybe<Strapi_ComponentAtomPeopleCard>>>;
};

export type Strapi_ComponentPageMeetTheTeamGalleryInput = {
  people?: Maybe<Array<Maybe<Strapi_ComponentAtomPeopleCardInput>>>;
};

export type Strapi_ComponentPageMeta = {
  __typename?: 'Strapi_ComponentPageMeta';
  id: Scalars['ID'];
  name: Scalars['String'];
  content: Scalars['String'];
};

export type Strapi_ComponentPageMetaInput = {
  name: Scalars['String'];
  content: Scalars['String'];
};

export type Strapi_ComponentPagePricingPlanPanel = {
  __typename?: 'Strapi_ComponentPagePricingPlanPanel';
  id: Scalars['ID'];
  main_heading?: Maybe<Scalars['String']>;
  main_description?: Maybe<Scalars['String']>;
  delivery_methods?: Maybe<Array<Maybe<Strapi_ComponentAtomDeliveryMethodCard>>>;
};

export type Strapi_ComponentPagePricingPlanPanelInput = {
  main_heading?: Maybe<Scalars['String']>;
  main_description?: Maybe<Scalars['String']>;
  delivery_methods?: Maybe<Array<Strapi_ComponentAtomDeliveryMethodCardInput>>;
};

export type Strapi_ComponentPagePromotionsCtaPanel = {
  __typename?: 'Strapi_ComponentPagePromotionsCtaPanel';
  id: Scalars['ID'];
  main_heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  second_heading?: Maybe<Scalars['String']>;
  second_description?: Maybe<Scalars['String']>;
  hubspot_form?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFile>;
  secondary_link?: Maybe<Strapi_ComponentAtomLink>;
  promotions?: Maybe<Array<Maybe<Strapi_Promotion>>>;
};


export type Strapi_ComponentPagePromotionsCtaPanelPromotionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentPagePromotionsCtaPanelInput = {
  main_heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  second_heading?: Maybe<Scalars['String']>;
  second_description?: Maybe<Scalars['String']>;
  hubspot_form?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  secondary_link?: Maybe<Strapi_ComponentAtomLinkInput>;
};

export type Strapi_ComponentPageQuoteAndText = {
  __typename?: 'Strapi_ComponentPageQuoteAndText';
  id: Scalars['ID'];
  quote: Scalars['String'];
  author?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFile>;
  video?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentPageQuoteAndTextInput = {
  quote: Scalars['String'];
  author?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  video?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageReviewsIoWidget = {
  __typename?: 'Strapi_ComponentPageReviewsIoWidget';
  id: Scalars['ID'];
  heading?: Maybe<Scalars['String']>;
  script?: Maybe<Strapi_ComponentPageHtml>;
  load_defer?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentPageTrustPilotWidget = {
  __typename?: 'Strapi_ComponentPageTrustPilotWidget';
  id: Scalars['ID'];
  heading?: Maybe<Scalars['String']>;
  script?: Maybe<Strapi_ComponentPageHtml>;
};

export type Strapi_ComponentPageReviewsIoWidgetInput = {
  heading?: Maybe<Scalars['String']>;
  script: Strapi_ComponentPageHtmlInput;
  load_defer?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentPageTrustPilotWidgetInput = {
  heading?: Maybe<Scalars['String']>;
  script: Strapi_ComponentPageHtmlInput;
};

export type Strapi_ComponentPageRichList = {
  __typename?: 'Strapi_ComponentPageRichList';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  cta?: Maybe<Strapi_ComponentAtomLink>;
  items?: Maybe<Array<Maybe<Strapi_ComponentAtomColumn>>>;
};

export type Strapi_ComponentPageRichListInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  cta?: Maybe<Strapi_ComponentAtomLinkInput>;
  items?: Maybe<Array<Strapi_ComponentAtomColumnInput>>;
};

export type Strapi_ComponentPageRichText = {
  __typename?: 'Strapi_ComponentPageRichText';
  id: Scalars['ID'];
  content: Scalars['String'];
  button?: Maybe<Strapi_ComponentAtomLink>;
};

export type Strapi_ComponentPageRichTextInput = {
  content: Scalars['String'];
  button?: Maybe<Strapi_ComponentAtomLinkInput>;
};

export type Strapi_ComponentPageSchoolInfoBox = {
  __typename?: 'Strapi_ComponentPageSchoolInfoBox';
  id: Scalars['ID'];
  misc_links?: Maybe<Array<Maybe<Strapi_ComponentAtomExternalLinks>>>;
  social_links?: Maybe<Array<Maybe<Strapi_ComponentAtomSocialLink>>>;
  contact_number?: Maybe<Scalars['String']>;
  internal_links_list_heading?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  external_link_heading?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  internal_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  external_links_list?: Maybe<Array<Maybe<Strapi_ComponentAtomExternalLinks>>>;
  opening_times?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageSchoolInfoBoxInput = {
  misc_links?: Maybe<Array<Maybe<Strapi_ComponentAtomExternalLinkInput>>>;
  social_links?: Maybe<Array<Maybe<Strapi_ComponentAtomSocialLinkInput>>>;
  contact_number?: Maybe<Scalars['String']>;
  internal_links_list_heading?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  external_link_heading?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  internal_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  external_links_list?: Maybe<Array<Maybe<Strapi_ComponentAtomExternalLinkInput>>>;
  opening_times?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageScrollingStatement = {
  __typename?: 'Strapi_ComponentPageScrollingStatement';
  id: Scalars['ID'];
  heading: Scalars['String'];
  scrolling_statement?: Maybe<Array<Maybe<Strapi_ComponentAtomScrollingStatement>>>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  image_left?: Maybe<Strapi_UploadFile>;
  image_right?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentPageScrollingStatementInput = {
  heading: Scalars['String'];
  scrolling_statement?: Maybe<Array<Maybe<Strapi_ComponentAtomScrollingStatementInput>>>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  image_left?: Maybe<Scalars['ID']>;
  image_right?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageSimpleTitle = {
  __typename?: 'Strapi_ComponentPageSimpleTitle';
  id: Scalars['ID'];
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageSimpleTitleInput = {
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentPageTeacherAndCoachInput = {
  quote_text?: Maybe<Scalars['String']>;
  quote_author?: Maybe<Scalars['String']>;
  quote_author_position?: Maybe<Scalars['String']>;
  intro_heading?: Maybe<Scalars['String']>;
  intro_text?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  teachers?: Maybe<Array<Maybe<Strapi_ComponentAtomTeacherInput>>>;
};

export type Strapi_ComponentPageTeacherAndCoaches = {
  __typename?: 'Strapi_ComponentPageTeacherAndCoaches';
  id: Scalars['ID'];
  quote_text?: Maybe<Scalars['String']>;
  quote_author?: Maybe<Scalars['String']>;
  quote_author_position?: Maybe<Scalars['String']>;
  intro_heading?: Maybe<Scalars['String']>;
  intro_text?: Maybe<Scalars['String']>;
  teachers?: Maybe<Array<Maybe<Strapi_ComponentAtomTeacher>>>;
  images?: Maybe<Array<Maybe<Strapi_UploadFile>>>;
};


export type Strapi_ComponentPageTeacherAndCoachesImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ComponentPageText = {
  __typename?: 'Strapi_ComponentPageText';
  id: Scalars['ID'];
  content: Scalars['String'];
  link?: Maybe<Strapi_ComponentAtomLink>;
};

export type Strapi_ComponentPageTextAndSplitImageInput = {
  main_heading?: Maybe<Scalars['String']>;
  main_description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  image_left?: Maybe<Scalars['ID']>;
  image_center?: Maybe<Scalars['ID']>;
  image_right?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageTextAndSplitImages = {
  __typename?: 'Strapi_ComponentPageTextAndSplitImages';
  id: Scalars['ID'];
  main_heading?: Maybe<Scalars['String']>;
  main_description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  image_left?: Maybe<Strapi_UploadFile>;
  image_center?: Maybe<Strapi_UploadFile>;
  image_right?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentPageTextInput = {
  content: Scalars['String'];
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
};

export type Strapi_ComponentPageThreeBlocksAndImage = {
  __typename?: 'Strapi_ComponentPageThreeBlocksAndImage';
  id: Scalars['ID'];
  list_one?: Maybe<Array<Maybe<Strapi_ComponentAtomArrowList>>>;
  list_heading_one?: Maybe<Scalars['String']>;
  list_heading_two?: Maybe<Scalars['String']>;
  list_heading_three?: Maybe<Scalars['String']>;
  list_two?: Maybe<Array<Maybe<Strapi_ComponentAtomArrowList>>>;
  list_three?: Maybe<Array<Maybe<Strapi_ComponentAtomArrowList>>>;
  image?: Maybe<Strapi_UploadFile>;
};

export type Strapi_ComponentPageThreeBlocksAndImageInput = {
  list_one?: Maybe<Array<Maybe<Strapi_ComponentAtomArrowListInput>>>;
  list_heading_one?: Maybe<Scalars['String']>;
  list_heading_two?: Maybe<Scalars['String']>;
  list_heading_three?: Maybe<Scalars['String']>;
  list_two?: Maybe<Array<Maybe<Strapi_ComponentAtomArrowListInput>>>;
  list_three?: Maybe<Array<Maybe<Strapi_ComponentAtomArrowListInput>>>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentPageTwoColumnInput = {
  left_column: Strapi_ComponentAtomColumnInput;
  left_cta?: Maybe<Strapi_ComponentAtomLinkInput>;
  right_column: Strapi_ComponentAtomColumnInput;
  right_cta?: Maybe<Strapi_ComponentAtomLinkInput>;
  shaded_background?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentPageTwoColumns = {
  __typename?: 'Strapi_ComponentPageTwoColumns';
  id: Scalars['ID'];
  left_column?: Maybe<Strapi_ComponentAtomColumn>;
  left_cta?: Maybe<Strapi_ComponentAtomLink>;
  right_column?: Maybe<Strapi_ComponentAtomColumn>;
  right_cta?: Maybe<Strapi_ComponentAtomLink>;
  shaded_background?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentPageTwoColumnsAndLinkInput = {
  heading_one?: Maybe<Scalars['String']>;
  description_one?: Maybe<Scalars['String']>;
  links_one?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  heading_two?: Maybe<Scalars['String']>;
  description_two?: Maybe<Scalars['String']>;
  links_two?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
};

export type Strapi_ComponentPageTwoColumnsAndLinks = {
  __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks';
  id: Scalars['ID'];
  heading_one?: Maybe<Scalars['String']>;
  description_one?: Maybe<Scalars['String']>;
  links_one?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  heading_two?: Maybe<Scalars['String']>;
  description_two?: Maybe<Scalars['String']>;
  links_two?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
};

export type Strapi_ComponentPageVideoAndText = {
  __typename?: 'Strapi_ComponentPageVideoAndText';
  id: Scalars['ID'];
  video?: Maybe<Strapi_UploadFile>;
  video_thumbnail?: Maybe<Strapi_UploadFile>;
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  button?: Maybe<Strapi_ComponentAtomLink>;
  shaded_background?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentPageVideoAndTextInput = {
  video?: Maybe<Scalars['ID']>;
  video_thumbnail?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  intro?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  button?: Maybe<Strapi_ComponentAtomLinkInput>;
  shaded_background?: Maybe<Scalars['Boolean']>;
};

export type Strapi_ComponentSchoolPostalAddress = {
  __typename?: 'Strapi_ComponentSchoolPostalAddress';
  id: Scalars['ID'];
  street_address: Scalars['String'];
  locality?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  country: Scalars['String'];
};

export type Strapi_ComponentSchoolPostalAddressInput = {
  street_address: Scalars['String'];
  locality?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  country: Scalars['String'];
};

export type Strapi_ComponentSchoolSchoolHero = {
  __typename?: 'Strapi_ComponentSchoolSchoolHero';
  id: Scalars['ID'];
  heading: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_ComponentAtomLink>;
  show_map: Scalars['Boolean'];
  replace_map_with?: Maybe<Strapi_ComponentPageHtml>;
  mapLocation?: Maybe<Scalars['Strapi_JSON']>;  
};

export type Strapi_ComponentSchoolSchoolHeroInput = {
  heading: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_ComponentAtomLinkInput>;
  show_map?: Maybe<Scalars['Boolean']>;
  replace_map_with?: Maybe<Strapi_ComponentPageHtmlInput>;
};

export type Strapi_ComponentSharedMetaSocial = {
  __typename?: 'Strapi_ComponentSharedMetaSocial';
  id: Scalars['ID'];
  socialNetwork: Strapi_Enum_Componentsharedmetasocial_Socialnetwork;
  title: Scalars['String'];
  description: Scalars['String'];
  image?: Maybe<Strapi_UploadFileEntityResponse>;
};

export type Strapi_ComponentSharedMetaSocialFiltersInput = {
  socialNetwork?: Maybe<Strapi_StringFilterInput>;
  title?: Maybe<Strapi_StringFilterInput>;
  description?: Maybe<Strapi_StringFilterInput>;
  and?: Maybe<Array<Maybe<Strapi_ComponentSharedMetaSocialFiltersInput>>>;
  or?: Maybe<Array<Maybe<Strapi_ComponentSharedMetaSocialFiltersInput>>>;
  not?: Maybe<Strapi_ComponentSharedMetaSocialFiltersInput>;
};

export type Strapi_ComponentSharedMetaSocialInput = {
  id?: Maybe<Scalars['ID']>;
  socialNetwork?: Maybe<Strapi_Enum_Componentsharedmetasocial_Socialnetwork>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_ComponentSharedSeo = {
  __typename?: 'Strapi_ComponentSharedSeo';
  id: Scalars['ID'];
  metaTitle: Scalars['String'];
  metaDescription: Scalars['String'];
  metaImage?: Maybe<Strapi_UploadFileEntityResponse>;
  metaSocial?: Maybe<Array<Maybe<Strapi_ComponentSharedMetaSocial>>>;
  structuredData?: Maybe<Scalars['Strapi_JSON']>;
  keywords?: Maybe<Scalars['String']>;
  canonicalURL?: Maybe<Scalars['String']>;
};


export type Strapi_ComponentSharedSeoMetaSocialArgs = {
  filters?: Maybe<Strapi_ComponentSharedMetaSocialFiltersInput>;
  pagination?: Maybe<Strapi_PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Strapi_ComponentSharedSeoFiltersInput = {
  metaTitle?: Maybe<Strapi_StringFilterInput>;
  metaDescription?: Maybe<Strapi_StringFilterInput>;
  metaSocial?: Maybe<Strapi_ComponentSharedMetaSocialFiltersInput>;
  structuredData?: Maybe<Strapi_JsonFilterInput>;
  keywords?: Maybe<Strapi_StringFilterInput>;
  canonicalURL?: Maybe<Strapi_StringFilterInput>;
  and?: Maybe<Array<Maybe<Strapi_ComponentSharedSeoFiltersInput>>>;
  or?: Maybe<Array<Maybe<Strapi_ComponentSharedSeoFiltersInput>>>;
  not?: Maybe<Strapi_ComponentSharedSeoFiltersInput>;
};

export type Strapi_ComponentSharedSeoInput = {
  id?: Maybe<Scalars['ID']>;
  metaTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaImage?: Maybe<Scalars['ID']>;
  metaSocial?: Maybe<Array<Maybe<Strapi_ComponentSharedMetaSocialInput>>>;
  structuredData?: Maybe<Scalars['Strapi_JSON']>;
  keywords?: Maybe<Scalars['String']>;
  canonicalURL?: Maybe<Scalars['String']>;
};


export type Strapi_ComponentSiteAdvancedSettingInput = {
  publish_url?: Maybe<Scalars['String']>;
  is_international_site?: Maybe<Scalars['Boolean']>;
  google_maps_api_key?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentSiteAdvancedSettings = {
  __typename?: 'Strapi_ComponentSiteAdvancedSettings';
  id: Scalars['ID'];
  publish_url?: Maybe<Scalars['String']>;
  is_international_site?: Maybe<Scalars['Boolean']>;
  google_maps_api_key?: Maybe<Scalars['String']>;
};

export type Strapi_ComponentSitePageScript = {
  __typename?: 'Strapi_ComponentSitePageScript';
  id: Scalars['ID'];
  name: Scalars['String'];
  html: Scalars['String'];
  load_in_head: Scalars['Boolean'];
  load_defer: Scalars['Boolean'];
};

export type Strapi_ComponentSitePageScriptInput = {
  name: Scalars['String'];
  html: Scalars['String'];
  load_in_head?: Maybe<Scalars['Boolean']>;
  load_defer?: Maybe<Scalars['Boolean']>;
};

export type Strapi_Course = {
  __typename?: 'Strapi_Course';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  short: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  feature_type?:Maybe<Scalars['String']>;
  course_features?: Maybe<Array<Maybe<Strapi_ComponentAtomCourseFeatures>>>;
  course_text?: Maybe<Array<Maybe<Strapi_ComponentAtomCourseText>>>;
  slug?: Maybe<Scalars['String']>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  image: Strapi_UploadFileEntityResponse;
  call_to_action?: Maybe<Strapi_ComponentPageCallToAction>;
  featured: Scalars['Boolean'];
  components?: Maybe<Array<Maybe<Strapi_CourseComponentsDynamicZone>>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_CourseRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};

export type Strapi_CourseAggregator = {
  __typename?: 'Strapi_CourseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_CourseComparisonTable = {
  __typename?: 'Strapi_CourseComparisonTable';
  title?: Maybe<Scalars['String']>;
  course_list?: Maybe<Array<Maybe<Strapi_ComponentDataCourseName>>>;
  website_locale?: Maybe<Strapi_WebsiteLocaleEntityResponse>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_CourseComparisonTableRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};

export type Strapi_CourseComparisonTableEntity = {
  __typename?: 'Strapi_CourseComparisonTableEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_CourseComparisonTable>;
};

export type Strapi_CourseComparisonTableEntityResponse = {
  __typename?: 'Strapi_CourseComparisonTableEntityResponse';
  data?: Maybe<Strapi_CourseComparisonTableEntity>;
};

export type Strapi_CourseComparisonTableEntityResponseCollection = {
  __typename?: 'Strapi_CourseComparisonTableEntityResponseCollection';
  data: Array<Strapi_CourseComparisonTableEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_CourseComparisonTableRelationResponseCollection = {
  __typename?: 'Strapi_CourseComparisonTableRelationResponseCollection';
  data: Array<Strapi_CourseComparisonTableEntity>;
};


export type Strapi_CourseComponentsDynamicZone = Strapi_ComponentPageCallToAction | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnglishLevelsAccordion | Strapi_ComponentPageEnglishLevelsTable | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHeroMap | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText;

export type Strapi_CourseEntity = {
  __typename?: 'Strapi_CourseEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Course>;
};

export type Strapi_CourseRelationResponseCollection = {
  __typename?: 'Strapi_CourseRelationResponseCollection';
  data: Array<Strapi_CourseEntity>;
};

export type Strapi_CourseConnection = {
  __typename?: 'Strapi_CourseConnection';
  values?: Maybe<Array<Maybe<Strapi_Course>>>;
  groupBy?: Maybe<Strapi_CourseGroupBy>;
  aggregate?: Maybe<Strapi_CourseAggregator>;
};

export type Strapi_CourseConnectionCall_To_Action = {
  __typename?: 'Strapi_CourseConnectionCall_to_action';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionCreated_At = {
  __typename?: 'Strapi_CourseConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionFeatured = {
  __typename?: 'Strapi_CourseConnectionFeatured';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionId = {
  __typename?: 'Strapi_CourseConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionImage = {
  __typename?: 'Strapi_CourseConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionName = {
  __typename?: 'Strapi_CourseConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionOriginal_Date = {
  __typename?: 'Strapi_CourseConnectionOriginal_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionPage_Settings = {
  __typename?: 'Strapi_CourseConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionPublished_At = {
  __typename?: 'Strapi_CourseConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionShort = {
  __typename?: 'Strapi_CourseConnectionShort';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionSlug = {
  __typename?: 'Strapi_CourseConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionUpdated_At = {
  __typename?: 'Strapi_CourseConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseConnectionWebsite_Locale = {
  __typename?: 'Strapi_CourseConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_CourseConnection>;
};

export type Strapi_CourseGroupBy = {
  __typename?: 'Strapi_CourseGroupBy';
  id?: Maybe<Array<Maybe<Strapi_CourseConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_CourseConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_CourseConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_CourseConnectionName>>>;
  short?: Maybe<Array<Maybe<Strapi_CourseConnectionShort>>>;
  slug?: Maybe<Array<Maybe<Strapi_CourseConnectionSlug>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_CourseConnectionWebsite_Locale>>>;
  image?: Maybe<Array<Maybe<Strapi_CourseConnectionImage>>>;
  call_to_action?: Maybe<Array<Maybe<Strapi_CourseConnectionCall_To_Action>>>;
  featured?: Maybe<Array<Maybe<Strapi_CourseConnectionFeatured>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_CourseConnectionPage_Settings>>>;
  original_date?: Maybe<Array<Maybe<Strapi_CourseConnectionOriginal_Date>>>;
  published_at?: Maybe<Array<Maybe<Strapi_CourseConnectionPublished_At>>>;
};

export type Strapi_CourseInput = {
  name: Scalars['String'];
  short: Scalars['String'];
  course_features?: Maybe<Array<Maybe<Strapi_ComponentAtomCourseFeatureInput>>>;
  course_text?: Maybe<Array<Maybe<Strapi_ComponentAtomCourseFeatureInput>>>;
  slug?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  call_to_action?: Maybe<Strapi_ComponentPageCallToActionInput>;
  featured?: Maybe<Scalars['Boolean']>;
  components?: Maybe<Array<Scalars['Strapi_CourseComponentsDynamicZoneInput']>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};



export type Strapi_DeliveryMethod = {
  __typename?: 'Strapi_DeliveryMethod';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  banner_text?: Maybe<Scalars['String']>;
  is_recommended: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  pricing_plan_heading?: Maybe<Scalars['String']>;
  pricing_plan_description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Strapi_ComponentAtomListItem>>>;
  price?: Maybe<Strapi_ComponentDataPriceDescription>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  hubspot_form?: Maybe<Scalars['String']>;
  footnote?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_DeliveryMethodAggregator = {
  __typename?: 'Strapi_DeliveryMethodAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_DeliveryMethodConnection = {
  __typename?: 'Strapi_DeliveryMethodConnection';
  values?: Maybe<Array<Maybe<Strapi_DeliveryMethod>>>;
  groupBy?: Maybe<Strapi_DeliveryMethodGroupBy>;
  aggregate?: Maybe<Strapi_DeliveryMethodAggregator>;
};

export type Strapi_DeliveryMethodConnectionBanner_Text = {
  __typename?: 'Strapi_DeliveryMethodConnectionBanner_text';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionCreated_At = {
  __typename?: 'Strapi_DeliveryMethodConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionFootnote = {
  __typename?: 'Strapi_DeliveryMethodConnectionFootnote';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionHeading = {
  __typename?: 'Strapi_DeliveryMethodConnectionHeading';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionHubspot_Form = {
  __typename?: 'Strapi_DeliveryMethodConnectionHubspot_form';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionId = {
  __typename?: 'Strapi_DeliveryMethodConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionIs_Recommended = {
  __typename?: 'Strapi_DeliveryMethodConnectionIs_recommended';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionLink = {
  __typename?: 'Strapi_DeliveryMethodConnectionLink';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionPrice = {
  __typename?: 'Strapi_DeliveryMethodConnectionPrice';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionPricing_Plan_Description = {
  __typename?: 'Strapi_DeliveryMethodConnectionPricing_plan_description';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionPricing_Plan_Heading = {
  __typename?: 'Strapi_DeliveryMethodConnectionPricing_plan_heading';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionPublished_At = {
  __typename?: 'Strapi_DeliveryMethodConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionUpdated_At = {
  __typename?: 'Strapi_DeliveryMethodConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodConnectionWebsite_Locale = {
  __typename?: 'Strapi_DeliveryMethodConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_DeliveryMethodConnection>;
};

export type Strapi_DeliveryMethodGroupBy = {
  __typename?: 'Strapi_DeliveryMethodGroupBy';
  id?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionUpdated_At>>>;
  banner_text?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionBanner_Text>>>;
  is_recommended?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionIs_Recommended>>>;
  heading?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionHeading>>>;
  pricing_plan_heading?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionPricing_Plan_Heading>>>;
  pricing_plan_description?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionPricing_Plan_Description>>>;
  price?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionPrice>>>;
  link?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionLink>>>;
  hubspot_form?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionHubspot_Form>>>;
  footnote?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionFootnote>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_DeliveryMethodConnectionPublished_At>>>;
};

export type Strapi_DeliveryMethodInput = {
  banner_text?: Maybe<Scalars['String']>;
  is_recommended?: Maybe<Scalars['Boolean']>;
  heading?: Maybe<Scalars['String']>;
  pricing_plan_heading?: Maybe<Scalars['String']>;
  pricing_plan_description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Strapi_ComponentAtomListItemInput>>>;
  price?: Maybe<Strapi_ComponentDataPriceDescriptionInput>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  hubspot_form?: Maybe<Scalars['String']>;
  footnote?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum Strapi_Enum_Componentatomwsesitelink_Region {
  asia_pacific = 'asia_pacific',
  europe_africa_and_middle_east = 'europe_africa_and_middle_east',
  latin_america = 'latin_america'
}

export enum Strapi_Enum_Componentpagecalltoaction_Style {
  light = 'light',
  dark = 'dark'
}

export enum Strapi_Enum_Componentpageimageandtext_Image_Position {
  left = 'left',
  right = 'right'
}


export enum Strapi_Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter'
}

export enum Strapi_Enum_Page_Index_Page {
  Schools = 'Schools',
  Exercises = 'Exercises',
  Promotions = 'Promotions',
  Certifications = 'Certifications',
  Courses = 'Courses',
  EnglishTests = 'EnglishTests',
  Events = 'Events',
  Blogs = 'Blogs',
  Exams = 'Exams'
}

export enum Strapi_Enum_School_Status {
  open_physically = 'open_physically',
  open_virtually = 'open_virtually',
  closed_temporarily = 'closed_temporarily',
  closed_permanently = 'closed_permanently'
}

export type Strapi_EnglishLevelGroup = {
  __typename?: 'Strapi_EnglishLevelGroup';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  title: Scalars['String'];
  english_levels?: Maybe<Array<Maybe<Strapi_ComponentDataEnglishLevel>>>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_CourseComparison = {
  __typename?: 'Strapi_CourseComparison';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  title: Scalars['String'];
  course_names?: Maybe<Array<Maybe<Strapi_ComponentDataCourseName>>>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_EnglishLevelGroupAggregator = {
  __typename?: 'Strapi_EnglishLevelGroupAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_EnglishLevelGroupConnection = {
  __typename?: 'Strapi_EnglishLevelGroupConnection';
  values?: Maybe<Array<Maybe<Strapi_EnglishLevelGroup>>>;
  groupBy?: Maybe<Strapi_EnglishLevelGroupGroupBy>;
  aggregate?: Maybe<Strapi_EnglishLevelGroupAggregator>;
};

export type Strapi_EnglishLevelGroupConnectionCreated_At = {
  __typename?: 'Strapi_EnglishLevelGroupConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EnglishLevelGroupConnection>;
};

export type Strapi_EnglishLevelGroupConnectionId = {
  __typename?: 'Strapi_EnglishLevelGroupConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishLevelGroupConnection>;
};

export type Strapi_EnglishLevelGroupConnectionPublished_At = {
  __typename?: 'Strapi_EnglishLevelGroupConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EnglishLevelGroupConnection>;
};

export type Strapi_EnglishLevelGroupConnectionTitle = {
  __typename?: 'Strapi_EnglishLevelGroupConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EnglishLevelGroupConnection>;
};

export type Strapi_EnglishLevelGroupConnectionUpdated_At = {
  __typename?: 'Strapi_EnglishLevelGroupConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EnglishLevelGroupConnection>;
};

export type Strapi_EnglishLevelGroupConnectionWebsite_Locale = {
  __typename?: 'Strapi_EnglishLevelGroupConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishLevelGroupConnection>;
};

export type Strapi_EnglishLevelGroupEntity = {
  __typename?: 'Strapi_EnglishLevelGroupEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_EnglishLevelGroup>;
};

export type Strapi_EnglishLevelGroupEntityResponse = {
  __typename?: 'Strapi_EnglishLevelGroupEntityResponse';
  data?: Maybe<Strapi_EnglishLevelGroupEntity>;
};

export type Strapi_EnglishLevelGroupEntityResponseCollection = {
  __typename?: 'Strapi_EnglishLevelGroupEntityResponseCollection';
  data: Array<Strapi_EnglishLevelGroupEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_EnglishLevelGroupGroupBy = {
  __typename?: 'Strapi_EnglishLevelGroupGroupBy';
  id?: Maybe<Array<Maybe<Strapi_EnglishLevelGroupConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_EnglishLevelGroupConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_EnglishLevelGroupConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_EnglishLevelGroupConnectionTitle>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_EnglishLevelGroupConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_EnglishLevelGroupConnectionPublished_At>>>;
};

export type Strapi_EnglishLevelGroupInput = {
  title: Scalars['String'];
  english_levels?: Maybe<Array<Maybe<Strapi_ComponentDataEnglishLevelInput>>>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EnglishTest = {
  __typename?: 'Strapi_EnglishTest';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  cta_component?: Maybe<Strapi_ComponentPageCallToAction>;
  activity_builder?: Maybe<Strapi_ComponentPageHtml>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  components?: Maybe<Array<Maybe<Strapi_EnglishTestComponentsDynamicZone>>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_EnglishTestAggregator = {
  __typename?: 'Strapi_EnglishTestAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_EnglishTestComponentsDynamicZone = Strapi_ComponentPageCallToAction | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnLvlsAcd | Strapi_ComponentPageEnLvlsTbl | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHeroMap | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText | Strapi_ComponentPageInlineHubspotForm | Strapi_Error;

export type Strapi_EnglishTestEntity = {
  __typename?: 'Strapi_EnglishTestEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_EnglishTest>;
};

export type Strapi_EnglishTestEntityResponse = {
  __typename?: 'Strapi_EnglishTestEntityResponse';
  data?: Maybe<Strapi_EnglishTestEntity>;
};

export type Strapi_EnglishTestEntityResponseCollection = {
  __typename?: 'Strapi_EnglishTestEntityResponseCollection';
  data: Array<Strapi_EnglishTestEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_EnglishTestConnection = {
  __typename?: 'Strapi_EnglishTestConnection';
  values?: Maybe<Array<Maybe<Strapi_EnglishTest>>>;
  groupBy?: Maybe<Strapi_EnglishTestGroupBy>;
  aggregate?: Maybe<Strapi_EnglishTestAggregator>;
};

export type Strapi_EnglishTestConnectionActivity_Builder = {
  __typename?: 'Strapi_EnglishTestConnectionActivity_builder';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionCreated_At = {
  __typename?: 'Strapi_EnglishTestConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionCta_Component = {
  __typename?: 'Strapi_EnglishTestConnectionCta_component';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionDescription = {
  __typename?: 'Strapi_EnglishTestConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionExcerpt = {
  __typename?: 'Strapi_EnglishTestConnectionExcerpt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionId = {
  __typename?: 'Strapi_EnglishTestConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionLink = {
  __typename?: 'Strapi_EnglishTestConnectionLink';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionName = {
  __typename?: 'Strapi_EnglishTestConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionPage_Settings = {
  __typename?: 'Strapi_EnglishTestConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionPublished_At = {
  __typename?: 'Strapi_EnglishTestConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionSlug = {
  __typename?: 'Strapi_EnglishTestConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionUpdated_At = {
  __typename?: 'Strapi_EnglishTestConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestConnectionWebsite_Locale = {
  __typename?: 'Strapi_EnglishTestConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EnglishTestConnection>;
};

export type Strapi_EnglishTestGroupBy = {
  __typename?: 'Strapi_EnglishTestGroupBy';
  id?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionName>>>;
  slug?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionSlug>>>;
  excerpt?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionExcerpt>>>;
  description?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionDescription>>>;
  link?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionLink>>>;
  cta_component?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionCta_Component>>>;
  activity_builder?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionActivity_Builder>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionWebsite_Locale>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionPage_Settings>>>;
  published_at?: Maybe<Array<Maybe<Strapi_EnglishTestConnectionPublished_At>>>;
};

export type Strapi_EnglishTestInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  cta_component?: Maybe<Strapi_ComponentPageCallToActionInput>;
  activity_builder?: Maybe<Strapi_ComponentPageHtmlInput>;
  website_locale?: Maybe<Scalars['ID']>;
  components?: Maybe<Array<Scalars['Strapi_EnglishTestComponentsDynamicZoneInput']>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Error = {
  __typename?: 'Strapi_Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type Strapi_Event = {
  __typename?: 'Strapi_Event';
  documentId: Maybe<Scalars['ID']>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  title: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  event_time: Scalars['Strapi_DateTime'];
  event_address?: Maybe<Scalars['String']>;
  categories?: Maybe<Strapi_CategoryRelationResponseCollection>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  embed_code?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFileEntityResponse>;
  call_to_action?: Maybe<Strapi_ComponentPageCallToAction>;
  related_events?: Maybe<Strapi_EventRelationResponseCollection>;
  school?: Maybe<Strapi_SchoolEntityResponse>;
  city?: Maybe<Strapi_CityEntityResponse>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_EventRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};


export type Strapi_EventEntity = {
  __typename?: 'Strapi_EventEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Event>;
};

export type Strapi_EventRelationResponseCollection = {
  __typename?: 'Strapi_EventRelationResponseCollection';
  data: Array<Strapi_EventEntity>;
};

export type Strapi_EventCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_EventRelated_EventsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_EventAggregator = {
  __typename?: 'Strapi_EventAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_EventConnection = {
  __typename?: 'Strapi_EventConnection';
  values?: Maybe<Array<Maybe<Strapi_Event>>>;
  groupBy?: Maybe<Strapi_EventGroupBy>;
  aggregate?: Maybe<Strapi_EventAggregator>;
};

export type Strapi_EventConnectionCall_To_Action = {
  __typename?: 'Strapi_EventConnectionCall_to_action';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionCity = {
  __typename?: 'Strapi_EventConnectionCity';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionContent = {
  __typename?: 'Strapi_EventConnectionContent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionCreated_At = {
  __typename?: 'Strapi_EventConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionEmbed_Code = {
  __typename?: 'Strapi_EventConnectionEmbed_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionEvent_Address = {
  __typename?: 'Strapi_EventConnectionEvent_address';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionEvent_Time = {
  __typename?: 'Strapi_EventConnectionEvent_time';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionId = {
  __typename?: 'Strapi_EventConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionImage = {
  __typename?: 'Strapi_EventConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionLink = {
  __typename?: 'Strapi_EventConnectionLink';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionPage_Settings = {
  __typename?: 'Strapi_EventConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionPublished_At = {
  __typename?: 'Strapi_EventConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionSchool = {
  __typename?: 'Strapi_EventConnectionSchool';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionSlug = {
  __typename?: 'Strapi_EventConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionTitle = {
  __typename?: 'Strapi_EventConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionUpdated_At = {
  __typename?: 'Strapi_EventConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventConnectionWebsite_Locale = {
  __typename?: 'Strapi_EventConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_EventConnection>;
};

export type Strapi_EventGroupBy = {
  __typename?: 'Strapi_EventGroupBy';
  id?: Maybe<Array<Maybe<Strapi_EventConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_EventConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_EventConnectionUpdated_At>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_EventConnectionWebsite_Locale>>>;
  title?: Maybe<Array<Maybe<Strapi_EventConnectionTitle>>>;
  slug?: Maybe<Array<Maybe<Strapi_EventConnectionSlug>>>;
  content?: Maybe<Array<Maybe<Strapi_EventConnectionContent>>>;
  event_time?: Maybe<Array<Maybe<Strapi_EventConnectionEvent_Time>>>;
  event_address?: Maybe<Array<Maybe<Strapi_EventConnectionEvent_Address>>>;
  link?: Maybe<Array<Maybe<Strapi_EventConnectionLink>>>;
  embed_code?: Maybe<Array<Maybe<Strapi_EventConnectionEmbed_Code>>>;
  image?: Maybe<Array<Maybe<Strapi_EventConnectionImage>>>;
  call_to_action?: Maybe<Array<Maybe<Strapi_EventConnectionCall_To_Action>>>;
  school?: Maybe<Array<Maybe<Strapi_EventConnectionSchool>>>;
  city?: Maybe<Array<Maybe<Strapi_EventConnectionCity>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_EventConnectionPage_Settings>>>;
  published_at?: Maybe<Array<Maybe<Strapi_EventConnectionPublished_At>>>;
};

export type Strapi_EventInput = {
  website_locale?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  event_time: Scalars['Strapi_DateTime'];
  event_address?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  embed_code?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  call_to_action?: Maybe<Strapi_ComponentPageCallToActionInput>;
  related_events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  school?: Maybe<Scalars['ID']>;
  city?: Maybe<Scalars['ID']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Exercise = {
  __typename?: 'Strapi_Exercise';
  documentId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Strapi_CategoryRelationResponseCollection>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  related_exercises?: Maybe<Strapi_ExerciseRelationResponseCollection>;
  excerpt?: Maybe<Scalars['String']>;
  image?: Maybe<Strapi_UploadFileEntityResponse>;
  html_code?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  internal_name?: Maybe<Scalars['String']>;
  show_date?: Maybe<Scalars['Boolean']>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_ExerciseRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};


export type Strapi_ExerciseEntity = {
  __typename?: 'Strapi_ExerciseEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Exercise>;
};

export type Strapi_ExerciseEntityResponse = {
  __typename?: 'Strapi_ExerciseEntityResponse';
  data?: Maybe<Strapi_ExerciseEntity>;
};

export type Strapi_ExerciseEntityResponseCollection = {
  __typename?: 'Strapi_ExerciseEntityResponseCollection';
  data: Array<Strapi_ExerciseEntity>;
  meta: Strapi_ResponseCollectionMeta;
};

export type Strapi_ExerciseRelationResponseCollection = {
  __typename?: 'Strapi_ExerciseRelationResponseCollection';
  data: Array<Strapi_ExerciseEntity>;
};

export type Strapi_ExerciseCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_ExerciseRelated_ExercisesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_ExerciseAggregator = {
  __typename?: 'Strapi_ExerciseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_ExerciseConnection = {
  __typename?: 'Strapi_ExerciseConnection';
  values?: Maybe<Array<Maybe<Strapi_Exercise>>>;
  groupBy?: Maybe<Strapi_ExerciseGroupBy>;
  aggregate?: Maybe<Strapi_ExerciseAggregator>;
};

export type Strapi_ExerciseConnectionBody = {
  __typename?: 'Strapi_ExerciseConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionCreated_At = {
  __typename?: 'Strapi_ExerciseConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionExcerpt = {
  __typename?: 'Strapi_ExerciseConnectionExcerpt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionHtml_Code = {
  __typename?: 'Strapi_ExerciseConnectionHtml_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionId = {
  __typename?: 'Strapi_ExerciseConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionImage = {
  __typename?: 'Strapi_ExerciseConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionInternal_Name = {
  __typename?: 'Strapi_ExerciseConnectionInternal_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionOriginal_Date = {
  __typename?: 'Strapi_ExerciseConnectionOriginal_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionPage_Settings = {
  __typename?: 'Strapi_ExerciseConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionPublished_At = {
  __typename?: 'Strapi_ExerciseConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionShow_Date = {
  __typename?: 'Strapi_ExerciseConnectionShow_date';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionSlug = {
  __typename?: 'Strapi_ExerciseConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionTitle = {
  __typename?: 'Strapi_ExerciseConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionUpdated_At = {
  __typename?: 'Strapi_ExerciseConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseConnectionWebsite_Locale = {
  __typename?: 'Strapi_ExerciseConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ExerciseConnection>;
};

export type Strapi_ExerciseGroupBy = {
  __typename?: 'Strapi_ExerciseGroupBy';
  id?: Maybe<Array<Maybe<Strapi_ExerciseConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_ExerciseConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_ExerciseConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_ExerciseConnectionTitle>>>;
  slug?: Maybe<Array<Maybe<Strapi_ExerciseConnectionSlug>>>;
  body?: Maybe<Array<Maybe<Strapi_ExerciseConnectionBody>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_ExerciseConnectionWebsite_Locale>>>;
  excerpt?: Maybe<Array<Maybe<Strapi_ExerciseConnectionExcerpt>>>;
  image?: Maybe<Array<Maybe<Strapi_ExerciseConnectionImage>>>;
  html_code?: Maybe<Array<Maybe<Strapi_ExerciseConnectionHtml_Code>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_ExerciseConnectionPage_Settings>>>;
  internal_name?: Maybe<Array<Maybe<Strapi_ExerciseConnectionInternal_Name>>>;
  show_date?: Maybe<Array<Maybe<Strapi_ExerciseConnectionShow_Date>>>;
  original_date?: Maybe<Array<Maybe<Strapi_ExerciseConnectionOriginal_Date>>>;
  published_at?: Maybe<Array<Maybe<Strapi_ExerciseConnectionPublished_At>>>;
};

export type Strapi_ExerciseInput = {
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  related_exercises?: Maybe<Array<Maybe<Scalars['ID']>>>;
  excerpt?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  html_code?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  internal_name?: Maybe<Scalars['String']>;
  show_date?: Maybe<Scalars['Boolean']>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type Strapi_FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['Strapi_JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['Strapi_JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_FooterCta = {
  __typename?: 'Strapi_FooterCta';
  documentId: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLink>;
  script?: Maybe<Scalars['String']>;
  element_id?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_FooterCtaAggregator = {
  __typename?: 'Strapi_FooterCtaAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_FooterCtaConnection = {
  __typename?: 'Strapi_FooterCtaConnection';
  values?: Maybe<Array<Maybe<Strapi_FooterCta>>>;
  groupBy?: Maybe<Strapi_FooterCtaGroupBy>;
  aggregate?: Maybe<Strapi_FooterCtaAggregator>;
};

export type Strapi_FooterCtaConnectionCreated_At = {
  __typename?: 'Strapi_FooterCtaConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionDescription = {
  __typename?: 'Strapi_FooterCtaConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionElement_Id = {
  __typename?: 'Strapi_FooterCtaConnectionElement_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionId = {
  __typename?: 'Strapi_FooterCtaConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionInternal_Name = {
  __typename?: 'Strapi_FooterCtaConnectionInternal_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionLink = {
  __typename?: 'Strapi_FooterCtaConnectionLink';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionScript = {
  __typename?: 'Strapi_FooterCtaConnectionScript';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionTitle = {
  __typename?: 'Strapi_FooterCtaConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionUpdated_At = {
  __typename?: 'Strapi_FooterCtaConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaConnectionWebsite_Locale = {
  __typename?: 'Strapi_FooterCtaConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_FooterCtaConnection>;
};

export type Strapi_FooterCtaGroupBy = {
  __typename?: 'Strapi_FooterCtaGroupBy';
  id?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionTitle>>>;
  description?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionDescription>>>;
  link?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionLink>>>;
  script?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionScript>>>;
  element_id?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionElement_Id>>>;
  internal_name?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionInternal_Name>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_FooterCtaConnectionWebsite_Locale>>>;
};

export type Strapi_FooterCtaInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_ComponentAtomLinkInput>;
  script?: Maybe<Scalars['String']>;
  element_id?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Homepage = {
  __typename?: 'Strapi_Homepage';
  internal_title: Scalars['String'];
  title: Scalars['String'];
  hero_image: Strapi_UploadFileEntityResponse;
  hero_title: Scalars['String'];
  hero_body: Scalars['String'];
  hero_cta: Strapi_ComponentAtomLink;
  courses_title: Scalars['String'];
  courses_body: Scalars['String'];
  courses_cta: Strapi_ComponentAtomLink;
  components: Array<Maybe<Strapi_HomepageComponentsDynamicZone>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  promotion?: Maybe<Strapi_PromotionEntityResponse>;
  seo: Strapi_ComponentSharedSeo;
  homepage?: Maybe<Strapi_HomepageEntityResponse>;
  hero_section?: Maybe<Strapi_ComponentAtomHeaderHeroSection>;
  internal_name?: Maybe<Scalars['String']>;
  show_form_in_header?: Maybe<Scalars['Boolean']>;
  inline_hubspot_form?: Maybe<Strapi_ComponentPageInlineHubspotForm>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_HomepageRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};

export type Strapi_HomepageAggregator = {
  __typename?: 'Strapi_HomepageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_HomepageComponentsDynamicZone = Strapi_ComponentPageImageAndText | Strapi_ComponentPageVideoAndText | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageTrustPilotWidget | Strapi_ComponentPageRichText | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageTextAndSplitImages;

export type Strapi_HomepageEntity = {
  __typename?: 'Strapi_HomepageEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Homepage>;
};

export type Strapi_HomepageConnection = {
  __typename?: 'Strapi_HomepageConnection';
  values?: Maybe<Array<Maybe<Strapi_Homepage>>>;
  groupBy?: Maybe<Strapi_HomepageGroupBy>;
  aggregate?: Maybe<Strapi_HomepageAggregator>;
};

export type Strapi_HomepageConnectionCourses_Body = {
  __typename?: 'Strapi_HomepageConnectionCourses_body';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionCourses_Cta = {
  __typename?: 'Strapi_HomepageConnectionCourses_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionCourses_Title = {
  __typename?: 'Strapi_HomepageConnectionCourses_title';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionCreated_At = {
  __typename?: 'Strapi_HomepageConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionHero_Body = {
  __typename?: 'Strapi_HomepageConnectionHero_body';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionHero_Cta = {
  __typename?: 'Strapi_HomepageConnectionHero_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionHero_Image = {
  __typename?: 'Strapi_HomepageConnectionHero_image';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionHero_Title = {
  __typename?: 'Strapi_HomepageConnectionHero_title';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionId = {
  __typename?: 'Strapi_HomepageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionInternal_Title = {
  __typename?: 'Strapi_HomepageConnectionInternal_title';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionPage_Settings = {
  __typename?: 'Strapi_HomepageConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionPromotion = {
  __typename?: 'Strapi_HomepageConnectionPromotion';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionPublished_At = {
  __typename?: 'Strapi_HomepageConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionTitle = {
  __typename?: 'Strapi_HomepageConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionUpdated_At = {
  __typename?: 'Strapi_HomepageConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageConnectionWebsite_Locale = {
  __typename?: 'Strapi_HomepageConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_HomepageConnection>;
};

export type Strapi_HomepageGroupBy = {
  __typename?: 'Strapi_HomepageGroupBy';
  id?: Maybe<Array<Maybe<Strapi_HomepageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_HomepageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_HomepageConnectionUpdated_At>>>;
  internal_title?: Maybe<Array<Maybe<Strapi_HomepageConnectionInternal_Title>>>;
  title?: Maybe<Array<Maybe<Strapi_HomepageConnectionTitle>>>;
  hero_image?: Maybe<Array<Maybe<Strapi_HomepageConnectionHero_Image>>>;
  hero_title?: Maybe<Array<Maybe<Strapi_HomepageConnectionHero_Title>>>;
  hero_body?: Maybe<Array<Maybe<Strapi_HomepageConnectionHero_Body>>>;
  hero_cta?: Maybe<Array<Maybe<Strapi_HomepageConnectionHero_Cta>>>;
  courses_title?: Maybe<Array<Maybe<Strapi_HomepageConnectionCourses_Title>>>;
  courses_body?: Maybe<Array<Maybe<Strapi_HomepageConnectionCourses_Body>>>;
  courses_cta?: Maybe<Array<Maybe<Strapi_HomepageConnectionCourses_Cta>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_HomepageConnectionPage_Settings>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_HomepageConnectionWebsite_Locale>>>;
  promotion?: Maybe<Array<Maybe<Strapi_HomepageConnectionPromotion>>>;
  published_at?: Maybe<Array<Maybe<Strapi_HomepageConnectionPublished_At>>>;
};

export type Strapi_HomepageInput = {
  internal_title: Scalars['String'];
  title: Scalars['String'];
  hero_image?: Maybe<Scalars['ID']>;
  hero_title: Scalars['String'];
  hero_body: Scalars['String'];
  hero_cta: Strapi_ComponentAtomLinkInput;
  courses_title: Scalars['String'];
  courses_body: Scalars['String'];
  courses_cta: Strapi_ComponentAtomLinkInput;
  components: Array<Scalars['Strapi_HomepageComponentsDynamicZoneInput']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  website_locale?: Maybe<Scalars['ID']>;
  promotion?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_InputId = {
  id: Scalars['ID'];
};


export type Strapi_JobType = {
  __typename?: 'Strapi_JobType';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_JobTypeEntity = {
  __typename?: 'Strapi_JobTypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_JobType>;
};

export type Strapi_JobTypeEntityResponse = {
  __typename?: 'Strapi_JobTypeEntityResponse';
  data?: Maybe<Strapi_JobTypeEntity>;
};

export type Strapi_JobTypeAggregator = {
  __typename?: 'Strapi_JobTypeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_JobTypeConnection = {
  __typename?: 'Strapi_JobTypeConnection';
  values?: Maybe<Array<Maybe<Strapi_JobType>>>;
  groupBy?: Maybe<Strapi_JobTypeGroupBy>;
  aggregate?: Maybe<Strapi_JobTypeAggregator>;
};

export type Strapi_JobTypeConnectionCreated_At = {
  __typename?: 'Strapi_JobTypeConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_JobTypeConnection>;
};

export type Strapi_JobTypeConnectionId = {
  __typename?: 'Strapi_JobTypeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_JobTypeConnection>;
};

export type Strapi_JobTypeConnectionName = {
  __typename?: 'Strapi_JobTypeConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_JobTypeConnection>;
};

export type Strapi_JobTypeConnectionPublished_At = {
  __typename?: 'Strapi_JobTypeConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_JobTypeConnection>;
};

export type Strapi_JobTypeConnectionUpdated_At = {
  __typename?: 'Strapi_JobTypeConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_JobTypeConnection>;
};

export type Strapi_JobTypeConnectionWebsite_Locale = {
  __typename?: 'Strapi_JobTypeConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_JobTypeConnection>;
};

export type Strapi_JobTypeGroupBy = {
  __typename?: 'Strapi_JobTypeGroupBy';
  id?: Maybe<Array<Maybe<Strapi_JobTypeConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_JobTypeConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_JobTypeConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_JobTypeConnectionName>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_JobTypeConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_JobTypeConnectionPublished_At>>>;
};

export type Strapi_JobTypeInput = {
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type Strapi_Modal = {
  __typename?: 'Strapi_Modal';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  internal_title: Scalars['String'];
  website_locale?: Maybe<Strapi_WebsiteLocale>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
};

export type Strapi_ModalAggregator = {
  __typename?: 'Strapi_ModalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_ModalConnection = {
  __typename?: 'Strapi_ModalConnection';
  values?: Maybe<Array<Maybe<Strapi_Modal>>>;
  groupBy?: Maybe<Strapi_ModalGroupBy>;
  aggregate?: Maybe<Strapi_ModalAggregator>;
};

export type Strapi_ModalConnectionCreated_At = {
  __typename?: 'Strapi_ModalConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionDescription = {
  __typename?: 'Strapi_ModalConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionHtml = {
  __typename?: 'Strapi_ModalConnectionHtml';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionId = {
  __typename?: 'Strapi_ModalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionInternal_Title = {
  __typename?: 'Strapi_ModalConnectionInternal_title';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionPublished_At = {
  __typename?: 'Strapi_ModalConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionTitle = {
  __typename?: 'Strapi_ModalConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionUpdated_At = {
  __typename?: 'Strapi_ModalConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalConnectionWebsite_Locale = {
  __typename?: 'Strapi_ModalConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_ModalConnection>;
};

export type Strapi_ModalGroupBy = {
  __typename?: 'Strapi_ModalGroupBy';
  id?: Maybe<Array<Maybe<Strapi_ModalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_ModalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_ModalConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_ModalConnectionTitle>>>;
  description?: Maybe<Array<Maybe<Strapi_ModalConnectionDescription>>>;
  html?: Maybe<Array<Maybe<Strapi_ModalConnectionHtml>>>;
  internal_title?: Maybe<Array<Maybe<Strapi_ModalConnectionInternal_Title>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_ModalConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_ModalConnectionPublished_At>>>;
};

export type Strapi_ModalInput = {
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  internal_title: Scalars['String'];
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Morph = Strapi_UsersPermissionsMe | Strapi_UsersPermissionsMeRole | Strapi_UsersPermissionsLoginPayload | Strapi_UserPermissionsPasswordPayload | Strapi_BlogPost | Strapi_BlogPostConnection | Strapi_BlogPostAggregator | Strapi_BlogPostGroupBy | Strapi_BlogPostConnectionId | Strapi_BlogPostConnectionCreated_At | Strapi_BlogPostConnectionUpdated_At | Strapi_BlogPostConnectionTitle | Strapi_BlogPostConnectionBody | Strapi_BlogPostConnectionWebsite_Locale | Strapi_BlogPostConnectionSlug | Strapi_BlogPostConnectionImage | Strapi_BlogPostConnectionExcerpt | Strapi_BlogPostConnectionPage_Settings | Strapi_BlogPostConnectionOriginal_Date | Strapi_BlogPostConnectionHtml_Code | Strapi_BlogPostConnectionInternal_Name | Strapi_BlogPostConnectionPublished_At | Strapi_CreateBlogPostPayload | Strapi_UpdateBlogPostPayload | Strapi_DeleteBlogPostPayload | Strapi_CareerPost | Strapi_CareerPostConnection | Strapi_CareerPostAggregator | Strapi_CareerPostGroupBy | Strapi_CareerPostConnectionId | Strapi_CareerPostConnectionCreated_At | Strapi_CareerPostConnectionUpdated_At | Strapi_CareerPostConnectionTitle | Strapi_CareerPostConnectionContent | Strapi_CareerPostConnectionSlug | Strapi_CareerPostConnectionLink | Strapi_CareerPostConnectionEmbed_Code | Strapi_CareerPostConnectionWebsite_Locale | Strapi_CareerPostConnectionShort | Strapi_CareerPostConnectionCall_To_Action | Strapi_CareerPostConnectionCity | Strapi_CareerPostConnectionJob_Type | Strapi_CareerPostConnectionPage_Settings | Strapi_CareerPostConnectionPublished_At | Strapi_CreateCareerPostPayload | Strapi_UpdateCareerPostPayload | Strapi_DeleteCareerPostPayload | Strapi_CareersCta | Strapi_CareersCtaConnection | Strapi_CareersCtaAggregator | Strapi_CareersCtaGroupBy | Strapi_CareersCtaConnectionId | Strapi_CareersCtaConnectionCreated_At | Strapi_CareersCtaConnectionUpdated_At | Strapi_CareersCtaConnectionCta_Panel | Strapi_CareersCtaConnectionCta_Name | Strapi_CareersCtaConnectionWebsite_Locale | Strapi_CareersCtaConnectionPublished_At | Strapi_CreateCareersCtaPayload | Strapi_UpdateCareersCtaPayload | Strapi_DeleteCareersCtaPayload | Strapi_Category | Strapi_CategoryConnection | Strapi_CategoryAggregator | Strapi_CategoryGroupBy | Strapi_CategoryConnectionId | Strapi_CategoryConnectionCreated_At | Strapi_CategoryConnectionUpdated_At | Strapi_CategoryConnectionName | Strapi_CategoryConnectionWebsite_Locale | Strapi_CreateCategoryPayload | Strapi_UpdateCategoryPayload | Strapi_DeleteCategoryPayload | Strapi_CertificationCta | Strapi_CertificationCtaConnection | Strapi_CertificationCtaAggregator | Strapi_CertificationCtaGroupBy | Strapi_CertificationCtaConnectionId | Strapi_CertificationCtaConnectionCreated_At | Strapi_CertificationCtaConnectionUpdated_At | Strapi_CertificationCtaConnectionColumn_One_Heading | Strapi_CertificationCtaConnectionColumn_One_Body | Strapi_CertificationCtaConnectionColumn_One_Link | Strapi_CertificationCtaConnectionColumn_Two_Heading | Strapi_CertificationCtaConnectionColumn_Two_Body | Strapi_CertificationCtaConnectionColumn_Two_Link | Strapi_CertificationCtaConnectionName | Strapi_CertificationCtaConnectionWebsite_Locale | Strapi_CertificationCtaConnectionPublished_At | Strapi_CreateCertificationCtaPayload | Strapi_UpdateCertificationCtaPayload | Strapi_DeleteCertificationCtaPayload | Strapi_Certification | Strapi_CertificationConnection | Strapi_CertificationAggregator | Strapi_CertificationGroupBy | Strapi_CertificationConnectionId | Strapi_CertificationConnectionCreated_At | Strapi_CertificationConnectionUpdated_At | Strapi_CertificationConnectionName | Strapi_CertificationConnectionSlug | Strapi_CertificationConnectionExcerpt | Strapi_CertificationConnectionCertification_Cta | Strapi_CertificationConnectionImage | Strapi_CertificationConnectionHero_Body | Strapi_CertificationConnectionHero_Link | Strapi_CertificationConnectionWebsite_Locale | Strapi_CertificationConnectionFooter_Cta | Strapi_CertificationConnectionCertification_English_Levels | Strapi_CertificationConnectionCity_Heading_Text | Strapi_CertificationConnectionExam_Schools_Heading | Strapi_CertificationConnectionReviews_Widget | Strapi_CertificationConnectionPage_Settings | Strapi_CertificationConnectionPublished_At | Strapi_CreateCertificationPayload | Strapi_UpdateCertificationPayload | Strapi_DeleteCertificationPayload | Strapi_City | Strapi_CityConnection | Strapi_CityAggregator | Strapi_CityGroupBy | Strapi_CityConnectionId | Strapi_CityConnectionCreated_At | Strapi_CityConnectionUpdated_At | Strapi_CityConnectionName | Strapi_CityConnectionWebsite_Locale | Strapi_CityConnectionDescription | Strapi_CityConnectionHero_Link | Strapi_CityConnectionImage | Strapi_CityConnectionImage_And_Text | Strapi_CityConnectionPage_Settings | Strapi_CityConnectionSlug | Strapi_CityConnectionPublished_At | Strapi_CreateCityPayload | Strapi_UpdateCityPayload | Strapi_DeleteCityPayload | Strapi_Course | Strapi_CourseConnection | Strapi_CourseAggregator | Strapi_CourseGroupBy | Strapi_CourseConnectionId | Strapi_CourseConnectionCreated_At | Strapi_CourseConnectionUpdated_At | Strapi_CourseConnectionName | Strapi_CourseConnectionShort | Strapi_CourseConnectionSlug | Strapi_CourseConnectionWebsite_Locale | Strapi_CourseConnectionImage | Strapi_CourseConnectionCall_To_Action | Strapi_CourseConnectionFeatured | Strapi_CourseConnectionPage_Settings | Strapi_CourseConnectionOriginal_Date | Strapi_CourseConnectionPublished_At | Strapi_CreateCoursePayload | Strapi_UpdateCoursePayload | Strapi_DeleteCoursePayload | Strapi_DeliveryMethod | Strapi_DeliveryMethodConnection | Strapi_DeliveryMethodAggregator | Strapi_DeliveryMethodGroupBy | Strapi_DeliveryMethodConnectionId | Strapi_DeliveryMethodConnectionCreated_At | Strapi_DeliveryMethodConnectionUpdated_At | Strapi_DeliveryMethodConnectionBanner_Text | Strapi_DeliveryMethodConnectionIs_Recommended | Strapi_DeliveryMethodConnectionHeading | Strapi_DeliveryMethodConnectionPricing_Plan_Heading | Strapi_DeliveryMethodConnectionPricing_Plan_Description | Strapi_DeliveryMethodConnectionPrice | Strapi_DeliveryMethodConnectionLink | Strapi_DeliveryMethodConnectionHubspot_Form | Strapi_DeliveryMethodConnectionFootnote | Strapi_DeliveryMethodConnectionWebsite_Locale | Strapi_DeliveryMethodConnectionPublished_At | Strapi_CreateDeliveryMethodPayload | Strapi_UpdateDeliveryMethodPayload | Strapi_DeleteDeliveryMethodPayload | Strapi_EnglishLevelGroup | Strapi_EnglishLevelGroupConnection | Strapi_EnglishLevelGroupAggregator | Strapi_EnglishLevelGroupGroupBy | Strapi_EnglishLevelGroupConnectionId | Strapi_EnglishLevelGroupConnectionCreated_At | Strapi_EnglishLevelGroupConnectionUpdated_At | Strapi_EnglishLevelGroupConnectionTitle | Strapi_EnglishLevelGroupConnectionWebsite_Locale | Strapi_EnglishLevelGroupConnectionPublished_At | Strapi_CreateEnglishLevelGroupPayload | Strapi_UpdateEnglishLevelGroupPayload | Strapi_DeleteEnglishLevelGroupPayload | Strapi_EnglishTest | Strapi_EnglishTestConnection | Strapi_EnglishTestAggregator | Strapi_EnglishTestGroupBy | Strapi_EnglishTestConnectionId | Strapi_EnglishTestConnectionCreated_At | Strapi_EnglishTestConnectionUpdated_At | Strapi_EnglishTestConnectionName | Strapi_EnglishTestConnectionSlug | Strapi_EnglishTestConnectionExcerpt | Strapi_EnglishTestConnectionDescription | Strapi_EnglishTestConnectionLink | Strapi_EnglishTestConnectionCta_Component | Strapi_EnglishTestConnectionActivity_Builder | Strapi_EnglishTestConnectionWebsite_Locale | Strapi_EnglishTestConnectionPage_Settings | Strapi_EnglishTestConnectionPublished_At | Strapi_CreateEnglishTestPayload | Strapi_UpdateEnglishTestPayload | Strapi_DeleteEnglishTestPayload | Strapi_Event | Strapi_EventConnection | Strapi_EventAggregator | Strapi_EventGroupBy | Strapi_EventConnectionId | Strapi_EventConnectionCreated_At | Strapi_EventConnectionUpdated_At | Strapi_EventConnectionWebsite_Locale | Strapi_EventConnectionTitle | Strapi_EventConnectionSlug | Strapi_EventConnectionContent | Strapi_EventConnectionEvent_Time | Strapi_EventConnectionEvent_Address | Strapi_EventConnectionLink | Strapi_EventConnectionEmbed_Code | Strapi_EventConnectionImage | Strapi_EventConnectionCall_To_Action | Strapi_EventConnectionSchool | Strapi_EventConnectionCity | Strapi_EventConnectionPage_Settings | Strapi_EventConnectionPublished_At | Strapi_CreateEventPayload | Strapi_UpdateEventPayload | Strapi_DeleteEventPayload | Strapi_Exercise | Strapi_ExerciseConnection | Strapi_ExerciseAggregator | Strapi_ExerciseGroupBy | Strapi_ExerciseConnectionId | Strapi_ExerciseConnectionCreated_At | Strapi_ExerciseConnectionUpdated_At | Strapi_ExerciseConnectionTitle | Strapi_ExerciseConnectionSlug | Strapi_ExerciseConnectionBody | Strapi_ExerciseConnectionWebsite_Locale | Strapi_ExerciseConnectionExcerpt | Strapi_ExerciseConnectionImage | Strapi_ExerciseConnectionHtml_Code | Strapi_ExerciseConnectionPage_Settings | Strapi_ExerciseConnectionInternal_Name | Strapi_ExerciseConnectionShow_Date | Strapi_ExerciseConnectionOriginal_Date | Strapi_ExerciseConnectionPublished_At | Strapi_CreateExercisePayload | Strapi_UpdateExercisePayload | Strapi_DeleteExercisePayload | Strapi_FooterCta | Strapi_FooterCtaConnection | Strapi_FooterCtaAggregator | Strapi_FooterCtaGroupBy | Strapi_FooterCtaConnectionId | Strapi_FooterCtaConnectionCreated_At | Strapi_FooterCtaConnectionUpdated_At | Strapi_FooterCtaConnectionTitle | Strapi_FooterCtaConnectionDescription | Strapi_ComponentDataCourseAvailability | Strapi_FooterCtaConnectionLink | Strapi_FooterCtaConnectionScript | Strapi_FooterCtaConnectionElement_Id | Strapi_FooterCtaConnectionInternal_Name | Strapi_FooterCtaConnectionWebsite_Locale | Strapi_CreateFooterCtaPayload | Strapi_UpdateFooterCtaPayload | Strapi_DeleteFooterCtaPayload | Strapi_Homepage | Strapi_HomepageConnection | Strapi_HomepageAggregator | Strapi_HomepageGroupBy | Strapi_HomepageConnectionId | Strapi_HomepageConnectionCreated_At | Strapi_HomepageConnectionUpdated_At | Strapi_HomepageConnectionInternal_Title | Strapi_HomepageConnectionTitle | Strapi_HomepageConnectionHero_Image | Strapi_HomepageConnectionHero_Title | Strapi_HomepageConnectionHero_Body | Strapi_HomepageConnectionHero_Cta | Strapi_HomepageConnectionCourses_Title | Strapi_HomepageConnectionCourses_Body | Strapi_HomepageConnectionCourses_Cta | Strapi_HomepageConnectionPage_Settings | Strapi_HomepageConnectionWebsite_Locale | Strapi_HomepageConnectionPromotion | Strapi_HomepageConnectionPublished_At | Strapi_CreateHomepagePayload | Strapi_UpdateHomepagePayload | Strapi_DeleteHomepagePayload | Strapi_JobType | Strapi_JobTypeConnection | Strapi_JobTypeAggregator | Strapi_JobTypeGroupBy | Strapi_JobTypeConnectionId | Strapi_JobTypeConnectionCreated_At | Strapi_JobTypeConnectionUpdated_At | Strapi_JobTypeConnectionName | Strapi_JobTypeConnectionWebsite_Locale | Strapi_JobTypeConnectionPublished_At | Strapi_CreateJobTypePayload | Strapi_UpdateJobTypePayload | Strapi_DeleteJobTypePayload | Strapi_Modal | Strapi_ModalConnection | Strapi_ModalAggregator | Strapi_ModalGroupBy | Strapi_ModalConnectionId | Strapi_ModalConnectionCreated_At | Strapi_ModalConnectionUpdated_At | Strapi_ModalConnectionTitle | Strapi_ModalConnectionDescription | Strapi_ModalConnectionHtml | Strapi_ModalConnectionInternal_Title | Strapi_ModalConnectionWebsite_Locale | Strapi_ModalConnectionPublished_At | Strapi_CreateModalPayload | Strapi_UpdateModalPayload | Strapi_DeleteModalPayload | Strapi_Page | Strapi_PageConnection | Strapi_PageAggregator | Strapi_PageGroupBy | Strapi_PageConnectionId | Strapi_PageConnectionCreated_At | Strapi_PageConnectionUpdated_At | Strapi_PageConnectionTitle | Strapi_PageConnectionSlug | Strapi_PageConnectionWebsite_Locale | Strapi_PageConnectionPage_Settings | Strapi_PageConnectionIndex_Page | Strapi_PageConnectionPublished_At | Strapi_CreatePagePayload | Strapi_UpdatePagePayload | Strapi_DeletePagePayload | Strapi_Promotion | Strapi_PromotionConnection | Strapi_PromotionAggregator | Strapi_PromotionGroupBy | Strapi_PromotionConnectionId | Strapi_PromotionConnectionCreated_At | Strapi_PromotionConnectionUpdated_At | Strapi_PromotionConnectionTitle | Strapi_PromotionConnectionSlug | Strapi_PromotionConnectionIdentifier | Strapi_PromotionConnectionWebsite_Locale | Strapi_PromotionConnectionBody | Strapi_PromotionConnectionExpires_At | Strapi_PromotionConnectionImage | Strapi_PromotionConnectionTerms_And_Conditions | Strapi_PromotionConnectionCall_To_Action | Strapi_PromotionConnectionScript | Strapi_PromotionConnectionHomepage_Link_Text | Strapi_PromotionConnectionInternal_Name | Strapi_PromotionConnectionPage_Settings | Strapi_PromotionConnectionPublished_At | Strapi_CreatePromotionPayload | Strapi_UpdatePromotionPayload | Strapi_DeletePromotionPayload | Strapi_School | Strapi_SchoolConnection | Strapi_SchoolAggregator | Strapi_SchoolGroupBy | Strapi_SchoolConnectionId | Strapi_SchoolConnectionCreated_At | Strapi_SchoolConnectionUpdated_At | Strapi_SchoolConnectionName | Strapi_SchoolConnectionSlug | Strapi_SchoolConnectionStatus | Strapi_SchoolConnectionPage_Settings | Strapi_SchoolConnectionSchool_Hero | Strapi_SchoolConnectionAddress | Strapi_SchoolConnectionMap_Marker | Strapi_SchoolConnectionPhone_Number | Strapi_SchoolConnectionEmail_Address | Strapi_SchoolConnectionActive_Promotion | Strapi_SchoolConnectionWebsite_Locale | Strapi_SchoolConnectionPublished_At | Strapi_CreateSchoolPayload | Strapi_UpdateSchoolPayload | Strapi_DeleteSchoolPayload | Strapi_WebsiteLocale | Strapi_WebsiteLocaleConnection | Strapi_WebsiteLocaleAggregator | Strapi_WebsiteLocaleGroupBy | Strapi_WebsiteLocaleConnectionId | Strapi_WebsiteLocaleConnectionCreated_At | Strapi_WebsiteLocaleConnectionUpdated_At | Strapi_WebsiteLocaleConnectionName | Strapi_WebsiteLocaleConnectionLanguage_Code | Strapi_WebsiteLocaleConnectionDefault_Footer_Cta | Strapi_WebsiteLocaleConnectionWebsite | Strapi_WebsiteLocaleConnectionDefault_Certification_Cta | Strapi_WebsiteLocaleConnectionExternal_Blog_Url | Strapi_WebsiteLocaleConnectionExternal_Blog_Text | Strapi_WebsiteLocaleConnectionHas_External_Blog | Strapi_WebsiteLocaleConnectionCareers_Cta | Strapi_WebsiteLocaleConnectionTranslations | Strapi_WebsiteLocaleConnectionFooter_Meta_Info | Strapi_WebsiteLocaleConnectionHas_Right_To_Left_Language | Strapi_WebsiteLocaleConnectionPath_Prefixes | Strapi_WebsiteLocaleConnectionTop_Bar_Cta | Strapi_WebsiteLocaleConnectionTelephone | Strapi_CreateWebsiteLocalePayload | Strapi_UpdateWebsiteLocalePayload | Strapi_DeleteWebsiteLocalePayload | Strapi_Website | Strapi_WebsiteConnection | Strapi_WebsiteAggregator | Strapi_WebsiteGroupBy | Strapi_WebsiteConnectionId | Strapi_WebsiteConnectionCreated_At | Strapi_WebsiteConnectionUpdated_At | Strapi_WebsiteConnectionName | Strapi_WebsiteConnectionDomain_Name | Strapi_WebsiteConnectionCountry_Code | Strapi_WebsiteConnectionDefault_Website_Locale | Strapi_WebsiteConnectionSettings | Strapi_WebsiteConnectionIs_Template | Strapi_CreateWebsitePayload | Strapi_UpdateWebsitePayload | Strapi_DeleteWebsitePayload | Strapi_UploadFile | Strapi_UploadFileConnection | Strapi_UploadFileAggregator | Strapi_UploadFileAggregatorSum | Strapi_UploadFileAggregatorAvg | Strapi_UploadFileAggregatorMin | Strapi_UploadFileAggregatorMax | Strapi_UploadFileGroupBy | Strapi_UploadFileConnectionId | Strapi_UploadFileConnectionCreated_At | Strapi_UploadFileConnectionUpdated_At | Strapi_UploadFileConnectionName | Strapi_UploadFileConnectionAlternativeText | Strapi_UploadFileConnectionCaption | Strapi_UploadFileConnectionWidth | Strapi_UploadFileConnectionHeight | Strapi_UploadFileConnectionFormats | Strapi_UploadFileConnectionHash | Strapi_UploadFileConnectionExt | Strapi_UploadFileConnectionMime | Strapi_UploadFileConnectionSize | Strapi_UploadFileConnectionUrl | Strapi_UploadFileConnectionPreviewUrl | Strapi_UploadFileConnectionProvider | Strapi_UploadFileConnectionProvider_Metadata | Strapi_DeleteFilePayload | Strapi_UsersPermissionsPermission | Strapi_UsersPermissionsRole | Strapi_UsersPermissionsRoleConnection | Strapi_UsersPermissionsRoleAggregator | Strapi_UsersPermissionsRoleGroupBy | Strapi_UsersPermissionsRoleConnectionId | Strapi_UsersPermissionsRoleConnectionName | Strapi_UsersPermissionsRoleConnectionDescription | Strapi_UsersPermissionsRoleConnectionType | Strapi_CreateRolePayload | Strapi_UpdateRolePayload | Strapi_DeleteRolePayload | Strapi_UsersPermissionsUser | Strapi_UsersPermissionsUserConnection | Strapi_UsersPermissionsUserAggregator | Strapi_UsersPermissionsUserGroupBy | Strapi_UsersPermissionsUserConnectionId | Strapi_UsersPermissionsUserConnectionCreated_At | Strapi_UsersPermissionsUserConnectionUpdated_At | Strapi_UsersPermissionsUserConnectionUsername | Strapi_UsersPermissionsUserConnectionEmail | Strapi_UsersPermissionsUserConnectionProvider | Strapi_UsersPermissionsUserConnectionConfirmed | Strapi_UsersPermissionsUserConnectionBlocked | Strapi_UsersPermissionsUserConnectionRole | Strapi_CreateUserPayload | Strapi_UpdateUserPayload | Strapi_DeleteUserPayload | Strapi_ComponentAtomArrowList | Strapi_ComponentAtomColumn | Strapi_ComponentAtomCourseFeatures | Strapi_ComponentAtomDeliveryMethodCard | Strapi_ComponentAtomEnglishLevel | Strapi_ComponentAtomExternalLinks | Strapi_ComponentAtomLink | Strapi_ComponentAtomListItem | Strapi_ComponentAtomLogos | Strapi_ComponentAtomMapMarker | Strapi_ComponentAtomPeopleCard | Strapi_ComponentAtomPricingPlan | Strapi_ComponentAtomScrollingStatement | Strapi_ComponentAtomSocialLink | Strapi_ComponentAtomTeacher | Strapi_ComponentAtomWseSiteLink | Strapi_ComponentDataEnglishLevelComparison | Strapi_ComponentDataEnglishLevel | Strapi_ComponentDataPageSettings | Strapi_ComponentDataPriceDescription | Strapi_ComponentNavigationNavigationItem | Strapi_ComponentPageCallToAction | Strapi_ComponentPageCareersGallery | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnglishLevelsAccordion | Strapi_ComponentPageEnglishLevelsTable | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHeroMap | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageInlineHubspotForm | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText | Strapi_ComponentSchoolPostalAddress | Strapi_ComponentSchoolSchoolHero | Strapi_ComponentSiteAdvancedSettings | Strapi_ComponentSitePageScript;

export type Strapi_Page = {
  __typename?: 'Strapi_Page';
  title: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  components: Array<Maybe<Strapi_PageComponentsDynamicZone>>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  meta_tags?: Maybe<Array<Maybe<Strapi_ComponentPageMeta>>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  index_page?: Maybe<Strapi_Enum_Page_Index_Page>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_PageRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};
export type Strapi_PageAggregator = {
  __typename?: 'Strapi_PageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_PageComponentsDynamicZone = Strapi_ComponentPageCallToAction | Strapi_ComponentPageCareersGallery | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnLvlsAcd | Strapi_ComponentPageEnLvlsTbl | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHeroMap | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageInlineHubspotForm | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText | Strapi_ComponentPageCourseCmprsns | Strapi_ComponentDataRelatedSchools | Strapi_Error;

export type Strapi_PageEntity = {
  __typename?: 'Strapi_PageEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Page>;
};

export type Strapi_PageRelationResponseCollection = {
  __typename?: 'Strapi_PageRelationResponseCollection';
  data: Array<Strapi_PageEntity>;
};

export type Strapi_PageEntityResponseCollection = {
  __typename?: 'Strapi_PageEntityResponseCollection';
  data: Array<Strapi_PageEntity>;
  meta: Strapi_ResponseCollectionMeta;
};


export type Strapi_PageConnection = {
  __typename?: 'Strapi_PageConnection';
  values?: Maybe<Array<Maybe<Strapi_Page>>>;
  groupBy?: Maybe<Strapi_PageGroupBy>;
  aggregate?: Maybe<Strapi_PageAggregator>;
};

export type Strapi_PageConnectionCreated_At = {
  __typename?: 'Strapi_PageConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionId = {
  __typename?: 'Strapi_PageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionIndex_Page = {
  __typename?: 'Strapi_PageConnectionIndex_page';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionPage_Settings = {
  __typename?: 'Strapi_PageConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionPublished_At = {
  __typename?: 'Strapi_PageConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionSlug = {
  __typename?: 'Strapi_PageConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionTitle = {
  __typename?: 'Strapi_PageConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionUpdated_At = {
  __typename?: 'Strapi_PageConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageConnectionWebsite_Locale = {
  __typename?: 'Strapi_PageConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PageConnection>;
};

export type Strapi_PageGroupBy = {
  __typename?: 'Strapi_PageGroupBy';
  id?: Maybe<Array<Maybe<Strapi_PageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_PageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_PageConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_PageConnectionTitle>>>;
  slug?: Maybe<Array<Maybe<Strapi_PageConnectionSlug>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_PageConnectionWebsite_Locale>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_PageConnectionPage_Settings>>>;
  index_page?: Maybe<Array<Maybe<Strapi_PageConnectionIndex_Page>>>;
  published_at?: Maybe<Array<Maybe<Strapi_PageConnectionPublished_At>>>;
};

export type Strapi_PageInput = {
  title: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  components: Array<Scalars['Strapi_PageComponentsDynamicZoneInput']>;
  website_locale?: Maybe<Scalars['ID']>;
  meta_tags?: Maybe<Array<Maybe<Strapi_ComponentPageMetaInput>>>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  index_page?: Maybe<Strapi_Enum_Page_Index_Page>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_Pagination = {
  __typename?: 'Strapi_Pagination';
  total: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  pageCount: Scalars['Int'];
};

export type Strapi_PaginationArg = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type Strapi_Promotion = {
  __typename?: 'Strapi_Promotion';
  documentId:  Maybe<Scalars['ID']>;
  title: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  body: Scalars['String'];
  expires_at: Scalars['Strapi_DateTime'];
  image?: Maybe<Strapi_UploadFileEntityResponse>;
  terms_and_conditions?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_ComponentPageCallToAction>;
  script?: Maybe<Scalars['String']>;
  homepage_link_text?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_PromotionRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};

export type Strapi_PromotionEntity = {
  __typename?: 'Strapi_PromotionEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_Promotion>;
};

export type Strapi_PromotionEntityResponse = {
  __typename?: 'Strapi_PromotionEntityResponse';
  data?: Maybe<Strapi_PromotionEntity>;
};

export type Strapi_PromotionRelationResponseCollection = {
  __typename?: 'Strapi_PromotionRelationResponseCollection';
  data: Array<Strapi_PromotionEntity>;
};

export type Strapi_PromotionAggregator = {
  __typename?: 'Strapi_PromotionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_PromotionConnection = {
  __typename?: 'Strapi_PromotionConnection';
  values?: Maybe<Array<Maybe<Strapi_Promotion>>>;
  groupBy?: Maybe<Strapi_PromotionGroupBy>;
  aggregate?: Maybe<Strapi_PromotionAggregator>;
};

export type Strapi_PromotionConnectionBody = {
  __typename?: 'Strapi_PromotionConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionCall_To_Action = {
  __typename?: 'Strapi_PromotionConnectionCall_to_action';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionCreated_At = {
  __typename?: 'Strapi_PromotionConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionExpires_At = {
  __typename?: 'Strapi_PromotionConnectionExpires_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionHomepage_Link_Text = {
  __typename?: 'Strapi_PromotionConnectionHomepage_link_text';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionId = {
  __typename?: 'Strapi_PromotionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionIdentifier = {
  __typename?: 'Strapi_PromotionConnectionIdentifier';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionImage = {
  __typename?: 'Strapi_PromotionConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionInternal_Name = {
  __typename?: 'Strapi_PromotionConnectionInternal_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionPage_Settings = {
  __typename?: 'Strapi_PromotionConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionPublished_At = {
  __typename?: 'Strapi_PromotionConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionScript = {
  __typename?: 'Strapi_PromotionConnectionScript';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionSlug = {
  __typename?: 'Strapi_PromotionConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionTerms_And_Conditions = {
  __typename?: 'Strapi_PromotionConnectionTerms_and_conditions';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionTitle = {
  __typename?: 'Strapi_PromotionConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionUpdated_At = {
  __typename?: 'Strapi_PromotionConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionConnectionWebsite_Locale = {
  __typename?: 'Strapi_PromotionConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_PromotionConnection>;
};

export type Strapi_PromotionGroupBy = {
  __typename?: 'Strapi_PromotionGroupBy';
  id?: Maybe<Array<Maybe<Strapi_PromotionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_PromotionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_PromotionConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<Strapi_PromotionConnectionTitle>>>;
  slug?: Maybe<Array<Maybe<Strapi_PromotionConnectionSlug>>>;
  identifier?: Maybe<Array<Maybe<Strapi_PromotionConnectionIdentifier>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_PromotionConnectionWebsite_Locale>>>;
  body?: Maybe<Array<Maybe<Strapi_PromotionConnectionBody>>>;
  expires_at?: Maybe<Array<Maybe<Strapi_PromotionConnectionExpires_At>>>;
  image?: Maybe<Array<Maybe<Strapi_PromotionConnectionImage>>>;
  terms_and_conditions?: Maybe<Array<Maybe<Strapi_PromotionConnectionTerms_And_Conditions>>>;
  call_to_action?: Maybe<Array<Maybe<Strapi_PromotionConnectionCall_To_Action>>>;
  script?: Maybe<Array<Maybe<Strapi_PromotionConnectionScript>>>;
  homepage_link_text?: Maybe<Array<Maybe<Strapi_PromotionConnectionHomepage_Link_Text>>>;
  internal_name?: Maybe<Array<Maybe<Strapi_PromotionConnectionInternal_Name>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_PromotionConnectionPage_Settings>>>;
  published_at?: Maybe<Array<Maybe<Strapi_PromotionConnectionPublished_At>>>;
};

export type Strapi_PromotionInput = {
  title: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  website_locale?: Maybe<Scalars['ID']>;
  body: Scalars['String'];
  expires_at: Scalars['Strapi_DateTime'];
  image?: Maybe<Scalars['ID']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_ComponentPageCallToActionInput>;
  script?: Maybe<Scalars['String']>;
  homepage_link_text?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum Strapi_PublicationState {
  LIVE = 'LIVE',
  PREVIEW = 'PREVIEW'
}

export enum Strapi_Enum_Componentpagerelatedlist_Relatedlist {
  Blogs = 'Blogs',
  Promotions = 'Promotions',
  Schools = 'Schools',
  Certifications = 'Certifications',
  Cities = 'Cities'
}

export type Strapi_RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_ResponseCollectionMeta = {
  __typename?: 'Strapi_ResponseCollectionMeta';
  pagination: Strapi_Pagination;
};

export type Strapi_School = {
  __typename?: 'Strapi_School';
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Strapi_Enum_School_Status>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettings>;
  school_hero?: Maybe<Strapi_ComponentSchoolSchoolHero>;
  address?: Maybe<Strapi_ComponentSchoolPostalAddress>;
  map_marker?: Maybe<Strapi_ComponentAtomMapMarker>;
  phone_number?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  active_promotion?: Maybe<Strapi_PromotionEntityResponse>;
  components?: Maybe<Array<Maybe<Strapi_SchoolComponentsDynamicZone>>>;
  website_locale: Strapi_WebsiteLocaleEntityResponse;
  promotions?: Maybe<Strapi_PromotionRelationResponseCollection>;
  career_posts?: Maybe<Strapi_CareerPostRelationResponseCollection>;
  categories?: Maybe<Strapi_CategoryRelationResponseCollection>;
  certifications?: Maybe<Strapi_CertificationRelationResponseCollection>;
  events?: Maybe<Strapi_EventRelationResponseCollection>;
  seo?: Maybe<Strapi_ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['Strapi_DateTime']>;
  updatedAt?: Maybe<Scalars['Strapi_DateTime']>;
  publishedAt?: Maybe<Scalars['Strapi_DateTime']>;
  localizations?: Maybe<Strapi_SchoolRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
};

export type Strapi_SchoolPromotionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_SchoolCareer_PostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_SchoolCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_SchoolCertificationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_SchoolEventsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_SchoolAdmin_UsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_SchoolAggregator = {
  __typename?: 'Strapi_SchoolAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_SchoolComponentsDynamicZone = Strapi_ComponentPageCallToAction | Strapi_ComponentPageColumns | Strapi_ComponentPageCourseCtaPanel | Strapi_ComponentPageDetailedPricingPlan | Strapi_ComponentPageEmbedCode | Strapi_ComponentPageEnglishLevelsAccordion | Strapi_ComponentPageEnglishLevelsTable | Strapi_ComponentPageEnglishLevels | Strapi_ComponentPageEventsCtaPanel | Strapi_ComponentPageHeroCourse | Strapi_ComponentPageHero | Strapi_ComponentPageHtml | Strapi_ComponentPageImageAndText | Strapi_ComponentPageLocationPanel | Strapi_ComponentPageLogoGallery | Strapi_ComponentPageMap | Strapi_ComponentPageMeetTheTeamGallery | Strapi_ComponentPageMeta | Strapi_ComponentPagePricingPlanPanel | Strapi_ComponentPagePromotionsCtaPanel | Strapi_ComponentPageQuoteAndText | Strapi_ComponentPageReviewsIoWidget | Strapi_ComponentPageRichList | Strapi_ComponentPageRichText | Strapi_ComponentPageSchoolInfoBox | Strapi_ComponentPageScrollingStatement | Strapi_ComponentPageSimpleTitle | Strapi_ComponentPageTeacherAndCoaches | Strapi_ComponentPageTextAndSplitImages | Strapi_ComponentPageText | Strapi_ComponentPageThreeBlocksAndImage | Strapi_ComponentPageTwoColumnsAndLinks | Strapi_ComponentPageTwoColumns | Strapi_ComponentPageVideoAndText;


export type Strapi_SchoolEntity = {
  __typename?: 'Strapi_SchoolEntity';
  documentId?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_School>;
};

export type Strapi_SchoolEntityResponse = {
  __typename?: 'Strapi_SchoolEntityResponse';
  data?: Maybe<Strapi_SchoolEntity>;
};

export type Strapi_SchoolConnection = {
  __typename?: 'Strapi_SchoolConnection';
  values?: Maybe<Array<Maybe<Strapi_School>>>;
  groupBy?: Maybe<Strapi_SchoolGroupBy>;
  aggregate?: Maybe<Strapi_SchoolAggregator>;
};

export type Strapi_SchoolConnectionActive_Promotion = {
  __typename?: 'Strapi_SchoolConnectionActive_promotion';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionAddress = {
  __typename?: 'Strapi_SchoolConnectionAddress';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionCreated_At = {
  __typename?: 'Strapi_SchoolConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionEmail_Address = {
  __typename?: 'Strapi_SchoolConnectionEmail_address';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionId = {
  __typename?: 'Strapi_SchoolConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionMap_Marker = {
  __typename?: 'Strapi_SchoolConnectionMap_marker';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionName = {
  __typename?: 'Strapi_SchoolConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionPage_Settings = {
  __typename?: 'Strapi_SchoolConnectionPage_settings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionPhone_Number = {
  __typename?: 'Strapi_SchoolConnectionPhone_number';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionPublished_At = {
  __typename?: 'Strapi_SchoolConnectionPublished_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionSchool_Hero = {
  __typename?: 'Strapi_SchoolConnectionSchool_hero';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionSlug = {
  __typename?: 'Strapi_SchoolConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionStatus = {
  __typename?: 'Strapi_SchoolConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionUpdated_At = {
  __typename?: 'Strapi_SchoolConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolConnectionWebsite_Locale = {
  __typename?: 'Strapi_SchoolConnectionWebsite_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_SchoolConnection>;
};

export type Strapi_SchoolGroupBy = {
  __typename?: 'Strapi_SchoolGroupBy';
  id?: Maybe<Array<Maybe<Strapi_SchoolConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_SchoolConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_SchoolConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_SchoolConnectionName>>>;
  slug?: Maybe<Array<Maybe<Strapi_SchoolConnectionSlug>>>;
  status?: Maybe<Array<Maybe<Strapi_SchoolConnectionStatus>>>;
  page_settings?: Maybe<Array<Maybe<Strapi_SchoolConnectionPage_Settings>>>;
  school_hero?: Maybe<Array<Maybe<Strapi_SchoolConnectionSchool_Hero>>>;
  address?: Maybe<Array<Maybe<Strapi_SchoolConnectionAddress>>>;
  map_marker?: Maybe<Array<Maybe<Strapi_SchoolConnectionMap_Marker>>>;
  phone_number?: Maybe<Array<Maybe<Strapi_SchoolConnectionPhone_Number>>>;
  email_address?: Maybe<Array<Maybe<Strapi_SchoolConnectionEmail_Address>>>;
  active_promotion?: Maybe<Array<Maybe<Strapi_SchoolConnectionActive_Promotion>>>;
  website_locale?: Maybe<Array<Maybe<Strapi_SchoolConnectionWebsite_Locale>>>;
  published_at?: Maybe<Array<Maybe<Strapi_SchoolConnectionPublished_At>>>;
};

export type Strapi_SchoolInput = {
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Strapi_Enum_School_Status>;
  page_settings?: Maybe<Strapi_ComponentDataPageSettingInput>;
  school_hero?: Maybe<Strapi_ComponentSchoolSchoolHeroInput>;
  address?: Maybe<Strapi_ComponentSchoolPostalAddressInput>;
  map_marker?: Maybe<Strapi_ComponentAtomMapMarkerInput>;
  phone_number?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  active_promotion?: Maybe<Scalars['ID']>;
  components?: Maybe<Array<Scalars['Strapi_SchoolComponentsDynamicZoneInput']>>;
  website_locale?: Maybe<Scalars['ID']>;
  promotions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  career_posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  certifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  admin_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_SchoolRelationResponseCollection = {
  __typename?: 'Strapi_SchoolRelationResponseCollection';
  data: Array<Strapi_SchoolEntity>;
};

export type Strapi_StringFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['String']>>>;
  or?: Maybe<Array<Maybe<Scalars['String']>>>;
  not?: Maybe<Strapi_StringFilterInput>;
  eq?: Maybe<Scalars['String']>;
  eqi?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  containsi?: Maybe<Scalars['String']>;
  notContainsi?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type Strapi_UploadFile = {
  __typename?: 'Strapi_UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['Strapi_JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['Strapi_JSON']>;
  related?: Maybe<Array<Maybe<Strapi_Morph>>>;
};

export type Strapi_UploadFileEntity = {
  __typename?: 'Strapi_UploadFileEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_UploadFile>;
};

export type Strapi_UploadFileEntityResponse = {
  __typename?: 'Strapi_UploadFileEntityResponse';
  data?: Maybe<Strapi_UploadFileEntity>;
};

export type Strapi_UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_UploadFileAggregator = {
  __typename?: 'Strapi_UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<Strapi_UploadFileAggregatorSum>;
  avg?: Maybe<Strapi_UploadFileAggregatorAvg>;
  min?: Maybe<Strapi_UploadFileAggregatorMin>;
  max?: Maybe<Strapi_UploadFileAggregatorMax>;
};

export type Strapi_UploadFileAggregatorAvg = {
  __typename?: 'Strapi_UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type Strapi_UploadFileAggregatorMax = {
  __typename?: 'Strapi_UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type Strapi_UploadFileAggregatorMin = {
  __typename?: 'Strapi_UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type Strapi_UploadFileAggregatorSum = {
  __typename?: 'Strapi_UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type Strapi_UploadFileConnection = {
  __typename?: 'Strapi_UploadFileConnection';
  values?: Maybe<Array<Maybe<Strapi_UploadFile>>>;
  groupBy?: Maybe<Strapi_UploadFileGroupBy>;
  aggregate?: Maybe<Strapi_UploadFileAggregator>;
};

export type Strapi_UploadFileConnectionAlternativeText = {
  __typename?: 'Strapi_UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionCaption = {
  __typename?: 'Strapi_UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionCreated_At = {
  __typename?: 'Strapi_UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionExt = {
  __typename?: 'Strapi_UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionFormats = {
  __typename?: 'Strapi_UploadFileConnectionFormats';
  key?: Maybe<Scalars['Strapi_JSON']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionHash = {
  __typename?: 'Strapi_UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionHeight = {
  __typename?: 'Strapi_UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionId = {
  __typename?: 'Strapi_UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionMime = {
  __typename?: 'Strapi_UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionName = {
  __typename?: 'Strapi_UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionPreviewUrl = {
  __typename?: 'Strapi_UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionProvider = {
  __typename?: 'Strapi_UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionProvider_Metadata = {
  __typename?: 'Strapi_UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['Strapi_JSON']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionSize = {
  __typename?: 'Strapi_UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionUpdated_At = {
  __typename?: 'Strapi_UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionUrl = {
  __typename?: 'Strapi_UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileConnectionWidth = {
  __typename?: 'Strapi_UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<Strapi_UploadFileConnection>;
};

export type Strapi_UploadFileGroupBy = {
  __typename?: 'Strapi_UploadFileGroupBy';
  id?: Maybe<Array<Maybe<Strapi_UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<Strapi_UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<Strapi_UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<Strapi_UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<Strapi_UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<Strapi_UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<Strapi_UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<Strapi_UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<Strapi_UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<Strapi_UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<Strapi_UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<Strapi_UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<Strapi_UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<Strapi_UploadFileConnectionProvider_Metadata>>>;
};

export type Strapi_UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_UserPermissionsPasswordPayload = {
  __typename?: 'Strapi_UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type Strapi_UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type Strapi_UsersPermissionsLoginPayload = {
  __typename?: 'Strapi_UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: Strapi_UsersPermissionsMe;
};

export type Strapi_UsersPermissionsMe = {
  __typename?: 'Strapi_UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Strapi_UsersPermissionsMeRole>;
};

export type Strapi_UsersPermissionsMeRole = {
  __typename?: 'Strapi_UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Strapi_UsersPermissionsPermission = {
  __typename?: 'Strapi_UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<Strapi_UsersPermissionsRole>;
};

export type Strapi_UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Strapi_UsersPermissionsRole = {
  __typename?: 'Strapi_UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Strapi_UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<Strapi_UsersPermissionsUser>>>;
};


export type Strapi_UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};


export type Strapi_UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_UsersPermissionsRoleAggregator = {
  __typename?: 'Strapi_UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_UsersPermissionsRoleConnection = {
  __typename?: 'Strapi_UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<Strapi_UsersPermissionsRole>>>;
  groupBy?: Maybe<Strapi_UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<Strapi_UsersPermissionsRoleAggregator>;
};

export type Strapi_UsersPermissionsRoleConnectionDescription = {
  __typename?: 'Strapi_UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UsersPermissionsRoleConnection>;
};

export type Strapi_UsersPermissionsRoleConnectionId = {
  __typename?: 'Strapi_UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_UsersPermissionsRoleConnection>;
};

export type Strapi_UsersPermissionsRoleConnectionName = {
  __typename?: 'Strapi_UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UsersPermissionsRoleConnection>;
};

export type Strapi_UsersPermissionsRoleConnectionType = {
  __typename?: 'Strapi_UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UsersPermissionsRoleConnection>;
};

export type Strapi_UsersPermissionsRoleGroupBy = {
  __typename?: 'Strapi_UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<Strapi_UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<Strapi_UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<Strapi_UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<Strapi_UsersPermissionsRoleConnectionType>>>;
};

export type Strapi_UsersPermissionsUser = {
  __typename?: 'Strapi_UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Strapi_UsersPermissionsRole>;
};

export type Strapi_UsersPermissionsUserAggregator = {
  __typename?: 'Strapi_UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_UsersPermissionsUserConnection = {
  __typename?: 'Strapi_UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<Strapi_UsersPermissionsUser>>>;
  groupBy?: Maybe<Strapi_UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<Strapi_UsersPermissionsUserAggregator>;
};

export type Strapi_UsersPermissionsUserConnectionBlocked = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionEmail = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionId = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionProvider = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionRole = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserConnectionUsername = {
  __typename?: 'Strapi_UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_UsersPermissionsUserConnection>;
};

export type Strapi_UsersPermissionsUserGroupBy = {
  __typename?: 'Strapi_UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<Strapi_UsersPermissionsUserConnectionRole>>>;
};

export type Strapi_Website = {
  __typename?: 'Strapi_Website';
  documentId: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  name: Scalars['String'];
  domain_name: Scalars['String'];
  country_code?: Maybe<Scalars['String']>;
  global_scripts?: Maybe<Array<Maybe<Strapi_ComponentSitePageScript>>>;
  default_website_locale?: Maybe<Strapi_WebsiteLocale>;
  settings?: Maybe<Strapi_ComponentSiteAdvancedSettings>;
  is_template?: Maybe<Scalars['Boolean']>;
  website_locales?: Maybe<Array<Maybe<Strapi_WebsiteLocale>>>;
};


export type Strapi_WebsiteWebsite_LocalesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['Strapi_JSON']>;
};

export type Strapi_WebsiteAggregator = {
  __typename?: 'Strapi_WebsiteAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_WebsiteConnection = {
  __typename?: 'Strapi_WebsiteConnection';
  values?: Maybe<Array<Maybe<Strapi_Website>>>;
  groupBy?: Maybe<Strapi_WebsiteGroupBy>;
  aggregate?: Maybe<Strapi_WebsiteAggregator>;
};

export type Strapi_WebsiteConnectionCountry_Code = {
  __typename?: 'Strapi_WebsiteConnectionCountry_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionCreated_At = {
  __typename?: 'Strapi_WebsiteConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionDefault_Website_Locale = {
  __typename?: 'Strapi_WebsiteConnectionDefault_website_locale';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionDomain_Name = {
  __typename?: 'Strapi_WebsiteConnectionDomain_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionId = {
  __typename?: 'Strapi_WebsiteConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionIs_Template = {
  __typename?: 'Strapi_WebsiteConnectionIs_template';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionName = {
  __typename?: 'Strapi_WebsiteConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionSettings = {
  __typename?: 'Strapi_WebsiteConnectionSettings';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteConnectionUpdated_At = {
  __typename?: 'Strapi_WebsiteConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_WebsiteConnection>;
};

export type Strapi_WebsiteGroupBy = {
  __typename?: 'Strapi_WebsiteGroupBy';
  id?: Maybe<Array<Maybe<Strapi_WebsiteConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_WebsiteConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_WebsiteConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_WebsiteConnectionName>>>;
  domain_name?: Maybe<Array<Maybe<Strapi_WebsiteConnectionDomain_Name>>>;
  country_code?: Maybe<Array<Maybe<Strapi_WebsiteConnectionCountry_Code>>>;
  default_website_locale?: Maybe<Array<Maybe<Strapi_WebsiteConnectionDefault_Website_Locale>>>;
  settings?: Maybe<Array<Maybe<Strapi_WebsiteConnectionSettings>>>;
  is_template?: Maybe<Array<Maybe<Strapi_WebsiteConnectionIs_Template>>>;
};

export type Strapi_WebsiteInput = {
  name: Scalars['String'];
  domain_name: Scalars['String'];
  country_code?: Maybe<Scalars['String']>;
  website_locales?: Maybe<Array<Maybe<Scalars['ID']>>>;
  global_scripts?: Maybe<Array<Maybe<Strapi_ComponentSitePageScriptInput>>>;
  default_website_locale?: Maybe<Scalars['ID']>;
  settings?: Maybe<Strapi_ComponentSiteAdvancedSettingInput>;
  admin_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_template?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_WebsiteLocale = {
  __typename?: 'Strapi_WebsiteLocale';
  documentId: Scalars['ID'];
  created_at: Scalars['Strapi_DateTime'];
  updated_at: Scalars['Strapi_DateTime'];
  name: Scalars['String'];
  language_code: Scalars['String'];
  locale: Scalars['String'];
  navigation?: Maybe<Array<Maybe<Strapi_ComponentNavigationNavigationItem>>>;
  footer_left_links?: Maybe<Array<Maybe<Strapi_ComponentNavigationNavigationItem>>>;
  legal_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  social_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLink>>>;
  default_footer_cta?: Maybe<Strapi_FooterCta>;
  website?: Maybe<Strapi_Website>;
  default_certification_cta?: Maybe<Strapi_CertificationCta>;
  external_blog_url?: Maybe<Scalars['String']>;
  external_blog_text?: Maybe<Scalars['String']>;
  has_external_blog?: Maybe<Scalars['Boolean']>;
  careers_cta?: Maybe<Strapi_CareersCta>;
  translations?: Maybe<Scalars['Strapi_JSON']>;
  international_header_site_links?: Maybe<Array<Maybe<Strapi_ComponentAtomWseSiteLink>>>;
  footer_meta_info?: Maybe<Scalars['String']>;
  footer_right_links?: Maybe<Array<Maybe<Strapi_ComponentNavigationNavigationItem>>>;
  has_right_to_left_language: Scalars['Boolean'];
  path_prefixes?: Maybe<Scalars['Strapi_JSON']>;
  top_bar_cta?: Maybe<Strapi_ComponentAtomLink>;
  telephone?: Maybe<Scalars['String']>;
  learning_products?: Maybe<Array<Maybe<Strapi_ComponentAtomLearningProductList>>>;
};

export type Strapi_WebsiteLocaleAggregator = {
  __typename?: 'Strapi_WebsiteLocaleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Strapi_WebsiteLocaleConnection = {
  __typename?: 'Strapi_WebsiteLocaleConnection';
  values?: Maybe<Array<Maybe<Strapi_WebsiteLocale>>>;
  groupBy?: Maybe<Strapi_WebsiteLocaleGroupBy>;
  aggregate?: Maybe<Strapi_WebsiteLocaleAggregator>;
};

export type Strapi_WebsiteLocaleEntity = {
  __typename?: 'Strapi_WebsiteLocaleEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_WebsiteLocaleEntityResponse = {
  __typename?: 'Strapi_WebsiteLocaleEntityResponse';
  data?: Maybe<Strapi_WebsiteLocaleEntity>;
};


export type Strapi_WebsiteLocaleConnectionCareers_Cta = {
  __typename?: 'Strapi_WebsiteLocaleConnectionCareers_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionCreated_At = {
  __typename?: 'Strapi_WebsiteLocaleConnectionCreated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionDefault_Certification_Cta = {
  __typename?: 'Strapi_WebsiteLocaleConnectionDefault_certification_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionDefault_Footer_Cta = {
  __typename?: 'Strapi_WebsiteLocaleConnectionDefault_footer_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionExternal_Blog_Text = {
  __typename?: 'Strapi_WebsiteLocaleConnectionExternal_blog_text';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionExternal_Blog_Url = {
  __typename?: 'Strapi_WebsiteLocaleConnectionExternal_blog_url';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionFooter_Meta_Info = {
  __typename?: 'Strapi_WebsiteLocaleConnectionFooter_meta_info';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionHas_External_Blog = {
  __typename?: 'Strapi_WebsiteLocaleConnectionHas_external_blog';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionHas_Right_To_Left_Language = {
  __typename?: 'Strapi_WebsiteLocaleConnectionHas_right_to_left_language';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionId = {
  __typename?: 'Strapi_WebsiteLocaleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionLanguage_Code = {
  __typename?: 'Strapi_WebsiteLocaleConnectionLanguage_code';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionName = {
  __typename?: 'Strapi_WebsiteLocaleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionPath_Prefixes = {
  __typename?: 'Strapi_WebsiteLocaleConnectionPath_prefixes';
  key?: Maybe<Scalars['Strapi_JSON']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionTelephone = {
  __typename?: 'Strapi_WebsiteLocaleConnectionTelephone';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionTop_Bar_Cta = {
  __typename?: 'Strapi_WebsiteLocaleConnectionTop_bar_cta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionTranslations = {
  __typename?: 'Strapi_WebsiteLocaleConnectionTranslations';
  key?: Maybe<Scalars['Strapi_JSON']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionUpdated_At = {
  __typename?: 'Strapi_WebsiteLocaleConnectionUpdated_at';
  key?: Maybe<Scalars['Strapi_DateTime']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleConnectionWebsite = {
  __typename?: 'Strapi_WebsiteLocaleConnectionWebsite';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<Strapi_WebsiteLocaleConnection>;
};

export type Strapi_WebsiteLocaleGroupBy = {
  __typename?: 'Strapi_WebsiteLocaleGroupBy';
  id?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionId>>>;
  created_at?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionName>>>;
  language_code?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionLanguage_Code>>>;
  default_footer_cta?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionDefault_Footer_Cta>>>;
  website?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionWebsite>>>;
  default_certification_cta?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionDefault_Certification_Cta>>>;
  external_blog_url?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionExternal_Blog_Url>>>;
  external_blog_text?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionExternal_Blog_Text>>>;
  has_external_blog?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionHas_External_Blog>>>;
  careers_cta?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionCareers_Cta>>>;
  translations?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionTranslations>>>;
  footer_meta_info?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionFooter_Meta_Info>>>;
  has_right_to_left_language?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionHas_Right_To_Left_Language>>>;
  path_prefixes?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionPath_Prefixes>>>;
  top_bar_cta?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionTop_Bar_Cta>>>;
  telephone?: Maybe<Array<Maybe<Strapi_WebsiteLocaleConnectionTelephone>>>;
};

export type Strapi_WebsiteLocaleInput = {
  name: Scalars['String'];
  language_code: Scalars['String'];
  navigation?: Maybe<Array<Strapi_ComponentNavigationNavigationItemInput>>;
  footer_left_links?: Maybe<Array<Strapi_ComponentNavigationNavigationItemInput>>;
  legal_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  social_links?: Maybe<Array<Maybe<Strapi_ComponentAtomLinkInput>>>;
  default_footer_cta?: Maybe<Scalars['ID']>;
  website?: Maybe<Scalars['ID']>;
  default_certification_cta?: Maybe<Scalars['ID']>;
  external_blog_url?: Maybe<Scalars['String']>;
  external_blog_text?: Maybe<Scalars['String']>;
  has_external_blog?: Maybe<Scalars['Boolean']>;
  careers_cta?: Maybe<Scalars['ID']>;
  translations?: Maybe<Scalars['Strapi_JSON']>;
  international_header_site_links?: Maybe<Array<Maybe<Strapi_ComponentAtomWseSiteLinkInput>>>;
  footer_meta_info?: Maybe<Scalars['String']>;
  footer_right_links?: Maybe<Array<Maybe<Strapi_ComponentNavigationNavigationItemInput>>>;
  has_right_to_left_language?: Maybe<Scalars['Boolean']>;
  path_prefixes?: Maybe<Scalars['Strapi_JSON']>;
  top_bar_cta?: Maybe<Strapi_ComponentAtomLinkInput>;
  telephone?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
  learning_products?: Maybe<Array<Maybe<Strapi_ComponentAtomLearningProductListInput>>>;
};

export type Strapi_CreateBlogPostInput = {
  data?: Maybe<Strapi_BlogPostInput>;
};

export type Strapi_CreateBlogPostPayload = {
  __typename?: 'Strapi_createBlogPostPayload';
  blogPost?: Maybe<Strapi_BlogPost>;
};

export type Strapi_CreateCareerPostInput = {
  data?: Maybe<Strapi_CareerPostInput>;
};

export type Strapi_CreateCareerPostPayload = {
  __typename?: 'Strapi_createCareerPostPayload';
  careerPost?: Maybe<Strapi_CareerPost>;
};

export type Strapi_CreateCareersCtaInput = {
  data?: Maybe<Strapi_CareersCtaInput>;
};

export type Strapi_CreateCareersCtaPayload = {
  __typename?: 'Strapi_createCareersCtaPayload';
  careersCta?: Maybe<Strapi_CareersCta>;
};

export type Strapi_CreateCategoryInput = {
  data?: Maybe<Strapi_CategoryInput>;
};

export type Strapi_CreateCategoryPayload = {
  __typename?: 'Strapi_createCategoryPayload';
  category?: Maybe<Strapi_Category>;
};

export type Strapi_CreateCertificationCtaInput = {
  data?: Maybe<Strapi_CertificationCtaInput>;
};

export type Strapi_CreateCertificationCtaPayload = {
  __typename?: 'Strapi_createCertificationCtaPayload';
  certificationCta?: Maybe<Strapi_CertificationCta>;
};

export type Strapi_CreateCertificationInput = {
  data?: Maybe<Strapi_CertificationInput>;
};

export type Strapi_CreateCertificationPayload = {
  __typename?: 'Strapi_createCertificationPayload';
  certification?: Maybe<Strapi_Certification>;
};

export type Strapi_CreateCityInput = {
  data?: Maybe<Strapi_CityInput>;
};

export type Strapi_CreateCityPayload = {
  __typename?: 'Strapi_createCityPayload';
  city?: Maybe<Strapi_City>;
};

export type Strapi_CreateCourseInput = {
  data?: Maybe<Strapi_CourseInput>;
};

export type Strapi_CreateCoursePayload = {
  __typename?: 'Strapi_createCoursePayload';
  course?: Maybe<Strapi_Course>;
};

export type Strapi_CreateDeliveryMethodInput = {
  data?: Maybe<Strapi_DeliveryMethodInput>;
};

export type Strapi_CreateDeliveryMethodPayload = {
  __typename?: 'Strapi_createDeliveryMethodPayload';
  deliveryMethod?: Maybe<Strapi_DeliveryMethod>;
};

export type Strapi_CreateEnglishLevelGroupInput = {
  data?: Maybe<Strapi_EnglishLevelGroupInput>;
};

export type Strapi_CreateEnglishLevelGroupPayload = {
  __typename?: 'Strapi_createEnglishLevelGroupPayload';
  englishLevelGroup?: Maybe<Strapi_EnglishLevelGroup>;
};

export type Strapi_CreateEnglishTestInput = {
  data?: Maybe<Strapi_EnglishTestInput>;
};

export type Strapi_CreateEnglishTestPayload = {
  __typename?: 'Strapi_createEnglishTestPayload';
  englishTest?: Maybe<Strapi_EnglishTest>;
};

export type Strapi_CreateEventInput = {
  data?: Maybe<Strapi_EventInput>;
};

export type Strapi_CreateEventPayload = {
  __typename?: 'Strapi_createEventPayload';
  event?: Maybe<Strapi_Event>;
};

export type Strapi_CreateExerciseInput = {
  data?: Maybe<Strapi_ExerciseInput>;
};

export type Strapi_CreateExercisePayload = {
  __typename?: 'Strapi_createExercisePayload';
  exercise?: Maybe<Strapi_Exercise>;
};

export type Strapi_CreateFooterCtaInput = {
  data?: Maybe<Strapi_FooterCtaInput>;
};

export type Strapi_CreateFooterCtaPayload = {
  __typename?: 'Strapi_createFooterCtaPayload';
  footerCta?: Maybe<Strapi_FooterCta>;
};

export type Strapi_CreateHomepageInput = {
  data?: Maybe<Strapi_HomepageInput>;
};

export type Strapi_CreateHomepagePayload = {
  __typename?: 'Strapi_createHomepagePayload';
  homepage?: Maybe<Strapi_Homepage>;
};

export type Strapi_CreateJobTypeInput = {
  data?: Maybe<Strapi_JobTypeInput>;
};

export type Strapi_CreateJobTypePayload = {
  __typename?: 'Strapi_createJobTypePayload';
  jobType?: Maybe<Strapi_JobType>;
};

export type Strapi_CreateModalInput = {
  data?: Maybe<Strapi_ModalInput>;
};

export type Strapi_CreateModalPayload = {
  __typename?: 'Strapi_createModalPayload';
  modal?: Maybe<Strapi_Modal>;
};

export type Strapi_CreatePageInput = {
  data?: Maybe<Strapi_PageInput>;
};

export type Strapi_CreatePagePayload = {
  __typename?: 'Strapi_createPagePayload';
  page?: Maybe<Strapi_Page>;
};

export type Strapi_CreatePromotionInput = {
  data?: Maybe<Strapi_PromotionInput>;
};

export type Strapi_CreatePromotionPayload = {
  __typename?: 'Strapi_createPromotionPayload';
  promotion?: Maybe<Strapi_Promotion>;
};

export type Strapi_CreateRoleInput = {
  data?: Maybe<Strapi_RoleInput>;
};

export type Strapi_CreateRolePayload = {
  __typename?: 'Strapi_createRolePayload';
  role?: Maybe<Strapi_UsersPermissionsRole>;
};

export type Strapi_CreateSchoolInput = {
  data?: Maybe<Strapi_SchoolInput>;
};

export type Strapi_CreateSchoolPayload = {
  __typename?: 'Strapi_createSchoolPayload';
  school?: Maybe<Strapi_School>;
};

export type Strapi_CreateUserInput = {
  data?: Maybe<Strapi_UserInput>;
};

export type Strapi_CreateUserPayload = {
  __typename?: 'Strapi_createUserPayload';
  user?: Maybe<Strapi_UsersPermissionsUser>;
};

export type Strapi_CreateWebsiteInput = {
  data?: Maybe<Strapi_WebsiteInput>;
};

export type Strapi_CreateWebsiteLocaleInput = {
  data?: Maybe<Strapi_WebsiteLocaleInput>;
};

export type Strapi_CreateWebsiteLocalePayload = {
  __typename?: 'Strapi_createWebsiteLocalePayload';
  websiteLocale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_CreateWebsitePayload = {
  __typename?: 'Strapi_createWebsitePayload';
  website?: Maybe<Strapi_Website>;
};

export type Strapi_DeleteBlogPostInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteBlogPostPayload = {
  __typename?: 'Strapi_deleteBlogPostPayload';
  blogPost?: Maybe<Strapi_BlogPost>;
};

export type Strapi_DeleteCareerPostInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCareerPostPayload = {
  __typename?: 'Strapi_deleteCareerPostPayload';
  careerPost?: Maybe<Strapi_CareerPost>;
};

export type Strapi_DeleteCareersCtaInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCareersCtaPayload = {
  __typename?: 'Strapi_deleteCareersCtaPayload';
  careersCta?: Maybe<Strapi_CareersCta>;
};

export type Strapi_DeleteCategoryInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCategoryPayload = {
  __typename?: 'Strapi_deleteCategoryPayload';
  category?: Maybe<Strapi_Category>;
};

export type Strapi_DeleteCertificationCtaInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCertificationCtaPayload = {
  __typename?: 'Strapi_deleteCertificationCtaPayload';
  certificationCta?: Maybe<Strapi_CertificationCta>;
};

export type Strapi_DeleteCertificationInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCertificationPayload = {
  __typename?: 'Strapi_deleteCertificationPayload';
  certification?: Maybe<Strapi_Certification>;
};

export type Strapi_DeleteCityInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCityPayload = {
  __typename?: 'Strapi_deleteCityPayload';
  city?: Maybe<Strapi_City>;
};

export type Strapi_DeleteCourseInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteCoursePayload = {
  __typename?: 'Strapi_deleteCoursePayload';
  course?: Maybe<Strapi_Course>;
};

export type Strapi_DeleteDeliveryMethodInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteDeliveryMethodPayload = {
  __typename?: 'Strapi_deleteDeliveryMethodPayload';
  deliveryMethod?: Maybe<Strapi_DeliveryMethod>;
};

export type Strapi_DeleteEnglishLevelGroupInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteEnglishLevelGroupPayload = {
  __typename?: 'Strapi_deleteEnglishLevelGroupPayload';
  englishLevelGroup?: Maybe<Strapi_EnglishLevelGroup>;
};

export type Strapi_DeleteEnglishTestInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteEnglishTestPayload = {
  __typename?: 'Strapi_deleteEnglishTestPayload';
  englishTest?: Maybe<Strapi_EnglishTest>;
};

export type Strapi_DeleteEventInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteEventPayload = {
  __typename?: 'Strapi_deleteEventPayload';
  event?: Maybe<Strapi_Event>;
};

export type Strapi_DeleteExerciseInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteExercisePayload = {
  __typename?: 'Strapi_deleteExercisePayload';
  exercise?: Maybe<Strapi_Exercise>;
};

export type Strapi_DeleteFileInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteFilePayload = {
  __typename?: 'Strapi_deleteFilePayload';
  file?: Maybe<Strapi_UploadFile>;
};

export type Strapi_DeleteFooterCtaInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteFooterCtaPayload = {
  __typename?: 'Strapi_deleteFooterCtaPayload';
  footerCta?: Maybe<Strapi_FooterCta>;
};

export type Strapi_DeleteHomepageInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteHomepagePayload = {
  __typename?: 'Strapi_deleteHomepagePayload';
  homepage?: Maybe<Strapi_Homepage>;
};

export type Strapi_DeleteJobTypeInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteJobTypePayload = {
  __typename?: 'Strapi_deleteJobTypePayload';
  jobType?: Maybe<Strapi_JobType>;
};

export type Strapi_DeleteModalInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteModalPayload = {
  __typename?: 'Strapi_deleteModalPayload';
  modal?: Maybe<Strapi_Modal>;
};

export type Strapi_DeletePageInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeletePagePayload = {
  __typename?: 'Strapi_deletePagePayload';
  page?: Maybe<Strapi_Page>;
};

export type Strapi_DeletePromotionInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeletePromotionPayload = {
  __typename?: 'Strapi_deletePromotionPayload';
  promotion?: Maybe<Strapi_Promotion>;
};

export type Strapi_DeleteRoleInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteRolePayload = {
  __typename?: 'Strapi_deleteRolePayload';
  role?: Maybe<Strapi_UsersPermissionsRole>;
};

export type Strapi_DeleteSchoolInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteSchoolPayload = {
  __typename?: 'Strapi_deleteSchoolPayload';
  school?: Maybe<Strapi_School>;
};

export type Strapi_DeleteUserInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteUserPayload = {
  __typename?: 'Strapi_deleteUserPayload';
  user?: Maybe<Strapi_UsersPermissionsUser>;
};

export type Strapi_DeleteWebsiteInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteWebsiteLocaleInput = {
  where?: Maybe<Strapi_InputId>;
};

export type Strapi_DeleteWebsiteLocalePayload = {
  __typename?: 'Strapi_deleteWebsiteLocalePayload';
  websiteLocale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_DeleteWebsitePayload = {
  __typename?: 'Strapi_deleteWebsitePayload';
  website?: Maybe<Strapi_Website>;
};

export type Strapi_EditBlogPostInput = {
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  related_posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  slug?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  excerpt?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  html_code?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditCareerPostInput = {
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  embed_code?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  short?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_EditComponentPageCallToActionInput>;
  city?: Maybe<Scalars['ID']>;
  job_type?: Maybe<Scalars['ID']>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditCareersCtaInput = {
  cta_panel?: Maybe<Strapi_EditComponentPageImageAndTextInput>;
  cta_name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditCategoryInput = {
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditCertificationCtaInput = {
  column_one_heading?: Maybe<Scalars['String']>;
  column_one_body?: Maybe<Scalars['String']>;
  column_one_link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  column_two_heading?: Maybe<Scalars['String']>;
  column_two_body?: Maybe<Scalars['String']>;
  column_two_link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditCertificationInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  certification_cta?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  hero_body?: Maybe<Scalars['String']>;
  hero_link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  schools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  footer_cta?: Maybe<Strapi_EditComponentPageCallToActionInput>;
  certification_english_levels?: Maybe<Strapi_EditComponentPageEnglishLevelInput>;
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  city_heading_text?: Maybe<Scalars['String']>;
  exam_schools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  exam_schools_heading?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Scalars['Strapi_CertificationComponentsDynamicZoneInput']>>;
  reviews_widget?: Maybe<Strapi_EditComponentPageReviewsIoWidgetInput>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditCityInput = {
  name?: Maybe<Scalars['String']>;
  schools?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  hero_link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  image?: Maybe<Scalars['ID']>;
  components?: Maybe<Array<Scalars['Strapi_CityComponentsDynamicZoneInput']>>;
  image_and_text?: Maybe<Strapi_EditComponentPageImageAndTextInput>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  slug?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentAtomArrowListInput = {
  id?: Maybe<Scalars['ID']>;
  list_item?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomColumnInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomCourseFeatureInput = {
  id?: Maybe<Scalars['ID']>;
  feature?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomCourseTextInput = {
  id?: Maybe<Scalars['ID']>;
  title?:Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomDeliveryMethodCardInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  delivery_method?: Maybe<Scalars['ID']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  show_features?: Maybe<Scalars['Boolean']>;
  show_price?: Maybe<Scalars['Boolean']>;
};

export type Strapi_EditComponentAtomEnglishLevelInput = {
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['String']>;
  level_description?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomExternalLinkInput = {
  id?: Maybe<Scalars['ID']>;
  link_name?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  open_in_new_window?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
};

export type Strapi_EditComponentAtomLinkInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['ID']>;
  open_in_new_window?: Maybe<Scalars['Boolean']>;
  nofollow?: Maybe<Scalars['Boolean']>;
  modal?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentAtomListItemInput = {
  id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
  is_faded?: Maybe<Scalars['Boolean']>;
};

export type Strapi_EditComponentAtomLogoInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentAtomMapMarkerInput = {
  id?: Maybe<Scalars['ID']>;
  pop_up_html?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type Strapi_EditComponentAtomPeopleCardInput = {
  id?: Maybe<Scalars['ID']>;
  person_name?: Maybe<Scalars['String']>;
  person_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentAtomPricingPlanInput = {
  id?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  hubspot_form?: Maybe<Scalars['String']>;
  banner_text?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomScrollingStatementInput = {
  id?: Maybe<Scalars['ID']>;
  statement?: Maybe<Scalars['String']>;
  sub_heading?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomSocialLinkInput = {
  id?: Maybe<Scalars['ID']>;
  link_name?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentAtomTeacherInput = {
  id?: Maybe<Scalars['ID']>;
  teacher_name?: Maybe<Scalars['String']>;
  teacher_position?: Maybe<Scalars['String']>;
  teacher_image?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentAtomWseSiteLinkInput = {
  id?: Maybe<Scalars['ID']>;
  territory?: Maybe<Scalars['String']>;
  link_url?: Maybe<Scalars['String']>;
  flag_image?: Maybe<Scalars['ID']>;
  region?: Maybe<Strapi_Enum_Componentatomwsesitelink_Region>;
};

export type Strapi_EditComponentAtomLearningProductListInput = {
  product_name?: Maybe<Scalars['String']>;
  product_link_url?: Maybe<Scalars['String']>;
  product_image?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentDataEnglishLevelComparisonInput = {
  id?: Maybe<Scalars['ID']>;
  certification?: Maybe<Scalars['String']>;
  corresponding_level?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentDataEnglishLevelInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  certifications?: Maybe<Array<Maybe<Strapi_EditComponentDataEnglishLevelComparisonInput>>>;
  information_blocks?: Maybe<Array<Maybe<Strapi_EditComponentAtomColumnInput>>>;
  examples?: Maybe<Strapi_EditComponentAtomColumnInput>;
  website_locale?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentDataPageSettingInput = {
  id?: Maybe<Scalars['ID']>;
  show_footer_cta?: Maybe<Scalars['Boolean']>;
  custom_footer_cta?: Maybe<Scalars['ID']>;
  meta_description?: Maybe<Scalars['String']>;
  avoid_indexing?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentDataPriceDescriptionInput = {
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentNavigationNavigationItemInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  child_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
};

export type Strapi_EditComponentPageCallToActionInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  style?: Maybe<Strapi_Enum_Componentpagecalltoaction_Style>;
};

export type Strapi_EditComponentPageCareersGalleryInput = {
  id?: Maybe<Scalars['ID']>;
  career_posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Strapi_EditComponentPageColumnInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Maybe<Strapi_EditComponentAtomColumnInput>>>;
  show_column_index?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
};

export type Strapi_EditComponentPageCourseCtaPanelInput = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  Speech_bubble_text?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageDetailedPricingPlanInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  delivery_method?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageEmbedCodeInput = {
  id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageEnglishLevelInput = {
  id?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  footer_header?: Maybe<Scalars['String']>;
  footer_description?: Maybe<Scalars['String']>;
  footer_link_url?: Maybe<Scalars['String']>;
  footer_link_url_text?: Maybe<Scalars['String']>;
  English_Level?: Maybe<Array<Maybe<Strapi_EditComponentAtomEnglishLevelInput>>>;
};

export type Strapi_EditComponentPageEnglishLevelsAccordionInput = {
  id?: Maybe<Scalars['ID']>;
  english_level_group?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageEnglishLevelsTableInput = {
  id?: Maybe<Scalars['ID']>;
  english_level_group?: Maybe<Scalars['ID']>;
  highlighted_columns?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageEventsCtaPanelInput = {
  id?: Maybe<Scalars['ID']>;
  panel_title?: Maybe<Scalars['String']>;
  event_link_text?: Maybe<Scalars['String']>;
  event_link_url?: Maybe<Scalars['String']>;
  event_calendar_text?: Maybe<Scalars['String']>;
  event_calendar_url?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageHeroCourseInput = {
  id?: Maybe<Scalars['ID']>;
  main_heading?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  logo_one?: Maybe<Scalars['ID']>;
  logo_two?: Maybe<Scalars['ID']>;
  logo_one_url_link?: Maybe<Scalars['String']>;
  logo_two_url_link?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageHeroInput = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  button?: Maybe<Strapi_EditComponentAtomLinkInput>;
};

export type Strapi_EditComponentPageHeroMapInput = {
  documentId?: Maybe<Scalars['ID']>;
  map_title?: Maybe<Scalars['String']>;
  map_default_zoom?: Maybe<Scalars['Int']>;
  markers?: Maybe<Array<Maybe<Strapi_EditComponentAtomMapMarkerInput>>>;
};

export type Strapi_EditComponentPageHtmlInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  html_code?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageImageAndTextInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  button?: Maybe<Strapi_EditComponentAtomLinkInput>;
  image_position?: Maybe<Strapi_Enum_Componentpageimageandtext_Image_Position>;
  image?: Maybe<Scalars['ID']>;
  intro?: Maybe<Scalars['String']>;
  shaded_background?: Maybe<Scalars['Boolean']>;
  website_locale?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageInlineHubspotFormInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageLocationPanelInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  map?: Maybe<Strapi_EditComponentPageMapInput>;
};

export type Strapi_EditComponentPageLogoGalleryInput = {
  id?: Maybe<Scalars['ID']>;
  logos?: Maybe<Array<Maybe<Strapi_EditComponentAtomLogoInput>>>;
  logo_title?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageMapInput = {
  documentId?: Maybe<Scalars['ID']>;
  width?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  default_zoom?: Maybe<Scalars['Int']>;
  markers?: Maybe<Array<Maybe<Strapi_EditComponentAtomMapMarkerInput>>>;
  default_center?: Maybe<Strapi_EditComponentAtomMapMarkerInput>;
};

export type Strapi_EditComponentPageMeetTheTeamGalleryInput = {
  id?: Maybe<Scalars['ID']>;
  people?: Maybe<Array<Maybe<Strapi_EditComponentAtomPeopleCardInput>>>;
};

export type Strapi_EditComponentPageMetaInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPagePricingPlanPanelInput = {
  id?: Maybe<Scalars['ID']>;
  main_heading?: Maybe<Scalars['String']>;
  main_description?: Maybe<Scalars['String']>;
  delivery_methods?: Maybe<Array<Maybe<Strapi_EditComponentAtomDeliveryMethodCardInput>>>;
};

export type Strapi_EditComponentPagePromotionsCtaPanelInput = {
  id?: Maybe<Scalars['ID']>;
  main_heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  second_heading?: Maybe<Scalars['String']>;
  second_description?: Maybe<Scalars['String']>;
  hubspot_form?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  secondary_link?: Maybe<Strapi_EditComponentAtomLinkInput>;
};

export type Strapi_EditComponentPageQuoteAndTextInput = {
  id?: Maybe<Scalars['ID']>;
  quote?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  video?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageReviewsIoWidgetInput = {
  id?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  script?: Maybe<Strapi_EditComponentPageHtmlInput>;
};

export type Strapi_EditComponentPageRichListInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  cta?: Maybe<Strapi_EditComponentAtomLinkInput>;
  items?: Maybe<Array<Maybe<Strapi_EditComponentAtomColumnInput>>>;
};

export type Strapi_EditComponentPageRichTextInput = {
  id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
  button?: Maybe<Strapi_EditComponentAtomLinkInput>;
};

export type Strapi_EditComponentPageSchoolInfoBoxInput = {
  id?: Maybe<Scalars['ID']>;
  misc_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomExternalLinkInput>>>;
  social_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomSocialLinkInput>>>;
  contact_number?: Maybe<Scalars['String']>;
  internal_links_list_heading?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  external_link_heading?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  internal_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  external_links_list?: Maybe<Array<Maybe<Strapi_EditComponentAtomExternalLinkInput>>>;
  opening_times?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageScrollingStatementInput = {
  id?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  scrolling_statement?: Maybe<Array<Maybe<Strapi_EditComponentAtomScrollingStatementInput>>>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  image_left?: Maybe<Scalars['ID']>;
  image_right?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageSimpleTitleInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentPageTeacherAndCoachInput = {
  id?: Maybe<Scalars['ID']>;
  quote_text?: Maybe<Scalars['String']>;
  quote_author?: Maybe<Scalars['String']>;
  quote_author_position?: Maybe<Scalars['String']>;
  intro_heading?: Maybe<Scalars['String']>;
  intro_text?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  teachers?: Maybe<Array<Maybe<Strapi_EditComponentAtomTeacherInput>>>;
};

export type Strapi_EditComponentPageTextAndSplitImageInput = {
  id?: Maybe<Scalars['ID']>;
  main_heading?: Maybe<Scalars['String']>;
  main_description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  image_left?: Maybe<Scalars['ID']>;
  image_center?: Maybe<Scalars['ID']>;
  image_right?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageTextInput = {
  id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
};

export type Strapi_EditComponentPageThreeBlocksAndImageInput = {
  id?: Maybe<Scalars['ID']>;
  list_one?: Maybe<Array<Maybe<Strapi_EditComponentAtomArrowListInput>>>;
  list_heading_one?: Maybe<Scalars['String']>;
  list_heading_two?: Maybe<Scalars['String']>;
  list_heading_three?: Maybe<Scalars['String']>;
  list_two?: Maybe<Array<Maybe<Strapi_EditComponentAtomArrowListInput>>>;
  list_three?: Maybe<Array<Maybe<Strapi_EditComponentAtomArrowListInput>>>;
  image?: Maybe<Scalars['ID']>;
};

export type Strapi_EditComponentPageTwoColumnInput = {
  id?: Maybe<Scalars['ID']>;
  left_column?: Maybe<Strapi_EditComponentAtomColumnInput>;
  left_cta?: Maybe<Strapi_EditComponentAtomLinkInput>;
  right_column?: Maybe<Strapi_EditComponentAtomColumnInput>;
  right_cta?: Maybe<Strapi_EditComponentAtomLinkInput>;
  shaded_background?: Maybe<Scalars['Boolean']>;
};

export type Strapi_EditComponentPageTwoColumnsAndLinkInput = {
  id?: Maybe<Scalars['ID']>;
  heading_one?: Maybe<Scalars['String']>;
  description_one?: Maybe<Scalars['String']>;
  links_one?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  heading_two?: Maybe<Scalars['String']>;
  description_two?: Maybe<Scalars['String']>;
  links_two?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
};

export type Strapi_EditComponentPageVideoAndTextInput = {
  id?: Maybe<Scalars['ID']>;
  video?: Maybe<Scalars['ID']>;
  video_thumbnail?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  button?: Maybe<Strapi_EditComponentAtomLinkInput>;
  shaded_background?: Maybe<Scalars['Boolean']>;
};

export type Strapi_EditComponentSchoolPostalAddressInput = {
  id?: Maybe<Scalars['ID']>;
  street_address?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentSchoolSchoolHeroInput = {
  id?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_EditComponentAtomLinkInput>;
  show_map?: Maybe<Scalars['Boolean']>;
  replace_map_with?: Maybe<Strapi_EditComponentPageHtmlInput>;
};

export type Strapi_EditComponentSiteAdvancedSettingInput = {
  id?: Maybe<Scalars['ID']>;
  publish_url?: Maybe<Scalars['String']>;
  is_international_site?: Maybe<Scalars['Boolean']>;
  google_maps_api_key?: Maybe<Scalars['String']>;
};

export type Strapi_EditComponentSitePageScriptInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  load_in_head?: Maybe<Scalars['Boolean']>;
  load_defer?: Maybe<Scalars['Boolean']>;
};

export type Strapi_EditCourseInput = {
  name?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  feature_type?:Maybe<Scalars['String']>;
  course_features?: Maybe<Array<Maybe<Strapi_EditComponentAtomCourseFeatureInput>>>;
  course_text?: Maybe<Array<Maybe<Strapi_EditComponentAtomCourseTextInput>>>;
  slug?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['ID']>;
  call_to_action?: Maybe<Strapi_EditComponentPageCallToActionInput>;
  featured?: Maybe<Scalars['Boolean']>;
  components?: Maybe<Array<Scalars['Strapi_CourseComponentsDynamicZoneInput']>>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditDeliveryMethodInput = {
  banner_text?: Maybe<Scalars['String']>;
  is_recommended?: Maybe<Scalars['Boolean']>;
  heading?: Maybe<Scalars['String']>;
  pricing_plan_heading?: Maybe<Scalars['String']>;
  pricing_plan_description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Strapi_EditComponentAtomListItemInput>>>;
  price?: Maybe<Strapi_EditComponentDataPriceDescriptionInput>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  hubspot_form?: Maybe<Scalars['String']>;
  footnote?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditEnglishLevelGroupInput = {
  title?: Maybe<Scalars['String']>;
  english_levels?: Maybe<Array<Maybe<Strapi_EditComponentDataEnglishLevelInput>>>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditEnglishTestInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  cta_component?: Maybe<Strapi_EditComponentPageCallToActionInput>;
  activity_builder?: Maybe<Strapi_EditComponentPageHtmlInput>;
  website_locale?: Maybe<Scalars['ID']>;
  components?: Maybe<Array<Scalars['Strapi_EnglishTestComponentsDynamicZoneInput']>>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditEventInput = {
  website_locale?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  event_time?: Maybe<Scalars['Strapi_DateTime']>;
  event_address?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  embed_code?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  call_to_action?: Maybe<Strapi_EditComponentPageCallToActionInput>;
  related_events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  school?: Maybe<Scalars['ID']>;
  city?: Maybe<Scalars['ID']>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditExerciseInput = {
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  website_locale?: Maybe<Scalars['ID']>;
  related_exercises?: Maybe<Array<Maybe<Scalars['ID']>>>;
  excerpt?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  html_code?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  internal_name?: Maybe<Scalars['String']>;
  show_date?: Maybe<Scalars['Boolean']>;
  original_date?: Maybe<Scalars['Strapi_Date']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['Strapi_JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['Strapi_JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditFooterCtaInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Strapi_EditComponentAtomLinkInput>;
  script?: Maybe<Scalars['String']>;
  element_id?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditHomepageInput = {
  internal_title?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  hero_image?: Maybe<Scalars['ID']>;
  hero_title?: Maybe<Scalars['String']>;
  hero_body?: Maybe<Scalars['String']>;
  hero_cta?: Maybe<Strapi_EditComponentAtomLinkInput>;
  courses_title?: Maybe<Scalars['String']>;
  courses_body?: Maybe<Scalars['String']>;
  courses_cta?: Maybe<Strapi_EditComponentAtomLinkInput>;
  components: Array<Scalars['Strapi_HomepageComponentsDynamicZoneInput']>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  website_locale?: Maybe<Scalars['ID']>;
  promotion?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditJobTypeInput = {
  name?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditModalInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  internal_title?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditPageInput = {
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  components: Array<Scalars['Strapi_PageComponentsDynamicZoneInput']>;
  website_locale?: Maybe<Scalars['ID']>;
  meta_tags?: Maybe<Array<Maybe<Strapi_EditComponentPageMetaInput>>>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  index_page?: Maybe<Strapi_Enum_Page_Index_Page>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditPromotionInput = {
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  website_locale?: Maybe<Scalars['ID']>;
  body?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Strapi_DateTime']>;
  image?: Maybe<Scalars['ID']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
  call_to_action?: Maybe<Strapi_EditComponentPageCallToActionInput>;
  script?: Maybe<Scalars['String']>;
  homepage_link_text?: Maybe<Scalars['String']>;
  internal_name?: Maybe<Scalars['String']>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditSchoolInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Strapi_Enum_School_Status>;
  page_settings?: Maybe<Strapi_EditComponentDataPageSettingInput>;
  school_hero?: Maybe<Strapi_EditComponentSchoolSchoolHeroInput>;
  address?: Maybe<Strapi_EditComponentSchoolPostalAddressInput>;
  map_marker?: Maybe<Strapi_EditComponentAtomMapMarkerInput>;
  phone_number?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  active_promotion?: Maybe<Scalars['ID']>;
  components?: Maybe<Array<Scalars['Strapi_SchoolComponentsDynamicZoneInput']>>;
  website_locale?: Maybe<Scalars['ID']>;
  promotions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  career_posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  certifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  events?: Maybe<Array<Maybe<Scalars['ID']>>>;
  admin_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['Strapi_DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditWebsiteInput = {
  name?: Maybe<Scalars['String']>;
  domain_name?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  website_locales?: Maybe<Array<Maybe<Scalars['ID']>>>;
  global_scripts?: Maybe<Array<Maybe<Strapi_EditComponentSitePageScriptInput>>>;
  default_website_locale?: Maybe<Scalars['ID']>;
  settings?: Maybe<Strapi_EditComponentSiteAdvancedSettingInput>;
  admin_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_template?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Strapi_EditWebsiteLocaleInput = {
  name?: Maybe<Scalars['String']>;
  language_code?: Maybe<Scalars['String']>;
  navigation?: Maybe<Array<Maybe<Strapi_EditComponentNavigationNavigationItemInput>>>;
  footer_left_links?: Maybe<Array<Maybe<Strapi_EditComponentNavigationNavigationItemInput>>>;
  legal_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  social_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomLinkInput>>>;
  default_footer_cta?: Maybe<Scalars['ID']>;
  website?: Maybe<Scalars['ID']>;
  default_certification_cta?: Maybe<Scalars['ID']>;
  external_blog_url?: Maybe<Scalars['String']>;
  external_blog_text?: Maybe<Scalars['String']>;
  has_external_blog?: Maybe<Scalars['Boolean']>;
  careers_cta?: Maybe<Scalars['ID']>;
  translations?: Maybe<Scalars['Strapi_JSON']>;
  international_header_site_links?: Maybe<Array<Maybe<Strapi_EditComponentAtomWseSiteLinkInput>>>;
  footer_meta_info?: Maybe<Scalars['String']>;
  footer_right_links?: Maybe<Array<Maybe<Strapi_EditComponentNavigationNavigationItemInput>>>;
  has_right_to_left_language?: Maybe<Scalars['Boolean']>;
  path_prefixes?: Maybe<Scalars['Strapi_JSON']>;
  top_bar_cta?: Maybe<Strapi_EditComponentAtomLinkInput>;
  telephone?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
  learning_products?: Maybe<Array<Maybe<Strapi_EditComponentAtomLearningProductListInput>>>;
};

export type Strapi_UpdateBlogPostInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditBlogPostInput>;
};

export type Strapi_UpdateBlogPostPayload = {
  __typename?: 'Strapi_updateBlogPostPayload';
  blogPost?: Maybe<Strapi_BlogPost>;
};

export type Strapi_UpdateCareerPostInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCareerPostInput>;
};

export type Strapi_UpdateCareerPostPayload = {
  __typename?: 'Strapi_updateCareerPostPayload';
  careerPost?: Maybe<Strapi_CareerPost>;
};

export type Strapi_UpdateCareersCtaInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCareersCtaInput>;
};

export type Strapi_UpdateCareersCtaPayload = {
  __typename?: 'Strapi_updateCareersCtaPayload';
  careersCta?: Maybe<Strapi_CareersCta>;
};

export type Strapi_UpdateCategoryInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCategoryInput>;
};

export type Strapi_UpdateCategoryPayload = {
  __typename?: 'Strapi_updateCategoryPayload';
  category?: Maybe<Strapi_Category>;
};

export type Strapi_UpdateCertificationCtaInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCertificationCtaInput>;
};

export type Strapi_UpdateCertificationCtaPayload = {
  __typename?: 'Strapi_updateCertificationCtaPayload';
  certificationCta?: Maybe<Strapi_CertificationCta>;
};

export type Strapi_UpdateCertificationInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCertificationInput>;
};

export type Strapi_UpdateCertificationPayload = {
  __typename?: 'Strapi_updateCertificationPayload';
  certification?: Maybe<Strapi_Certification>;
};

export type Strapi_UpdateCityInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCityInput>;
};

export type Strapi_UpdateCityPayload = {
  __typename?: 'Strapi_updateCityPayload';
  city?: Maybe<Strapi_City>;
};

export type Strapi_UpdateCourseInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditCourseInput>;
};

export type Strapi_UpdateCoursePayload = {
  __typename?: 'Strapi_updateCoursePayload';
  course?: Maybe<Strapi_Course>;
};

export type Strapi_UpdateDeliveryMethodInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditDeliveryMethodInput>;
};

export type Strapi_UpdateDeliveryMethodPayload = {
  __typename?: 'Strapi_updateDeliveryMethodPayload';
  deliveryMethod?: Maybe<Strapi_DeliveryMethod>;
};

export type Strapi_UpdateEnglishLevelGroupInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditEnglishLevelGroupInput>;
};

export type Strapi_UpdateEnglishLevelGroupPayload = {
  __typename?: 'Strapi_updateEnglishLevelGroupPayload';
  englishLevelGroup?: Maybe<Strapi_EnglishLevelGroup>;
};

export type Strapi_UpdateEnglishTestInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditEnglishTestInput>;
};

export type Strapi_UpdateEnglishTestPayload = {
  __typename?: 'Strapi_updateEnglishTestPayload';
  englishTest?: Maybe<Strapi_EnglishTest>;
};

export type Strapi_UpdateEventInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditEventInput>;
};

export type Strapi_UpdateEventPayload = {
  __typename?: 'Strapi_updateEventPayload';
  event?: Maybe<Strapi_Event>;
};

export type Strapi_UpdateExerciseInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditExerciseInput>;
};

export type Strapi_UpdateExercisePayload = {
  __typename?: 'Strapi_updateExercisePayload';
  exercise?: Maybe<Strapi_Exercise>;
};

export type Strapi_UpdateFooterCtaInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditFooterCtaInput>;
};

export type Strapi_UpdateFooterCtaPayload = {
  __typename?: 'Strapi_updateFooterCtaPayload';
  footerCta?: Maybe<Strapi_FooterCta>;
};

export type Strapi_UpdateHomepageInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditHomepageInput>;
};

export type Strapi_UpdateHomepagePayload = {
  __typename?: 'Strapi_updateHomepagePayload';
  homepage?: Maybe<Strapi_Homepage>;
};

export type Strapi_UpdateJobTypeInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditJobTypeInput>;
};

export type Strapi_UpdateJobTypePayload = {
  __typename?: 'Strapi_updateJobTypePayload';
  jobType?: Maybe<Strapi_JobType>;
};

export type Strapi_UpdateModalInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditModalInput>;
};

export type Strapi_UpdateModalPayload = {
  __typename?: 'Strapi_updateModalPayload';
  modal?: Maybe<Strapi_Modal>;
};

export type Strapi_UpdatePageInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditPageInput>;
};

export type Strapi_UpdatePagePayload = {
  __typename?: 'Strapi_updatePagePayload';
  page?: Maybe<Strapi_Page>;
};

export type Strapi_UpdatePromotionInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditPromotionInput>;
};

export type Strapi_UpdatePromotionPayload = {
  __typename?: 'Strapi_updatePromotionPayload';
  promotion?: Maybe<Strapi_Promotion>;
};

export type Strapi_UpdateRoleInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditRoleInput>;
};

export type Strapi_UpdateRolePayload = {
  __typename?: 'Strapi_updateRolePayload';
  role?: Maybe<Strapi_UsersPermissionsRole>;
};

export type Strapi_UpdateSchoolInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditSchoolInput>;
};

export type Strapi_UpdateSchoolPayload = {
  __typename?: 'Strapi_updateSchoolPayload';
  school?: Maybe<Strapi_School>;
};

export type Strapi_UpdateUserInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditUserInput>;
};

export type Strapi_UpdateUserPayload = {
  __typename?: 'Strapi_updateUserPayload';
  user?: Maybe<Strapi_UsersPermissionsUser>;
};

export type Strapi_UpdateWebsiteInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditWebsiteInput>;
};

export type Strapi_UpdateWebsiteLocaleInput = {
  where?: Maybe<Strapi_InputId>;
  data?: Maybe<Strapi_EditWebsiteLocaleInput>;
};

export type Strapi_UpdateWebsiteLocalePayload = {
  __typename?: 'Strapi_updateWebsiteLocalePayload';
  websiteLocale?: Maybe<Strapi_WebsiteLocale>;
};

export type Strapi_UpdateWebsitePayload = {
  __typename?: 'Strapi_updateWebsitePayload';
  website?: Maybe<Strapi_Website>;
};

export type StringQueryOperatorInput = {
  eq?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  regex?: Maybe<Scalars['String']>;
  glob?: Maybe<Scalars['String']>;
};

export type GatsbyNodeBlogPostsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type GatsbyNodeBlogPostsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { blogPosts?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_BlogPost' }
      & Pick<Strapi_BlogPost, 'id' | 'slug'>
      & { related_posts?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_BlogPost' }
        & Pick<Strapi_BlogPost, 'id'>
      )>>>, pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
      )> }
    )>>> }
  ) }
);

export type GatsbyNodeCareerPostsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type GatsbyNodeCareerPostsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { careerPosts?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_CareerPost' }
      & Pick<Strapi_CareerPost, 'slug'>
      & { pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
      )> }
    )>>> }
  ) }
);

export type GatsbyNodeCertificationsQueryVariables = Exact<{
  websiteLocaleId: Scalars['String'];
}>;

export type GatsbyNodeCertificationsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { certifications?: Maybe<(
      { __typename?: 'Strapi_CertificationEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CertificationEntity' }
        & Pick<Strapi_CertificationEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Certification' }
          & Pick<Strapi_Certification, 'slug' | 'name'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CertificationRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CertificationEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Certification' }
                & Pick<Strapi_Certification, 'locale' | 'slug'>
              )> }
            )> }
          )>, cities?: Maybe<(
            { __typename?: 'Strapi_CityRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CityEntity' }
              & Pick<Strapi_CityEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_City' }
                & Pick<Strapi_City, 'slug' | 'name'>
                & { localizations?: Maybe<(
                  { __typename?: 'Strapi_CityRelationResponseCollection' }
                  & { data: Array<(
                    { __typename?: 'Strapi_CityEntity' }
                    & { attributes?: Maybe<(
                      { __typename?: 'Strapi_City' }
                      & Pick<Strapi_City, 'locale' | 'slug' | 'name'>
                    )> }
                  )> }
                )> }
              )> }
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type GatsbyNodeCitiesQueryVariables = Exact<{
  websiteLocaleId: Scalars['String'];
}>;

export type GatsbyNodeCitiesQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { cities?: Maybe<(
      { __typename?: 'Strapi_CityEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CityEntity' }
        & Pick<Strapi_CityEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_City' }
          & Pick<Strapi_City, 'name' | 'slug'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CityRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CityEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_City' }
                & Pick<Strapi_City, 'locale' | 'slug' | 'name'>
              )> }
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type GatsbyNodeCoursesQueryVariables = Exact<{
  websiteLocaleId: Scalars['String'];
}>;


export type GatsbyNodeCoursesQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { courses?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Course' }
      & Pick<Strapi_Course, 'slug'>
      & { pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
      )> }
    )>>> }
  ) }
);

export type GatsbyNodeEnglishTestsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type GatsbyNodeEnglishTestsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { englishTests?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_EnglishTest' }
      & Pick<Strapi_EnglishTest, 'slug' | 'name' | 'id'>
      & { pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
      )> }
    )>>> }
  ) }
);

export type GatsbyNodeEventPostsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  currentDate: Scalars['Date'];
}>;


export type GatsbyNodeEventPostsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { events?: Maybe<(
      { __typename?: 'Strapi_EventEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_EventEntity' }
        & Pick<Strapi_EventEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Event' }
          & Pick<Strapi_Event, 'slug'>
          & { eventTime: Strapi_Event['event_time'] }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_EventRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_EventEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Event' }
                & Pick<Strapi_Event, 'locale' | 'slug'>
              )> }
            )> }
          )>, related_events?: Maybe<(
            { __typename?: 'Strapi_EventRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_EventEntity' }
              & Pick<Strapi_EventEntity, 'documentId'>
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type GatsbyNodeExercisesQueryVariables = Exact<{
  websiteLocaleId: Scalars['String'];
}>;


export type GatsbyNodeExercisesQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { exercises?: Maybe<(
      { __typename?: 'Strapi_ExerciseEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_ExerciseEntity' }
        & Pick<Strapi_ExerciseEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Exercise' }
          & Pick<Strapi_Exercise, 'publishedAt' | 'slug' | 'excerpt'|'documentId'>
          & { showDate: Strapi_Exercise['show_date'], originalDate: Strapi_Exercise['original_date'] }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_ExerciseRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_ExerciseEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Exercise' }
                & Pick<Strapi_Exercise, 'locale' | 'slug'>
              )> }
            )> }
          )>, categories?: Maybe<(
            { __typename?: 'Strapi_CategoryRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CategoryEntity' }
              & Pick<Strapi_CategoryEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Category' }
                & Pick<Strapi_Category, 'name'>
              )> }
            )> }
          )>, image?: Maybe<(
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & { data?: Maybe<(
              { __typename?: 'Strapi_UploadFileEntity' }
              & Pick<Strapi_UploadFileEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_UploadFile' }
                & Pick<Strapi_UploadFile, 'url'>
              )> }
            )> }
          )>, relatedExercises?: Maybe<(
            { __typename?: 'Strapi_ExerciseRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_ExerciseEntity' }
              & Pick<Strapi_ExerciseEntity, 'documentId'>
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type GatsbyNodeHomepageQueryVariables = Exact<{
  websiteLocaleId: Scalars['String'];
}>;

export type GatsbyNodeHomepageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { homepages?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Homepage' }
      & Pick<Strapi_Homepage, 'id'>
    )>>> }
  ) }
);

export type GatsbyNodePagesQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type GatsbyNodePagesQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'slug'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_PageRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PageEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Page' }
                & Pick<Strapi_Page, 'locale' | 'slug'>
              )> }
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
          )> }
        )> }
      )> }
    )> }
  ) }
);


export type GatsbyNodePromotionsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type GatsbyNodePromotionsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { promotions?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Promotion' }
      & Pick<Strapi_Promotion, 'slug' | 'terms_and_conditions'>
    )>>> }
  ) }
);

export type GatsbyNodeSchoolsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type GatsbyNodeSchoolsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { schools?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_School' }
      & Pick<Strapi_School, 'slug'>
      & { pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & Pick<Strapi_ComponentDataPageSettings, 'avoid_indexing'>
      )> }
    )>>> }
  ) }
);

export type ModalFragment = (
  { __typename?: 'Strapi_Modal' }
  & Pick<Strapi_Modal, 'id' | 'title' | 'description' | 'html'>
);

export type LinkComponentFragment = (
  { __typename?: 'Strapi_ComponentAtomLink' }
  & Pick<Strapi_ComponentAtomLink, 'id' | 'title' | 'url' | 'nofollow'>
  & { openInNewWindow: Strapi_ComponentAtomLink['open_in_new_window'] }
  & { page?: Maybe<(
    { __typename?: 'Strapi_Page' }
    & Pick<Strapi_Page, 'slug'>
  )>, modal?: Maybe<(
    { __typename?: 'Strapi_Modal' }
    & ModalFragment
  )> }
);

export type NavigationItemComponentFragment = (
  { __typename?: 'Strapi_ComponentNavigationNavigationItem' }
  & Pick<Strapi_ComponentNavigationNavigationItem, 'title'>
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, childLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>> }
);

export type FooterCtaFragment = (
  { __typename?: 'Strapi_FooterCta' }
  & Pick<Strapi_FooterCta, 'documentId'| 'title' | 'script' | 'description' | 'element_id'>
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type WebsiteLocaleFragment = (
  { __typename?: 'Strapi_WebsiteLocale' }
  & Pick<Strapi_WebsiteLocale, 'documentId' | 'name' | 'translations' | 'telephone' | 'locale'>
  & { languageCode: Strapi_WebsiteLocale['language_code'], hasExternalBlog: Strapi_WebsiteLocale['has_external_blog'], externalBlogText: Strapi_WebsiteLocale['external_blog_text'], externalBlogUrl: Strapi_WebsiteLocale['external_blog_url'], pathPrefixes: Strapi_WebsiteLocale['path_prefixes'], footerMetaInfo: Strapi_WebsiteLocale['footer_meta_info'], hasRightToLeftLanguage: Strapi_WebsiteLocale['has_right_to_left_language'] }
  & { navigation?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentNavigationNavigationItem' }
    & NavigationItemComponentFragment
  )>>>, topBarCta?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, footerLeftLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentNavigationNavigationItem' }
    & NavigationItemComponentFragment
  )>>>, footerRightLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentNavigationNavigationItem' }
    & NavigationItemComponentFragment
  )>>>, legalLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, socialLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, footerCta?: Maybe<(
    { __typename?: 'Strapi_FooterCta' }
    & FooterCtaFragment
  )>, internationalHeaderSiteLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomWseSiteLink' }
    & Pick<Strapi_ComponentAtomWseSiteLink, 'territory' | 'region'>
    & { linkUrl: Strapi_ComponentAtomWseSiteLink['link_url'] }
    & { flagImage?: Maybe<(
      { __typename?: 'Strapi_UploadFile' }
      & Pick<Strapi_UploadFile, 'url'>
    )> }
  )>>>, defaultCertificationCta?: Maybe<(
    { __typename?: 'Strapi_CertificationCta' }
    & Pick<Strapi_CertificationCta, 'id'>
  )>, careersCta?: Maybe<(
    { __typename?: 'Strapi_CareersCta' }
    & Pick<Strapi_CareersCta, 'id'>
  )>
  }
);

export type WebsiteFragment = (
  { __typename?: 'Strapi_Website' }
  & Pick<Strapi_Website, 'documentId'>
  & { domainName: Strapi_Website['domain_name'], countryCode: Strapi_Website['country_code'] }
  & { globalScripts?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentSitePageScript' }
    & Pick<Strapi_ComponentSitePageScript, 'name' | 'html'>
    & { loadInHead: Strapi_ComponentSitePageScript['load_in_head'] }
    & { load_defer: Strapi_ComponentSitePageScript }
  )>>>, settings?: Maybe<(
    { __typename?: 'Strapi_ComponentSiteAdvancedSettings' }
    & { isInternationalSite: Strapi_ComponentSiteAdvancedSettings['is_international_site'] }
  )> }
);

export type GatsbyNodeWebsiteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GatsbyNodeWebsiteQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { website?: Maybe<(
      { __typename?: 'Strapi_Website' }
      & { websiteLocales?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_WebsiteLocale' }
        & WebsiteLocaleFragment
      )>>>, defaultWebsiteLocale?: Maybe<(
        { __typename?: 'Strapi_WebsiteLocale' }
        & WebsiteLocaleFragment
      )> }
      & WebsiteFragment
    )> }
  ) }
);

export type NamedCityEntityResponseFragment = (
  { __typename?: 'Strapi_CityEntityResponse' }
  & { data?: Maybe<(
    { __typename?: 'Strapi_CityEntity' }
    & Pick<Strapi_CityEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Strapi_City' }
      & Pick<Strapi_City, 'name'>
    )> }
  )> }
);

export type NamedJobEntityResponseFragment = (
  { __typename?: 'Strapi_JobTypeEntityResponse' }
  & { data?: Maybe<(
    { __typename?: 'Strapi_JobTypeEntity' }
    & Pick<Strapi_JobTypeEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Strapi_JobType' }
      & Pick<Strapi_JobType, 'name'>
    )> }
  )> }
);

export type CityLinkFragment = (
  { __typename?: 'Strapi_City' }
  & Pick<Strapi_City, 'name' | 'slug'>
);

export type StaticHeaderDataQueryVariables = Exact<{ [key: string]: never; }>;


export type StaticHeaderDataQuery = (
  { __typename?: 'Query' }
  & { site?: Maybe<(
    { __typename?: 'Site' }
    & { siteMetadata?: Maybe<(
      { __typename?: 'SiteSiteMetadata' }
      & Pick<SiteSiteMetadata, 'title' | 'studentLogin'>
    )> }
  )>, strapi: (
    { __typename?: 'Strapi' }
    & { websites?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Website' }
      & Pick<Strapi_Website, 'id'>
      & { website_locales?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_WebsiteLocale' }
        & Pick<Strapi_WebsiteLocale, 'language_code'>
      )>>>, default_website_locale?: Maybe<(
        { __typename?: 'Strapi_WebsiteLocale' }
        & Pick<Strapi_WebsiteLocale, 'language_code'>
      )> }
    )>>> }
  ) }
);

export type BrandQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandQueryQuery = (
  { __typename?: 'Query' }
  & { site?: Maybe<(
    { __typename?: 'Site' }
    & { siteMetadata?: Maybe<(
      { __typename?: 'SiteSiteMetadata' }
      & Pick<SiteSiteMetadata, 'title'>
    )> }
  )> }
);

export type SeoQueryVariables = Exact<{ [key: string]: never; }>;


export type SeoQuery = (
  { __typename?: 'Query' }
  & { site?: Maybe<(
    { __typename?: 'Site' }
    & { siteMetadata?: Maybe<(
      { __typename?: 'SiteSiteMetadata' }
      & { defaultTitle: SiteSiteMetadata['title'], defaultDescription: SiteSiteMetadata['description'] }
    )> }
  )> }
);

export type StrapiImageFragment = (
  { __typename?: 'Strapi_UploadFile' }
  & Pick<Strapi_UploadFile, 'alternativeText' | 'caption' | 'width' | 'height' | 'formats' | 'url'>
);

export type StrapiImageEntityResponseFragment = (
  { __typename?: 'Strapi_UploadFileEntityResponse' }
  & { data?: Maybe<(
    { __typename?: 'Strapi_UploadFileEntity' }
    & Pick<Strapi_UploadFileEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Strapi_UploadFile' }
      & StrapiImageFragment
    )> }
  )> }
);

export type StrapiVideoFragment = (
  { __typename?: 'Strapi_UploadFile' }
  & Pick<Strapi_UploadFile, 'url' | 'size' | 'alternativeText' | 'caption' | 'id' | 'mime' | 'name' | 'previewUrl'>
);

export type HeroComponentFragment = (
  { __typename: 'Strapi_ComponentPageHero' }
  & Pick<Strapi_ComponentPageHero, 'title' | 'intro'>
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, links?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, button?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type ImageAndTextComponentFragment = (
  { __typename?: 'Strapi_ComponentPageImageAndText' }
  & Pick<Strapi_ComponentPageImageAndText, 'title' | 'intro'>
  & { imagePosition: Strapi_ComponentPageImageAndText['image_position'], shadedBackground: Strapi_ComponentPageImageAndText['shaded_background'] }
  & { links?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, button?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type VideoAndTextComponentFragment = (
  { __typename?: 'Strapi_ComponentPageVideoAndText' }
  & Pick<Strapi_ComponentPageVideoAndText, 'title' | 'intro'>
  & { shadedBackground: Strapi_ComponentPageVideoAndText['shaded_background'] }
  & { links?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, video?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiVideoFragment
  )>, button?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, videoThumbnail?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type RelatedListComponentFragment = (
  { __typename?: 'Strapi_ComponentPageRelatedList' }
  & Pick<Strapi_ComponentPageRelatedList, 'relatedList'>
);


export type Strapi_ComponentPageRelatedList = {
  __typename?: 'Strapi_ComponentPageRelatedList';
  id: Scalars['ID'];
  relatedList: Strapi_Enum_Componentpagerelatedlist_Relatedlist;
};

export type InlineCtaComponentFragment = (
  { __typename?: 'Strapi_ComponentPageCallToAction' }
  & Pick<Strapi_ComponentPageCallToAction, 'title' | 'description' | 'style'>
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type EmbedCodeFragment = (
  { __typename?: 'Strapi_ComponentPageEmbedCode' }
  & Pick<Strapi_ComponentPageEmbedCode, 'content'>
);

export type SimpleTitleComponentFragment = (
  { __typename?: 'Strapi_ComponentPageSimpleTitle' }
  & Pick<Strapi_ComponentPageSimpleTitle, 'title' | 'intro'>
);

export type RichTextComponentFragment = (
  { __typename?: 'Strapi_ComponentPageRichText' }
  & Pick<Strapi_ComponentPageRichText, 'content'>
  & { button?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type TextComponentFragment = (
  { __typename?: 'Strapi_ComponentPageText' }
  & Pick<Strapi_ComponentPageText, 'content'>
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type ColumnComponentFragment = (
  { __typename?: 'Strapi_ComponentAtomColumn' }
  & Pick<Strapi_ComponentAtomColumn, 'title' | 'content'>
);

export type ColumnsComponentFragment = (
  { __typename?: 'Strapi_ComponentPageColumns' }
  & Pick<Strapi_ComponentPageColumns, 'description'>
  & { heading: Strapi_ComponentPageColumns['title'], showColumnIndex: Strapi_ComponentPageColumns['show_column_index'] }
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, columns?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomColumn' }
    & ColumnComponentFragment
  )>>> }
);

export type LogoGalleryComponentFragment = (
  { __typename?: 'Strapi_ComponentPageLogoGallery' }
  & { logoTitle: Strapi_ComponentPageLogoGallery['logo_title'] }
  & { logos?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLogos' }
    & Pick<Strapi_ComponentAtomLogos, 'name'>
    & { image?: Maybe<(
      { __typename?: 'Strapi_UploadFile' }
      & StrapiImageFragment
    )> }
  )>>> }
);

export type HtmlComponentFragment = (
  { __typename?: 'Strapi_ComponentPageHtml' }
  & { htmlCode: Strapi_ComponentPageHtml['html_code'] }
);

export type ReviewsIoComponentFragment = (
  { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
  & Pick<Strapi_ComponentPageReviewsIoWidget, 'heading'>
  & { script?: Maybe<(
    { __typename?: 'Strapi_ComponentPageHtml' }
    & HtmlComponentFragment
  )> }
  & { load_defer: Strapi_ComponentPageReviewsIoWidget }
);

export type TrustPilotComponentFragment = (
  { __typename?: 'Strapi_ComponentPageTrustPilotWidget' }
  & Pick<Strapi_ComponentPageTrustPilotWidget, 'heading'>
  & { script?: Maybe<(
    { __typename?: 'Strapi_ComponentPageHtml' }
    & HtmlComponentFragment
  )> }
);


export type QuoteAndTextFragment = (
  { __typename?: 'Strapi_ComponentPageQuoteAndText' }
  & Pick<Strapi_ComponentPageQuoteAndText, 'quote' | 'author' | 'position'>
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, video?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiVideoFragment
  )> }
);

export type CourseCtaPanelFragment = (
  { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
  & Pick<Strapi_ComponentPageCourseCtaPanel, 'description'>
  & { speechBubbleText: Strapi_ComponentPageCourseCtaPanel['Speech_bubble_text'] }
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type EnglishLevelsFragment = (
  { __typename?: 'Strapi_ComponentPageEnglishLevels' }
  & Pick<Strapi_ComponentPageEnglishLevels, 'heading' | 'description'>
  & { footerHeader: Strapi_ComponentPageEnglishLevels['footer_header'], footerDescription: Strapi_ComponentPageEnglishLevels['footer_description'], footerLinkUrl: Strapi_ComponentPageEnglishLevels['footer_link_url'], footerLinkUrlText: Strapi_ComponentPageEnglishLevels['footer_link_url_text'] }
  & { englishLevels?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomEnglishLevel' }
    & Pick<Strapi_ComponentAtomEnglishLevel, 'level'>
    & { levelDescription: Strapi_ComponentAtomEnglishLevel['level_description'] }
  )>>> }
);

export type ScrollingStatementComponentFragment = (
  { __typename?: 'Strapi_ComponentPageScrollingStatement' }
  & { title: Strapi_ComponentPageScrollingStatement['heading'] }
  & { scrollingStatements?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomScrollingStatement' }
    & Pick<Strapi_ComponentAtomScrollingStatement, 'statement'>
    & { subHeading: Strapi_ComponentAtomScrollingStatement['sub_heading'] }
  )>>>, link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, imageLeft?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, imageRight?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type LocationPanelFragment = (
  { __typename?: 'Strapi_ComponentPageLocationPanel' }
  & Pick<Strapi_ComponentPageLocationPanel, 'title' | 'text'  | 'mapLocation'>
  & { optional_link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, map?: Maybe<(
    { __typename?: 'Strapi_ComponentPageMap' }
    & MapFragment
  )> }
);

export type EventsCtaFragment = (
  { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
  & { panelTitle: Strapi_ComponentPageEventsCtaPanel['panel_title'], eventLinkText: Strapi_ComponentPageEventsCtaPanel['event_link_text'], eventLinkUrl: Strapi_ComponentPageEventsCtaPanel['event_link_url'], eventCalendarText: Strapi_ComponentPageEventsCtaPanel['event_calendar_text'], eventCalendarUrl: Strapi_ComponentPageEventsCtaPanel['event_calendar_url'] }
);

export type MapFragment = (
  { __typename?: 'Strapi_ComponentPageMap' }
  & Pick<Strapi_ComponentPageMap, 'width' | 'height' | 'mapLocation'>
  & { defaultZoom: Strapi_ComponentPageMap['default_zoom'] }
  & { defaultCenter?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomMapMarker' }
    & MapMarkerFragment
  )>, markers?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomMapMarker' }
    & MapMarkerFragment
  )>>> }
);

export type SeoComponentFragment = (
  { __typename?: 'Strapi_ComponentSharedSeo' }
  & Pick<Strapi_ComponentSharedSeo, 'canonicalURL' | 'keywords' | 'metaTitle' | 'metaDescription' | 'structuredData'>
  & { metaImage?: Maybe<(
    { __typename?: 'Strapi_UploadFileEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'Strapi_UploadFileEntity' }
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_UploadFile' }
        & StrapiImageFragment
      )> }
    )> }
  )>, metaSocial?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentSharedMetaSocial' }
    & Pick<Strapi_ComponentSharedMetaSocial, 'description' | 'socialNetwork' | 'title'>
    & { image?: Maybe<(
      { __typename?: 'Strapi_UploadFileEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_UploadFileEntity' }
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_UploadFile' }
          & StrapiImageFragment
        )> }
      )> }
    )> }
  )>>> }
);

export type SchoolHeroFragment = (
  { __typename?: 'Strapi_ComponentSchoolSchoolHero' }
  & Pick<Strapi_ComponentSchoolSchoolHero, 'heading' | 'description'| 'mapLocation'>
  & { showMap: Strapi_ComponentSchoolSchoolHero['show_map'] }
  & { callToAction?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, replaceMapWith?: Maybe<(
    { __typename?: 'Strapi_ComponentPageHtml' }
    & HtmlComponentFragment
  )> }
);

export type SchoolAddressFragment = (
  { __typename?: 'Strapi_ComponentSchoolPostalAddress' }
  & Pick<Strapi_ComponentSchoolPostalAddress, 'locality' | 'region' | 'country' | 'documentId'>
  & { streetAddress: Strapi_ComponentSchoolPostalAddress['street_address'], postalCode: Strapi_ComponentSchoolPostalAddress['postal_code'] }
);

export type SchoolFragment = (
  { __typename?: 'Strapi_School' }
  & Pick<Strapi_School, 'slug' | 'name' | 'status'>
  & { phoneNumber: Strapi_School['phone_number'], emailAddress: Strapi_School['email_address'] }
  & { schoolHero?: Maybe<(
    { __typename?: 'Strapi_ComponentSchoolSchoolHero' }
    & SchoolHeroFragment
  )>, address?: Maybe<(
    { __typename?: 'Strapi_ComponentSchoolPostalAddress' }
    & SchoolAddressFragment
  )>, mapMarker?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomMapMarker' }
    & MapMarkerFragment
  )>, activePromotion?: Maybe<(
    { __typename?: 'Strapi_PromotionEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'Strapi_PromotionEntity' }
      & Pick<Strapi_PromotionEntity, 'documentId'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Promotion' }
        & Pick<Strapi_Promotion, 'title' | 'slug' | 'homepage_link_text'>
      )> }
    )> }
  )>, certifications?: Maybe<(
    { __typename?: 'Strapi_CertificationRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_CertificationEntity' }
      & Pick<Strapi_CertificationEntity, 'documentId'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Certification' }
        & Pick<Strapi_Certification, 'name'>
      )> }
    )> }
  )>, components?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentPageCallToAction' }
    & PageComponents_Strapi_ComponentPageCallToAction_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageColumns' }
    & PageComponents_Strapi_ComponentPageColumns_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
    & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
    & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageEmbedCode' }
    & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
    & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
    & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageEnglishLevels' }
    & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
    & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageHeroCourse' }
    & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageHero' }
    & PageComponents_Strapi_ComponentPageHero_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageHtml' }
    & PageComponents_Strapi_ComponentPageHtml_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageImageAndText' }
    & PageComponents_Strapi_ComponentPageImageAndText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageLocationPanel' }
    & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageLogoGallery' }
    & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageMap' }
    & PageComponents_Strapi_ComponentPageMap_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
    & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageMeta' }
    & PageComponents_Strapi_ComponentPageMeta_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
    & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
    & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageQuoteAndText' }
    & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
    & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageRichList' }
    & PageComponents_Strapi_ComponentPageRichList_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageRichText' }
    & PageComponents_Strapi_ComponentPageRichText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
    & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageScrollingStatement' }
    & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageSimpleTitle' }
    & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
    & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
    & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageText' }
    & PageComponents_Strapi_ComponentPageText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
    & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
    & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageTwoColumns' }
    & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageVideoAndText' }
    & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
  ) | (
    { __typename?: 'Strapi_Error' }
    & PageComponents_Strapi_Error_Fragment
  )>>>, categories?: Maybe<(
    { __typename?: 'Strapi_CategoryRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_CategoryEntity' }
      & Pick<Strapi_CategoryEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Category' }
        & Pick<Strapi_Category, 'name'>
      )> }
    )> }
  )>, events?: Maybe<(
    { __typename?: 'Strapi_EventRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_EventEntity' }
      & Pick<Strapi_EventEntity, 'documentId'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Event' }
        & EventFragment
      )> }
    )> }
  )>, pageSettings?: Maybe<(
    { __typename?: 'Strapi_ComponentDataPageSettings' }
    & PageSettingsFragment
  )>, seo?: Maybe<(
    { __typename?: 'Strapi_ComponentSharedSeo' }
    & SeoComponentFragment
  )> }
);

export type EventFragment = (
  { __typename?: 'Strapi_Event' }
  & Pick<Strapi_Event, 'documentId' | 'title' | 'slug'>
  & { eventTime: Strapi_Event['event_time'], eventAddress: Strapi_Event['event_address'] }
  & { school?: Maybe<(
    { __typename?: 'Strapi_School' }
    & Pick<Strapi_School, 'name'>
  )>, city?: Maybe<(
    { __typename?: 'Strapi_City' }
    & Pick<Strapi_City, 'name'>
  )>, categories?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_Category' }
    & Pick<Strapi_Category, 'name'>
  )>>>, image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type MapMarkerFragment = (
  { __typename?: 'Strapi_ComponentAtomMapMarker' }
  & Pick<Strapi_ComponentAtomMapMarker, 'id' | 'mapLocation'>
);

export type PriceDescriptionFragment = (
  { __typename?: 'Strapi_ComponentDataPriceDescription' }
  & Pick<Strapi_ComponentDataPriceDescription, 'label' | 'price' | 'frequency'>
);

export type DeliveryMethodFragment = (
  { __typename?: 'Strapi_DeliveryMethod' }
  & Pick<Strapi_DeliveryMethod, 'footnote'>
  & { pricingPlanHeading: Strapi_DeliveryMethod['pricing_plan_heading'], pricingPlanDescription: Strapi_DeliveryMethod['pricing_plan_description'], bannerText: Strapi_DeliveryMethod['banner_text'], isRecommended: Strapi_DeliveryMethod['is_recommended'] }
  & { price?: Maybe<(
    { __typename?: 'Strapi_ComponentDataPriceDescription' }
    & Pick<Strapi_ComponentDataPriceDescription, 'label' | 'price' | 'frequency'>
  )>, features?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomListItem' }
    & Pick<Strapi_ComponentAtomListItem, 'content'>
    & { isFaded: Strapi_ComponentAtomListItem['is_faded'] }
  )>>>, link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type SchoolInfoBoxFragment = (
  { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
  & Pick<Strapi_ComponentPageSchoolInfoBox, 'address'>
  & { contactNumber: Strapi_ComponentPageSchoolInfoBox['contact_number'], internalLinksListHeading: Strapi_ComponentPageSchoolInfoBox['internal_links_list_heading'], emailAddress: Strapi_ComponentPageSchoolInfoBox['email_address'], externalLinkHeading: Strapi_ComponentPageSchoolInfoBox['external_link_heading'], openingTimes: Strapi_ComponentPageSchoolInfoBox['opening_times'] }
  & { miscLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomExternalLinks' }
    & { linkName: Strapi_ComponentAtomExternalLinks['link_name'], linkUrl: Strapi_ComponentAtomExternalLinks['link_url'], openInNewWindow: Strapi_ComponentAtomExternalLinks['open_in_new_window'], noFollow: Strapi_ComponentAtomExternalLinks['nofollow'] }
  )>>>, socialLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomSocialLink' }
    & { linkName: Strapi_ComponentAtomSocialLink['link_name'], linkUrl: Strapi_ComponentAtomSocialLink['link_url'] }
  )>>>, internalLinks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, externalLinksList?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomExternalLinks' }
    & { linkName: Strapi_ComponentAtomExternalLinks['link_name'], linkUrl: Strapi_ComponentAtomExternalLinks['link_url'], openInNewWindow: Strapi_ComponentAtomExternalLinks['open_in_new_window'], noFollow: Strapi_ComponentAtomExternalLinks['nofollow'] }
  )>>> }
);

export type DeliveryMethodCardFragment = (
  { __typename?: 'Strapi_ComponentAtomDeliveryMethodCard' }
  & { showFeatures: Strapi_ComponentAtomDeliveryMethodCard['show_features'], showPrice: Strapi_ComponentAtomDeliveryMethodCard['show_price'] }
  & { deliveryMethod?: Maybe<(
    { __typename?: 'Strapi_DeliveryMethod' }
    & DeliveryMethodFragment
  )>, link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type PricingPlanFragment = (
  { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
  & { mainHeading: Strapi_ComponentPagePricingPlanPanel['main_heading'], mainDescription: Strapi_ComponentPagePricingPlanPanel['main_description'] }
  & { deliveryMethods?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomDeliveryMethodCard' }
    & DeliveryMethodCardFragment
  )>>> }
);

export type TextAndSplitImagesFragment = (
  { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
  & { mainHeading: Strapi_ComponentPageTextAndSplitImages['main_heading'], mainDescription: Strapi_ComponentPageTextAndSplitImages['main_description'] }
  & { links?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, imageLeft?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, imageCenter?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, imageRight?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type PromotionPanelFragment = (
  { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
  & Pick<Strapi_ComponentPagePromotionsCtaPanel, 'description'>
  & { mainHeading: Strapi_ComponentPagePromotionsCtaPanel['main_heading'], secondHeading: Strapi_ComponentPagePromotionsCtaPanel['second_heading'], secondDescription: Strapi_ComponentPagePromotionsCtaPanel['second_description'] }
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, promotions?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_Promotion' }
    & Pick<Strapi_Promotion, 'title'>
  )>>>, image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, secondaryLink?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type ThreeBlocksAndImageFragment = (
  { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
  & { listHeadingOne: Strapi_ComponentPageThreeBlocksAndImage['list_heading_one'], listHeadingTwo: Strapi_ComponentPageThreeBlocksAndImage['list_heading_two'], listHeadingThree: Strapi_ComponentPageThreeBlocksAndImage['list_heading_three'] }
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, listOne?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomArrowList' }
    & { listItem: Strapi_ComponentAtomArrowList['list_item'] }
  )>>>, listTwo?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomArrowList' }
    & { listItem: Strapi_ComponentAtomArrowList['list_item'] }
  )>>>, listThree?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomArrowList' }
    & { listItem: Strapi_ComponentAtomArrowList['list_item'] }
  )>>> }
);

export type EnglishLevelsTableComponentFragment = (
  { __typename?: 'Strapi_ComponentPageEnglishLevelsTable' }
  & { highlightedColumns: Strapi_ComponentPageEnglishLevelsTable['highlighted_columns'] }
  & { englishLevelGroup?: Maybe<(
    { __typename?: 'Strapi_EnglishLevelGroup' }
    & EnglishLevelGroupFragment
  )> }
);

export type CourseComparisonComponentFragment = (
  { __typename?: 'Strapi_ComponentPageCourseComparison' }
  & { courseComparisonTable?: Maybe<(
    { __typename?: 'Strapi_CourseComparisonTable' }
    & CourseComparisonGroupFragment
  )> }
);

export type EnglishLevelsAccordionComponentFragment = (
  { __typename?: 'Strapi_ComponentPageEnglishLevelsAccordion' }
  & { englishLevelGroup?: Maybe<(
    { __typename?: 'Strapi_EnglishLevelGroup' }
    & EnglishLevelGroupFragment
  )> }
);

export type TwoColumnsFragment = (
  { __typename?: 'Strapi_ComponentPageTwoColumns' }
  & { shadedBackground: Strapi_ComponentPageTwoColumns['shaded_background'] }
  & { leftColumn?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomColumn' }
    & ColumnComponentFragment
  )>, leftCta?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, rightColumn?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomColumn' }
    & ColumnComponentFragment
  )>, rightCta?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type TwoColumnsAndLinksFragment = (
  { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
  & { headingOne: Strapi_ComponentPageTwoColumnsAndLinks['heading_one'], descriptionOne: Strapi_ComponentPageTwoColumnsAndLinks['description_one'], headingTwo: Strapi_ComponentPageTwoColumnsAndLinks['heading_two'], descriptionTwo: Strapi_ComponentPageTwoColumnsAndLinks['description_two'] }
  & { linksOne?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, linksTwo?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>> }
);

export type RichListComponentFragment = (
  { __typename?: 'Strapi_ComponentPageRichList' }
  & Pick<Strapi_ComponentPageRichList, 'title' | 'description'>
  & { cta?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, items?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomColumn' }
    & ColumnComponentFragment
  )>>> }
);

export type DetailedPricingPlanFragment = (
  { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
  & Pick<Strapi_ComponentPageDetailedPricingPlan, 'title' | 'description'>
  & { links?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>>>, deliveryMethod?: Maybe<(
    { __typename?: 'Strapi_DeliveryMethod' }
    & DeliveryMethodFragment
  )> }
);

export type TeachersAndCoachesFragment = (
  { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
  & { quoteText: Strapi_ComponentPageTeacherAndCoaches['quote_text'], quoteAuthor: Strapi_ComponentPageTeacherAndCoaches['quote_author'], quoteAuthorPosition: Strapi_ComponentPageTeacherAndCoaches['quote_author_position'], introHeading: Strapi_ComponentPageTeacherAndCoaches['intro_heading'], introText: Strapi_ComponentPageTeacherAndCoaches['intro_text'] }
  & { images?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>>>, teachers?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomTeacher' }
    & { teacherName: Strapi_ComponentAtomTeacher['teacher_name'], teacherPosition: Strapi_ComponentAtomTeacher['teacher_position'] }
    & { teacherImage?: Maybe<(
      { __typename?: 'Strapi_UploadFile' }
      & StrapiImageFragment
    )> }
  )>>> }
);

export type MeetTheTeamGalleryFragment = (
  { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
  & { people?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomPeopleCard' }
    & Pick<Strapi_ComponentAtomPeopleCard, 'description'>
    & { personName: Strapi_ComponentAtomPeopleCard['person_name'], personTitle: Strapi_ComponentAtomPeopleCard['person_title'] }
    & { image?: Maybe<(
      { __typename?: 'Strapi_UploadFile' }
      & StrapiImageFragment
    )> }
  )>>> }
);

export type InlineHubspotFormFragment = (
  { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
  & Pick<Strapi_ComponentPageInlineHubspotForm, 'title' | 'description' | 'html'>
);

export type HeroMapFragment = (
  { __typename?: 'Strapi_ComponentPageHeroMap' }
  & { mapTitle: Strapi_ComponentPageHeroMap['map_title'], mapDefaultZoom: Strapi_ComponentPageHeroMap['map_default_zoom'] }
  & { markers?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomMapMarker' }
    & MapMarkerFragment
  )>>> }
);

export type PageSettingsFragment = (
  { __typename?: 'Strapi_ComponentDataPageSettings' }
  & Pick<Strapi_ComponentDataPageSettings, 'title'>
  & { metaDescription: Strapi_ComponentDataPageSettings['meta_description'], avoidIndexing: Strapi_ComponentDataPageSettings['avoid_indexing'], showFooterCta: Strapi_ComponentDataPageSettings['show_footer_cta'] }
  & { customFooterCta?: Maybe<(
    { __typename?: 'Strapi_FooterCta' }
    & FooterCtaFragment
  )> }
);


export type RelatedSchoolsComponentFragment = (
  { __typename?: 'Strapi_ComponentDataRelatedSchools' }
  & { relatedSchools?: Maybe<(
    { __typename?: 'Strapi_SchoolRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_SchoolEntity' }
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_School' }
        & Pick<Strapi_School, 'name' | 'locale'>
        & { emailAddress: Strapi_School['email_address'], phoneNumber: Strapi_School['phone_number'] }
        & { address?: Maybe<(
          { __typename?: 'Strapi_ComponentSchoolPostalAddress' }
          & SchoolAddressFragment
        )>, mapMarker?: Maybe<(
          { __typename?: 'Strapi_ComponentAtomMapMarker' }
          & MapMarkerFragment
        )> }
      )> }
    )> }
  )> }
);


type PageComponents_Strapi_ComponentPageCallToAction_Fragment = (
  { __typename: 'Strapi_ComponentPageCallToAction' }
  & InlineCtaComponentFragment
);

type PageComponents_Strapi_ComponentPageCareersGallery_Fragment = (
  { __typename: 'Strapi_ComponentPageCareersGallery' }
  & { careerPosts?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_CareerPost' }
    & CareerFragment
  )>>> }
);

type PageComponents_Strapi_ComponentPageColumns_Fragment = (
  { __typename: 'Strapi_ComponentPageColumns' }
  & ColumnsComponentFragment
);

type PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment = (
  { __typename: 'Strapi_ComponentPageCourseCtaPanel' }
  & CourseCtaPanelFragment
);

type PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment = (
  { __typename: 'Strapi_ComponentPageDetailedPricingPlan' }
  & DetailedPricingPlanFragment
);

type PageComponents_Strapi_ComponentPageEmbedCode_Fragment = (
  { __typename: 'Strapi_ComponentPageEmbedCode' }
  & EmbedCodeFragment
);

type PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment = (
  { __typename: 'Strapi_ComponentPageEnLvlsAcd' }
  & EnglishLevelsAccordionComponentFragment
);

type PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment = (
  { __typename: 'Strapi_ComponentPageEnLvlsTbl' }
  & EnglishLevelsTableComponentFragment
);

type PageComponents_Strapi_ComponentPageEnglishLevelsAccordion_Fragment = (
  { __typename: 'Strapi_ComponentPageEnglishLevelsAccordion' }
  & EnglishLevelsAccordionComponentFragment
);

type PageComponents_Strapi_ComponentPageEnglishLevelsTable_Fragment = (
  { __typename: 'Strapi_ComponentPageEnglishLevelsTable' }
  & EnglishLevelsTableComponentFragment
);

type PageComponents_Strapi_ComponentPageCourseComparison_Fragment = (
  { __typename: 'Strapi_ComponentPageCourseComparison' }
  & CourseComparisonComponentFragment
);

type PageComponents_Strapi_ComponentPageEnglishLevels_Fragment = (
  { __typename: 'Strapi_ComponentPageEnglishLevels' }
  & EnglishLevelsFragment
);

type PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment = (
  { __typename: 'Strapi_ComponentPageEventsCtaPanel' }
  & EventsCtaFragment
);

type PageComponents_Strapi_ComponentPageHeroCourse_Fragment = (
  { __typename: 'Strapi_ComponentPageHeroCourse' }
  & HeroCourseFragment
);

type PageComponents_Strapi_ComponentPageHeroMap_Fragment = (
  { __typename: 'Strapi_ComponentPageHeroMap' }
  & HeroMapFragment
);

type PageComponents_Strapi_ComponentPageHero_Fragment = (
  { __typename: 'Strapi_ComponentPageHero' }
  & HeroComponentFragment
);

type PageComponents_Strapi_ComponentPageHtml_Fragment = (
  { __typename: 'Strapi_ComponentPageHtml' }
  & HtmlComponentFragment
);

type PageComponents_Strapi_ComponentPageImageAndText_Fragment = (
  { __typename: 'Strapi_ComponentPageImageAndText' }
  & ImageAndTextComponentFragment
);

type PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment = (
  { __typename: 'Strapi_ComponentPageInlineHubspotForm' }
  & InlineHubspotFormFragment
);

type PageComponents_Strapi_ComponentPageLocationPanel_Fragment = (
  { __typename: 'Strapi_ComponentPageLocationPanel' }
  & LocationPanelFragment
);

type PageComponents_Strapi_ComponentPageLogoGallery_Fragment = (
  { __typename: 'Strapi_ComponentPageLogoGallery' }
  & LogoGalleryComponentFragment
);

type PageComponents_Strapi_ComponentPageMap_Fragment = (
  { __typename: 'Strapi_ComponentPageMap' }
  & MapFragment
);

type PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment = (
  { __typename: 'Strapi_ComponentPageMeetTheTeamGallery' }
  & MeetTheTeamGalleryFragment
);

type PageComponents_Strapi_ComponentPageMeta_Fragment = { __typename: 'Strapi_ComponentPageMeta' };

type PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment = (
  { __typename: 'Strapi_ComponentPagePricingPlanPanel' }
  & PricingPlanFragment
);

type PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment = (
  { __typename: 'Strapi_ComponentPagePromotionsCtaPanel' }
  & PromotionPanelFragment
);

type PageComponents_Strapi_ComponentPageQuoteAndText_Fragment = (
  { __typename: 'Strapi_ComponentPageQuoteAndText' }
  & QuoteAndTextFragment
);

type PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment = (
  { __typename: 'Strapi_ComponentPageReviewsIoWidget' }
  & ReviewsIoComponentFragment
);

type PageComponents_Strapi_ComponentPageTrustPilotWidget_Fragment = (
  { __typename: 'Strapi_ComponentPageTrustPilotWidget' }
  & TrustPilotComponentFragment
);

type PageComponents_Strapi_ComponentPageRichList_Fragment = (
  { __typename: 'Strapi_ComponentPageRichList' }
  & RichListComponentFragment
);

type PageComponents_Strapi_ComponentPageRichText_Fragment = (
  { __typename: 'Strapi_ComponentPageRichText' }
  & RichTextComponentFragment
);

type PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment = (
  { __typename: 'Strapi_ComponentPageSchoolInfoBox' }
  & SchoolInfoBoxFragment
);

type PageComponents_Strapi_ComponentPageScrollingStatement_Fragment = (
  { __typename: 'Strapi_ComponentPageScrollingStatement' }
  & ScrollingStatementComponentFragment
);

type PageComponents_Strapi_ComponentPageSimpleTitle_Fragment = (
  { __typename: 'Strapi_ComponentPageSimpleTitle' }
  & SimpleTitleComponentFragment
);

type PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment = (
  { __typename: 'Strapi_ComponentPageTeacherAndCoaches' }
  & TeachersAndCoachesFragment
);

type PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment = (
  { __typename: 'Strapi_ComponentPageTextAndSplitImages' }
  & TextAndSplitImagesFragment
);

type PageComponents_Strapi_ComponentPageText_Fragment = (
  { __typename: 'Strapi_ComponentPageText' }
  & TextComponentFragment
);

type PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment = (
  { __typename: 'Strapi_ComponentPageThreeBlocksAndImage' }
  & ThreeBlocksAndImageFragment
);

type PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment = (
  { __typename: 'Strapi_ComponentPageTwoColumnsAndLinks' }
  & TwoColumnsAndLinksFragment
);

type PageComponents_Strapi_ComponentPageTwoColumns_Fragment = (
  { __typename: 'Strapi_ComponentPageTwoColumns' }
  & TwoColumnsFragment
);

type PageComponents_Strapi_ComponentPageVideoAndText_Fragment = (
  { __typename: 'Strapi_ComponentPageVideoAndText' }
  & VideoAndTextComponentFragment
);

type PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment = (
  { __typename: 'Strapi_ComponentPageCourseCmprsns' }
  & CourseComparisonComponentFragment
);

type PageComponents_Strapi_ComponentDataRelatedSchools_Fragment = (
  { __typename: 'Strapi_ComponentDataRelatedSchools' }
  & RelatedSchoolsComponentFragment
);

type PageComponents_Strapi_Error_Fragment = { __typename: 'Strapi_Error' };

export type PageComponentsFragment = PageComponents_Strapi_ComponentPageCallToAction_Fragment | PageComponents_Strapi_ComponentPageCareersGallery_Fragment | PageComponents_Strapi_ComponentPageColumns_Fragment | PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment | PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment | PageComponents_Strapi_ComponentPageEmbedCode_Fragment | PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment | PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment | PageComponents_Strapi_ComponentPageEnglishLevels_Fragment | PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment | PageComponents_Strapi_ComponentPageHeroCourse_Fragment | PageComponents_Strapi_ComponentPageHeroMap_Fragment | PageComponents_Strapi_ComponentPageHero_Fragment | PageComponents_Strapi_ComponentPageHtml_Fragment | PageComponents_Strapi_ComponentPageImageAndText_Fragment | PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment | PageComponents_Strapi_ComponentPageLocationPanel_Fragment | PageComponents_Strapi_ComponentPageLogoGallery_Fragment | PageComponents_Strapi_ComponentPageMap_Fragment | PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment | PageComponents_Strapi_ComponentPageMeta_Fragment | PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment | PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment | PageComponents_Strapi_ComponentPageQuoteAndText_Fragment | PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment | PageComponents_Strapi_ComponentPageTrustPilotWidget_Fragment | PageComponents_Strapi_ComponentPageRichList_Fragment | PageComponents_Strapi_ComponentPageRichText_Fragment | PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment | PageComponents_Strapi_ComponentPageScrollingStatement_Fragment | PageComponents_Strapi_ComponentPageSimpleTitle_Fragment | PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment | PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment | PageComponents_Strapi_ComponentPageText_Fragment | PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment | PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment | PageComponents_Strapi_ComponentPageTwoColumns_Fragment | PageComponents_Strapi_ComponentPageVideoAndText_Fragment | PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment | PageComponents_Strapi_ComponentDataRelatedSchools_Fragment | PageComponents_Strapi_Error_Fragment;

export type HeroCourseFragment = (
  { __typename?: 'Strapi_ComponentPageHeroCourse' }
  & Pick<Strapi_ComponentPageHeroCourse, 'short'>
  & { mainHeading: Strapi_ComponentPageHeroCourse['main_heading'], logoOneUrlLink: Strapi_ComponentPageHeroCourse['logo_one_url_link'], logoTwoUrlLink: Strapi_ComponentPageHeroCourse['logo_two_url_link'] }
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, logoOne?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, logoTwo?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type CityFragment = (
  { __typename?: 'Strapi_City' }
  & Pick<Strapi_City, 'name' | 'slug' | 'description'>
  & { schools?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_School' }
    & SchoolFragment
  )>>>, heroLink?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type BlogFragment = (
  { __typename?: 'Strapi_BlogPost' }
  & Pick<Strapi_BlogPost, 'documentId' | 'title' | 'slug' | 'excerpt' | 'body'>
  & { publishedAt: Strapi_BlogPost['published_at'], updatedAt: Strapi_BlogPost['updated_at'], originalDate: Strapi_BlogPost['original_date'] }
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, categories?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_Category' }
    & Pick<Strapi_Category, 'id' | 'name'>
  )>>> }
);
export type CareerFragment = (
  { __typename?: 'Strapi_CareerPost' }
  & Pick<Strapi_CareerPost, 'title' | 'short' | 'slug' | 'content' | 'publishedAt'>
  & { link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, jobType?: Maybe<(
    { __typename?: 'Strapi_JobTypeEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'Strapi_JobTypeEntity' }
      & Pick<Strapi_JobTypeEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_JobType' }
        & Pick<Strapi_JobType, 'name'>
      )> }
    )> }
  )>, city?: Maybe<(
    { __typename?: 'Strapi_CityEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'Strapi_CityEntity' }
      & Pick<Strapi_CityEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_City' }
        & Pick<Strapi_City, 'name'>
      )> }
    )> }
  )> }
);

export type NamedSchoolEntityResponseFragment = (
  { __typename?: 'Strapi_SchoolEntityResponse' }
  & { data?: Maybe<(
    { __typename?: 'Strapi_SchoolEntity' }
    & Pick<Strapi_SchoolEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Strapi_School' }
      & Pick<Strapi_School, 'name'>
    )> }
  )> }
);

export type HomepageFragment = (
  { __typename?: 'Strapi_Homepage' }
  & Pick<Strapi_Homepage, 'title'>
  & { heroTitle: Strapi_Homepage['hero_title'], heroBody: Strapi_Homepage['hero_body'], showFormInHeader: Strapi_Homepage['show_form_in_header'], coursesTitle: Strapi_Homepage['courses_title'], coursesBody: Strapi_Homepage['courses_body'] }
  & { heroImage: (
    { __typename?: 'Strapi_UploadFileEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'Strapi_UploadFileEntity' }
      & Pick<Strapi_UploadFileEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_UploadFile' }
        & StrapiImageFragment
      )> }
    )> }
  ), heroCta: (
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  ), heroSection?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomHeaderHeroSection' }
    & Pick<Strapi_ComponentAtomHeaderHeroSection, 'hero_title' | 'show_hero_section'>
    & { hero_full_image?: Maybe<(
      { __typename?: 'Strapi_UploadFileEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_UploadFileEntity' }
        & Pick<Strapi_UploadFileEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_UploadFile' }
          & StrapiImageFragment
        )> }
      )> }
    )>, heroBodyFeature?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_ComponentAtomCourseFeatures' }
      & Pick<Strapi_ComponentAtomCourseFeatures, 'feature'>
    )>>>, hero_cta?: Maybe<(
      { __typename?: 'Strapi_ComponentAtomLink' }
      & LinkComponentFragment
    )> }
  )>, inlineHubspotForm?: Maybe<(
    { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
    & InlineHubspotFormFragment
  )>, coursesCta: (
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  ), components: Array<Maybe<(
    { __typename?: 'Strapi_ComponentPageImageAndText' }
    & PageComponents_Strapi_ComponentPageImageAndText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageVideoAndText' }
    & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageScrollingStatement' }
    & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
    & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageTrustPilotWidget' }
    & PageComponents_Strapi_ComponentPageTrustPilotWidget_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageRichText' }
    & PageComponents_Strapi_ComponentPageRichText_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageLocationPanel' }
    & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
  ) | (
    { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
    & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
  ) | (
    { __typename?: 'Strapi_Error' }
    & PageComponents_Strapi_Error_Fragment
  )>>, pageSettings?: Maybe<(
    { __typename?: 'Strapi_ComponentDataPageSettings' }
    & PageSettingsFragment
  )>, promotion?: Maybe<(
    { __typename?: 'Strapi_PromotionEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'Strapi_PromotionEntity' }
      & Pick<Strapi_PromotionEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Promotion' }
        & PromotionFragment
      )> }
    )> }
  )>, seo: (
    { __typename?: 'Strapi_ComponentSharedSeo' }
    & SeoComponentFragment
  ) }
);
export type PromotionFragment = (
  { __typename?: 'Strapi_Promotion' }
  & Pick<Strapi_Promotion, 'documentId'|'title' | 'slug' | 'identifier' | 'body' | 'expires_at' | 'terms_and_conditions'>
  & { created_at: Strapi_Promotion['createdAt'], updated_at: Strapi_Promotion['updatedAt'], homepageLinkText: Strapi_Promotion['homepage_link_text'], published_at: Strapi_Promotion['publishedAt'] }
  & { callToAction?: Maybe<(
    { __typename?: 'Strapi_ComponentPageCallToAction' }
    & InlineCtaComponentFragment
  )> }
);

export type CourseFragment = (
  { __typename?: 'Strapi_Course' }
  & Pick<Strapi_Course, 'documentId' |'name' | 'short' | 'slug' | 'featured'>
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )> }
);

export type EnglishLevelComponentFragment = (
  { __typename?: 'Strapi_ComponentDataEnglishLevel' }
  & Pick<Strapi_ComponentDataEnglishLevel, 'name' | 'description' | 'level'>
  & { certifications?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentDataEnglishLevelComparison' }
    & Pick<Strapi_ComponentDataEnglishLevelComparison, 'certification'>
    & { correspondingLevel: Strapi_ComponentDataEnglishLevelComparison['corresponding_level'] }
  )>>>, information_blocks?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentAtomColumn' }
    & ColumnComponentFragment
  )>>>, examples?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomColumn' }
    & ColumnComponentFragment
  )> }
);

export type CourseNameComponentFragment = (
  { __typename?: 'Strapi_ComponentDataCourseName' }
  & Pick<Strapi_ComponentDataCourseName, 'name' >
  & { coursesAvailable?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_ComponentDataCourseAvailability' }
    & Pick<Strapi_ComponentDataCourseAvailability, 'courseName'>
    & { availability: Strapi_ComponentDataCourseAvailability['availability'] }
  )>>> }
);

export type EnglishLevelGroupFragment = (
  { __typename?: 'Strapi_EnglishLevelGroup' }
  & Pick<Strapi_EnglishLevelGroup, 'id'>
  & { englishLevels?: Maybe<Array<Maybe<(
    { __typename: 'Strapi_ComponentDataEnglishLevel' }
    & EnglishLevelComponentFragment
  )>>> }
);

export type CourseComparisonGroupFragment = (
  { __typename?: 'Strapi_CourseComparison' }
  & Pick<Strapi_CourseComparison, 'id'>
  & { courseName?: Maybe<Array<Maybe<(
    { __typename: 'Strapi_ComponentDataCourseName' }
    & CourseNameComponentFragment
  )>>> }
);

export type BlogPostsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type BlogPostsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { allBlogPostsWithCategories?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_BlogPost' }
      & BlogFragment
    )>>>, pages?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Page' }
      & Pick<Strapi_Page, 'title' | 'slug'>
      & { components: Array<Maybe<(
        { __typename?: 'Strapi_ComponentPageCallToAction' }
        & PageComponents_Strapi_ComponentPageCallToAction_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCareersGallery' }
        & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageColumns' }
        & PageComponents_Strapi_ComponentPageColumns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
        & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
        & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEmbedCode' }
        & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevelsAccordion' }
        & PageComponents_Strapi_ComponentPageEnglishLevelsAccordion_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevelsTable' }
        & PageComponents_Strapi_ComponentPageEnglishLevelsTable_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevels' }
        & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCourseComparison' }
        & PageComponents_Strapi_ComponentPageCourseComparison_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
        & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHeroCourse' }
        & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHeroMap' }
        & PageComponents_Strapi_ComponentPageHeroMap_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHero' }
        & PageComponents_Strapi_ComponentPageHero_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHtml' }
        & PageComponents_Strapi_ComponentPageHtml_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageImageAndText' }
        & PageComponents_Strapi_ComponentPageImageAndText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
        & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageLocationPanel' }
        & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageLogoGallery' }
        & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMap' }
        & PageComponents_Strapi_ComponentPageMap_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
        & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMeta' }
        & PageComponents_Strapi_ComponentPageMeta_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
        & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
        & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageQuoteAndText' }
        & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
        & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageRichList' }
        & PageComponents_Strapi_ComponentPageRichList_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageRichText' }
        & PageComponents_Strapi_ComponentPageRichText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
        & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageScrollingStatement' }
        & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageSimpleTitle' }
        & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
        & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
        & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageText' }
        & PageComponents_Strapi_ComponentPageText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
        & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
        & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTwoColumns' }
        & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageVideoAndText' }
        & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
      )| (
        { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
        & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentDataRelatedSchools' }
        & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
      ) | (
        { __typename?: 'Strapi_Error' }
        & PageComponents_Strapi_Error_Fragment
      )>>, page_settings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & PageSettingsFragment
      )> }
    )>>> }
  ) }
);

export type SingleBlogPostQueryVariables = Exact<{
  documentId: Scalars['ID'];
  relatedIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  websiteLocaleId: Scalars['ID'];
}>;


export type SingleBlogPostQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { relatedPosts?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_BlogPost' }
      & Pick<Strapi_BlogPost, 'documentId' | 'title' | 'slug' | 'excerpt'>
      & { publishedAt: Strapi_BlogPost['published_at'], originalDate: Strapi_BlogPost['original_date'] }
      & { image?: Maybe<(
        { __typename?: 'Strapi_UploadFile' }
        & StrapiImageFragment
      )>, categories?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_Category' }
        & Pick<Strapi_Category, 'name'>
      )>>> }
    )>>>, blogPost?: Maybe<(
      { __typename?: 'Strapi_BlogPost' }
      & Pick<Strapi_BlogPost, 'title' | 'slug' | 'documentId' | 'excerpt' | 'body'>
      & { publishedAt: Strapi_BlogPost['published_at'], updatedAt: Strapi_BlogPost['updated_at'], originalDate: Strapi_BlogPost['original_date'], htmlCode: Strapi_BlogPost['html_code'] }
      & { pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & PageSettingsFragment
      )>, categories?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_Category' }
        & Pick<Strapi_Category, 'id' | 'name'>
      )>>>, image?: Maybe<(
        { __typename?: 'Strapi_UploadFile' }
        & StrapiImageFragment
      )> }
      & { components?: Maybe<Array<Maybe<(
          { __typename?: 'Strapi_ComponentPageCallToAction' }
          & PageComponents_Strapi_ComponentPageCallToAction_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageColumns' }
          & PageComponents_Strapi_ComponentPageColumns_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
          & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
          & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageEmbedCode' }
          & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageEnglishLevelsAccordion' }
          & PageComponents_Strapi_ComponentPageEnglishLevelsAccordion_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageEnglishLevelsTable' }
          & PageComponents_Strapi_ComponentPageEnglishLevelsTable_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageCourseComparison' }
          & PageComponents_Strapi_ComponentPageCourseComparison_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageEnglishLevels' }
          & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
          & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageHeroCourse' }
          & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageHeroMap' }
          & PageComponents_Strapi_ComponentPageHeroMap_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageHero' }
          & PageComponents_Strapi_ComponentPageHero_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageHtml' }
          & PageComponents_Strapi_ComponentPageHtml_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageImageAndText' }
          & PageComponents_Strapi_ComponentPageImageAndText_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageLocationPanel' }
          & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageLogoGallery' }
          & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageMap' }
          & PageComponents_Strapi_ComponentPageMap_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
          & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageMeta' }
          & PageComponents_Strapi_ComponentPageMeta_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
          & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
          & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageQuoteAndText' }
          & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
          & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageRichList' }
          & PageComponents_Strapi_ComponentPageRichList_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageRichText' }
          & PageComponents_Strapi_ComponentPageRichText_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
          & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageScrollingStatement' }
          & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageSimpleTitle' }
          & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
          & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
          & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageText' }
          & PageComponents_Strapi_ComponentPageText_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
          & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
          & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageTwoColumns' }
          & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
        ) | (
          { __typename?: 'Strapi_ComponentPageVideoAndText' }
          & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
        )>>> 
        }
    )> }
  ) }
);

export type CareerCardFragment = (
  { __typename?: 'Strapi_CareerPost' }
  & Pick<Strapi_CareerPost, 'documentId'|'title' | 'short' | 'slug' | 'publishedAt'>
  & { jobType?: Maybe<(
    { __typename?: 'Strapi_JobTypeEntityResponse' }
    & NamedJobEntityResponseFragment
  )>, city?: Maybe<(
    { __typename?: 'Strapi_CityEntityResponse' }
    & NamedCityEntityResponseFragment
  )> }
);

export type CareerPostsQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  careersCtaId: Scalars['ID'];
  hasCareersCta: Scalars['Boolean'];
}>;

export type CareerPostsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { careersCta?: Maybe<(
      { __typename?: 'Strapi_CareersCtaEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CareersCtaEntity' }
        & Pick<Strapi_CareersCtaEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_CareersCta' }
          & { ctaPanel?: Maybe<(
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & ImageAndTextComponentFragment
          )> }
        )> }
      )> }
    )>, allCareerPosts?: Maybe<(
      { __typename?: 'Strapi_CareerPostEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CareerPostEntity' }
        & Pick<Strapi_CareerPostEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_CareerPost' }
          & CareerCardFragment
        )> }
      )> }
    )>, careerPosts?: Maybe<(
      { __typename?: 'Strapi_CareerPostEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CareerPostEntity' }
        & Pick<Strapi_CareerPostEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_CareerPost' }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CareerPostRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CareerPostEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_CareerPost' }
                & Pick<Strapi_CareerPost, 'locale' | 'slug'>
              )> }
            )> }
          )> }
          & CareerCardFragment
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SingleCareerPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleCareerPostQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { careerPost?: Maybe<(
      { __typename?: 'Strapi_CareerPostEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CareerPostEntity' }
        & Pick<Strapi_CareerPostEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_CareerPost' }
          & Pick<Strapi_CareerPost, 'title' | 'slug' | 'content' | 'publishedAt'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CareerPostRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CareerPostEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_CareerPost' }
                & Pick<Strapi_CareerPost, 'locale'>
              )> }
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, jobType?: Maybe<(
            { __typename?: 'Strapi_JobTypeEntityResponse' }
            & NamedJobEntityResponseFragment
          )>, city?: Maybe<(
            { __typename?: 'Strapi_CityEntityResponse' }
            & NamedCityEntityResponseFragment
          )>, link?: Maybe<(
            { __typename?: 'Strapi_ComponentAtomLink' }
            & LinkComponentFragment
          )>, callToAction?: Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & InlineCtaComponentFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SingleCertificationCityPageQueryVariables = Exact<{
  id: Scalars['ID'];
  cityId: Scalars['ID'];
}>;


export type SingleCertificationCityPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { certification?: Maybe<(
      { __typename?: 'Strapi_CertificationEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CertificationEntity' }
        & Pick<Strapi_CertificationEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Certification' }
          & Pick<Strapi_Certification, 'name'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CertificationRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CertificationEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Certification' }
                & Pick<Strapi_Certification, 'locale'>
              )> }
            )> }
          )>, image?: Maybe<(
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & StrapiImageEntityResponseFragment
          )>, footerCta?: Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & InlineCtaComponentFragment
          )> }
        )> }
      )> }
    )>, city?: Maybe<(
      { __typename?: 'Strapi_CityEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CityEntity' }
        & Pick<Strapi_CityEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_City' }
          & Pick<Strapi_City, 'name' | 'description'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CityRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CityEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_City' }
                & Pick<Strapi_City, 'locale'>
              )> }
            )> }
          )>, image?: Maybe<(
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & StrapiImageEntityResponseFragment
          )>, heroLink?: Maybe<(
            { __typename?: 'Strapi_ComponentAtomLink' }
            & LinkComponentFragment
          )>, imageAndText?: Maybe<(
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & ImageAndTextComponentFragment
          )>, schools?: Maybe<(
            { __typename?: 'Strapi_SchoolRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_SchoolEntity' }
              & Pick<Strapi_SchoolEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_School' }
                & SchoolFragment
              )> }
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type CertificationsIndexQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  certificationCtaId: Scalars['ID'];
  hasDefaultCertificationCta: Scalars['Boolean'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type CertificationsIndexQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { certificationCta?: Maybe<(
      { __typename?: 'Strapi_CertificationCtaEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CertificationCtaEntity' }
        & Pick<Strapi_CertificationCtaEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_CertificationCta' }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CertificationCtaRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CertificationCtaEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_CertificationCta' }
                & Pick<Strapi_CertificationCta, 'website_locale'>
              )> }
            )> }
          )> }
          & CertificationCtaFragment
        )> }
      )> }
    )>, certifications?: Maybe<(
      { __typename?: 'Strapi_CertificationEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CertificationEntity' }
        & Pick<Strapi_CertificationEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Certification' }
          & Pick<Strapi_Certification, 'excerpt' | 'name' | 'slug'>
          & { seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);


export type CertificationCtaFragment = (
  { __typename?: 'Strapi_CertificationCta' }
  & { columnOneHeading: Strapi_CertificationCta['column_one_heading'], columnOneBody: Strapi_CertificationCta['column_one_body'], columnTwoHeading: Strapi_CertificationCta['column_two_heading'], columnTwoBody: Strapi_CertificationCta['column_two_body'] }
  & { columnOneLink?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, columnTwoLink?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )> }
);

export type SingleCertificationPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleCertificationPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { certification?: Maybe<(
      { __typename?: 'Strapi_CertificationEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CertificationEntity' }
        & Pick<Strapi_CertificationEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Certification' }
          & Pick<Strapi_Certification, 'name' | 'slug' | 'excerpt'>
          & { heroBody: Strapi_Certification['hero_body'], cityHeadingText: Strapi_Certification['city_heading_text'], examSchoolsHeading: Strapi_Certification['exam_schools_heading'] }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CertificationRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CertificationEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Certification' }
                & Pick<Strapi_Certification, 'locale'>
              )> }
            )> }
          )>, image?: Maybe<(
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & StrapiImageEntityResponseFragment
          )>, heroLink?: Maybe<(
            { __typename?: 'Strapi_ComponentAtomLink' }
            & LinkComponentFragment
          )>, englishLevels?: Maybe<(
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & EnglishLevelsFragment
          )>, certificationCta?: Maybe<(
            { __typename?: 'Strapi_CertificationCtaEntityResponse' }
            & { data?: Maybe<(
              { __typename?: 'Strapi_CertificationCtaEntity' }
              & Pick<Strapi_CertificationCtaEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_CertificationCta' }
                & CertificationCtaFragment
              )> }
            )> }
          )>, reviewsWidget?: Maybe<(
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & ReviewsIoComponentFragment
          )>, examSchools?: Maybe<(
            { __typename?: 'Strapi_SchoolRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_SchoolEntity' }
              & Pick<Strapi_SchoolEntity, 'documentId'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_School' }
                & SchoolFragment
              )> }
            )> }
          )>, footerCta?: Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & InlineCtaComponentFragment
          )>, cities?: Maybe<(
            { __typename?: 'Strapi_CityRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CityEntity' }
              & Pick<Strapi_CityEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_City' }
                & CityLinkFragment
              )> }
            )> }
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, components?: Maybe<Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SingleCoursePostQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type SingleCoursePostQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { course?: Maybe<(
      { __typename?: 'Strapi_Course' }
      & Pick<Strapi_Course, 'name' | 'slug' | 'short' | 'title' |'feature_type'>
      & { courseFeatures?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_ComponentAtomCourseFeatures' }
        & Pick<Strapi_ComponentAtomCourseFeatures, 'feature'>
      )>>>, 
      courseText?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_ComponentAtomCourseText' }
        & Pick<Strapi_ComponentAtomCourseText, 'title'| 'description' >
      )>>>,
      courseCTA?: Maybe<(
        { __typename?: 'Strapi_ComponentAtomLink' }
        & LinkComponentFragment)>,
      image?: Maybe<(
        { __typename?: 'Strapi_UploadFile' }
        & StrapiImageFragment
      )>, components?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_ComponentPageCallToAction' }
        & PageComponents_Strapi_ComponentPageCallToAction_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageColumns' }
        & PageComponents_Strapi_ComponentPageColumns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
        & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
        & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEmbedCode' }
        & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevelsAccordion' }
        & PageComponents_Strapi_ComponentPageEnglishLevelsAccordion_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevelsTable' }
        & PageComponents_Strapi_ComponentPageEnglishLevelsTable_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCourseComparison' }
        & PageComponents_Strapi_ComponentPageCourseComparison_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevels' }
        & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
        & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHeroCourse' }
        & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHeroMap' }
        & PageComponents_Strapi_ComponentPageHeroMap_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHero' }
        & PageComponents_Strapi_ComponentPageHero_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHtml' }
        & PageComponents_Strapi_ComponentPageHtml_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageImageAndText' }
        & PageComponents_Strapi_ComponentPageImageAndText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageLocationPanel' }
        & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageLogoGallery' }
        & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMap' }
        & PageComponents_Strapi_ComponentPageMap_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
        & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMeta' }
        & PageComponents_Strapi_ComponentPageMeta_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
        & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
        & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageQuoteAndText' }
        & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
        & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageRichList' }
        & PageComponents_Strapi_ComponentPageRichList_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageRichText' }
        & PageComponents_Strapi_ComponentPageRichText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
        & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageScrollingStatement' }
        & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageSimpleTitle' }
        & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
        & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
        & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageText' }
        & PageComponents_Strapi_ComponentPageText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
        & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
        & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTwoColumns' }
        & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageVideoAndText' }
        & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
      )>>>, callToAction?: Maybe<(
        { __typename?: 'Strapi_ComponentPageCallToAction' }
        & InlineCtaComponentFragment
      )>, pageSettings?: Maybe<(
        { __typename?: 'Strapi_ComponentDataPageSettings' }
        & PageSettingsFragment
      )> }
    )> }
  ) }
);

export type CoursesQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
}>;

export type CoursesQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { courses?: Maybe<(
      { __typename?: 'Strapi_CourseEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CourseEntity' }
        & Pick<Strapi_CourseEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Course' }
          & Pick<Strapi_Course, 'name' | 'slug' | 'short'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CourseRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CourseEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Course' }
                & Pick<Strapi_Course, 'locale'>
              )> }
            )> }
          )>, courseFeatures?: Maybe<Array<Maybe<(
            { __typename?: 'Strapi_ComponentAtomCourseFeatures' }
            & Pick<Strapi_ComponentAtomCourseFeatures, 'feature'>
          )>>>, 
          courseText?: Maybe<Array<Maybe<(
            { __typename?: 'Strapi_ComponentAtomCourseText' }
            & Pick<Strapi_ComponentAtomCourseText, 'title'| 'description'>
          )>>>,
          image: (
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & StrapiImageEntityResponseFragment
          ) }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SingleEnglishTestPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;



export type SingleEnglishTestPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { englishTest?: Maybe<(
      { __typename?: 'Strapi_EnglishTestEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_EnglishTestEntity' }
        & Pick<Strapi_EnglishTestEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_EnglishTest' }
          & Pick<Strapi_EnglishTest, 'name' | 'slug' | 'description'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_EnglishTestRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_EnglishTestEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_EnglishTest' }
                & Pick<Strapi_EnglishTest, 'locale'>
              )> }
            )> }
          )>, activityBuilder?: Maybe<(
            { __typename?: 'Strapi_ComponentPageHtml' }
            & HtmlComponentFragment
          )>, link?: Maybe<(
            { __typename?: 'Strapi_ComponentAtomLink' }
            & LinkComponentFragment
          )>, components?: Maybe<Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>>, ctaComponent?: Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & InlineCtaComponentFragment
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo: (
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          ) }
        )> }
      )> }
    )> }
  ) }
);


export type EnglishTestsIndexQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type EnglishTestsIndexQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { englishTests?: Maybe<(
      { __typename?: 'Strapi_EnglishTestEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_EnglishTestEntity' }
        & Pick<Strapi_EnglishTestEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_EnglishTest' }
          & Pick<Strapi_EnglishTest, 'excerpt' | 'name' | 'slug'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_EnglishTestRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_EnglishTestEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_EnglishTest' }
                & Pick<Strapi_EnglishTest, 'website_locale'>
              )> }
            )> }
          )> }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);


export type EventCardFragment = (
  { __typename?: 'Strapi_Event' }
  & Pick<Strapi_Event, 'slug' | 'title'>
  & { eventTime: Strapi_Event['event_time'], eventAddress: Strapi_Event['event_address'] }
  & { school?: Maybe<(
    { __typename?: 'Strapi_School' }
    & Pick<Strapi_School, 'name'>
  )>, city?: Maybe<(
    { __typename?: 'Strapi_City' }
    & Pick<Strapi_City, 'name'>
  )>, categories?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_Category' }
    & Pick<Strapi_Category, 'name'>
  )>>>, image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & Pick<Strapi_UploadFile, 'name' | 'alternativeText' | 'caption' | 'width' | 'height' | 'formats' | 'mime' | 'size' | 'url' | 'previewUrl'>
  )> }
);

export type EventsIndexPageQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  eventIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  currentDate: Scalars['Date'];
}>;


export type EventsIndexPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { schools?: Maybe<(
      { __typename?: 'Strapi_SchoolEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_SchoolEntity' }
        & Pick<Strapi_SchoolEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_School' }
          & Pick<Strapi_School, 'name'>
        )> }
      )> }
    )>, cities?: Maybe<(
      { __typename?: 'Strapi_CityEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CityEntity' }
        & Pick<Strapi_CityEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_City' }
          & Pick<Strapi_City, 'name'>
        )> }
      )> }
    )>, allEvents?: Maybe<(
      { __typename?: 'Strapi_EventEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_EventEntity' }
        & Pick<Strapi_EventEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Event' }
          & EventCardFragment
        )> }
      )> }
    )>, events?: Maybe<(
      { __typename?: 'Strapi_EventEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_EventEntity' }
        & Pick<Strapi_EventEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Event' }
          & Pick<Strapi_Event, 'title' | 'slug' | 'content' | 'embed_code'>
          & { eventTime: Strapi_Event['event_time'], eventAddress: Strapi_Event['event_address'] }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_EventRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_EventEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Event' }
                & Pick<Strapi_Event, 'locale'>
              )> }
            )> }
          )>, categories?: Maybe<(
            { __typename?: 'Strapi_CategoryRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CategoryEntity' }
              & Pick<Strapi_CategoryEntity, 'id'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Category' }
                & Pick<Strapi_Category, 'name'>
              )> }
            )> }
          )>, image?: Maybe<(
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & StrapiImageEntityResponseFragment
          )>, school?: Maybe<(
            { __typename?: 'Strapi_SchoolEntityResponse' }
            & NamedSchoolEntityResponseFragment
          )>, city?: Maybe<(
            { __typename?: 'Strapi_CityEntityResponse' }
            & NamedCityEntityResponseFragment
          )>, link?: Maybe<(
            { __typename?: 'Strapi_ComponentAtomLink' }
            & LinkComponentFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type RelatedEventFragment = (
  { __typename?: 'Strapi_Event' }
  & Pick<Strapi_Event,'documentId' |'title' | 'slug'>
  & { eventTime: Strapi_Event['event_time'], eventAddress: Strapi_Event['event_address'] }
  & { image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, categories?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_Category' }
    & Pick<Strapi_Category, 'name'>
  )>>> }
);

export type EventPostFragment = (
  { __typename?: 'Strapi_Event' }
  & Pick<Strapi_Event, 'title' | 'slug' | 'content' | 'embed_code'>
  & { eventTime: Strapi_Event['event_time'], eventAddress: Strapi_Event['event_address'] }
  & { categories?: Maybe<Array<Maybe<(
    { __typename?: 'Strapi_Category' }
    & Pick<Strapi_Category, 'name'>
  )>>>, image?: Maybe<(
    { __typename?: 'Strapi_UploadFile' }
    & StrapiImageFragment
  )>, link?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomLink' }
    & LinkComponentFragment
  )>, callToAction?: Maybe<(
    { __typename?: 'Strapi_ComponentPageCallToAction' }
    & InlineCtaComponentFragment
  )>, pageSettings?: Maybe<(
    { __typename?: 'Strapi_ComponentDataPageSettings' }
    & PageSettingsFragment
  )> }
);

export type SingleEventPostQueryVariables = Exact<{
  documentId: Scalars['ID'];
  fetchOtherEvents: Scalars['Boolean'];
  currentDate: Scalars['Date'];
}>;


export type SingleEventPostQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { events?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Event' }
      & RelatedEventFragment
    )>>>, event?: Maybe<(
      { __typename?: 'Strapi_Event' }
      & { relatedEvents?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_Event' }
        & RelatedEventFragment
      )>>> }
      & EventPostFragment
    )> }
  ) }
);

export type ExercisePostFragment = (
  { __typename?: 'Strapi_Exercise' }
  & Pick<Strapi_Exercise, 'body' | 'excerpt'| 'documentId'>
  & { htmlCode: Strapi_Exercise['html_code'] }
  & { pageSettings?: Maybe<(
    { __typename?: 'Strapi_ComponentDataPageSettings' }
    & PageSettingsFragment
  )> }
  & ExerciseBaseFragment
);

export type SingleExercisePostQueryVariables = Exact<{
  documentId: Scalars['ID'];
  relatedIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SingleExercisePostQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { relatedExercises?: Maybe<Array<Maybe<(
      { __typename?: 'Strapi_Exercise' }
      & ExerciseCardFragment
    )>>>, exercise?: Maybe<(
      { __typename?: 'Strapi_Exercise' }
      & ExercisePostFragment
      & { components?: Maybe<Array<Maybe<(
        { __typename?: 'Strapi_ComponentPageCallToAction' }
        & PageComponents_Strapi_ComponentPageCallToAction_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageColumns' }
        & PageComponents_Strapi_ComponentPageColumns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
        & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
        & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEmbedCode' }
        & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevelsAccordion' }
        & PageComponents_Strapi_ComponentPageEnglishLevelsAccordion_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevelsTable' }
        & PageComponents_Strapi_ComponentPageEnglishLevelsTable_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageCourseComparison' }
        & PageComponents_Strapi_ComponentPageCourseComparison_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEnglishLevels' }
        & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
        & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHeroCourse' }
        & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHeroMap' }
        & PageComponents_Strapi_ComponentPageHeroMap_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHero' }
        & PageComponents_Strapi_ComponentPageHero_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageHtml' }
        & PageComponents_Strapi_ComponentPageHtml_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageImageAndText' }
        & PageComponents_Strapi_ComponentPageImageAndText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageLocationPanel' }
        & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageLogoGallery' }
        & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMap' }
        & PageComponents_Strapi_ComponentPageMap_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
        & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageMeta' }
        & PageComponents_Strapi_ComponentPageMeta_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
        & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
        & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageQuoteAndText' }
        & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
        & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageRichList' }
        & PageComponents_Strapi_ComponentPageRichList_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageRichText' }
        & PageComponents_Strapi_ComponentPageRichText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
        & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageScrollingStatement' }
        & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageSimpleTitle' }
        & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
        & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
        & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageText' }
        & PageComponents_Strapi_ComponentPageText_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
        & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
        & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageTwoColumns' }
        & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
      ) | (
        { __typename?: 'Strapi_ComponentPageVideoAndText' }
        & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
      )>>> 
      }
    )>
    }   
  ) }
);

export type ExerciseBaseFragment = (
  { __typename?: 'Strapi_Exercise' }
  & Pick<Strapi_Exercise, 'title' | 'publishedAt'>
  & { showDate: Strapi_Exercise['show_date'], originalDate: Strapi_Exercise['original_date'] }
  & { categories?: Maybe<(
    { __typename?: 'Strapi_CategoryRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_CategoryEntity' }
      & Pick<Strapi_CategoryEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Category' }
        & Pick<Strapi_Category, 'name'>
      )> }
    )> }
  )>, image?: Maybe<(
    { __typename?: 'Strapi_UploadFileEntityResponse' }
    & StrapiImageEntityResponseFragment
  )> }
);
export type ExerciseCardFragment = (
  { __typename?: 'Strapi_Exercise' }
  & Pick<Strapi_Exercise, 'slug' | 'excerpt' | 'documentId'>
  & ExerciseBaseFragment
);

export type ExerciseIndexQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type ExerciseIndexQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { allExercisesWithCategories?: Maybe<(
      { __typename?: 'Strapi_ExerciseEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_ExerciseEntity' }
        & Pick<Strapi_ExerciseEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Exercise' }
          & ExerciseCardFragment
        )> }
      )> }
    )>, exercises?: Maybe<(
      { __typename?: 'Strapi_ExerciseEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_ExerciseEntity' }
        & Pick<Strapi_ExerciseEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Exercise' }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_ExerciseRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_ExerciseEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Exercise' }
                & Pick<Strapi_Exercise, 'locale'>
              )> }
            )> }
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
          & ExerciseCardFragment
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type StrapiHomepageQueryVariables = Exact<{
  documentId: Scalars['ID'];
  websiteLocaleId: Scalars['ID'];
}>;




export type StrapiHomepageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { homepage?: Maybe<(
      { __typename?: 'Strapi_HomepageEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_HomepageEntity' }
        & Pick<Strapi_HomepageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Homepage' }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_HomepageRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_HomepageEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Homepage' }
                & Pick<Strapi_Homepage, 'locale'>
              )> }
            )> }
          )> }
          & HomepageFragment
        )> }
      )> }
    )>, courses?: Maybe<(
      { __typename?: 'Strapi_CourseEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_CourseEntity' }
        & Pick<Strapi_CourseEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Course' }
          & Pick<Strapi_Course, 'featured'>
          & CourseFragment
        )> }
      )> }
    )> }
  ) }
);

export type StrapiNotFoundPageQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  locale?: Maybe<Scalars['Strapi_I18NLocaleCode']>;
}>;


export type StrapiNotFoundPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_PageRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PageEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Page' }
                & Pick<Strapi_Page, 'locale'>
              )> }
            )> }
          )>, components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo: (
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          ) }
        )> }
      )> }
    )> }
  ) }
);


export type StrapiPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StrapiPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_PageRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PageEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Page' }
                & Pick<Strapi_Page, 'locale'>
              )> }
            )> }
          )>, components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type PromotionsIndexQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type PromotionsIndexQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { promotions?: Maybe<(
      { __typename?: 'Strapi_PromotionEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PromotionEntity' }
        & Pick<Strapi_PromotionEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Promotion' }
          & Pick<Strapi_Promotion, 'title' | 'slug'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_PromotionRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PromotionEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Promotion' }
                & Pick<Strapi_Promotion, 'locale'>
              )> }
            )> }
          )> }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SinglePromotionPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SinglePromotionPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { promotion?: Maybe<(
      { __typename?: 'Strapi_PromotionEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_PromotionEntity' }
        & Pick<Strapi_PromotionEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Promotion' }
          & Pick<Strapi_Promotion, 'title' | 'slug' | 'body' | 'identifier' | 'script'>
          & { expiresAt: Strapi_Promotion['expires_at'], termsAndConditions: Strapi_Promotion['terms_and_conditions'] }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_PromotionRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PromotionEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Promotion' }
                & Pick<Strapi_Promotion, 'locale'>
              )> }
            )> }
          )>, image?: Maybe<(
            { __typename?: 'Strapi_UploadFileEntityResponse' }
            & StrapiImageEntityResponseFragment
          )>, callToAction?: Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & InlineCtaComponentFragment
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SinglePromotionPageTermsAndConditionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SinglePromotionPageTermsAndConditionsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { promotion?: Maybe<(
      { __typename?: 'Strapi_PromotionEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_PromotionEntity' }
        & Pick<Strapi_PromotionEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Promotion' }
          & Pick<Strapi_Promotion, 'title' | 'slug' | 'publishedAt'>
          & { expiresAt: Strapi_Promotion['expires_at'], termsAndConditions: Strapi_Promotion['terms_and_conditions'] }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_PromotionRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PromotionEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Promotion' }
                & Pick<Strapi_Promotion, 'locale'>
              )> }
            )> }
          )> }
        )> }
      )> }
    )> }
  ) }
);


export type CitySchoolsPostPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CitySchoolsPostPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { city?: Maybe<(
      { __typename?: 'Strapi_CityEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CityEntity' }
        & Pick<Strapi_CityEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_City' }
          & { hide_map: boolean }
          & Pick<Strapi_City, 'name' | 'title'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_CityRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CityEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_City' }
                & Pick<Strapi_City, 'locale' > 
              )> }
            )> }
          )>, components?: Maybe<Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>>, imageAndText?: Maybe<(
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & ImageAndTextComponentFragment
          )>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )>, schools?: Maybe<(
            { __typename?: 'Strapi_SchoolRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_SchoolEntity' }
              & Pick<Strapi_SchoolEntity, 'documentId'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_School' }
                & SchoolFragment
              )> }
            )> }
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SchoolCareerPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  hasCareersCta: Scalars['Boolean'];
  careersCtaId: Scalars['ID'];
}>;


export type SchoolCareerPostsQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { careersCta?: Maybe<(
      { __typename?: 'Strapi_CareersCtaEntityResponse' }
      & { data?: Maybe<(
        { __typename?: 'Strapi_CareersCtaEntity' }
        & Pick<Strapi_CareersCtaEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_CareersCta' }
          & { ctaPanel?: Maybe<(
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & ImageAndTextComponentFragment
          )> }
        )> }
      )> }
    )>, schools?: Maybe<(
      { __typename?: 'Strapi_SchoolEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_SchoolEntity' }
        & Pick<Strapi_SchoolEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_School' }
          & Pick<Strapi_School, 'name'>
          & { careerPosts?: Maybe<(
            { __typename?: 'Strapi_CareerPostRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_CareerPostEntity' }
              & Pick<Strapi_CareerPostEntity, 'documentId'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_CareerPost' }
                & Pick<Strapi_CareerPost, 'title' | 'short' | 'slug'>
                & { localizations?: Maybe<(
                  { __typename?: 'Strapi_CareerPostRelationResponseCollection' }
                  & { data: Array<(
                    { __typename?: 'Strapi_CareerPostEntity' }
                    & { attributes?: Maybe<(
                      { __typename?: 'Strapi_CareerPost' }
                      & Pick<Strapi_CareerPost, 'locale'>
                    )> }
                  )> }
                )>, jobType?: Maybe<(
                  { __typename?: 'Strapi_JobTypeEntityResponse' }
                  & { data?: Maybe<(
                    { __typename?: 'Strapi_JobTypeEntity' }
                    & Pick<Strapi_JobTypeEntity, 'id'>
                    & { attributes?: Maybe<(
                      { __typename?: 'Strapi_JobType' }
                      & Pick<Strapi_JobType, 'name'>
                    )> }
                  )> }
                )>, city?: Maybe<(
                  { __typename?: 'Strapi_CityEntityResponse' }
                  & { data?: Maybe<(
                    { __typename?: 'Strapi_CityEntity' }
                    & Pick<Strapi_CityEntity, 'documentId'>
                    & { attributes?: Maybe<(
                      { __typename?: 'Strapi_City' }
                      & Pick<Strapi_City, 'name'>
                    )> }
                  )> }
                )> }
              )> }
            )> }
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);


export type StrapiSingleSchoolPostPageQueryVariables = Exact<{
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['Strapi_I18NLocaleCode']>;
}>;


export type StrapiSingleSchoolPostPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { school?: Maybe<(
      { __typename?: 'Strapi_School' }
      & SchoolFragment
    )> }
  ) }
);

export type SchoolPromotionsIndexQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SchoolPromotionsIndexQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { schools?: Maybe<(
      { __typename?: 'Strapi_SchoolEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_SchoolEntity' }
        & Pick<Strapi_SchoolEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_School' }
          & Pick<Strapi_School, 'name'>
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_SchoolRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_SchoolEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_School' }
                & Pick<Strapi_School, 'locale'>
              )> }
            )> }
          )>, promotions?: Maybe<(
            { __typename?: 'Strapi_PromotionRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_PromotionEntity' }
              & Pick<Strapi_PromotionEntity, 'documentId'>
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_Promotion' }
                & Pick<Strapi_Promotion, 'title' | 'slug'>
              )> }
            )> }
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )>, pages?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'id'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, page_settings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )> }
  ) }
);

export type SchoolCardFragment = (
  { __typename?: 'Strapi_School' }
  & Pick<Strapi_School, 'slug' | 'name' | 'status'>
  & { phoneNumber: Strapi_School['phone_number'], emailAddress: Strapi_School['email_address'] }
  & { schoolHero?: Maybe<(
    { __typename?: 'Strapi_ComponentSchoolSchoolHero' }
    & Pick<Strapi_ComponentSchoolSchoolHero, 'heading' | 'description'>
  )>, address?: Maybe<(
    { __typename?: 'Strapi_ComponentSchoolPostalAddress' }
    & Pick<Strapi_ComponentSchoolPostalAddress, 'locality' | 'region' | 'country' | 'id'>
    & { streetAddress: Strapi_ComponentSchoolPostalAddress['street_address'], postalCode: Strapi_ComponentSchoolPostalAddress['postal_code'] }
  )>, mapMarker?: Maybe<(
    { __typename?: 'Strapi_ComponentAtomMapMarker' }
    & Pick<Strapi_ComponentAtomMapMarker, 'id' | 'mapLocation'>
  )>, certifications?: Maybe<(
    { __typename?: 'Strapi_CertificationRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_CertificationEntity' }
      & Pick<Strapi_CertificationEntity, 'documentId'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Certification' }
        & Pick<Strapi_Certification, 'name'>
      )> }
    )> }
  )>, categories?: Maybe<(
    { __typename?: 'Strapi_CategoryRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'Strapi_CategoryEntity' }
      & Pick<Strapi_CategoryEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Strapi_Category' }
        & Pick<Strapi_Category, 'name'>
      )> }
    )> }
  )> }
);

export type SchoolIndexPageQueryVariables = Exact<{
  websiteLocaleId: Scalars['ID'];
}>;


export type SchoolIndexPageQuery = (
  { __typename?: 'Query' }
  & { strapi: (
    { __typename?: 'Strapi' }
    & { schoolsIndexPage?: Maybe<(
      { __typename?: 'Strapi_PageEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_PageEntity' }
        & Pick<Strapi_PageEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_Page' }
          & Pick<Strapi_Page, 'title' | 'slug'>
          & { components: Array<Maybe<(
            { __typename?: 'Strapi_ComponentPageCallToAction' }
            & PageComponents_Strapi_ComponentPageCallToAction_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCareersGallery' }
            & PageComponents_Strapi_ComponentPageCareersGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageColumns' }
            & PageComponents_Strapi_ComponentPageColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCtaPanel' }
            & PageComponents_Strapi_ComponentPageCourseCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageDetailedPricingPlan' }
            & PageComponents_Strapi_ComponentPageDetailedPricingPlan_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEmbedCode' }
            & PageComponents_Strapi_ComponentPageEmbedCode_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsAcd' }
            & PageComponents_Strapi_ComponentPageEnLvlsAcd_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnLvlsTbl' }
            & PageComponents_Strapi_ComponentPageEnLvlsTbl_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEnglishLevels' }
            & PageComponents_Strapi_ComponentPageEnglishLevels_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageEventsCtaPanel' }
            & PageComponents_Strapi_ComponentPageEventsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroCourse' }
            & PageComponents_Strapi_ComponentPageHeroCourse_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHeroMap' }
            & PageComponents_Strapi_ComponentPageHeroMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHero' }
            & PageComponents_Strapi_ComponentPageHero_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageHtml' }
            & PageComponents_Strapi_ComponentPageHtml_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageImageAndText' }
            & PageComponents_Strapi_ComponentPageImageAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageInlineHubspotForm' }
            & PageComponents_Strapi_ComponentPageInlineHubspotForm_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLocationPanel' }
            & PageComponents_Strapi_ComponentPageLocationPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageLogoGallery' }
            & PageComponents_Strapi_ComponentPageLogoGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMap' }
            & PageComponents_Strapi_ComponentPageMap_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeetTheTeamGallery' }
            & PageComponents_Strapi_ComponentPageMeetTheTeamGallery_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageMeta' }
            & PageComponents_Strapi_ComponentPageMeta_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePricingPlanPanel' }
            & PageComponents_Strapi_ComponentPagePricingPlanPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPagePromotionsCtaPanel' }
            & PageComponents_Strapi_ComponentPagePromotionsCtaPanel_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageQuoteAndText' }
            & PageComponents_Strapi_ComponentPageQuoteAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageReviewsIoWidget' }
            & PageComponents_Strapi_ComponentPageReviewsIoWidget_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichList' }
            & PageComponents_Strapi_ComponentPageRichList_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageRichText' }
            & PageComponents_Strapi_ComponentPageRichText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSchoolInfoBox' }
            & PageComponents_Strapi_ComponentPageSchoolInfoBox_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageScrollingStatement' }
            & PageComponents_Strapi_ComponentPageScrollingStatement_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageSimpleTitle' }
            & PageComponents_Strapi_ComponentPageSimpleTitle_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTeacherAndCoaches' }
            & PageComponents_Strapi_ComponentPageTeacherAndCoaches_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTextAndSplitImages' }
            & PageComponents_Strapi_ComponentPageTextAndSplitImages_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageText' }
            & PageComponents_Strapi_ComponentPageText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageThreeBlocksAndImage' }
            & PageComponents_Strapi_ComponentPageThreeBlocksAndImage_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumnsAndLinks' }
            & PageComponents_Strapi_ComponentPageTwoColumnsAndLinks_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageTwoColumns' }
            & PageComponents_Strapi_ComponentPageTwoColumns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageVideoAndText' }
            & PageComponents_Strapi_ComponentPageVideoAndText_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentPageCourseCmprsns' }
            & PageComponents_Strapi_ComponentPageCourseCmprsns_Fragment
          ) | (
            { __typename?: 'Strapi_ComponentDataRelatedSchools' }
            & PageComponents_Strapi_ComponentDataRelatedSchools_Fragment
          ) | (
            { __typename?: 'Strapi_Error' }
            & PageComponents_Strapi_Error_Fragment
          )>>, pageSettings?: Maybe<(
            { __typename?: 'Strapi_ComponentDataPageSettings' }
            & PageSettingsFragment
          )>, seo?: Maybe<(
            { __typename?: 'Strapi_ComponentSharedSeo' }
            & SeoComponentFragment
          )> }
        )> }
      )> }
    )>, allSchools?: Maybe<(
      { __typename?: 'Strapi_SchoolEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_SchoolEntity' }
        & Pick<Strapi_SchoolEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_School' }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_SchoolRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_SchoolEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_School' }
                & Pick<Strapi_School, 'locale'>
              )> }
            )> }
          )> }
          & SchoolCardFragment
        )> }
      )> }
    )>, schools?: Maybe<(
      { __typename?: 'Strapi_SchoolEntityResponseCollection' }
      & { data: Array<(
        { __typename?: 'Strapi_SchoolEntity' }
        & Pick<Strapi_SchoolEntity, 'documentId'>
        & { attributes?: Maybe<(
          { __typename?: 'Strapi_School' }
          & { localizations?: Maybe<(
            { __typename?: 'Strapi_SchoolRelationResponseCollection' }
            & { data: Array<(
              { __typename?: 'Strapi_SchoolEntity' }
              & { attributes?: Maybe<(
                { __typename?: 'Strapi_School' }
                & Pick<Strapi_School, 'locale'>
              )> }
            )> }
          )> }
          & SchoolCardFragment
        )> }
      )> }
    )> }
  ) }
);
